(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8fbd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8fbd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("346VI", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b71ef8c0192a76$export$2e2bcd8739ae039);
if (window.DrDocWeb !== undefined) console.warn('Lib Duplicate: DrDocWeb');
function $23b71ef8c0192a76$export$2e2bcd8739ae039() {}
/**
 * Convert a string to HTML entities
 */ String.prototype.toHtmlEntities = function() {
    return this.replace(/./gm, function(s) {
        // return "&#" + s.charCodeAt(0) + ";";
        return s.match(/[a-z0-9\s]+/i) ? s : "&#" + s.charCodeAt(0) + ";";
    });
};
/**
 * Create string from HTML entities
 */ String.fromHtmlEntities = function(string) {
    return (string + "").replace(/&#\d+;/gm, function(s) {
        return String.fromCharCode(s.match(/\d+/gm)[0]);
    });
};
String.prototype.contains = function(search, start) {
    'use strict';
    if (typeof start !== 'number') start = 0;
    if (start + search.length > this.length) return false;
    else return this.indexOf(search, start) !== -1;
};
String.prototype.hashCode = function() {
    var hash = 0, i1, chr;
    if (this.length === 0) return hash;
    for(i1 = 0; i1 < this.length; i1++){
        chr = this.charCodeAt(i1);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
console.log('DRDOCWEB INIT');
//module.exports = DrDocWeb
//export default DrDocWeb
//export { DrDocWeb };
window.DrDocWeb = $23b71ef8c0192a76$export$2e2bcd8739ae039;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerHost = document.location.protocol + '//' + document.location.hostname;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort = document.location.port;
$23b71ef8c0192a76$export$2e2bcd8739ae039.ServerBase = function() {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerHost + (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty($23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort) ? ':' + $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerPort : '');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError = function(error) {
    console.warn(error);
    $23b71ef8c0192a76$export$2e2bcd8739ae039.ModalError('Fehler!');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.IsMobile = function() {
    return window.innerWidth < window.innerHeight && window.innerWidth < 560; //850;
//return window.innerWidth < 800;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode = function(val) {
    return encodeURIComponent(typeof val === "object" ? $23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToJson(val) : val);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr = function(obj) {
    if (obj === null || obj === undefined) return '';
    if (typeof obj === 'string') return obj;
    var strArr = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var v = obj[p];
        /*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
            {
                // => typeof Dataset
                // IDataset / Dataset.IsModel(value): $ModelType, $ClassName, Dataset
                if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
                else return value;
            }) : v));*/ strArr.push($23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(p) + "=" + $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(v));
    }
    var str = strArr.join("&");
    //return (str.length == 0 ? '' : '?' + str);
    return str;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.QueryStrToObject = function(str) {
    let obj = {};
    if (str === null || str === undefined) return obj;
    if (str.substring(0, 1) === '?') str = str.substring(1);
    let arr = str.split('&');
    for(var i1 in arr){
        let kvp = arr[i1].split('=');
        if (kvp !== undefined && kvp.length === 2) obj[decodeURIComponent(kvp[0])] = decodeURIComponent(kvp[1]);
    }
    return obj;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetDataToObject = function() {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.QueryStrToObject(window.location.search);
};
/*DrDocWeb.ArrayEquals = function(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
};*/ // Sind alle arr1 in arr2 enthalten?
$23b71ef8c0192a76$export$2e2bcd8739ae039.ArrayEquals = function(arr1, arr2, caseSensitive) {
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0)) return true;
    for (let elem1 of arr1){
        if (elem1 === undefined || elem1 === null || elem1.length == 0) continue;
        //console.log('elem1', elem1);
        let found = false;
        for (let elem2 of arr2){
            if (elem2 === undefined || elem2 === null || elem2.length == 0) continue;
            if (caseSensitive && elem2 === elem1 || !caseSensitive && elem2.toLowerCase() === elem1.toLowerCase()) {
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};
/*DrDocWeb.ArrayEquals = function(arr1, arr2, caseSensitive)
{
    if ((arr1 === undefined || arr1 === null || arr1.length == 0) && (arr2 === undefined || arr2 === null || arr2.length == 0))
    {
        return true;
    }
    	
    for (let i in arr1)
    {
        if ((caseSensitive && arr1[i] !== arr2[i]) || (!caseSensitive && arr1[i].toLowerCase() !== arr2[i].toLowerCase()))
            return false;
    }
        
    //console.log('ArrayEquals', arr1, ' === ', arr2);
    return true;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemWhere = function(data, propName, propValue) {
    let i1 = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemIndexWhere(data, propName, propValue);
    if (i1 >= 0) return data[i1];
    return null;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetArrayItemIndexWhere = function(data, propName, propValue) {
    for(var i1 = 0; i1 < data.length; i1++)if (typeof propName === 'function') {
        if (propName(data[i1]) === true) return i1;
    } else {
        if (data[i1][propName] == propValue) return i1;
    }
    return -1;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjGetKeys = function(obj) {
    let ret = [];
    if (obj != null && obj != undefined) {
        for(let x in obj)ret.push(x);
        return ret;
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FormToObject = function(formName, splitter) {
    let form = null;
    if (typeof formName === 'string') form = document.forms[formName];
    else form = formName;
    if (form === undefined) return undefined;
    if (splitter === undefined || splitter === null) splitter = String.fromCharCode(1);
    if (typeof splitter === 'number') splitter = String.fromCharCode(splitter);
    let data = {};
    // $(form).serializeArray();
    for(let i1 = 0; i1 < form.elements.length; i1++){
        let form_elem = form.elements[i1];
        //if (form_elem.value !== undefined)
        let name = form_elem.name;
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) {
            //if (pre !== undefined)
            //{
            //    name = pre + name;
            //}
            // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
            let type = form_elem.getAttribute('type');
            if (type != undefined && type != null) type = type.toLowerCase();
            let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';
            //console.log('Form: ', name, type, isCheckable);
            //if (!isCheckable || type === 'checkbox' || (isCheckable && form_elem.checked === true))
            //if (!isCheckable || (type === 'checkbox' || form_elem.getAttribute('data-has-changed') == 'true'))
            //{
            let val = '';
            if (form_elem.value !== undefined && form_elem.value !== null) {
                if (isCheckable) val = form_elem.checked === true ? form_elem.value : '';
                else val = form_elem.value;
            }
            // 
            /*if (val == '' && type === 'checkbox' && form_elem.getAttribute('data-has-changed') == 'true')
            {
                val = '!' + form_elem.value;
            }*/ if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val)) val = '';
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val) && form_elem.getAttribute('trim') == 'true') continue;
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(val) && isCheckable) continue;
            // Falls ein Wert bereits vorhanden ist, dann anfügen.
            if (data[name] !== undefined && data[name] !== null) {
                if (typeof splitter === 'function') data[name] = splitter(name, data[name], val);
                else if (splitter === 'array') data[name].push(val);
                else data[name] = data[name] + splitter + val;
            } else if (splitter === 'array') data[name] = [
                val
            ];
            else data[name] = val;
        //}
        }
        continue;
    }
    // Am Ende leere Splitter trimmen
    if (typeof splitter !== 'function' && splitter !== 'array') for(let fieldName in data){
        let fieldValue = data[fieldName];
        if (fieldValue !== undefined && fieldValue !== null && typeof fieldValue === 'string') //data[fieldName] = fieldValue.replace(/[\|]+$/, '');
        data[fieldName] = fieldValue.replace(new RegExp('[\\' + splitter + ']+$'), '');
    }
    //console.log('Form A', data);
    //console.log('Form B', form.elements);
    return data;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetFormDataFromEvent = function(ev) {
    if (ev instanceof FormData) return ev;
    let hasFile = false;
    var formData = new FormData();
    if (ev.dataTransfer && ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for(var i1 = 0; i1 < ev.dataTransfer.items.length; i1++)// If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i1].kind === 'file') {
            var file = ev.dataTransfer.items[i1].getAsFile();
            //console.log('... file[' + i + '].name = ' + file.name);
            formData.append("file" + i1, file);
            hasFile = true;
        }
    } else if (ev.dataTransfer && ev.dataTransfer.files) // Use DataTransfer interface to access the file(s)
    for(var i1 = 0; i1 < ev.dataTransfer.files.length; i1++){
        //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
        formData.append("file" + i1, ev.dataTransfer.files[i1]);
        hasFile = true;
    }
    else if (ev.target && ev.target.files) for(var i1 = 0; i1 < ev.target.files.length; i1++){
        formData.append("file" + i1, ev.target.files[i1]);
        hasFile = true;
    }
    else if (ev.files) for(var i1 = 0; i1 < ev.files.length; i1++){
        formData.append("file" + i1, ev.files[i1]);
        hasFile = true;
    }
    if (hasFile) return formData;
    else return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestTag = function(sourceElement, tagName) {
    let trElem = sourceElement;
    while(trElem != undefined && trElem != null){
        if (trElem.tagName.toLowerCase() == tagName.toLowerCase()) return trElem;
        trElem = trElem.parentNode;
    }
    return undefined;
};
// Holt das nächste Form, welches kein Child von einem Element mit dem Attribut "data-form-ignore" ist.
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm = function(sourceElement) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = null;
    if (sourceElement !== undefined && sourceElement !== null && sourceElement.tagName != undefined && sourceElement.tagName.toLowerCase() == 'form') result = sourceElement;
    else result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, 'form:not([data-form-ignore] *)', true);
    //result = DrDocWeb.GetElement(sourceElement, 'form:has(:not([data-ignore]))');
    //result = DrDocWeb.GetElement(sourceElement, 'form:not(:has([data-ignore]))');
    return result;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestFormToObject = function(sourceElement, splitter) {
    //formData = document.querySelector('form [' + attr_name + '="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    let result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm(sourceElement);
    if (result !== undefined && result !== null) return $23b71ef8c0192a76$export$2e2bcd8739ae039.FormToObject(result, splitter);
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ClearClosestForm = function(sourceElement) {
    let form = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetClosestForm(sourceElement);
    if (form !== undefined && form !== null) for(let i1 = 0; i1 < form.elements.length; i1++){
        let form_elem = form.elements[i1];
        let name = form_elem.name;
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) {
            // Wenn ein Element checkable ist, dann nur den aktiven Wert setzen.
            let type = form_elem.getAttribute('type');
            if (type != undefined && type != null) type = type.toLowerCase();
            let isCheckable = type === 'select' || type === 'radio' || type === 'checkbox';
            let val = '';
            if (form_elem.value !== undefined && form_elem.value !== null) {
                if (isCheckable) form_elem.checked = null;
                else form_elem.value = '';
            }
        }
    }
};
/*DrDocWeb._ClosestFormToObject = function(sourceElement, splitter)
{
    let result = undefined;
    if (sourceElement.nodeName !== undefined && sourceElement.nodeName.toLowerCase() === 'form')
        result = sourceElement;
    else
    {
        result = $(sourceElement).parents('form')[0];
        if (result === undefined || result === null)
        {
            result = $(sourceElement).children('form')[0];
        }
    }
    if (result !== undefined && result !== null)
    {
        return DrDocWeb.FormToObject(result, splitter);
    }
    return undefined;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker = function(parentObj, parentProp, refObjList) {
    let obj = parentObj[parentProp];
    for(var prop in obj){
        let value = obj[prop];
        if (prop === '$id') {
            refObjList[value] = obj;
            delete obj['$id'];
        } else if (prop === '$values') {
            $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, prop, refObjList);
            parentObj[parentProp] = value;
        } else if (prop === '$ref') parentObj[parentProp] = refObjList[value];
        else if (typeof value === 'object') $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, prop, refObjList);
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObject = function(text) {
    if (text == null || text == undefined) return {};
    if (typeof text === 'object') return text;
    if (typeof text !== 'string') {
        console.log('DrDocWeb.JsonToObject: Bad format: ', text);
        return text;
    }
    var obj = {
        _root: JSON.parse(text)
    };
    var refObjList = {};
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObjectWalker(obj, '_root', refObjList);
    return obj._root;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToJson = function(obj) {
    if (obj == undefined || obj == null) return '';
    return JSON.stringify(obj);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CloneCopy = function(obj) {
    if (obj == undefined || obj == null) return obj;
    if (typeof obj === 'string' || typeof obj === 'number') return obj;
    if (Array.isArray(obj)) return obj.slice(0);
    if (typeof obj === 'object') {
        var arrTmp = {};
        Object.assign(arrTmp, obj);
        return arrTmp;
    }
    console.warn('DrDocWeb.CloneCopy: unknown obj type: ', typeof obj, obj);
    return obj;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CloneCopyTo = function(src, dst, ignorePropsArr) {
    for(var i1 in src)if (ignorePropsArr == undefined || ignorePropsArr == null || ignorePropsArr.indexOf(i1) === -1) dst[i1] = src[i1];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetRequestUrl = function(url, getData) {
    var requestUrl = $23b71ef8c0192a76$export$2e2bcd8739ae039.ServerBase();
    // hat die "url" schon einen Hostnamen?
    // => dann setzen
    if (url !== null && url !== undefined) {
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) requestUrl = url;
        else if (url.indexOf(requestUrl) === 0) requestUrl = url;
        else if (url.indexOf('/') === 0) requestUrl += url;
        else requestUrl += '/' + url;
    }
    // GET Parameter in URL übernehmen
    if (getData !== null && getData !== undefined) {
        requestUrl += requestUrl.indexOf('?') === -1 ? '?' : '&';
        requestUrl += $23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr(getData);
    }
    return requestUrl;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Send = function(method, url, getData, postData, parseAs, sendAs, cookie, retAsync) {
    const promiseFn = function(resolve, reject) {
        //console.log('DrDocWeb.Send', method, url, getData, postData, parseAs, sendAs);
        try {
            var requestUrl = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetRequestUrl(url, getData);
            var request = new XMLHttpRequest();
            //try {
            const openRequestFn = function() {
                // Asynchron
                request.open(method, requestUrl, retAsync === true || retAsync === undefined);
                // Synchron
                //request.open(method, requestUrl, false);
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cookie)) {
                    request.withCredentials = true;
                    //request.setRequestHeader('Access-Control-Allow-Origin', '*');
                    //request.setRequestHeader('Access-Control-Allow-Headers', 'Cookie');
                    request.setRequestHeader('Cookie', cookie);
                //console.log('DrDocWeb.Send ('+requestUrl+'): Cookie: ' + cookie);
                }
            };
            var processResponse = function(responseObj) {
                if (parseAs !== undefined && parseAs !== null && (parseAs.toLowerCase() == 'json' || parseAs.toLowerCase() == 'text/json' || parseAs.toLowerCase() == 'application/json')) return $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonToObject(responseObj.responseText); //JSON.parse(event.target.responseText));
                else return responseObj.responseText;
            };
            postData !== undefined && FormData;
            //request.setRequestHeader('Access-Control-Allow-Origin', '*');
            /*request.setRequestHeader('Referer', null);
            request.setRequestHeader('Cookie', null);
            request.setRequestHeader('Host', null);
            request.setRequestHeader('Origin', null);
            request.setRequestHeader('User-Agent', null);
    
            request.removeRequestHeader('Referer');
            request.removeRequestHeader('Cookie');
            request.removeRequestHeader('Host');
            request.removeRequestHeader('Origin');
            request.removeRequestHeader('User-Agent');*/ if (retAsync === true || retAsync === undefined) {
                //console.log('DrDocWeb.Send loading... ', event, method, url, getData, postData, parseAs, sendAs);
                if (resolve !== undefined && resolve !== null) request.addEventListener('load', function(event) {
                    //console.log('DrDocWeb.Send.onLoad', event, method, url, getData, postData, parseAs, sendAs);
                    //console.log('reponse', event);
                    if (reject !== undefined && reject !== null && event.target.status >= 400) {
                        console.log('DrDocWeb.Send.onLoad.catch status ', event.target.status);
                        reject(processResponse(event.target));
                    } else resolve(processResponse(event.target));
                });
                if (reject !== undefined && reject !== null) {
                    request.addEventListener('timeout', reject);
                    request.addEventListener('error', reject);
                    request.addEventListener('abort', reject);
                }
            }
            // POST Parameter senden
            if (postData === undefined) {
                openRequestFn();
                request.send();
            } else if (postData instanceof FormData || sendAs == 'form') {
                // Progress-Bar
                /*
                let progressBarId = 'progress-' + DrDocWeb.RandomChars(12);
                let progressBarHtml = `
                <div id="${progressBarId}" class="progress" role="progressbar" aria-label="Document File Upload" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
  <div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%;"></div>
</div>
                `;
                let progressBarModal = DrDocWeb.ModalSecondary('Upload', progressBarHtml);

                let progressbarOnChange = function (e) {
                    //console.log('Upload Progress (e): ', e);
                    const percentComplete = e ? ((e.loaded / e.total) * 100) : 0;
                    //if (e.lengthComputable) {
                    //console.log('Upload Progress: ', percentComplete);
                    document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
                    let progressBarElem = document.getElementById(progressBarId);
                    progressBarElem.setAttribute('aria-valuenow', percentComplete);
                    //}
                };
                progressbarOnChange();
                request.addEventListener('progress', progressbarOnChange);
                if (request.upload !== undefined)
                    request.upload.onprogress = progressbarOnChange;
                request.onprogress = progressbarOnChange;
                let progressBarCloseFn = function () {
                    if (progressBarModal != undefined && progressBarModal != null)
                        progressBarModal.close();
                };*/ if ($23b71ef8c0192a76$export$2e2bcd8739ae039.ModalProgress != undefined) {
                    let progressBarModal = $23b71ef8c0192a76$export$2e2bcd8739ae039.ModalProgress('Document File Upload..');
                    progressBarModal.setPercentComplete(0);
                    let progressbarOnChange = function(e) {
                        //console.log('Upload Progress (e): ', e);
                        const percentComplete = e ? e.loaded / e.total * 100 : 0;
                        progressBarModal.setPercentComplete(percentComplete);
                    };
                    request.addEventListener('progress', progressbarOnChange);
                    if (request.upload !== undefined) request.upload.onprogress = progressbarOnChange;
                    request.onprogress = progressbarOnChange;
                    let progressBarCloseFn = function() {
                        if (progressBarModal != undefined && progressBarModal != null) progressBarModal.close();
                    };
                    request.addEventListener('load', progressBarCloseFn);
                    request.addEventListener('timeout', progressBarCloseFn);
                    request.addEventListener('error', progressBarCloseFn);
                    request.addEventListener('abort', progressBarCloseFn);
                }
                openRequestFn();
                request.send(postData);
            } else if (sendAs == 'json' || sendAs == 'text/json' || sendAs == 'application/json') {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/json');
                request.send(JSON.stringify(postData));
            } else {
                openRequestFn();
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                request.send($23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectToQueryStr(postData));
            }
            if (retAsync === true || retAsync === undefined) ;
            else //Sync
            return processResponse(request);
        } catch (err) {
            if (reject !== undefined && reject !== null) {
                console.log('DrDocWeb.Send.catch 1');
                reject(err);
            } else {
                console.log('DrDocWeb.Send.catch 2');
                console.error(err);
                throw err;
            }
        }
    };
    if (retAsync === true || retAsync === undefined) //console.log('DrDocWeb.Send.Promise');
    return new Promise(promiseFn);
    else //console.log('DrDocWeb.Send.Sync');
    return promiseFn();
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet = function(url, getData, parseAs) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Send('GET', url, getData, undefined, parseAs);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.SendPost = function(url, getData, postData, parseAs) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Send('POST', url, getData, postData, parseAs);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.RandomChars = function(length) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.Random(length, 'abcdefghijklmnopqrstuvwxyz');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Random = function(length, characters) {
    let result = '';
    if (length === undefined) length = 32;
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(characters)) characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};
// Checksum
$23b71ef8c0192a76$export$2e2bcd8739ae039.ChecksumCyrb53 = function(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i1 = 0, ch; i1 < str.length; i1++){
        ch = str.charCodeAt(i1);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CheckRecursion = function() {
    // the name of the calling function 
    var fname = $23b71ef8c0192a76$export$2e2bcd8739ae039.CheckRecursion.arguments.callee.caller.name;
    // obtain the stack trace ***not cross browser***
    // tested on Firefox
    var err = new Error();
    var stack = err.stack.split('\n');
    // returns true if the calling function appears more than once
    var i1, n, cnt;
    n = stack.length;
    cnt = 0;
    for(i1 = 0; i1 < n; i1++)if (fname == stack[i1].substring(0, stack[i1].indexOf('@'))) {
        cnt++;
        if (cnt > 1) return true;
    }
    return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.Crud = function(getData) {
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet('/model/crud', getData, 'json');
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen = function(callback) {
    /*if (callback != null)
    {
        callback(null, null);
    }*/ // Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
    $23b71ef8c0192a76$export$2e2bcd8739ae039.SendGet('/node/de/test', {
        listener: 99
    }, (obj)=>{
        //console.warn('MAIN Load', e.target.responseText);
        //console.warn('MAIN Load', e);
        //Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
        if (callback != null) callback(obj, true);
        //Dataset.ListenState = true;
        //Vue.set(Dataset, 'ListenState', true);
        $23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen(callback);
    }, (obj)=>{
        //Dataset.ListenState = false;
        //Vue.set(Dataset, 'ListenState', false);
        // Bei Fehler, nach einigen Sekunden erneut versuchen.
        setTimeout(()=>{
            $23b71ef8c0192a76$export$2e2bcd8739ae039.CrudListen(callback);
        }, 1000);
        if (callback != null) callback(null, false);
        console.warn('MAIN Error', obj, callback, false);
        if ($23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError != null) $23b71ef8c0192a76$export$2e2bcd8739ae039.DefaultError(obj);
    });
};
/*DrDocWeb.DataSelect = function(data, selector)
{
    if (data === undefined || data === null)
        return [];
    
    let ret_data = [];
    data.forEach(function(itm) {
        if (selector === undefined || selector(ret_data) === true)
        ret_data.push(itm);
    });
    return ret_data;
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseBool = function(value) {
    if (value === undefined || value === null) return false;
    if (typeof value === 'bool' || typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLocaleLowerCase() === 'true' || value === '1';
    return false;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ParseInt = function(value) {
    if (value === undefined || value === null || isNaN(value)) return 0;
    if (typeof value === 'float') return value;
    if (typeof value === 'number') return value;
    //return +value;
    return parseFloat(value);
// parseInt
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ParseDateTime = function(dateStr) {
    dateStr = $23b71ef8c0192a76$export$2e2bcd8739ae039.ToIsoDateTimeStr(dateStr);
    if (dateStr === undefined) return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date)) return dateStr;
    return new Date(dateStr);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ToIsoDateTimeStr = function(dateStr) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dateStr)) return undefined;
    if (!isNaN(dateStr) && (typeof dateStr === 'date' || dateStr instanceof Date)) return dateStr.toISOString();
    // toUTCString
    if (typeof dateStr === 'number') //console.log('DrDocWeb.ToIsoDateTimeStr: typeof dateStr === number', dateStr, new Date(dateStr * 1000), new Date(dateStr * 1000), new Date(dateStr * 1000 * 100));
    return new Date(dateStr).toISOString();
    if (typeof dateStr !== 'string') {
        console.warn('DrDocWeb.ToIsoDateTimeStr / typeof dateStr !== string / ', typeof dateStr, ' / ', dateStr);
        return undefined;
    }
    let dateTimeComponents = dateStr.split(' ');
    if (dateTimeComponents.length == 2) {
        let dateComponents = dateTimeComponents[0].split('.');
        let timeComponents = dateTimeComponents[1].split(':');
        if (dateComponents.length == 3 && timeComponents.length >= 2) return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0] + 'T' + timeComponents[0] + ':' + timeComponents[0];
    } else if (dateTimeComponents.length == 1) {
        let dateComponents = dateTimeComponents[0].split('.');
        if (dateComponents.length == 3) return dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0];
    //return dateComponents[1];
    }
    //console.warn('DrDocWeb.ParseDateTime: bad date', dateStr, dateTimeComponents);
    return dateStr;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAddMulti = function(dsDate, duration_total_str) {
    for (let dauer_str of duration_total_str.split(' ')){
        if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dauer_str) || dauer_str.length < 2) continue;
        let dauer_unit = dauer_str.substring(dauer_str.length - 1);
        let dauer_num = $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseInt(dauer_str.substring(0, dauer_str.length - 1));
        dsDate = $23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAdd(dsDate, dauer_num, dauer_unit);
    }
    return dsDate;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.DateTimeAdd = function(dt, amount, dateType) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(dt)) dt = new Date();
    else if (typeof dt === 'date' || dt instanceof Date) ;
    else dt = $23b71ef8c0192a76$export$2e2bcd8739ae039.ParseDateTime(dt);
    switch(dateType.toUpperCase()){
        case 'T':
        case 'D':
        case 'DAY':
        case 'DAYS':
            return dt.setDate(dt.getDate() + amount) && dt;
        case 'W':
        case 'WEEK':
        case 'WEEKS':
            return dt.setDate(dt.getDate() + 7 * amount) && dt;
        case 'M':
        case 'MONTH':
        case 'MONTHS':
            return dt.setMonth(dt.getMonth() + amount) && dt;
        case 'Y':
        case 'J':
        case 'YEAR':
        case 'YEARS':
            return dt.setFullYear(dt.getFullYear() + amount) && dt;
        default:
            console.warn('DrDocWeb.DateTimeAdd: bad date unit: ', dateType);
            break;
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.EventFire = function(el, eventName, fn) {
    var doc = !el ? document : el.ownerDocument || document;
    //console.log('Fire Event', eventName, el);
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(eventName) && eventName.substring(0, 2) == 'on') //console.log('DrDocWeb.EventFire: mod: ', eventName, ' -> ', eventName.substring(2));
    eventName = eventName.substring(2);
    var evObj = null;
    if (document.createEvent) {
        evObj = doc.createEvent('Events'); // HTMLEvents
        // initEvent(type, bubbles, cancelable)
        evObj.initEvent(eventName, true, true); //false);
    } else {
        evObj = doc.createEventObject();
        evObj.eventType = eventName;
    }
    if (fn !== undefined && fn !== null && typeof fn === 'function') try {
        fn(evObj);
    } catch (ex) {
        console.warn('DrDocWeb.EventFire: ', el, eventName, ex);
    }
    if (document.createEvent) doc.dispatchEvent(evObj);
    else //if (doc.fireEvent)
    //doc.fireEvent('on' + eventName);
    doc.fireEvent('on' + evObj.eventType, evObj);
};
// --
// DOM
// Suche nach:
// - DrDocWeb.GetParentNode
// - DrDocWeb.FindChildElement
// - DrDocWeb.FindChildElements
// - DrDocWeb.SelectLastElementById
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement = function(sourceElement, selector, first, searchParent) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    try {
        if (typeof sourceElement === 'string') sourceElement = document.querySelectorAll(sourceElement);
    } catch  {
        console.warn('DrDocWeb.GetElement: Bad sourceElement', sourceElement, selector);
        sourceElement = document;
    }
    //if (sourceElement === document)
    //    sourceElement = document.documentElement;
    let elems = null;
    // 1. Element selbst prüfen
    if (sourceElement.matches !== undefined && typeof sourceElement.matches === 'function') {
        if (sourceElement.matches(selector) === true) //console.log('DrDocWeb.GetElement: sourceElement.matches(selector): ', selector, sourceElement);
        return sourceElement;
    }
    // 2. Children durchsuchen
    if (sourceElement.querySelectorAll !== undefined && typeof sourceElement.querySelectorAll === 'function') elems = sourceElement.querySelectorAll(selector);
    // 3. Parents durchsuchen, einschließlich dem Element selbst
    elems = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements(sourceElement, selector);
    // elem.closest() sucht nur den DOM nach oben und nicht wieder im siblingNode nach unten (nächster Ast), daher DrDocWeb.GetParentElements verwenden
    /*if (elems === undefined || elems === null || elems.length === 0) {
        // The closest() method..
        // - searches up the DOM tree for elements which matches a specified CSS selector.
        // - starts at the element itself, then the anchestors (parent, grandparent, ...) until a match is found.
        // returns null() if no match is found.

        if (sourceElement.closest !== undefined && typeof sourceElement.closest === 'function') {
            let ret = sourceElement.closest(selector);
            //if (ret)
            //console.log('DrDocWeb.GetElement: sourceElement.closest(selector): ', selector, sourceElement, ret);
            if (ret != undefined && ret != null)
                return ret;
        }
        console.log('DrDocWeb.GetElement: sourceElement.closest() nicht gefunden! Selector: ', selector, ' / sourceElement: ', sourceElement);
    }*/ if (elems === undefined || elems === null || elems.length === 0) //console.log('DrDocWeb.GetElement: Element wurde nicht gefunden! ', selector, sourceElement);
    return undefined;
    if (first === undefined && elems.length > 1) console.log('DrDocWeb.GetElement: Element wurde mehrfach gefunden! Selector: ', selector, ' / first: ', first, ' / Elements: ', elems, ' / Source: ', sourceElement);
    if (first === true || first === 1) return elems[0];
    if (first === -1) return elems[elems.length - 1];
    else return elems[elems.length - 1];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    let result = null;
    result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetChildElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) return result;
    result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements(sourceElement, selector);
    if (result !== undefined && result !== null && result.length > 0) return result;
    return [];
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    while(sourceElement !== undefined && sourceElement !== null){
        let result = sourceElement.querySelectorAll(selector);
        if (result !== undefined && result !== null && result.length > 0) return result;
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetParentElement = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    while(sourceElement !== undefined && sourceElement !== null){
        let result = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, selector, true);
        console.log('DrDocWeb.GetParentElement: selector: ', selector, ' / sourceElement: ', sourceElement, ' / result: ', result);
        if (result !== undefined && result !== null) return result;
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetChildElements = function(sourceElement, selector) {
    if (sourceElement === undefined || sourceElement === null) sourceElement = document;
    /*for (let i in sourceElement.childNodes)
    {

    }*/ return sourceElement.querySelectorAll(selector);
};
/*DrDocWeb._GetParentNode = function(sourceElement, compare)
{
    if (compare === undefined || typeof compare !== 'function')
        return undefined;
    if (sourceElement === undefined)
        sourceElement = document;

    while (sourceElement !== undefined && sourceElement !== null)
    {
        let result = compare(sourceElement);
        if (result !== undefined && result !== null && result !== false)
        {
            return sourceElement;
            //return result;
        }
        sourceElement = sourceElement.parentNode;
    }
    return undefined;
};*/ /*DrDocWeb._SelectLastElementById = function(id)
{
    var elems = document.querySelectorAll('#' + id);
    if (elems === undefined)
    return undefined;
    return elems[elems.length-1];
};*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElement = function(element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment') return undefined;
    if (attr_value === null || attr_value === undefined) return undefined;
    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true) return element;
            if (attr_comparer === undefined && elem_attr_val == attr_value) return element;
        }
    }
    for(var i1 in element.childNodes){
        let sub = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElement(element.childNodes[i1], attr_name, attr_value, attr_comparer);
        if (sub != null) return sub;
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElements = function(element, attr_name, attr_value, attr_comparer) {
    if (element === null || element === undefined || element.nodeName == '#text' || element.nodeName == '#comment') return undefined;
    if (attr_value === null || attr_value === undefined) return undefined;
    let list = [];
    if (typeof element.getAttribute === 'function') {
        let elem_attr_val = element.getAttribute(attr_name);
        if (elem_attr_val !== undefined && elem_attr_val !== null && elem_attr_val.length > 0) {
            if (attr_comparer !== undefined && attr_comparer(elem_attr_val, attr_value) === true) list = [
                element
            ];
            if (attr_comparer === undefined && elem_attr_val == attr_value) list = [
                element
            ];
        }
    }
    for(var i1 in element.childNodes){
        let sub = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindChildElements(element.childNodes[i1], attr_name, attr_value, attr_comparer);
        if (sub !== undefined && sub !== null && sub.length > 0) //if (list === undefined)
        //    list = sub;
        //else
        //{
        //list.push(...sub);
        for(let sub_i in sub)list.push(sub[sub_i]);
    }
    return list;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.WindowIsMaximized = function() {
    let isFullscreen = screen.availWidth - window.innerWidth === 0;
    return window.fullScreen === true || document.fullscreenElement != undefined || isFullscreen;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.loadCSS = function(cssFilePath, cssId, initDoc) {
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cssId) && document.getElementById(cssId) != undefined) return;
    if (initDoc) {
        console.log(document.getElementsByTagName('head'));
        console.log(document.getElementsByTagName('body'));
        var head = document.getElementsByTagName('head')[0];
        if (head == null || head == undefined) return;
        var meta = document.createElement('meta');
        meta.setAttribute('name', 'viewport');
        meta.setAttribute('content', 'width=device-width, initial-scale=1, shrink-to-fit=no');
        head.appendChild(meta);
        var meta = document.createElement('meta');
        meta.setAttribute('charset', 'utf-8');
        head.appendChild(meta);
    }
    var link = document.createElement('link');
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(cssId)) link.id = cssId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = cssFilePath;
    //link.media = 'all';
    head.appendChild(link);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.setInnerHTML = function(elm, html, callback) {
    var doc = elm.ownerDocument || document;
    try {
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(html) && html.indexOf('<') == -1 && html.indexOf('>') == -1) elm.innerText = html;
        else elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach((oldScript)=>{
            const newScript = doc.createElement("script");
            Array.from(oldScript.attributes).forEach((attr)=>newScript.setAttribute(attr.name, attr.value));
            newScript.appendChild(doc.createTextNode(oldScript.innerHTML));
            if (callback != undefined) {
                newScript.onload = callback;
                newScript.onreadystatechange = function() {
                    if (this.readyState == 'complete') callback();
                };
            }
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
    } catch (ex) {
        console.warn('DrDocWeb.setInnerHTML: HTML konnte nicht geparst werden', html, elem, ex);
    }
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize = function(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr) {
    if (iframe != undefined && iframe != null) {
        if (iframe.contentWindow != undefined && iframe.contentWindow != null && iframe.contentWindow.document != undefined && iframe.contentWindow.document != null) {
            //console.log('DrDocWeb.IframeAutosize: SetSize (1): ', iframe.contentWindow.document.readyState);
            // Erneut ausführen, bis das Dokument geladen ist
            if (iframe.contentWindow.document.readyState !== 'complete') {
                //console.log('DrDocWeb.IframeAutosize: iframe.contentWindow.document.readyState: ', iframe.contentWindow.document.readyState);
                setTimeout(function() {
                    $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
                }, 200);
                //DrDocWeb.IframeAutosize(iframe, selector);
                return;
            }
            if (lastWidth == undefined || lastWidth === null) iframe.width = '100%';
            //iframe.height = '400px';
            //iframe.style.width = '100%';
            //iframe.style.width = '100px';
            //iframe.style.height = '1000px';
            let doc = iframe.contentWindow.document;
            let maxW = 0;
            let maxH = 0; //iframe.height;
            if (doc.body != undefined && doc.body != null) {
                if (doc.body.scrollWidth != undefined) maxW = Math.max(maxW, doc.body.scrollWidth);
                if (doc.body.scrollHeight != undefined) maxH = Math.max(maxH, doc.body.scrollHeight);
            }
            if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(selector)) {
                let selectorElemArr = doc.querySelectorAll(selector);
                //console.log('DrDocWeb.IframeAutosize: selector: ', selector, selectorElem);
                if (selectorElemArr != undefined && selectorElemArr != null) selectorElemArr.forEach(function(selectorElem) {
                    if (selectorElem != undefined && selectorElem != null) {
                        //if (selectorElem.width != undefined)
                        //    maxW = Math.max(maxW, selectorElem.width);
                        if (selectorElem.scrollWidth != undefined) maxW = Math.max(maxW, selectorElem.scrollWidth);
                        //if (selectorElem.height != undefined)
                        //    maxH = Math.max(maxH, selectorElem.height);
                        if (selectorElem.scrollHeight != undefined) maxH = Math.max(maxH, selectorElem.scrollHeight);
                    }
                });
            //console.log('DrDocWeb.IframeAutosize: Size: ', maxW, ' x ', maxH);
            }
            if (doc.documentElement != undefined && doc.documentElement != null) {
                if (doc.documentElement.scrollWidth != undefined) maxW = Math.max(maxW, doc.documentElement.scrollWidth);
                if (doc.documentElement.scrollHeight != undefined) maxH = Math.max(maxH, doc.documentElement.scrollHeight);
            }
            /*if (iframe.contentWindow.width != undefined)
                maxW = Math.max(maxW, iframe.contentWindow.width);
            if (iframe.contentWindow.height != undefined)
                maxH = Math.max(maxH, iframe.contentWindow.height);*/ //console.log('DrDocWeb.IframeAutosize: SetSize (2): ', iframe.src, maxH, doc.body.scrollHeight, doc.documentElement.scrollHeight, iframe.contentWindow.height); //, doc);
            /*if (maxH > 150) {
                //iframe.width = maxW + 'px';
                iframe.height = maxH + 'px';

                // Wenn auch Inhalte bereits geladen wurden, nur alle 5 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 5000);
            }
            else {
                // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
                setTimeout(function () {
                    DrDocWeb.IframeAutosize(iframe, selector, false);
                }, 1000);
            }*/ // Wenn auch Inhalte noch nicht geladen wurden, alle 0,2 Sek. Größe erneut anpassen
            setTimeout(function() {
                $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, maxW, maxH, maxWidthStr, maxHeightStr);
            }, 1000);
            //console.log('DrDocWeb.IframeAutosize: Size: Neu: ', maxW, ' x ', maxH, ' / alt: ', lastWidth, ' x ', lastHeight, ' / max: ', maxWidthStr, 'x', maxHeightStr);
            if (lastWidth == undefined || maxW > lastWidth + 150) {
                iframe.style.width = maxW + 0 + 'px';
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(maxWidthStr)) iframe.style.maxWidth = maxWidthStr;
                else iframe.style.maxWidth = maxW + 0 + 'px';
            }
            if (lastHeight == undefined || maxH > lastHeight + 150) {
                iframe.style.height = maxH + 0 + 'px';
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(maxHeightStr)) iframe.style.maxHeight = maxHeightStr;
                else iframe.style.maxHeight = maxH + 0 + 'px';
            }
            iframe.contentWindow.document.documentElement.style.overflow = 'hidden';
        } else {
            //console.log('DrDocWeb.IframeAutosize: Init (0): ', iframe.src);
            if (iframe._hasLoadEvent === true) return;
            iframe._hasLoadEvent = true;
            iframe.addEventListener('load', function(e) {
                //console.log('DrDocWeb.IframeAutosize: onLoad (1, root): ', iframe.src);
                $23b71ef8c0192a76$export$2e2bcd8739ae039.IframeAutosize(iframe, selector, lastWidth, lastHeight, maxWidthStr, maxHeightStr);
            });
        }
    } else ;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftWindowBoundry = function(wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenLeft) return wnd.screenLeft;
    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenX) return wnd.screenX;
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopWindowBoundry = function(wnd) {
    // In Internet Explorer window.screenLeft is the window's left boundry
    if (wnd.screenTop) return wnd.screenTop;
    // In Firefox window.screenX is the window's left boundry
    if (wnd.screenY) return wnd.screenY;
    return 0;
};
// // Find Left Boundry of the Screen/Monitor
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftScreenBoundry = function(wnd) {
    let left = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindLeftWindowBoundry(wnd);
    // Check if the window is off the primary monitor in a positive axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------   1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    if (left > wnd.screen.width) return left - (left - wnd.screen.width);
    // Check if the window is off the primary monitor in a negative axis
    // X,Y                  X,Y                    S = Screen, W = Window
    // 0,0  ----------  -1280,0  ----------
    //     |          |         |  ---     |
    //     |          |         | | W |    |
    //     |        S |         |  ---   S |
    //      ----------           ----------
    // This only works in Firefox at the moment due to a bug in Internet Explorer opening new windows into a negative axis
    // However, you can move opened windows into a negative axis as a workaround
    if (left < 0 && left > wnd.screen.width * -1) return wnd.screen.width * -1;
    // If neither of the above, the monitor is on the primary monitor whose's screen X should be 0
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopScreenBoundry = function(wnd) {
    let top = $23b71ef8c0192a76$export$2e2bcd8739ae039.FindTopWindowBoundry(wnd);
    if (top > wnd.screen.height) return top - (top - wnd.screen.height);
    if (top < 0 && top > wnd.screen.height * -1) return wnd.screen.height * -1;
    return 0;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.ObjectForEachSorted = function(obj, action) {
    var keys = Object.keys(obj);
    var len = keys.length;
    keys.sort();
    for(i = 0; i < len; i++)action(keys[i], obj[keys[i]]);
};
// --
// Cookie Funktionen
$23b71ef8c0192a76$export$2e2bcd8739ae039.SetCookie = function(cname, cvalue, exdays, path) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "Expires=" + d.toUTCString();
    //console.log('DrDocWeb.SetCookie(' + cname + ', ' + cvalue + ')', '\r\n', document.cookie);
    document.cookie = $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cname) + "=" + $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cvalue) + "; " + expires + "; Path=" + (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(path) ? path : '/') + "; SameSite=Lax;"; //SameSite=None;"; //samesite=lax;"; // SameSite=Lax;"; //SameSite=None; Secure";
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetCookie = function(cname, defaultValue) {
    let name = $23b71ef8c0192a76$export$2e2bcd8739ae039.UrlEncode(cname) + "=";
    let ret = '';
    //let decodedCookie = document.cookie);
    if (document.cookie) {
        let ca = document.cookie.split(';');
        for(let i1 = 0; i1 < ca.length; i1++){
            let c = ca[i1];
            while(c.charAt(0) == ' ')c = c.substring(1);
            if (c.indexOf(name) === 0) {
                ret = decodeURIComponent(c.substring(name.length, c.length));
                break;
            }
        }
    //console.log('Cookie... ', ca);
    }
    if (defaultValue === undefined) defaultValue = '';
    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(ret) ? defaultValue : ret;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.GetCookiePrefix = function(namePrefix) {
    //let name = DrDocWeb.UrlEncode(cname) + "=";
    let ret = [];
    //let decodedCookie = document.cookie);
    if (document.cookie) {
        let ca = document.cookie.split(';');
        for(let i1 = 0; i1 < ca.length; i1++){
            let c = ca[i1];
            while(c.charAt(0) == ' ')c = c.substring(1);
            let iOfEq = c.indexOf('=');
            if (iOfEq < 0) continue;
            let name = c.substring(0, iOfEq);
            if (name.indexOf(namePrefix) === 0) {
                let value = decodeURIComponent(c.substring(iOfEq + 1));
                console.log('DrDocWeb.GetCookiePrefix: Cookie gefunden! ', name, '|', value, '|');
                ret.push({
                    name: name,
                    value: value
                });
            }
        }
    //console.log('Cookie... ', ca);
    }
    //console.log('DrDocWeb.GetCookie(' + cname + ', ' + defaultValue + ') = ', ret, '\r\n', document.cookie);
    return ret;
};
// ---
// Tree-View
// Root Element (UL): .tree
// Item Element (LI): .tree-item (ggf.: .tree-item-action)
// Item Element Container (UL): (ggf.: .tree-sub .tree-active)
$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeView = function() {
    //console.log('DrDocWeb.TreeView: init');
    var treeRootElemArr = document.querySelectorAll(".tree");
    if (treeRootElemArr != undefined && treeRootElemArr != null && treeRootElemArr.length > 0) for(let i1 = 0; i1 < treeRootElemArr.length; i1++)$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeViewIntern(treeRootElemArr[i1]);
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.TreeViewIntern = function(treeRootElem) {
    /*if (treeRootElem._tree_initialized === true)
    {
        console.log('DrDocWeb.TreeViewIntern (bereits initialisiert): ', treeRootElem);
        return;
    }
    treeRootElem._tree_initialized = true;
    console.log('DrDocWeb.TreeViewIntern: init', treeRootElem);*/ var treeToggler = treeRootElem.querySelectorAll(".tree-item");
    //console.log('DrDocWeb.TreeViewIntern: .tree-item"*: ', treeToggler, '/', treeRootElem);
    if (treeToggler == undefined || treeToggler == null || treeToggler.length == 0) {
        treeToggler = treeRootElem.childNodes;
        //console.log('DrDocWeb.TreeViewIntern: >*: ', treeToggler, '/', treeRootElem);
        if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) for(let i1 = 0; i1 < treeToggler.length; i1++){
            let liElem = treeToggler[i1];
            if (!liElem.classList) continue;
            liElem.classList.add('tree-item');
            let ulElem = liElem.querySelector("ul");
            if (ulElem) ulElem.classList.add('tree-sub');
        }
    }
    treeToggler = treeRootElem.querySelectorAll(".tree-item");
    if (treeToggler != undefined && treeToggler != null && treeToggler.length > 0) {
        //console.log('DrDocWeb.TreeViewIntern: ', treeToggler);
        let updateTreeElem = function(liElem) {
            //liElem.classList.add("tree-caret-item");
            let ulElem = liElem.querySelector(".tree-sub");
            // wenn kein .tree-sub gefunden wurde, das erste "ul" finden
            if (ulElem == null || ulElem == undefined) {
                ulElem = liElem.querySelector("ul");
                if (ulElem) ulElem.classList.add('tree-sub');
            }
            //if (ulElem == null || ulElem == undefined)
            //    ulElem = liElem.querySelector("*");
            if (ulElem) {
                if (ulElem.classList.contains('tree-active')) liElem.classList.add("tree-caret-down");
                else liElem.classList.remove("tree-caret-down");
            } else ;
        };
        for(let i1 = 0; i1 < treeToggler.length; i1++){
            let liElem = treeToggler[i1];
            if (!liElem.classList) continue;
            updateTreeElem(liElem);
            //console.log('Tree, LI: ', liElem.firstChild, liElem.querySelector("*"), liElem.querySelector("span"), liElem.childNodes[0]);
            let onClick = function(e) {
                //let liElem = treeToggler[i]; //DrDocWeb.GetElement(liElem, 'li', true);
                // nur Event ausführen, wenn das OnClick Target passt: als das selbe Element oder ein direktes Child ist
                if (e.target !== liElem && e.target.parentNode !== liElem && !e.target.classList.contains('tree-item-action')) {
                    console.log('DrDocWeb.TreeViewIntern: onClick: e.target !== liElem, ', e, e.target, liElem);
                    return;
                }
                //console.log('DrDocWeb.TreeViewIntern: onClick: ', liElem);
                //let ulElem = DrDocWeb.GetElement(liElem, 'ul', true);
                let ulElem = liElem.querySelector(".tree-sub");
                /*if (ulElem == null || ulElem == undefined)
                {
                    ulElem = liElem.querySelector("ul");
                    if (ulElem)
                        ulElem.classList.add('tree-sub');
                }*/ //if (ulElem == null || ulElem == undefined)
                //    ulElem = liElem.querySelector("*");
                if (ulElem) ulElem.classList.toggle("tree-active");
                updateTreeElem(liElem);
            };
            //liElem.addEventListener("click", onClick);
            let actionElem = null;
            if (actionElem == null || actionElem == undefined) actionElem = liElem.querySelector(".tree-item-action");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("li");
            //if (actionElem == null || actionElem == undefined)
            //    actionElem = liElem.querySelector("*");
            if (actionElem == null || actionElem == undefined) // Trigger für Action darf nicht direkt das "li"-Element sein, sonst wird beim Click alle darunter sgeschlossen
            actionElem = liElem;
            if (actionElem != undefined && actionElem != null) {
                if (actionElem.__tree_onClick != undefined) {
                    actionElem.removeEventListener("click", actionElem.__tree_onClick);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, true);
                    actionElem.removeEventListener("click", actionElem.__tree_onClick, false);
                }
                actionElem.__tree_onClick = onClick;
                actionElem.addEventListener("click", onClick, false);
            } else console.log('DrDocWeb.TreeViewIntern: no action Element found: ', liElem, actionElem);
        }
    }
};
// ---
$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode = function(str) {
    return str.replace(/["\\]/g, '\\$&');
};
// ---
$23b71ef8c0192a76$export$2e2bcd8739ae039.DataGroup = function(data, selector_arr, emptyKeyValue, selector_i) {
    if (selector_i === undefined || selector_i < 0) selector_i = 0;
    if (selector_i >= selector_arr.length) return undefined;
    let ret_data = {};
    if (data !== undefined && data !== null) {
        //data.forEach(function (itm) {
        for(let data_key in data){
            let itm = data[data_key];
            let key = selector_arr[selector_i](itm);
            let key_arr = null;
            // "itm" in "ret_data" einsortieren
            // Wenn key ein Array ist, für jedes Element einzeln einsortieren
            if (key != undefined && key != null && Array.isArray(key)) {
                if (key.length === 0) key_arr = [
                    ''
                ];
                else key_arr = key;
            } else key_arr = [
                key
            ];
            for (let key_itm of key_arr){
                // Default Key setzen, falls leer
                if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(key_itm) && !$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(emptyKeyValue)) key_itm = emptyKeyValue;
                if (ret_data[key_itm] === undefined) ret_data[key_itm] = [];
                //console.log('DrDocWeb.DataGroup: key_arr: ', key_itm, ': ', ret_data[key_itm]);
                if (ret_data[key_itm].indexOf(itm) === -1) ret_data[key_itm].push(itm);
            }
        }
        if (selector_i + 1 < selector_arr.length) for(let key in ret_data)ret_data[key] = $23b71ef8c0192a76$export$2e2bcd8739ae039.DataGroup(ret_data[key], selector_arr, emptyKeyValue, selector_i + 1);
    }
    //console.log('DrDocWeb.DataGroup: ', ret_data);
    return ret_data;
};
// ---
// KVP / Key-Value-Pair
// DrDocWeb.kvp_get(this, 'rootNamespace-1', 'search', 'field_')
// DrDocWeb.kvp_get(sourceElement, 'rootNamespace-1', 'search', 'field_', searchData, true);
// data-kvp-namespace="rootNamespace-1" data-kvp-key="Feld1" data-kvp-search="Test GmbH" data-kvp-value2="Test"
// => { 'field_Feld1': 'Test GmbH', field_value2: 'Test' }
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR = 'data-kvp';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-namespace';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_KEY = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-key';
$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_VALUE = $23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-value';
$23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_get = function(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement == undefined || sourceElement == null) return;
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(valueName)) valueName = 'value';
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(returnKeyPrefix)) returnKeyPrefix = '';
    if (obj == undefined || obj == null) obj = {};
    //var rootElement = DrDocWeb.IsNullOrEmpty(selector) ? null : DrDocWeb.GetElement(sourceElement, selector);
    if (strictParentHierarchy) $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    else {
        let elemList = document.querySelectorAll(`[${$23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE}="${$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) for (let elem1 of elemList)$23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(elem1, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    }
    //let elemNodeIgnoreList = [];
    //DrDocWeb.kvp_getInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);
    //console.log('DrDocWeb.kvp_get: root: ', obj);
    return obj;
};
/*DrDocWeb.kvp_getInternal = function (sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList) {
    if (elemNodeIgnoreList.indexOf(sourceElement) >= 0)
        return;
    elemNodeIgnoreList.push(sourceElement);

    if (strictHierarchy) {
        // Strikt suchen
        DrDocWeb.kvp_getRecursiveInternal(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, searchParent, elemNodeIgnoreList);
    }
    else {
        let elemList = document.querySelectorAll(`[${DrDocWeb.KVP_ATTR_NAMESPACE}="${DrDocWeb.SelectorAttributeEncode(rootNamespace)}"]`);
        if (elemList != undefined && elemList != null) {
            for (let elem of elemList) {
                DrDocWeb.kvp_getRecursiveInternal(elem, rootNamespace, valueName, returnKeyPrefix, obj, strictHierarchy, false, elemNodeIgnoreList);
            }
        }
    }
}*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal = function(sourceElement, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy) {
    if (sourceElement.getAttribute !== undefined && typeof sourceElement.getAttribute === 'function') {
        let key = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_KEY);
        // key vorhanden?
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(key)) {
            let namespace = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR_NAMESPACE);
            // Namespace prüfen
            if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(namespace) && $23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(rootNamespace) || namespace === rootNamespace) {
                // data-kvp-<valueName>="..."
                let value = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.KVP_ATTR + '-' + valueName.toLowerCase());
                if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(value)) obj[returnKeyPrefix + key] = value;
            }
        }
    }
    //if (rootElement === sourceElement)
    //    return;
    if (strictParentHierarchy) // Rekursive über Parent Node durchlaufen
    {
        if (sourceElement.parentNode != null && sourceElement.parentNode != undefined) $23b71ef8c0192a76$export$2e2bcd8739ae039.kvp_getRecursiveInternal(sourceElement.parentNode, rootNamespace, valueName, returnKeyPrefix, obj, strictParentHierarchy);
    }
};
// ---
// Drag and Drop
/*
+CSS:
[data-drag]
{
    cursor: pointer;
    user-select: none;
}
.drag-active[data-drag]
{
    border-color: $gray-500;
    border-width: 1px;
    border-style: solid;
}

+HTML:
<ul data-drag-value="value">
    <li data-drag="{{$_this.ID_Name}}" data-drag-value="apple" data-drag-action="copy,move,copyMove,link">Apples</li>
    <li data-drag="{{$_this.ID_Name}}">Oranges</li>
    <li data-drag="{{$_this.ID_Name}}">Bananas</li>
    <li data-drag="{{$_this.ID_Name}}">Strawberries</li>
</ul>
<div data-drag-action="drop">

DrDocWeb.dnd_init(elem)
DrDocWeb.dnd_getValue(elem)
*/ $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR = 'data-drag';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_DROP = 'data-drop';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-value';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-action';
$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_TRIGGER = $23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR + '-trigger';
//DrDocWeb.DND_ATTR_IGNORE = DrDocWeb.DND_ATTR + '-ignore';
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected = {};
// Initialisiert alle Elemente mit dem Attribut data-drag="Name"
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_init = function(sourceElement) {
    let selector = `[${$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR}]`;
    let arr = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElements(sourceElement, selector);
    //console.log('dnd_init: ', arr);
    for (let elem1 of arr)$23b71ef8c0192a76$var$dnd_initElement(elem1);
/*for (let elem of DrDocWeb.GetElements(sourceElement, `[${DrDocWeb.DND_ATTR_IGNORE}]`)) {
        if (DrDocWeb.ParseBool(elem.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
            elem.draggable = false;

            elem.addEventListener('dragstart', function (e) {
                console.log('DND: Disable: Start: ', e.targer, elem);
                e.preventDefault();
                return false;
            });
        }
    }*/ };
function $23b71ef8c0192a76$var$dnd_getDragDropEvent(type, dataTransfer) {
    var dragDropEvent = new DragEvent(type);
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dataTransfer);
    Object.defineProperty(dragDropEvent.constructor.prototype, 'dataTransfer', dataTransfer);
    dragDropEvent['dataTransfer'] = dataTransfer;
    //console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',  dragDropEvent.dataTransfer.getData('Text'));
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', dragDropEvent);
    return dragDropEvent;
}
// Drag n Drop Element initialisieren
function $23b71ef8c0192a76$var$dnd_initElement(sourceElement, name) {
    if (sourceElement == undefined || sourceElement == null) return;
    // nur einmal initialisieren
    if (sourceElement._dnd_initialized === true) return;
    sourceElement._dnd_initialized = true;
    if (typeof sourceElement.getAttribute !== 'function') return;
    //if (DrDocWeb.IsNullOrEmpty(name))
    name = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR);
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(name)) return;
    // prüfen, ob das Draggable Element ein anderes Trigger Element hat
    let triggerElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.GetElement(sourceElement, `[${$23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_TRIGGER}="${$23b71ef8c0192a76$export$2e2bcd8739ae039.SelectorAttributeEncode(name)}"]`, true);
    if (triggerElement != undefined && triggerElement != null) {
        //console.log('DND Init: User Trigger Element ', triggerElement, ' for source elem ', sourceElement);
        let dragAction = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        } else {
            // Element als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
            sourceElement.addEventListener('dragstart', function(e) {
                //console.log('dragstart: ', e.target, e);
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/ $23b71ef8c0192a76$var$dnd_dragStart(name, e);
            });
            // Element als Draggable markieren
            triggerElement.addEventListener('mousedown', function(e) {
                e.preventDefault();
                sourceElement.draggable = true;
                sourceElement.setAttribute('draggable', 'true');
                //setTimeout(function () {
                //    DrDocWeb.EventFire(sourceElement, 'mousedown');
                //    DrDocWeb.EventFire(sourceElement, 'dragstart');
                //}, 100);
                //DrDocWeb.EventFire(sourceElement, 'dragstart');
                /*var dragDataTransfer = {
                    data: {},
                    setData: function(type, value) { this.data[type] = value; },
                    getData: function(type) { return this.data[type] }
                 };

                 dragDataTransfer.setData('Text', 'foo....................');
                 var dragstaEv = dnd_getDragDropEvent('dragstart', dragDataTransfer);
                 sourceElement.dispatchEvent(dragstaEv);*/ return false;
            });
        }
        sourceElement.addEventListener('dragover', function(e) {
            $23b71ef8c0192a76$var$dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/ sourceElement.addEventListener('drop', function(e) {
            $23b71ef8c0192a76$var$dnd_drop(name, e);
        });
    } else {
        let dragAction = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
        //console.log('dnd_initElement: ', name);
        if (dragAction == 'false' || dragAction == 'none' || dragAction == 'drop' || dragAction == 'dropzone') {
            // Nur als Dropzone
            // Element nicht als Draggable markieren
            sourceElement.draggable = false;
            sourceElement.setAttribute('draggable', 'false');
        } else {
            // Element als Draggable markieren
            sourceElement.draggable = true;
            sourceElement.setAttribute('draggable', 'true');
            sourceElement.addEventListener('dragstart', function(e) {
                /*console.log('dragstart: ', DrDocWeb.DND_ATTR_IGNORE, ' / ', e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE), ' / ', e.target, e);
                if (DrDocWeb.ParseBool(e.target.getAttribute(DrDocWeb.DND_ATTR_IGNORE))) {
                    console.log('DRAG n Drop Cancel: ', e.target);
                    e.preventDefault();
                    return false;
                }*/ $23b71ef8c0192a76$var$dnd_dragStart(name, e);
            });
        }
        sourceElement.addEventListener('dragover', function(e) {
            $23b71ef8c0192a76$var$dnd_dragOver(name, e);
        });
        /*sourceElement.addEventListener('dragend', function (e) {
            dnd_dragEnd(name, e);
        });*/ sourceElement.addEventListener('drop', function(e) {
            $23b71ef8c0192a76$var$dnd_drop(name, e);
        });
    }
}
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem = function(name, sourceElement, getContainer) {
    if (typeof sourceElement.hasAttribute === 'function') {
        if (sourceElement.hasAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR) && name == sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR)) /*if (getContainer === true) {
                let containerElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
                if (containerElement != undefined && containerElement != null) {
                    //console.log('DrDocWeb.dnd_getElem: Container, ', DrDocWeb.DND_ATTR, name, sourceElement, ' => ', containerElement);
                    return containerElement;
                }
            }*/ //console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR, name, sourceElement);
        return sourceElement;
    /*if (sourceElement.hasAttribute(DrDocWeb.DND_ATTR_DROP) && name == sourceElement.getAttribute(DrDocWeb.DND_ATTR_DROP)) {
            console.log('DrDocWeb.dnd_getElem: ', DrDocWeb.DND_ATTR_DROP, name, sourceElement);
            return sourceElement;
        }*/ }
    let elemTmp = sourceElement.parentNode;
    if (elemTmp !== undefined && elemTmp !== null) {
        let parent = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, elemTmp, getContainer);
        if (parent !== undefined && parent !== null) return parent;
    }
    //let selector = `[${DrDocWeb.DND_ATTR}="${name}"]`;
    //return DrDocWeb.GetElement(sourceElement, selector, true);
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem = function(sourceElement) {
    if (sourceElement != undefined && sourceElement != null) {
        if (typeof sourceElement.hasAttribute === 'function' && sourceElement.hasAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE)) return sourceElement;
        let elemTmp = sourceElement.parentNode;
        if (elemTmp !== undefined && elemTmp !== null) {
            let parent = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem(elemTmp);
            if (parent !== undefined && parent !== null) return parent;
        }
    }
    return undefined;
};
$23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValue = function(sourceElement) {
    sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getValueElem(sourceElement);
    return sourceElement != undefined && sourceElement != null && typeof sourceElement.getAttribute === 'function' ? sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_VALUE) : '';
};
// The user starts to drag an element
function $23b71ef8c0192a76$var$dnd_dragStart(name, e) {
    if (!e) return;
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    let sourceElementTrigger = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, false);
    if (!sourceElement) return;
    /*
    // Drag n Drop Container und Trigger Element unterscheiden sich
    if (sourceElementTrigger !== sourceElement)
    {
        console.log('DND: Drag n Drop Container und Trigger Element unterscheiden sich: ', sourceElementTrigger, sourceElement);
        // sourceElement.draggable = true;
        // Container Element initialisieren
        dnd_initElement(sourceElement, name);
        e.preventDefault();
        // "dragstart" erneut für Container Element ausführen
        setTimeout(function(){
            DrDocWeb.EventFire(sourceElement, 'dragstart', function(e2){
        console.log('DND: Drag n Drop Container', ' / dragstart fired', e2);
            });
        }, 100);
        return false;
    }
    console.log('DND: Drag n Drop Start', sourceElementTrigger, sourceElement);
    */ //let moveElement = DrDocWeb.GetElement(sourceElement, `[${DrDocWeb.DND_ATTR}-container="${DrDocWeb.SelectorAttributeEncode(name)}"]`, true);
    //if (moveElement != undefined && moveElement != null) {
    //    sourceElement = moveElement;
    //}
    sourceElement.classList.add('drag-active');
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations
    //console.log('dnd_dragStart: ', sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);
    let actionStr = sourceElement.getAttribute($23b71ef8c0192a76$export$2e2bcd8739ae039.DND_ATTR_ACTION);
    if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(actionStr)) //console.log('dnd_dragStart: effectAllowed: ', actionStr);
    e.dataTransfer.effectAllowed = actionStr;
    else e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', null);
    sourceElement.dnd = {
        sourceElement: sourceElement,
        sourceElementParent: sourceElement.parentNode,
        targetElement: null,
        targetElementParent: null,
        previousElementSibling: sourceElement.previousElementSibling,
        nextElementSibling: sourceElement.nextElementSibling,
        effectAllowed: e.dataTransfer.effectAllowed
    };
    //sourceElement.style.cursor = 'move';
    //sourceElement.style.backgroundColor = 'green';
    $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = sourceElement;
}
// A dragged element is over the drop target
// The ondragover event specifies where the dragged data can be dropped.
function $23b71ef8c0192a76$var$dnd_dragOver(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) //console.log('dnd_dragOver: DrDocWeb.dnd_selected[name] == null: ', name);
    return;
    e.preventDefault();
    /*let sourceElement = null;
    if (e.target._dnd_elem !== undefined) {
        sourceElement = e.target._dnd_elem;
    }
    else {
        sourceElement = DrDocWeb.dnd_getElem(name, e.target, true);
        e.target._dnd_elem = sourceElement;
    }*/ let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name];
    let targetElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    if (sourceElement == null || sourceElement == undefined) return;
    // Effekt setzen für Cursor Symbol
    if (sourceElement.dnd != undefined && !$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(sourceElement.dnd.effectAllowed)) e.dataTransfer.dropEffect = sourceElement.dnd.effectAllowed;
    // Element beim Drag and Drop einsortieren
    //if (DrDocWeb.IsNullOrEmpty(e.dataTransfer.effectAllowed) || e.dataTransfer.effectAllowed == 'move') {
    /*try {
        //console.log('dnd_dragOver: ', sourceElement, sourceElement.nextElementSibling);
        if (dnd_dragOver_isBeforeInternal(DrDocWeb.dnd_selected[name], sourceElement)) {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement);
        } else {
            sourceElement.parentNode.insertBefore(DrDocWeb.dnd_selected[name], sourceElement.nextElementSibling);
        }
    } catch { }*/ /*}
    else {
        //console.log('dnd_dragOver: effectAllowed: ', e.dataTransfer.effectAllowed);
        //var dt =  e.originalEvent.dataTransfer;
        //dt.dropEffect = e.dataTransfer.effectAllowed;
        //e.dataTransfer.dropEffect = e.dataTransfer.effectAllowed;
        //e.preventDefault();
    }*/ // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined) {
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null) sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }
}
function $23b71ef8c0192a76$var$dnd_dragOver_isBeforeInternal(el1, el2) {
    if (!el1 || !el2) return false;
    let cur = null;
    if (el2.parentNode === el1.parentNode) for(cur = el1.previousElementSibling; cur; cur = cur.previousElementSibling){
        if (cur === el2) return true;
    }
    return false;
}
// A dragged element is dropped on the target
// onDrop wird VOR onDragEnd aufgerufen
function $23b71ef8c0192a76$var$dnd_drop(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) //console.log('dnd_drop: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
    return;
    //console.log('dnd_drop: e: ', name, DrDocWeb.dnd_selected[name], e);
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name];
    if (sourceElement == undefined || sourceElement == null) //console.log('dnd_drop: sourceElement == null: ', name, e.target);
    return;
    let targetElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    // Call preventDefault() to prevent the browser default handling of the data (default is open as link on drop)
    e.preventDefault();
    sourceElement.classList.remove('drag-active');
    // Ziel Parent Element setzen
    /*if (sourceElement.dnd != undefined)
    {
        sourceElement.dnd.targetElement = sourceElement;

        if (sourceElement.parentNode != undefined && sourceElement.parentNode != null)
            sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    }*/ if (sourceElement.dnd != undefined) {
        // In Target einsortieren
        if (!$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed == 'move') try {
            if ($23b71ef8c0192a76$var$dnd_dragOver_isBeforeInternal($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement)) targetElement.parentNode.insertBefore($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement);
            else targetElement.parentNode.insertBefore($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name], targetElement.nextElementSibling);
        } catch  {}
        // Ziel Parent Element setzen
        if (targetElement != undefined && targetElement != null) {
            e.target.dnd = sourceElement.dnd;
            targetElement.dnd = sourceElement.dnd;
            sourceElement.dnd.targetElement = targetElement;
            if (targetElement.parentNode != undefined && targetElement.parentNode != null) sourceElement.dnd.targetElementParent = targetElement.parentNode;
        }
    }
    //console.log('dnd_drop: ', name, ' / Target: ', e.target, ' / Source: ', sourceElement, ' / DND: ', sourceElement.dnd);
    //console.log('dnd_drop: ', name, ' / DND: ', sourceElement.dnd);
    // Source Element zurücksetzen
    //setTimeout(function () {
    $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = null;
//}, 5);
}
// onDragEnd wird NACH onDrop aufgerufen
function $23b71ef8c0192a76$var$dnd_dragEnd(name, e) {
    if ($23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] == null) // console.log('dnd_dragEnd: DrDocWeb.dnd_selected[name] == null: ', name, e.target);
    return;
    let sourceElement = $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_getElem(name, e.target, true);
    if (!sourceElement) return;
    sourceElement.classList.remove('drag-active');
    //console.log('dnd_dragEnd: ', e, sourceElement, ' Prev: ', sourceElement.previousElementSibling, ' / Next: ', sourceElement.nextElementSibling);
    // Ziel Parent Element setzen
    if (sourceElement.dnd != undefined && sourceElement.parentNode != undefined && sourceElement.parentNode != null) sourceElement.dnd.targetElementParent = sourceElement.parentNode;
    // mit Timeout ausführen, damit "e.target" auf das Ziel weist
    //setTimeout(function(){
    // Element wieder an Quelle zurückschieben, wenn effectAllowed z.B. 'copy' ist
    // aber nur wenn: Element beim Drag and Drop einsortiert wurde
    /*if (sourceElement.dnd != undefined && !DrDocWeb.IsNullOrEmpty(sourceElement.dnd.effectAllowed) && sourceElement.dnd.effectAllowed != 'move') {
        //console.log('dnd_dragEnd: dnd 1 copy: ', sourceElement.dnd.effectAllowed, e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
        if (sourceElement.parentNode !== sourceElement.dnd.sourceElementParent) {
            sourceElement.parentNode.removeChild(sourceElement);
            sourceElement.dnd.sourceElementParent.appendChild(sourceElement);
        }
    }
    else {
        // move
        //console.log('dnd_dragEnd: dnd 2 move: ', e.target===sourceElement, sourceElement.dnd.sourceElement===sourceElement, sourceElement);
    }*/ //}, 100);
    // Source Element zurücksetzen
    setTimeout(function() {
        $23b71ef8c0192a76$export$2e2bcd8739ae039.dnd_selected[name] = null;
    }, 5);
}
// --
/*

            function mergeNode(node_new, node_old) {
                    if (node_new.childNodes === undefined && node_old.childNodes === undefined) {
                        //console.log('mergeNode undefined', node_new, node_old);
                        if (node_new.isSameNode(node_old))
                            console.log('mergeNode undefined', node_new, node_old);
                        return true;
                    }
    
                    if (node_new.childNodes.length != node_old.childNodes.length) {
                        console.log('mergeNode Length', node_new.childNodes.length, node_old.childNodes.length, node_new.childNodes, node_old.childNodes);
                        return false;
                    }
    
                    if (node_new.childNodes !== undefined && node_old.childNodes !== undefined) {
                        for (let i in node_new.childNodes) {
                            if (mergeNode(node_new.childNodes[i], node_old.childNodes[i]) === false)
                                return false;
                        }
                        return true;
                    }
    
                    return false;
                }
*/ // ---
// Math Helper
$23b71ef8c0192a76$export$2e2bcd8739ae039.Math_Median = function(values) {
    if (values.length === 0) return 0;
    values.sort(function(a, b) {
        return a - b;
    });
    var half = Math.floor(values.length / 2);
    if (values.length % 2) return values[half];
    return (values[half - 1] + values[half]) / 2.0;
};
// --
// String Funktionen
$23b71ef8c0192a76$export$2e2bcd8739ae039.IsNullOrEmpty = function(val) {
    return val === undefined || val === null || typeof val === 'string' && val === '' || typeof val === 'number' && isNaN(val) === true;
};
// --
// String Extensions
if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
};
if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
// --
// Base64 Encode
$23b71ef8c0192a76$export$2e2bcd8739ae039.b64EncodeUnicode = function(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    //return String.fromCharCode('0x' + p1);
    }));
};
/// Base64 Decode
$23b71ef8c0192a76$export$2e2bcd8739ae039.b64DecodeUnicode = function(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
};
// --
// JSON Funktionen
// JSON Parse
$23b71ef8c0192a76$export$2e2bcd8739ae039.JsonParse = function(jsonStr) {
    if (jsonStr == null || jsonStr.length == 0) return null;
    return $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonRetrocycle(JSON.parse(jsonStr)); //event.target.responseText));
};
/**
 * Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js).
 * Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */ /* = {
    decycle: null,
    retrocycle: null
};*/ (function() {
    /**
     * The findReferences function walks recursively through an object graph built from a Json.NET string,
     * looking for $id properties. When it finds an object with that property, then it adds it to the catalog under that key.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function findReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var id = obj.$id;
            if (typeof id === "string") catalog[id] = obj;
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                var i1 = void 0;
                for(i1 = 0; i1 < obj.length; i1 += 1)findReferences(obj[i1], catalog);
            } else for(var name_1 in obj){
                if (obj.hasOwnProperty(name_1)) {
                    if (typeof obj[name_1] === "object") findReferences(obj[name_1], catalog);
                }
            }
        }
    }
    /**
     * The resolveReferences function walks through the object graph and replaces any references with the objects from the catalog.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function resolveReferences(obj, catalog) {
        if (obj && typeof obj === "object") {
            var i1 = void 0;
            var item = void 0;
            var id = void 0;
            if (Object.prototype.toString.apply(obj) === "[object Array]") for(i1 = 0; i1 < obj.length; i1 += 1){
                item = obj[i1];
                if (item && typeof item === "object") {
                    id = item.$ref;
                    if (typeof id === "string") obj[i1] = catalog[id];
                    else obj[i1] = resolveReferences(item, catalog);
                }
            }
            else if (obj.$values && Object.prototype.toString.apply(obj.$values) === "[object Array]") {
                var arr = new Array();
                for(i1 = 0; i1 < obj.$values.length; i1 += 1){
                    item = obj.$values[i1];
                    if (item && typeof item === "object") {
                        id = item.$ref;
                        if (typeof id === "string") arr[i1] = catalog[id];
                        else arr[i1] = resolveReferences(item, catalog);
                    } else arr[i1] = item;
                }
                obj = arr;
            } else {
                var name_2;
                for(name_2 in obj){
                    if (obj.hasOwnProperty(name_2)) {
                        if (typeof obj[name_2] === "object") {
                            item = obj[name_2];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === "string") obj[name_2] = catalog[id];
                                else obj[name_2] = resolveReferences(item, catalog);
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    /**
     * The createReferences function recurses through the object, producing the deep copy.
     * @param obj The object from Json.NET
     * @param catalog The catalog of references that maintains state through the series of recursive calls.
     */ function getDecycledCopy(obj, catalog) {
        var i1; // The loop counter
        var name; // Property name
        var nu; // The new object or array
        switch(typeof obj){
            case "object":
                // typeof null === 'object', so get out if this value is not really an object.
                // Also get out if it is a weird builtin object.
                if (obj === null || obj instanceof Boolean || obj instanceof Date || obj instanceof Number || obj instanceof RegExp || obj instanceof String) return obj;
                // If the value is an object or array, look to see if we have already
                // encountered it. If so, return a {$id:id} object. This is a hard way, O(n)
                // linear search that will get slower as the number of unique objects grows.
                // JavaScript really should have a decent dictionary or map class.
                for(i1 = 0; i1 < catalog.length; i1 += 1){
                    if (catalog[i1] === obj) return {
                        $ref: i1.toString()
                    };
                }
                // Otherwise, accumulate the unique value and its id.
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                // If it is an array, replicate the array.
                if (Object.prototype.toString.apply(obj) === "[object Array]") {
                    nu = [];
                    for(i1 = 0; i1 < obj.length; i1 += 1)nu[i1] = getDecycledCopy(obj[i1], catalog);
                } else {
                    // If it is an object, replicate the object.
                    nu = {};
                    for(name in obj)if (Object.prototype.hasOwnProperty.call(obj, name)) nu[name] = getDecycledCopy(obj[name], catalog);
                }
                return nu;
            case "number":
            case "string":
            case "boolean":
            default:
                return obj;
        }
    }
    /** Make a deep copy of an object or array, assuring that there is at most
        one instance of each object or array in the resulting structure. The
        duplicate references (which might be forming cycles) are replaced with
        an object of the form
          {$id: id}
        where the id is a simple string
    Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js)
    Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
 */ function decycle(obj) {
        var catalog = []; // Keep a reference to each unique object or array
        var newObj = getDecycledCopy(obj, catalog);
        return newObj;
    }
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonDecycle = decycle;
    /** Restore an object that was reduced by decycle. Members whose values are objects of the form
         {$ref: id}
    are replaced with references to the value found by the id. This will
    restore cycles. The object will be mutated.

    So,
         var s = '{$id:1, members: [{$ref:"1"}]';
         return retrocycle(JSON.parse(s));
    produces an object containing an array which holds the object itself.
    */ function retrocycle(obj) {
        var catalog = [];
        findReferences(obj, catalog);
        return resolveReferences(obj, catalog);
    }
    $23b71ef8c0192a76$export$2e2bcd8739ae039.JsonRetrocycle = retrocycle;
})();

});

parcelRegister("3j512", function(module, exports) {

$parcel$export(module.exports, "default", () => $2687097d5145937a$export$2e2bcd8739ae039);
/*
// Be sure to include popper.min.js before Bootstrap’s JavaScript
import * as Popper from "@popperjs/core";
import { createPopper } from '@popperjs/core';
window.Popper = Popper;
window.createPopper = createPopper;
*/ //import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';
//import './node_modules/pdfjs-dist/build/pdf.mjs';
//import { getDocument } from "./node_modules/pdfjs-dist/legacy/build/pdf.mjs";

var $346VI = parcelRequire("346VI");
parcelRequire("a7Paw");

var $iuVXB = parcelRequire("iuVXB");

var $hkmmp = parcelRequire("hkmmp");

var $9hg18 = parcelRequire("9hg18");

var $fWhbk = parcelRequire("fWhbk");

var $60OaQ = parcelRequire("60OaQ");

var $iiLdM = parcelRequire("iiLdM");
window.Store = (0, $hkmmp.default);
window.Node = (0, $fWhbk.default);
window.uniqolor = (0, (/*@__PURE__*/$parcel$interopDefault($iiLdM)));
if (window.DrDoc !== undefined) console.warn('Lib Duplicate: DrDoc');
function $2687097d5145937a$export$2e2bcd8739ae039() {}
// DrDoc wird global in DrDoc.Init() gesetzt
// window.DrDoc = DrDoc;
window.Split = (0, $60OaQ.default);
// --
// Dr.DOC
// Requires: DrDocWeb, Node, Store
// --
$2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId = function(sourceElement, archiveName, newWindow) {
    if (newWindow === true) return 'system/mask-info';
    var elem = null;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask-searchfields|content', sourceElement);
    // Modal VOR den anderen
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask|content', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/mask-info|content', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|dataset', sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName + '|dataset', sourceElement);
    //elem = 'system/mask|content';
    if (elem == undefined || elem == null) //return 'system/list|content|' + archiveName + '|dataset';
    return 'system/mask|content';
    else return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId = function(sourceElement, archiveName, newWindow, forceList) {
    if (newWindow === true) return 'system/list-info';
    var elem = null;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName, sourceElement);
    if (forceList === true) return 'system/list|content|' + archiveName;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-info|content', sourceElement);
    // Kanban Dr.DOC Theme
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content|' + archiveName, sourceElement);
    // Kanban Default Theme
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content', sourceElement);
    if (elem == undefined || elem == null) //return 'system/list|content|' + archiveName;
    return 'system/list-info|content';
    else return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.LoadListWebNodeComponent = function(getObj) {
    // Manche Object Properties können werst aufgelöst werden, wenn syst/list geladen wurde (z.B. "targetElement: DrDoc.GetListNodeId(..)")
    // daher als Funktion übergeben
    if (getObj === undefined || getObj === null) {
        console.log('DrDoc.LoadListWebNodeComponent: obj is undefined');
        return undefined;
    }
    let obj = typeof getObj === 'function' ? getObj() : getObj;
    // Wenn targetContainerElement #template_drdoc_main existiert, Soll system/list aufgerufen werden, um im normalen Listen Context (Archiv wählen etc) zu bleiben.
    let targetContainerElement = document.querySelector('#template_drdoc_main');
    let targetElement = (0, $fWhbk.default).GetElement(obj.targetElement, obj.sourceElement);
    //let targetNodeId = DrDoc.GetListNodeId(obj.sourceElement, obj.archiveName, obj.newWindow);
    if (targetContainerElement !== undefined && targetContainerElement !== null) // Main Dr.DOC Container exisitiert
    {
        if (targetElement == undefined || targetElement == null) {
            // Target Element wurde nicht gefunden
            // Type String für targetElement bedeutet, dass das List Element nicht gefunden wurde
            // => 'system/list' in Main Dr.DOC Container laden
            console.log('DrDoc.LoadListWebNodeComponent: system/list laden..');
            return (0, $fWhbk.default).LoadComponent({
                nodeId: 'system/list',
                sourceElement: obj.sourceElement,
                targetElement: targetContainerElement,
                getData: {}
            }).then(function(result) {
                obj = typeof getObj === 'function' ? getObj(targetContainerElement) : getObj;
                console.log('DrDoc.LoadListWebNodeComponent: system/list wurde geladen', ' / obj.targetElement: ', obj.targetElement);
                //if (!DrDocWeb.IsNullOrEmpty(obj.targetElement) && typeof obj.targetElement === 'string')
                //{
                //    obj.targetElement = DrDoc.GetListNodeId(null, obj.getData.archive);
                //}
                obj.targetElement = 'system/list';
                console.log('DrDoc.LoadListWebNodeComponent: system/list wurde geladen', ' / obj: ', obj);
                // 'system/list' sollte jetzt existieren
                $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
                return (0, $fWhbk.default).LoadComponent(obj);
            });
        }
    }
    console.log('DrDoc.LoadListWebNodeComponent: Node.LoadComponent direkt laden: ', obj.targetElement, ' | ', targetElement);
    //obj.targetElement = targetContainerElement;
    //obj.nodeId = 'system/home';
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent(obj);
};
/*DrDoc.GetListTemplateName = function (sourceElement) {
    // system/list | content | wfmain | TODOLISTE | 19735
    let searchTemplateName = '_DEFAULT_';
    //let nodeId = rowElem;
    let nodeIdOrig = Node.GetNodeId(sourceElement);
    if (!DrDocWeb.IsNullOrEmpty(nodeIdOrig)) {
        let nodeIdSegments = nodeIdOrig.split('|');
        if (nodeIdSegments.length > 3) {
            searchTemplateName = nodeIdSegments[3];
        }
        //let nodeId = nodeIdSegments.join('|');
        //console.log('DrDoc.UpdateDatasetRow', nodeIdOrig, " => ", nodeId);
    }
    return searchTemplateName;
};*/ $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID = function(sourceElement) {
    var nodeName_selected = (0, $fWhbk.default).GetNodeId(sourceElement);
    var nodeNameSegments_selected = nodeName_selected.split('|');
    var documentId_selected = nodeNameSegments_selected[nodeNameSegments_selected.length - 1];
    return documentId_selected;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate = function(sourceElement, archiveName) {
    let selectedSearchTemplate = (0, $346VI.default).kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate['searchtemplate'])) {
        //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 1 strict true: ', selectedSearchTemplate);
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }
    /*selectedSearchTemplate = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, false);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate['searchtemplate']))
    {
        console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 2 strict false: ', selectedSearchTemplate);
        DrDoc.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }*/ let configSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate', '_DEFAULT_');
    //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate config: ', configSearchTemplate);
    return configSearchTemplate;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection = function(sourceElement, archiveName) {
    // verwendete Feld Auswahlen laden aus DatasetListContainerWebNode
    //let selectedSearchTemplate2 = DrDocWeb.kvp_get(sourceElement, 'selection', 'value', null, null, true);
    //let selectedSearchTemplate3 = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, true);
    //let selectedSearchTemplate4 = DrDocWeb.kvp_get(sourceElement, 'recursive-query', 'value', null, null, true);
    let selectedSearchTemplate = (0, $346VI.default).kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    //console.log('DrDoc.GetSearchFieldSelection: ', selectedSearchTemplate, ' / ', selectedSearchTemplate2, ' / ', selectedSearchTemplate3, ' / ', selectedSearchTemplate4);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate['fieldselection'])) return selectedSearchTemplate['fieldselection'];
    else return '';
};
// DOM Node
$2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal = function(sourceElement, archiveName, byIdGetRow, documentIdOrig) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement, null);
    let elem = undefined;
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-default|content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');
    let selectedSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
    let documentId = documentIdOrig;
    if (byIdGetRow) {
        if (!(0, $346VI.default).IsNullOrEmpty(documentId) || documentId != 0) documentId = '|' + documentId;
        else console.warn('DrDoc.GetTableRowElementByIDInternal: es wurde keine "documentId" \xfcbergeben - List Element nicht gefunden!', sourceElement, archiveName, documentIdOrig, '"' + selectedSearchTemplate + '"');
    } else documentId = '';
    // list-info.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-info|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content', sourceElement);
    // list-thes.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-thes|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content', sourceElement);
    // list-thes.content ist MultiArchiveDatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName + '|zusatzinfo', sourceElement);
    if ((elem == undefined || elem == null) && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate)) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list|content|' + archiveName + '|_DEFAULT_' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content', sourceElement);
    if ((elem == undefined || elem == null) && !(0, $346VI.default).IsNullOrEmpty(selectedSearchTemplate)) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban|content' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/list-kanban2|content' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_search' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_fav' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_his' + documentId, sourceElement);
    if (elem == undefined || elem == null) elem = (0, $fWhbk.default).GetElement('system/home|list_recent' + documentId, sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list|content|'+archiveName + '|_DEFAULT_');
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|dataset-list-content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');
    if (elem === undefined || elem === null) {
        if (sourceElement == undefined || sourceElement == null) {
            console.warn('DrDoc.GetTableRowElementByIDInternal: List Element nicht gefunden! / archiveName: ', archiveName, ' / byIdGetRow: ', byIdGetRow, ' / documentId: ', documentId, ' / documentIdOrig: ', documentIdOrig, ' / selectedSearchTemplate: "' + selectedSearchTemplate + '" / sourceElement: ', sourceElement);
            return undefined;
        } else // Nochmal ohne source element probieren
        return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(undefined, archiveName, byIdGetRow, documentIdOrig); //, isZusatzInfo);
    }
    //console.log('DrDoc.GetTableRowElementByIDInternal', elem, archiveName, byIdGetRow, documentIdOrig, '"' + selectedSearchTemplate + '"');
    return elem;
};
$2687097d5145937a$export$2e2bcd8739ae039.Home = function(sourceElement) {
    //DrDoc.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dr.DOC Home',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        nodeId: 'system/home',
        nav: 'push'
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.Desktop = function(sourceElement) {
    //DrDoc.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dr.DOC Desktop',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        nodeId: 'system/desktop',
        nav: 'push'
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.GetDataset = function(sourceElement, archiveName, documentIdField, documentId, mode, ignoreUnloadEvent) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    //if (typeof node === 'string')
    //{
    //    if (mode !== undefined && mode.length > 0)
    //        nodeId = 'system/mask-' + mode + '|content';
    //    else
    //        nodeId = 'system/mask|content';
    //}
    /*if (DrDocWeb.IsMobile())
    {
        nodeId = null;
    }*/ return (0, $fWhbk.default).LoadComponent({
        title: 'Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id_field: documentIdField === undefined || documentIdField === null ? '' : documentIdField,
            id: documentId === undefined || documentId === null ? '' : documentId,
            mode: mode,
            thes: false //true
        },
        ignoreUnloadEvent: ignoreUnloadEvent
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFn = function(sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, hasDocument) {
    // Immer|Kontext,123,Rechendef Ausf.;Parameter
    var fnArgs = fnStr.split(';');
    if (fnArgs == null || fnArgs == undefined || fnArgs.length < 3) {
        console.error('DrDoc.ButtonFn: Bad Buttonfunction', fnStr);
        (0, $346VI.default).Modal('ButtonFn', `Bad Function "${fnStr}".`);
        return;
    }
    var fnExecContext = fnArgs[0];
    var fnNr = fnArgs[1];
    var fnName = fnArgs[2];
    var fnValue = fnArgs[3];
    //let form = DrDocWeb.GetElement(sourceElement, 'form');
    // form[fnValue].value
    let postData = {};
    let form = (0, $fWhbk.default).ParseFormData(sourceElement, null, postData, true, false);
    console.log('ButtonFn', sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, ' / Form: ', form, postData, postData[fnValue]);
    switch(fnNr){
        // 391: Feld drucken
        // 400: Vorblättern
        // 401: Zurückblättern
        // 306: Datenübergabe
        // 308: drucken
        // 126: DS kopieren
        // 403: DS löschen
        // 515: ersetzen
        // 405: Dokument anzeigen
        // 180: Export Ascii
        // 541: Dok. exportieren
        // 402: Speichern
        // 230: Abbrechen
        // 182: Import ASCII
        // 189: Dokument neu
        // 724: Auto. Thes. ausführen
        // 725: DS aktualisieren
        // 55556: Kenntnisnahme
        // 2200: Kalenderneueingabe
        // 3200: Kalenderexport
        case '405':
            // Btn. Dok. anzeigen
            //DrDoc.MaskShowDocument(sourceElement, archiveName, documentId);
            $2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset(sourceElement, true, true);
            break;
        case '332':
        case '434':
            // E-Mail
            $2687097d5145937a$export$2e2bcd8739ae039.ButtonFnEmail(sourceElement, archiveName, documentIdField, documentId, postData[fnValue], hasDocument);
            break;
        case '445':
            // Tel wählen
            window.open('tel:' + postData[fnValue]);
            break;
        case '606':
            // Website
            window.open(postData[fnValue].replaceAll('|', '; '));
            break;
        case '723':
            // Rechendef ausführen
            $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'calc', true);
            break;
        default:
            (0, $346VI.default).Modal('ButtonFn', `Function "${fnName}", Nr. "${fnNr}" not Implemented yet!`);
            break;
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFnPrintGen = function(_sourceElement, archiveName, documentIdField, documentId, hasDocument) {
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12); //sourceElement.getAttribute('id');
    let retHtml = ``;
    hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;
    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden
    retHtml += `

        F\xfcr ZUGFeRD PDF + XML anklicken.<br/>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_pdf" value="1" ${hasDocument ? '' : 'checked'} />
            <label class="form-check-label d-block" for="${elemId}--format_pdf">PDF</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_xml" value="1" ${hasDocument ? '' : 'checked'} />
            <label class="form-check-label d-block" for="${elemId}--format_xml">XML</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML ver\xf6ffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument ver\xf6ffentlichen</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_btn_fn_action_${elemId}'](this);">
            Aktionen ausf\xfchren (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
        `;
    retHtml += `
        `;
    console.log('Generate Doc Button 1: ', _sourceElement, archiveName);
    let modal = (0, $346VI.default).Modal('Dokument generieren', retHtml);
    window['_dd_btn_fn_action_' + elemId] = function(sourceElement) {
        console.log('Generate Doc Button 2: ', sourceElement, archiveName);
        return (0, $fWhbk.default).LoadComponent({
            title: 'Dokument generieren (Vorschau)',
            sourceElement: sourceElement,
            targetElement: 'system/rec-out|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: !(0, $346VI.default).IsNullOrEmpty(documentIdField) ? documentIdField : $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                id: documentId,
                archive_doc: true,
                email: false,
                email_att: false,
                email_value: '',
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                format_pdf: document.getElementById(elemId + '--format_pdf').checked,
                format_xml: document.getElementById(elemId + '--format_xml').checked,
                log: true
            }
        }).then(function(win) {
            modal.hide();
            /*setTimeout(function(){
                DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 1000);*/ setTimeout(function() {
                $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(_sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 3500);
        });
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.ButtonFnEmail = function(_sourceElement, archiveName, documentIdField, documentId, value, hasDocument, nodeIdPath) {
    if ((0, $346VI.default).IsNullOrEmpty(nodeIdPath)) nodeIdPath = 'system/rec-out';
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12);
    let retHtml = ``;
    hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;
    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden
    retHtml += `
<button type="button" class="btn btn-primary btn-sm" onclick="window.open('mailto:${value}');">E-Mail verfassen (lokale App)</button>

<br />
<hr>
<br />

<form onsubmit="window['_dd_btn_fn_action_${elemId}'](this); return false;">

<label class="form-label">Empf\xe4nger E-Mail-Adresse:
<input type="email" class="form-control" placeholder="Empf\xe4nger E-Mail &quot;${value}&quot; \xfcberschreiben" id="${elemId}--email-address" value="${value}">
</label>

<br /><br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email"><b>E-Mail versenden</b></label>
        </div>
        <div class="ms-4">
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email_att" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email_att">Ein <b>Dokument als Anhang</b> per <b>E-Mail versenden</b></label>
        </div>
        </div>
        
<br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML ver\xf6ffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument ver\xf6ffentlichen</label>
        </div>

        <br /><br />

        <button type="submit" class="btn btn-success btn-sm">
            Aktionen ausf\xfchren (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
</form>
        `;
    retHtml += `
        `;
    console.log('Send Mail Button 1: ', _sourceElement, archiveName);
    let modal = (0, $346VI.default).Modal('E-Mail senden', retHtml);
    window['_dd_btn_fn_action_' + elemId] = function(sourceElement) {
        let sendEmailAtt = document.getElementById(elemId + '--email_att').checked === true;
        console.log('Send Mail Button 2: ', sourceElement, archiveName);
        return (0, $fWhbk.default).LoadComponent({
            title: 'E-Mail versenden (Vorschau)',
            sourceElement: sourceElement,
            //targetElement: 'system/rec-out|content|archive-' + archiveName,
            targetElement: nodeIdPath + '|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: !(0, $346VI.default).IsNullOrEmpty(documentIdField) ? documentIdField : $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                id: documentId,
                archive_doc: false,
                zugferd: false,
                email: document.getElementById(elemId + '--email').checked,
                email_value: document.getElementById(elemId + '--email-address').value,
                email_att: sendEmailAtt,
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                log: true
            }
        }).then(function(win) {
            modal.hide();
            // Fenster schließen, da existierender DS angezeigt werden soll
            if (win !== undefined) win.close();
            setTimeout(function() {
                $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocument(_sourceElement, archiveName, documentId);
            }, 500);
        });
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.SignForm = function(_sourceElement, archiveName, documentIdField, documentId) {
    let elemId = 'elem-' + (0, $346VI.default).RandomChars(12);
    let retHtml = ``;
    let hasDocument = !(0, $346VI.default).IsNullOrEmpty(documentId) && +documentId > 0;
    //DrDoc.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId, page, sign, sign_create, sign_pos, sign_text_rel, sign_align)
    retHtml += `

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--new" value="1" />
            <label class="form-check-label d-block" for="${elemId}--new">Dieses Dokument als Vorlage verwenden und neues Dokument erstellen.</label>
        </div>
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--preset" value="" />
            <label class="form-label d-block" for="${elemId}--preset">Feldvorbelegung</label>
        </div>
        
        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_x" value="10%" />
            <label class="form-label d-block" for="${elemId}--pos_x">Position X</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_y" value="80%" />
            <label class="form-label d-block" for="${elemId}--pos_y">Position Y</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_w" value="55%" />
            <label class="form-label d-block" for="${elemId}--pos_w">Breite</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_h" value="80pt" />
            <label class="form-label d-block" for="${elemId}--pos_h">H\xf6he</label>
        </div>

        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_text_rel" value="Unterschrift;Unterschrift XYZ" />
            <label class="form-label d-block" for="${elemId}--sign_text_rel">Referenz Text</label>
        </div>

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_align" value="top" />
            <label class="form-label d-block" for="${elemId}--sign_align">Align</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_action_${elemId}'](this);">
            Aktionen ausf\xfchren&nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>

            <input type="text" class="form-control" id="${elemId}--result" value="" />
        `;
    retHtml += `
        `;
    let modal = (0, $346VI.default).Modal('Signatur Link erstellen', retHtml);
    window['_dd_action_' + elemId] = function(sourceElement) {
        let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId, 0, true, document.getElementById(elemId + '--new').checked, document.getElementById(elemId + '--preset').value, document.getElementById(elemId + '--pos_x').value + ';' + document.getElementById(elemId + '--pos_y').value + ';' + document.getElementById(elemId + '--pos_w').value + ';' + document.getElementById(elemId + '--pos_h').value, document.getElementById(elemId + '--sign_text_rel').value, document.getElementById(elemId + '--sign_align').value);
        document.getElementById(elemId + '--result').value = url;
        console.log('Generate Sign Doc Link 2: ', sourceElement, archiveName, url);
    };
};
$2687097d5145937a$export$2e2bcd8739ae039.Thesaurus = function(sourceElement, archiveName, documentId, fieldName, tableRow, mode, append, thesNew, sourceElemIsTargetElem) {
    //let nodeId = 'system/list-thes|content';
    const newWindow = true;
    let nodeId = sourceElemIsTargetElem ? sourceElement : newWindow == true ? 'system/list-thes|content' : $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    let field = $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, fieldName);
    /*let form = DrDocWeb.GetElement(sourceElement, 'form');
    if (form != null && form != undefined)
    {
        console.log('Thes.', form.beforeunload, form.onbeforeunload, form, sourceElement);
        sourceElement.beforeunload = undefined;
        form.beforeunload = undefined;
        window.onbeforeunload = undefined;
    }*/ //let confirmMsg = true;
    //if (thesNew === undefined || thesNew === null)
    //    thesNew = false;
    //if (thesNew)
    return (0, $fWhbk.default).LoadComponent({
        title: "Thesaurus f\xfcr das Feld " + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'thes',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: tableRow === undefined || tableRow === null ? 0 : tableRow,
            recursive: 'new',
            append: append,
            'tree-sub': true,
            //'thes-confirm': confirmMsg,
            'thes-new': thesNew === undefined || thesNew === null ? false : thesNew,
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: tableRow === undefined || tableRow === null ? 0 : tableRow,
                //thes_id: (documentId === undefined || documentId === null ? '' : documentId),
                id: documentId === undefined || documentId === null ? '' : documentId,
                append: append
            }
        },
        ignoreUnloadEvent: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.ThesaurusDropdown = function(sourceElement, archiveName, documentId, fieldName) {
    if (sourceElement.options.length > 2) return;
    return (0, $fWhbk.default).LoadComponent({
        title: 'Dropdown',
        sourceElement: sourceElement,
        targetElement: sourceElement,
        getData: {
            archive: archiveName,
            id: documentId,
            mode: 'thes-dropdown',
            thes: true,
            field: fieldName
        },
        ignoreLoadEvent: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.Zusatzinfo = function(sourceElement, archiveName, documentId, fieldName, tableRow, mode, newWindow, sourceElemIsTargetElem) {
    //let nodeId = 'system/list-info|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    let nodeId = sourceElemIsTargetElem ? sourceElement : newWindow == true ? 'system/list-info' : 'system/list-info|content';
    //let nodeId = 'system/list-info|content';
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, archiveName, true);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, '_zusatzinfo_');
    //let zusatzArchiveName = DrDoc.GetArchiveSession(archiveName).FieldSessions[fieldName].Zusatzinfo.ZusatzArchive.Archive.SimpleName;
    //DrDoc.configUser.set('view/selected-archive', zusatzArchiveName);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, zusatzArchiveName, true);
    //console.log('SOURCE ZUSATZ INFO', zusatzArchiveName, nodeId);
    let field = $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, fieldName);
    /*if (newWindow === true)
    {
        window.open()
    }
    else
    {
        DrDocWeb.ModalClose(sourceElement);
    }*/ var ret = (0, $fWhbk.default).LoadComponent({
        title: "Zusatzinfo f\xfcr das Feld " + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'info',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: tableRow === undefined || tableRow === null ? 0 : tableRow,
            recursive: 'new',
            'tree-sub': true,
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: tableRow === undefined || tableRow === null ? 0 : tableRow,
                id: documentId === undefined || documentId === null ? '' : documentId,
                append: false
            }
        },
        formFieldsOr: false,
        newWindow: newWindow
    });
    return ret;
};
$2687097d5145937a$export$2e2bcd8739ae039.OnFormInit = function(sourceElement, archiveName, documentId, mode, lockedDocumentId) {
    var formHasChanged = false;
    //console.log('Init Mask ', sourceElement, archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);
    // get, lock, 
    if (mode != 'form-searchfields' && mode != 'form-create' && mode != 'unlock-only') {
        var onFormInputChanged = function(e2) {
            //console.log('Input has changed!', formElem[0]);
            //formElem.attr('data-changed', 'true');
            formHasChanged = true;
        };
        //$(sourceElement).find('input').on('change', onFormInputChanged);
        //$(sourceElement).find('textarea').on('change', onFormInputChanged);
        //$(sourceElement).find('select').on('change', onFormInputChanged);
        sourceElement.querySelectorAll('input').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('textarea').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('select').forEach(function(elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        var beforeunloadFn = function(e2) {
            //DrDoc.CloseAllDocumentWnd();
            //console.log('..beforeunloadFn..'); //, this, e2);
            //console.log('Sollen die Änderungen in der Maske verworfen verden?', this);
            let ret = false;
            if (window.onbeforeunload == null || window.onbeforeunload == undefined) {
                //console.log('Nix machen, da Thes.!');
                if (this == window || this == document) return undefined;
                else return true;
            }
            // Wenn das Formular nicht geändert wurde und noch kein DS gelockt ist bzw. der geladene DS der gelockte ist,
            // dann abbrechen
            if (!formHasChanged && (lockedDocumentId <= 0 || lockedDocumentId == documentId)) {
                //console.log('Nix machen!');
                if (this == window || this == document) return undefined;
                else return true;
            }
            if (e2 != undefined && this == window || this == document) {
                console.log('beforeunloadFn - preventDefault');
                e2.preventDefault();
            }
            console.log('beforeunloadFn - Confirm Unlock', archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);
            if (!formHasChanged) {
                //if (this == window)
                //	return 'Soll der von Ihnen gesperrte Datensatz freigegeben werden?';
                //ret = confirm('Soll der von Ihnen gesperrte Datensatz freigegeben werden?');
                ret = true;
                (e2 || window.event).returnValue = 'EVENT: Sollen der von Ihnen gesperrte Datensatz freigegeben werden?';
            } else {
                ret = confirm("Sollen die \xc4nderungen im Datensatz verworfen und freigegeben verden?");
                (e2 || window.event).returnValue = "EVENT: Sollen die \xc4nderungen im Datensatz verworfen und freigegeben verden?";
            }
            if (ret) {
                console.log('beforeunloadFn - freigeben');
                if (sourceElement !== null && sourceElement !== undefined) sourceElement.beforeunload = undefined;
                window.onbeforeunload = undefined;
                // Datensatz entsperren, wenn einer vorliegt
                if (lockedDocumentId >= 0) $2687097d5145937a$export$2e2bcd8739ae039.UnlockOnlyDataset(sourceElement, archiveName, lockedDocumentId);
                return true;
            } else {
                console.log('beforeunloadFn - bearbeiten');
                // Maske einblenden, damit man sie entsperren kann
                $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset(archiveName);
                return false;
            }
        };
        //window.addEventListener("beforeunload", beforeunloadFn);
        window.onbeforeunload = beforeunloadFn;
        if (sourceElement !== null && sourceElement !== undefined) // wenn die Funktion "beforeunload" true zurück gibt, wird der neue Node geladen.
        sourceElement.beforeunload = beforeunloadFn;
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.OnFormSubmit = function(sourceElement, archiveName, documentId, mode) {
    //console.log('DrDoc.OnFormSubmit 1: ', mode, sourceElement);
    sourceElement = (0, $346VI.default).GetClosestForm(sourceElement);
    console.log('Form submitted..');
    if (!sourceElement.checkValidity()) {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');
        console.warn('DrDoc.OnFormSubmit: ', 'Form has Invalid Field-Values!');
    } else {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');
        //console.log('DrDoc.OnFormSubmit 2: ', sourceElement, archiveName, documentId, mode);
        if (mode == 'searchfields' || (0, $fWhbk.default).GetElement('system/mask-searchfields|content') !== undefined) return $2687097d5145937a$export$2e2bcd8739ae039.SearchFields(sourceElement, archiveName);
        else if (mode == 'create' || mode == 'form-create') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDataset(sourceElement, archiveName);
        else if (mode == 'create-new') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDataset(sourceElement, archiveName, true);
        else if (mode == 'create-form') return $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null); // data, presetName, newWindow)
        else return $2687097d5145937a$export$2e2bcd8739ae039.SaveDataset(sourceElement, archiveName, documentId);
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm = function(sourceElement, archiveName, data, presetName, newWindow) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archive, data, presetName);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName, newWindow);
    var getObj = {
        archive: archiveName,
        mode: 'form-create',
        preset: presetName === undefined || presetName === null ? '' : presetName
    };
    if (sourceElement == null || sourceElement == undefined) return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: null,
        targetElement: nodeId,
        getData: getObj,
        postData: data,
        newWindow: newWindow
    });
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset(archiveName);
    $2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem(sourceElement, archiveName);
    //Node.SetFormFieldGetData(getObj, data);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data //(data != null && data != undefined ? data : undefined)
    }).then((data)=>{
    //console.log('CreateDatasetForm (=> geladen): ', archiveName, 'form-create', sourceElement);
    // Wenn der Datensatz geladen wurde, Modal wieder schließen.
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDataset = function(sourceElement, archiveName, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/mask-create|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    //    nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName, newWindow);
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'create'
        },
        //postData: { }
        closeModalAfter: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm = function(sourceElement, archiveName) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm(sourceElement, archive);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let nodeId = 'system/mask-searchfields|content';
    //let nodeId = 'system/mask-searchfields|content|' + archiveName;
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            view: 'Search',
            archive: archiveName,
            mode: 'form-searchfields'
        },
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFields = function(sourceElement, archiveName, data, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let getObj = {
        archive: archiveName,
        mode: 'searchfields'
    };
    // Feldsuche als GET
    //let postObj = null;
    (0, $fWhbk.default).SetFormFieldGetData(getObj, data);
    // Feldsuche als POST
    //let postObj = data;
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        //sourceElement: sourceElement,
        //targetElement: DrDoc.GetListNodeId(sourceElement, archiveName, newWindow),
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, newWindow, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: getObj,
        postData: data == undefined || data == null ? undefined : {},
        writeToGetData: true,
        formFieldsOr: true,
        newWindow: newWindow,
        nav: 'push',
        // Childs aus Modal nicht entfernen, da es Formulardaten enthält
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsInfo = function(sourceElement, archiveName, data, newWindow) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    // newWindow == null || newWindow == undefined ||
    let nodeId = newWindow == true || sourceElement == undefined || sourceElement == null ? 'system/list-info' : $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    let getObj = {
        archive: archiveName,
        mode: 'searchfields',
        recursive: 'new',
        'tree-sub': true,
        nav: 'push'
    };
    //Node.SetFormFieldGetData(getObj, data);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Feldsuche im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName) + '',
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data,
        formFieldsOr: true,
        newWindow: newWindow
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal = function(sourceElement, archiveName, nodeId, title) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archive, nodeId, title);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //console.log('DrDoc.SearchTemplateForm: ', sourceElement);
    return (0, $fWhbk.default).LoadComponent({
        title: title,
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName
        },
        closeModalBefore: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchPresetForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/preset|content', 'Datensatz erstellen mit Feldvorbelegung');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchTemplateForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/search-template|content', 'Vorlagensuche');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/search|content', 'Suche');
};
$2687097d5145937a$export$2e2bcd8739ae039.SelectArchiveForm = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetFormInternal(sourceElement, archiveName, 'system/select-archive|content', "Archiv w\xe4hlen");
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate = function(sourceElement, archiveName, templateName) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate(sourceElement, archive, templateName);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/list|content';
    /*return DrDoc.LoadListWebNodeComponent(function(sourceElement2){ return {
        title: 'Vorlagensuche',
        sourceElement: sourceElement,
        targetElement: DrDoc.GetListNodeId((sourceElement2 ? sourceElement2 : sourceElement), archiveName),
        getData: {
            archive: archiveName,
            mode: 'template',
            value: templateName,
            //searchTemplateName: templateName,
            search: '',
            content_substring: false
        },
        postData: {},
        nav: 'push',
        closeModalBefore: true,
    };}).then(DrDoc.SetViewInit);*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Vorlagensuche',
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, false, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'template',
            value: templateName,
            //searchTemplateName: templateName,
            search: '',
            content_substring: false
        },
        postData: {},
        nav: 'push',
        closeModalBefore: true
    });
/*.then(async function () {
        await DrDoc.SetViewInit();
        setTimeout(function(){
            DrDoc.UpdateViewMode();
        }, 4500);
        setTimeout(function(){
            DrDoc.SetViewList();
        }, 2*4500);
        //DrDoc.updateMainMenuExpansion();
    });*/ //}).then(DrDoc.SetViewInit);
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchToDo = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, 'TODOLISTE', '', 'Hypersuche To Do');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchInbox = function(sourceElement, archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, 'INBOX', '', 'Hypersuche Posteingang');
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchHyper = function(sourceElement, archiveName, hyperName, hyperSearchText, title) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archive, hyperName, hyperSearchText, title);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    let progressBarModal = (0, $346VI.default).ModalProgress(`Starte Hypersuche ${hyperName}..`);
    /*return DrDoc.LoadListWebNodeComponent(function(){ return {
        title: title,
        //sourceElement: sourceElement,
        //targetElement: 'system/list',
        sourceElement: document.querySelector('#template_drdoc_main'),
        targetElement: document.querySelector('#template_drdoc_main'),
        getData: { archive: archiveName, mode: 'hyper', value: hyperName, search: hyperSearchText },
        nav: 'push',
    };}).then(function () {
        DrDoc.SetViewInit();
        DrDoc.updateMainMenuExpansion();
        DrDoc.SearchCountElement();
        progressBarModal.close();
    });*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: title,
        //sourceElement: sourceElement,
        //sourceElement: 'system/list', //DrDoc.GetListNodeId(sourceElement, archiveName),
        //sourceElement: document.querySelector('#template_drdoc_main'),
        //targetElement: document.querySelector('#template_drdoc_main'),
        //sourceElement: document.querySelector('#template_drdoc_main'),
        nodeId: 'system/list',
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'hyper',
            value: hyperName,
            search: hyperSearchText
        },
        nav: 'push'
    }).then(function() {
        $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
        $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
        $2687097d5145937a$export$2e2bcd8739ae039.SearchCountElement();
        progressBarModal.close();
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SearchText = function(sourceElement, archiveName, searchText) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
        return $2687097d5145937a$export$2e2bcd8739ae039.SearchText(sourceElement, archive, searchText);
    });
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewList();
    return (0, $fWhbk.default).LoadComponent({
        title: 'Datensatz-Liste',
        //sourceElement: sourceElement,
        //targetElement: DrDoc.GetListNodeId(sourceElement, archiveName),
        nodeId: $2687097d5145937a$export$2e2bcd8739ae039.GetListNodeId(sourceElement, archiveName, false, true),
        sourceElement: sourceElement,
        targetElement: document.querySelector('#template_drdoc_main'),
        navRoot: true,
        getData: {
            archive: archiveName,
            mode: 'textretrieval',
            value: searchText
        },
        nav: 'push',
        closeModalBefore: true
    }).then($2687097d5145937a$export$2e2bcd8739ae039.SetViewInit);
};
$2687097d5145937a$export$2e2bcd8739ae039.TreeSearchRecursive = function(sourceElement, archiveName, targetNodeID) {
    return $2687097d5145937a$export$2e2bcd8739ae039.ActionRecursive(sourceElement, archiveName, targetNodeID, 'searchfields');
};
$2687097d5145937a$export$2e2bcd8739ae039.ActionRecursive = function(sourceElement, archiveName, targetNodeID, mode, getDataEx) {
    let searchData = {
        archive: archiveName,
        recursive: false,
        mode: mode,
        page: 0,
        tree: false,
        'tree-sub': true
    };
    (0, $346VI.default).kvp_get(sourceElement, targetNodeID, 'search', 'field_', searchData, true);
    (0, $346VI.default).kvp_get(sourceElement, targetNodeID, 'recursive', '', searchData, false);
    /*if (DrDocWeb.IsNullOrEmpty(mode) && !DrDocWeb.IsNullOrEmpty(searchData['recursive-query'])) {
        searchData = searchData['recursive-query'];
        if (typeof searchData === 'string')
            searchData = DrDocWeb.QueryStrToObject(searchData);
    }*/ if ((0, $346VI.default).IsNullOrEmpty(mode) && (0, $346VI.default).IsNullOrEmpty(searchData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD])) {
        searchData['mode'] = 'searchfields';
        searchData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD] = '*';
    }
    if (getDataEx !== undefined && getDataEx !== null) Object.assign(searchData, getDataEx);
    console.log('DrDoc.TreeSearchRecursive: ', searchData);
    //Object.assign(searchData, );
    return (0, $fWhbk.default).LoadComponent({
        nav: false,
        sourceElement: sourceElement,
        targetElement: targetNodeID,
        getData: searchData,
        postData: {}
    });
};
// Datensatz-Zeile aktualisieren
$2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow = function(sourceElement, archiveName, documentId) {
    var rowElem1 = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (rowElem1 === undefined || rowElem1 === null || rowElem1 === false) {
        console.warn('DrDoc.UpdateDatasetRow: rowElem not found: ', sourceElement, archiveName, documentId);
        return undefined;
    }
    //setTimeout(function(){
    // system/list | content | wfmain | TODOLISTE | 19735
    //let searchTemplateName2 = DrDoc.GetListTemplateName(rowElem);
    //let searchTemplateName = f(rowElem, archiveName);
    //console.log('DrDoc.UpdateDatasetRow', rowElem, sourceElement, archiveName, documentId, searchTemplateName); //, ' / ', searchTemplateName2);
    let getData = {
        archive: archiveName,
        searchTemplateName: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(rowElem1, archiveName),
        //id: (documentId === undefined || documentId === null ? '' : documentId),
        //mode: 'get'
        mode: 'searchfields',
        selection: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection(rowElem1, archiveName),
        recursive: 'new',
        tree: false,
        'tree-sub': false
    };
    getData['field_' + $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD] = documentId;
    return (0, $fWhbk.default).LoadComponent({
        exact: true,
        title: 'Datensatz Zeile im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: rowElem1,
        targetElement: rowElem1,
        getData: getData,
        postData: {}
    });
//}, 5000);
};
$2687097d5145937a$export$2e2bcd8739ae039.AiDataset = function(sourceElement, archiveName, documentIdField, documentId, aiMode, aiValue) {
    //let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = (0, $fWhbk.default).GetNodeId($2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName)) + '|ai';
    console.log('DrDoc.AiDataset: ', 'node-id:', nodeId, $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName));
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'get',
            autolock: false,
            id_field: documentIdField,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            ai: aiMode,
            value: (0, $346VI.default).IsNullOrEmpty(aiValue) ? '' : aiValue
        }
    }).then(function() {
        setTimeout(function() {
            /*//let valueElem = document.getElementsByName('value');
                let valueElem = DrDocWeb.GetElement(sourceElement, 
                console.log('DrDoc.AiDataset: ', valueElem);
                if (valueElem && valueElem.length > 0)
                {
                    valueElem[0].scrollIntoView();
                }*/ //let objectSelector = DrDocWeb.GetElement(document, '.modal-body:has(#ai-chat-container)');
            let objectSelector = document.querySelector('.modal-body:has(#ai-chat-container)');
            if (objectSelector) //console.log('DrDoc.AiDataset: ', objectSelector, objectSelector2, document.querySelector('#ai-chat-container'));
            objectSelector.scrollTo({
                top: objectSelector.scrollHeight
            });
            // ai-chat-input
            let input = document.querySelector('#ai-chat-input');
            if (input) {
                input.scrollIntoView();
                input.focus();
            }
        }, 100);
    });
};
/*DrDoc.AiDatasetChatRequest = function (sourceElement, archiveName, documentId, chatReqText) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName) + '|ai';

    return Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            mode: 'set',
            ai: 'init-chat-doc',
        }
    });
};*/ // Datensatz
$2687097d5145937a$export$2e2bcd8739ae039.SaveDataset = function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    //let elem = Node.GetElement(nodeId);
    //elem.beforeunload = undefined;
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz speichern im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'set'
        },
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    }).then((data)=>{
        //console.log('SaveDataset (=> geladen): ', archiveName, 'set', sourceElement);
        $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
    });
};
$2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset = function(sourceElement, archiveName, documentId, action, text, getData) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    if (getData === undefined || getData === null) getData = {};
    getData.archive = archiveName;
    getData.id = (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId;
    getData.mode = action;
    return (0, $fWhbk.default).LoadComponent({
        title: text + ' im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getData,
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.DeleteDataset = function(sourceElement, archiveName, documentId) {
    if (window.confirm("Soll der Datensatz gel\xf6scht werden?")) return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'delete', "Datensatz l\xf6schen").then((data)=>{
        //DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
        var rowElem1 = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
        if (rowElem1 === undefined || rowElem1 === null || rowElem1 === false) {
            console.warn('DrDoc.DeleteDataset: rowElem not found: ', sourceElement, archiveName, documentId);
            return undefined;
        }
        rowElem1.classList.add('text-decoration-line-through'); // x-d-none');
    });
    else return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.PresetDataset = function(sourceElement, archiveName, documentId, presetName) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'preset', 'Datensatz (vor)belegen', {
        preset: presetName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.LockDataset = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'lock', 'Datensatz sperren');
};
$2687097d5145937a$export$2e2bcd8739ae039.UnlockDataset = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039._fn_Dataset(sourceElement, archiveName, documentId, 'unlock', 'Datensatz entsperren');
};
$2687097d5145937a$export$2e2bcd8739ae039.UnlockOnlyDataset = function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    return (0, $346VI.default).SendGet('model/crud', {
        archive: archiveName,
        action: 'unlock',
        id: documentId
    });
};
// 
$2687097d5145937a$export$2e2bcd8739ae039.CallbackFormInternal = function(sourceElement, nodeId, argValue, title, callbackFn) {
    let fnId = 'form_' + (0, $346VI.default).RandomChars(12);
    // in "system/select-wf-user|content" ruft der User das Callback über ein Promise auf
    return (0, $fWhbk.default).LoadComponent({
        title: !(0, $346VI.default).IsNullOrEmpty(title) ? title : 'Form',
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            // archive: archiveName,
            value: argValue,
            callback: fnId
        }
    }).then(function() {
        // Modal mit "system/select-wf-user|content" wurde geladen
        //console.log('DrDoc.CallbackFormInternal: then');
        return new Promise((resolve, reject)=>{
            // Promise resolve als Callback für Modal setzen
            // console.log('DrDoc.CallbackFormInternal: then->myPromise2');
            window.DrDoc[fnId] = resolve;
        }).then(function(obj) {
            // Modal schließen und Objekt an Callback übergeben
            // console.log('DrDoc.CallbackFormInternal: then->myPromise2->callbackFn', obj);
            (0, $346VI.default).ModalClose(obj.sourceElement);
            // bereinigen
            delete window.DrDoc[fnId];
            return callbackFn(obj);
        }).catch(function() {
            // bereinigen
            delete window.DrDoc[fnId];
        });
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser = async function(sourceElement) {
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, $2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    let WFT_Aufgabe = (0, $iuVXB.default).GetTableRows(formData['WFT_Aufgabe']);
    let WFT_Bearbeiter = (0, $iuVXB.default).GetTableRows(formData['WFT_Bearbeiter']);
    let WFT_erledigt_von = (0, $iuVXB.default).GetTableRows(formData['WFT_erledigt_von']);
    // "modeMulti" gibt an, ob WfSelectUser rekursiv aufgerufen werden soll
    // Es sollen alle %R% aber nur das erste "?" und das erste "[{}]" ersetzt werden
    let modeMulti = true;
    let rowIndexIst = WFT_erledigt_von.length;
    // Workflow-Bearbeiter wählen
    let rowIndexFound = WFT_Bearbeiter.indexOf('%R%');
    if (rowIndexFound === -1) {
        modeMulti = false;
        // Workflow-Bearbeiter zur Laufzeit wählen
        // "?" als zu wählender Soll-Bearbeiter ist nur zulässig, wenn es den nächsten Schritt betrifft
        rowIndexFound = WFT_Bearbeiter.indexOf('?');
        if (rowIndexFound === -1) {
            rowIndexFound = WFT_Bearbeiter.indexOf('[{}]');
            if (rowIndexFound === -1) // kein zu wählender Bearbeiter gefunden
            return true;
            else if (rowIndexFound > rowIndexIst + 1) // zu wähelnder Bearbeiter ist zu weit hinten
            //console.log('DrDoc.WfSelectUser: zu wähelnder Bearbeiter ist zu weit hinten: ', rowIndexFound, rowIndexIst, WFT_Bearbeiter, ' / ', WFT_erledigt_von);
            return true;
        } else if (rowIndexFound > rowIndexIst + 1) // zu wähelnder Bearbeiter ist zu weit hinten
        //console.log('DrDoc.WfSelectUser: zu wähelnder Bearbeiter ist zu weit hinten: ', rowIndexFound, rowIndexIst, WFT_Bearbeiter, ' / ', WFT_erledigt_von);
        return true;
    } else modeMulti = true;
    let formData2 = (0, $346VI.default).GetClosestForm(sourceElement);
    console.log('DrDoc.WfSelectUser: select WF: rowIndexFound: ', rowIndexFound, ' / ', formData2['WFT_Bearbeiter'][rowIndexFound].value);
    // Benutzer wählen
    // erst mit WF-Erledigung fortfahren, wenn alle %R% entfernt wurden
    return $2687097d5145937a$export$2e2bcd8739ae039.CallbackFormInternal(sourceElement, 'system/select-wf-user|content', WFT_Aufgabe[rowIndexFound], `Workflow-Schritt "${WFT_Aufgabe[rowIndexFound]}": Bitte WF-Namen und Benutzer w\xe4hlen`, function(obj) {
        console.log('DrDoc.WfSelectUser/CallbackFormInternal: Username/Group selected: ', obj);
        // neuen WF Namen und Bearbeiter setzen
        formData2['WFT_Aufgabe'][rowIndexFound].value = obj.wfName;
        formData2['WFT_Bearbeiter'][rowIndexFound].value = obj.username;
        // bei %R% erneut ausführen, bis alle angegeben wurden, bis kein %R% mehr gefunden wird
        if (modeMulti) return $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
        else return true;
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfCompleteDataset = async function(sourceElement, archiveName, documentId) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    console.log('DrDoc.WfCompleteDataset: ', sourceElement, archiveName, documentId);
    // Alle WF-Soll-User angeben für %R%
    let ret1 = await $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
    console.log('DrDoc.WfCompleteDataset:  Ret Done!', ret1);
    //return;
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Workflow erledigen im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'wf-complete'
        },
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        closeModalAfter: true
    }).then((data)=>{
        //console.log('WfCompleteDataset (=> geladen): ', archiveName, 'wf-complete', sourceElement);
        var prem1 = $2687097d5145937a$export$2e2bcd8739ae039.OnSelectNextDataset(sourceElement, archiveName, '', documentId);
        if (prem1 != undefined && prem1 != null) prem1.then(function(d) {
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
        });
        else {
            console.log('DrDoc.WfCompleteDataset: OnSelectNextDataset ERROR');
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfInsertDataset = async function(sourceElement, archiveName, documentId, insertIndex, mode) {
    let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, archiveName);
    let formData = (0, $346VI.default).GetClosestForm(sourceElement);
    let WFT_Aufgabe = formData['WFT_Aufgabe'];
    let WFT_Bearbeiter = formData['WFT_Bearbeiter'];
    let taskElem = WFT_Aufgabe[insertIndex];
    let trElem = (0, $346VI.default).GetClosestTag(taskElem, 'tr');
    //console.log('Task Elem Row: ', trElem);
    // Workflow-Schritte anfügen
    // das %R% wird in WfSelectUser angegeben.
    if (mode === 1) {
        // Weiterleiten
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 1].value = 'Weiterleiten';
        WFT_Bearbeiter[insertIndex + 1].value = '?';
    } else if (mode === 2) {
        // Weiterleiten mit Rücklauf
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 1].value = 'Weiterleiten';
        WFT_Bearbeiter[insertIndex + 1].value = '?';
        $2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow(trElem);
        WFT_Aufgabe[insertIndex + 2].value = "R\xfccklauf";
        WFT_Bearbeiter[insertIndex + 2].value = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName).UserSession.Username;
    }
    // Alle WF-Soll-User auswählen für %R%
    let ret1 = await $2687097d5145937a$export$2e2bcd8739ae039.WfSelectUser(sourceElement);
    console.log('DrDoc.WfInsertDataset:  Ret Done!', ret1);
    return (0, $fWhbk.default).LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Workflow erledigen im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId,
            mode: 'set'
        }
    }).then((data)=>{
        $2687097d5145937a$export$2e2bcd8739ae039.UpdateDatasetRow(sourceElement, archiveName, documentId);
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset = function(sourceElement, getDS, getDoc) {
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, $2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    let WF_LinkArchiv = formData['WF_LinkArchiv'];
    let WF_LinkGUID = formData['WF_LinkGUID'];
    if ((0, $346VI.default).IsNullOrEmpty(WF_LinkArchiv)) return false;
    if ((0, $346VI.default).IsNullOrEmpty(WF_LinkGUID)) return false;
    console.log('DrDoc.WfGetDataset: Form:  ', formData);
    let archive_arr = (0, $iuVXB.default).GetTableRows(WF_LinkArchiv);
    let guid_arr = (0, $iuVXB.default).GetTableRows(WF_LinkGUID);
    // Nach Archiv gruppieren
    let searchObj = {};
    for(let i in archive_arr){
        let archiveName = archive_arr[i];
        let guid = guid_arr[i];
        if ((0, $346VI.default).IsNullOrEmpty(archiveName)) continue;
        if ((0, $346VI.default).IsNullOrEmpty(guid)) continue;
        archiveName = archiveName.toLowerCase();
        if (searchObj[archiveName] === undefined) searchObj[archiveName] = [
            guid
        ];
        else searchObj[archiveName].push(guid);
    }
    console.log('DrDoc.WfGetDataset: WF Doks. 3: ', searchObj);
    for(let archiveName in searchObj){
        if (searchObj[archiveName].length > 0 && getDoc) {
            // Dokument laden, wenn nur 1 Dokument
            console.log('DrDoc.MaskShowDocumentByField: ', archiveName, 'DrDocGUID', searchObj[archiveName]);
            $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(null, archiveName, 'DrDocGUID', searchObj[archiveName].join('|'));
        }
        //else
        //{
        if (getDS) // Feldsuche in neuem Fenster
        $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsInfo(null, archiveName, {
            DrDocGUID: searchObj[archiveName].join('|')
        }, true);
    //}
    }
    return true;
};
// DrDoc.ID_FIELD = 'Dokument-Nr.';
// DrDoc.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD = (0, $iuVXB.default).ID_FIELD;
$2687097d5145937a$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = (0, $iuVXB.default).TABLE_ROW_SPLITTER;
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocument = function(sourceElement, archiveName, documentId) {
    $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(sourceElement, archiveName, $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD, documentId);
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField = function(archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    //let url = `/model/document?archive=${archiveName}&action=get&original=false&id_field=${fieldName}&id=${fieldValue}`;
    /*let url = '/model/document?' + DrDocWeb.ObjectToQueryStr({
        archive: archiveName,
        action: 'get',
        original: false,
        id_field: fieldName,
        id: fieldValue
    });*/ //let url = `/node/system/mask|content|${archiveName}|dataset|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}`;
    //let url = `/node/system/mask|content|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}&extern=true`;
    let url = '/node/system/mask|content|Bild?' + (0, $346VI.default).ObjectToQueryStr({
        mode: 'get',
        archive: archiveName,
        id_field: fieldName,
        id: fieldValue,
        extern: 'true',
        autolock: false,
        page: page,
        sign: sign,
        sign_create: sign_create,
        sign_create_preset: sign_create_preset,
        sign_pos: sign_pos,
        sign_text_rel: sign_text_rel,
        sign_align: sign_align
    });
    return url;
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField = function(sourceElement, archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align);
    return $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentUrl(sourceElement, archiveName, url);
};
$2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentUrl = function(sourceElement, archiveName, url) {
    // wenn es einWF Instanz ist, dann ausführen
    if (sourceElement !== undefined && sourceElement !== null) {
        let wfGetDs = $2687097d5145937a$export$2e2bcd8739ae039.WfGetDataset(sourceElement, false, true);
        if (wfGetDs === true) return true;
    }
    let wnd = $2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd(archiveName, true, url);
///if (wnd.location == undefined || DrDocWeb.IsNullOrEmpty(wnd.location.href) || wnd.location.href == 'about:blank')
//    wnd.location.href = url;
//else
//    wnd.location.replace(url);
};
$2687097d5145937a$export$2e2bcd8739ae039.CloseAllDocumentWnd = function() {
    console.log('DrDoc.CloseAllDocumentWnd ', window._docWindow);
    if (window._docWindow == null || window._docWindow == undefined) window._docWindow = {};
    for(var wndId in window._docWindow){
        var wnd = window._docWindow[wndId];
        if (wnd != undefined && wnd != null) wnd.close();
        delete window._docWindow[wndId];
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd = function(archiveName, create, url) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) archiveName = '_DEFAULT_';
    else archiveName = 'wnd-' + (0, $346VI.default).ChecksumCyrb53(archiveName).toString();
    if ((0, $346VI.default).IsNullOrEmpty(url)) url = 'about:blank';
    /*console.log('DrDoc.GetDocumentWnd: Open: ', url);
    if (url == 'about:blank')
    {
        return;
    }*/ var setWndPos = function(wndObj) {
        //var left = DrDocWeb.FindLeftScreenBoundry(wndObj);
        //var top = DrDocWeb.FindTopScreenBoundry(wndObj);
        //console.log('setWndPos: / left: ', left, ' / top: ', top);
        //return;
        if (wndObj == undefined || wndObj == null) return false;
        //DrDoc.configDevice.set(`window/${archiveName}/ext`, 2);
        //console.log('DrDoc.GetDocumentWnd: RESIZE', archiveName, `window/${archiveName}/ext`, DrDoc.configDevice.get(`window/${archiveName}/ext`));
        try {
            /*if (wndObj.outerWidth !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: WxH: ', wndObj, +wndObj.outerWidth, wndObj.outerHeight);

            if (wndObj.screenX !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: XxY: ', wndObj, wndObj.screenX, wndObj.screenY, ' / ', wndObj.top, wndObj.left);
            */ let w = 500;
            let h = w * 3.0 / 2.0;
            if (wndObj.width !== undefined) {
                w = wndObj.width;
                h = wndObj.height;
            } else if (wndObj.outerWidth !== undefined) {
                w = wndObj.outerWidth;
                h = wndObj.outerHeight;
            }
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/w`, w);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/h`, h);
            /*if (wndObj.left !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.left);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.top);
            }
            else if (wndObj.screenLeft !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.screenLeft);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.screenTop);
            }*/ //DrDoc.configDevice.set(`window/${archiveName}/x`, DrDocWeb.FindLeftScreenBoundry(wndObj));
            //DrDoc.configDevice.set(`window/${archiveName}/y`, DrDocWeb.FindTopScreenBoundry(wndObj));
            var left = (0, $346VI.default).FindLeftScreenBoundry(wndObj);
            var top = (0, $346VI.default).FindTopScreenBoundry(wndObj);
            //var left = wndObj.screenX + (wndObj.screen.width / 2) - (w / 2);
            //var top = (wndObj.screen.height / 2) - (h / 2);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/x`, left);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/y`, top);
            if (wndObj.screen !== undefined) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(`window/${archiveName}/ext`, wndObj.screen.isExtended);
        } catch (ex) {
        //console.warn('setWndPos', ex, wnd);
        }
    };
    // window._docWindow[ARCHIVE]
    // Falls das Dokument-Fenster bereits geladen wurde, diese wiederverwenden, damit der Focus nicht verloren geht.
    if (window._docWindow == null || window._docWindow == undefined) window._docWindow = {};
    //console.log('DrDoc.GetDocumentWnd(1): ', window._docWindow, archiveName, create);
    let wnd = window._docWindow[archiveName];
    if (wnd !== undefined && wnd !== null) {
        //if (wnd.document.readyState !== 'complete')
        /*if (wnd.document !== undefined && wnd.document.readyState !== 'complete')
        {
            return DrDoc.GetDocumentWnd(archiveName, create, url);
        }*/ //if (wnd.closed === false)
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 1 exit/ret', archiveName, ' closed: ', wnd.closed, wnd);
        //else
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 2 close/open', archiveName, ' closed: ', wnd.closed, wnd);
        /*if (wnd.closed === true)
        {
            console.log('DrDoc.GetDocumentWnd: Window Reactivate');
            wnd.open('about:blank');
        }*/ //console.log('DrDoc.GetDocumentWnd: Window Reactivate 1 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);
        // A: Fenster immer schließen
        //wnd.close();
        // B: Fenster wiederverwenden, wenn es noch offen ist
        if (wnd.closed === undefined || wnd.closed === false) {
            setWndPos(wnd);
            //console.log('DrDoc.GetDocumentWnd A: Reuse ', archiveName, wnd, wnd.closed);
            if (!(0, $346VI.default).IsNullOrEmpty(url)) wnd.location.replace(url);
            // Im Fullscreen das neue Fenster immer fokussieren
            if ((0, $346VI.default).WindowIsMaximized()) {
                console.log('############ WINDOW FOCUS');
                wnd.focus();
            //setTimeout(function(){wnd.focus();},500);
            }
            return wnd;
        }
        console.log('DrDoc.GetDocumentWnd A: Try Close ', archiveName, wnd, wnd.closed);
        try {
            wnd.close();
        //wnd.close('','_parent','');
        } catch (ex) {}
        delete window._docWindow[archiveName];
    //wnd = null;
    }
    if (create) {
        //if (wnd !== undefined && wnd !== null)
        //console.log('DrDoc.GetDocumentWnd: Window reactivate 2 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);
        //console.log('DrDoc.GetDocumentWnd: OPEN', archiveName);
        var newDocWindow = window.open((0, $346VI.default).IsNullOrEmpty(url) ? 'about:blank' : url, //'Dokument_' + archiveName,
        //'Dokument (' + archiveName + ')',
        //'_self',
        '_blank', 'height=700,width=500,status=no,toolbar=no,location=no,menubar=no,scrollbars=yes,modal=yes'); //,alwaysRaised=yes,alwaysLowered=yes,dependent=yes');
        var setWindowPropsEvent = function(e) {
            if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.has(`window/${archiveName}/w`)) {
                //console.log('DrDoc.GetDocumentWnd Reset: ', archiveName, DrDoc.configDevice.get(`window/${archiveName}/w`));
                if (newDocWindow.screen != undefined) newDocWindow.screen.isExtended = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/ext`);
                //newDocWindow.left = +DrDoc.configDevice.get(`window/${archiveName}/x`);
                //newDocWindow.top = +DrDoc.configDevice.get(`window/${archiveName}/y`);
                //newDocWindow.leftScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/x`);
                //newDocWindow.topScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/y`);
                newDocWindow.moveTo($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/x`), $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/y`));
                //newDocWindow.moveBy(DrDoc.configDevice.get(`window/${archiveName}/x`), DrDoc.configDevice.get(`window/${archiveName}/y`));
                //newDocWindow.width = +DrDoc.configDevice.get(`window/${archiveName}/w`);
                //newDocWindow.height = +DrDoc.configDevice.get(`window/${archiveName}/h`);
                newDocWindow.resizeTo($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/w`), $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get(`window/${archiveName}/h`));
            //if (newDocWindow.screen != undefined)
            //    newDocWindow.screen.isExtended = DrDoc.configDevice.get(`window/${archiveName}/ext`);
            }
        };
        window._docWindow[archiveName] = newDocWindow;
        //newDocWindow.postMessage("hello there!", "http://example.com");
        var fnEvent = function(e) {
            //console.log('DrDoc.GetDocumentWnd(load): ', '1:', e, '2:', e.target, '3:', this);
            //setWndPos(e.target);
            //setWndPos(newDocWindow);
            setWndPos(window._docWindow[archiveName]);
        //setWndPos(this);
        };
        setWindowPropsEvent();
        // Bei Änderung Fenster Pos. speichern
        newDocWindow.addEventListener('beforeunload', fnEvent, false);
        //newDocWindow.addEventListener('load', fnEvent);
        newDocWindow.addEventListener('resize', fnEvent);
        newDocWindow.addEventListener('mouseout', fnEvent);
        newDocWindow.addEventListener('close', fnEvent);
        newDocWindow.addEventListener('load', setWindowPropsEvent);
        /*setTimeout(function (e) {
            setWndPos(e.target);
            //setWndPos(newDocWindow);
            //setWndPos(this);
        }, 1000);
        setTimeout(function (e) {
            setWndPos(e.target);
            setWndPos(newDocWindow);
            //setWndPos(this);
        }, 5000);*/ /*var ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const cr = entry.contentRect;
              setWndPos(cr);
            }
        });
        ro.observe(newDocWindow.document);*/ /*newDocWindow.addEventListener('load', function(e)
        {
            console.log('New Window has been loadad', e, e.target.documentElement);
        }, true);
        mainWindow.focus();
        newDocWindow.blur();*/ //console.log('DrDoc.GetDocumentWnd(2): ', window._docWindow, archiveName, create);
        // Im Fullscreen das neue Fenster immer fokussieren
        if ((0, $346VI.default).WindowIsMaximized()) //console.log('############ WINDOW FOCUS');
        newDocWindow.focus();
        return newDocWindow;
    } else //console.log('DrDoc.GetDocumentWnd: Window delete ', archiveName, wnd);
    //delete window._docWindow[archiveName];
    return undefined;
};
// | ---        | ---      | --- |
// | Mode       | Readonly | OK |
// | ---        | ---      | --- |
// | Extern Wnd | true     | -   |
// | Modal      | true     | -   |
// | Control    | true     | -   |
// | Extern Wnd | false    | -   |
// | Modal      | false    | -   |
// | Control    | false    | -   | 
// | ---        | ---      | --- |
// DrDoc.CreateMarkdownElement('srcelemid', true, 'modal', null, true, false, `Name: (Name)`);
$2687097d5145937a$export$2e2bcd8739ae039.CreateMarkdownElement = function(sourceElement, isReadOnly, viewMode, mdMode, mdForceCreateWnd, mdAutosize, title) {
    let sourceElementOrig = sourceElement;
    if ((0, $346VI.default).IsNullOrEmpty(sourceElement)) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', sourceElement);
        return null;
    }
    if (typeof sourceElement === 'string') sourceElement = document.querySelector(sourceElement);
    if (sourceElement == undefined || sourceElement == null) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', sourceElementOrig);
        return;
    }
    let targetElementId = sourceElement.getAttribute('data-md-id');
    if (sourceElement == undefined || sourceElement == null) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', targetElementId, sourceElement);
        return null;
    //return undefined;
    }
    // zufällige Element ID erstellen
    if ((0, $346VI.default).IsNullOrEmpty(targetElementId)) {
        targetElementId = (0, $346VI.default).RandomChars(12);
        sourceElement.setAttribute('data-md-id', targetElementId);
    }
    // Wenn kein MD-Mode angegeben wurde, dann aus Settings übernehmen
    if (mdMode === undefined || mdMode === null) {
        var mdModeCtrl = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/markdown-ctrl', false);
        var mdModeModal = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/markdown-modal', true);
        //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode: ', mdMode, mdModeModal, mdModeCtrl);
        mdMode = mdModeModal === true || mdModeCtrl === true;
    //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode 2: ', mdMode);
    }
    var validateElemValue = function(retValue) {
        if (mdMode == true && !(0, $346VI.default).IsNullOrEmpty(retValue)) {
            // keine "<br>" direkt vor einem "<ul>" für Markdown-Text erlauben!
            // da Toast-UI sonst den Text leert
            const lineBreakReplacement = "<br>"; // funktioniert nicht
            //const lineBreakReplacement = "<br/>"; // funktioniert nicht
            //const lineBreakReplacement = "\\"; // funktioniert nicht
            //const lineBreakReplacement = "\\\r\n"; // funktioniert nicht
            //const lineBreakReplacement = "&#10;"; // funktioniert nur zur Anzeige, jedoch nicht wenn man zum Markdown Modus in den WYSIWYG Modus wechselt
            //const lineBreakReplacement = "&#10;\\"; // funktioniert nicht
            //const lineBreakReplacement = "  &#10;"; // <space><space>\n
            //const lineBreakReplacement = '\\\\\\n'; // "\\\n"
            //const lineBreakReplacement = "\\\\\n"; // "\\ \n"
            //const lineBreakReplacement = "<br/>";
            retValue = retValue.replaceAll('<br>', lineBreakReplacement).replaceAll('<br/>', lineBreakReplacement).replaceAll('<br />', lineBreakReplacement);
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');
            // MD Inline Code in Auflistungen verbieten
            // <li>`Test`</li>
            //retValue = retValue.replace(/(?<=\<li.*\>.*)\`([^\`]+)\`(?=.*\<\/li\>)/gi, '$1');
            // Pipe Symbol "|" in Tabellen-Zellen escapen, auch wenn es innerhalb von Inline-Code (z.B. `Code1|Code2`) steht.
            // ab 17.12.2024 eingetragen
            //retValue = retValue.replace(/(?<=\n\|\x20[^\r\n]*\`[^\r\n]*)(?<!\\)(\|)(?=[^\r\n]*\`)/gi, '\\$1');
            //retValue = retValue.replace(/(?<=\n\|\x20.*\`.*)(?<!\\)(\|)(?=.*\`)/gi, '\\$1');
            // ab 06.02.2025
            // retValue = retValue.replace(/(?<=(\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');
            // ab 20.02.2025
            retValue = retValue.replace(/(?<=\|[^\r\n\|\`\>]*(?:\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');
            // Pipe Symbol "|" In <li> Auflistungen escapen
            //retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');
            // Pipe Symbol "|" Innerhalb von HTML-Code escapen
            //retValue = retValue.replace(/(?<=\<[a-z]{1,2}[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/[a-z]{1,2}\>)/gi, '\\$1');
            // ab 17.12.2024 ausgetragen
            retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');
            // innerhalb von ```text ...  ``` den Text "```" escapen
            retValue = retValue.replace(/(?<=\n\`\`\`[^\`]*)(?<!\\)(\`\`\`)(?=[^\`]*\`\`\`)/gi, '\`\`\`');
        }
        return retValue;
    };
    var getElemValue = function() {
        //console.log('DrDoc.CreateMarkdownElement: getElemValue: ', sourceElement.value, sourceElement.innerHTML);
        let retValue = '';
        if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.value)) retValue = sourceElement.value;
        else if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.innerHTML)) retValue = sourceElement.innerHTML;
        else if (!(0, $346VI.default).IsNullOrEmpty(sourceElement.innerText)) retValue = sourceElement.innerText;
        return validateElemValue(retValue);
    };
    var contentElement = null;
    if (mdMode == true || viewMode == 'window' || viewMode == 'iframe') {
        // => Markdown Mode
        let url = '/node/system/md?id=' + targetElementId + '&readonly=' + (isReadOnly === true ? 'true' : 'false');
        var mdCom = new BroadcastChannel('md-' + targetElementId);
        //var initValue = sourceElement.value;
        var updateValue = function() {
            //console.log('MD: updateValue Wnd ', getElemValue(), '   //    ', sourceElement.value);
            mdCom.postMessage(getElemValue());
        };
        // rekursion vermeiden
        var evIsActive = true;
        // Textarea/sourceElement updaten, wenn Markdown geändert wird
        mdCom.onmessage = function(event) {
            //console.log('MD: Receive Value', event);
            // textarea updaten
            evIsActive = false;
            sourceElement.value = validateElemValue(event.data);
            evIsActive = true;
        };
        // Markdown updaten, wenn Textarea/sourceElement geändert wird
        sourceElement.addEventListener('change', function(e) {
            if (evIsActive) updateValue();
        });
        if (viewMode == 'window') {
            // Window
            let wnd = $2687097d5145937a$export$2e2bcd8739ae039.GetDocumentWnd('md-' + targetElementId, mdForceCreateWnd === true, url); // + '#' + DrDocWeb.RandomChars(6));
            if (wnd == undefined || wnd == null) {
                console.log('MD Wnd: not found: ', targetElementId);
                // Window existiert nicht
                return null;
            }
            wnd.updateValue = updateValue;
            /*wnd.contentWindow.addEventListener('load', function(e) {
                wnd.updateValue();
            });*/ //wnd.location.href = url + '#' + DrDocWeb.RandomChars(6);
            // Wenn das Fenster bereits geladen wurdem dann direkt Wert updaten, ansonsten im Load-Event laden
            if (wnd && wnd.contentWindow && wnd.contentWindow.document.readyState === 'complete') updateValue();
            else wnd.addEventListener('load', function(e) {
                updateValue();
            });
            wnd.addEventListener('popstate', function(e) {
                console.log('MD Wnd: popstate');
                setTimeout(updateValue, 1000);
            });
            /*wnd.addEventListener('beforeunload', function(e) {
                console.log('MD Wnd: beforeunload');
                setTimeout(updateValue, 4000);
            });
            wnd.addEventListener('unload', function(e) {
                console.log('MD Wnd: unload');
                setTimeout(updateValue, 200);
            });
            updateValue();*/ //setTimeout(updateValue, 100);
            //setTimeout(updateValue, 300);
            setTimeout(updateValue, 2000);
            return wnd;
        } else {
            // Iframe
            contentElement = document.createElement('iframe');
            contentElement.src = url;
            // Textarea verbergen
            //sourceElement.style.display = 'none';
            contentElement.updateValue = updateValue;
            //setTimeout(updateValue, 2600);
            // erst wenn das Element eingebunden wurde, und anschließend die Seite geladen wurde, "postMessage" mit Text übergeben.
            //contentElement.addEventListener('load', function(e0) {
            /*setTimeout(function() {
                updateValue();
                while (contentElement.contentWindow == undefined || contentElement.contentWindow == null)
                {
                    // wait..
                    ;;
                }
                contentElement.contentWindow.addEventListener('load', function(e) {
                    console.log('DrDoc.CreateMarkdownElement / contentElement.contentWindow.addEventListener(load)');
                    updateValue();
                });
                console.log('DrDoc.CreateMarkdownElement / setTimeout');
                updateValue();
            }, 100);*/ contentElement.addEventListener('load', function(e) {
                console.log('DrDoc.CreateMarkdownElement: iframe.addEventListener(load)');
                updateValue();
            });
            //});
            contentElement.id = 'md-iframe-' + targetElementId;
            contentElement.style.outline = 'none';
            contentElement.style.border = 'none';
            contentElement.style.borderStyle = 'none';
            contentElement.style.borderWidth = '0';
            contentElement.frameborder = '0';
            updateValue();
            if (viewMode != 'window' && viewMode != 'modal') {
                if (mdAutosize === true) {
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-main-container');
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    // Readonly in voller Höhe anzeigen
                    if (isReadOnly === true) (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror');
                    else (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '90vh');
                }
            //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
            //DrDocWeb.IframeAutosize(contentElement, '');
            /*setTimeout(function(){
                        //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
                        //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor.ww-mode');
                        DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    }, 1000);*/ }
        }
    } else {
        // Text Mode / kein Markdown Mode
        //console.log('DrDoc.CreateMarkdownElement: Element: ', sourceElement);
        var elemValue = getElemValue();
        //console.log('DrDoc.CreateMarkdownElement: Text (no MD): ', elemValue);
        if ((0, $346VI.default).IsNullOrEmpty(elemValue)) elemValue = '';
        //else
        //    elemValue = elemValue.replaceAll('<', '&lt;').replaceAll('>', '&gt;');
        contentElement = document.createElement('div');
        if (isReadOnly) {
            //contentElement.innerHTML = `<pre>${elemValue}</pre>`;
            contentElement.innerHTML = `<pre></pre>`;
            contentElement.querySelector('pre').innerText = elemValue;
        } else {
            //contentElement.innerHTML = `<textarea class="form-control" style="width: 100%; height: 100%;" rows="12" id="${targetElementId}--textarea" onchange="document.getElementById('${targetElementId}').value = this.value;">${elemValue}</textarea>`;
            contentElement.innerHTML = `<textarea class="form-control" style="width: 100%; height: 100%;" rows="12" id="${targetElementId}--textarea"></textarea>`;
            //contentElement.querySelector('textarea').innerText = elemValue;
            contentElement.querySelector('textarea').value = elemValue;
            contentElement.querySelector('textarea').onchange = function(e_t) {
                //document.getElementById(targetElementId).value = e_t.target.value;
                sourceElement.value = e_t.target.value;
            };
        }
    }
    if (viewMode != 'window' && viewMode != 'modal') {
        // sourceElement ausblenden
        sourceElement.style.display = 'none';
        // iframe anhängen
        if (sourceElement.parentNode) {
            if (!(0, $346VI.default).IsNullOrEmpty(contentElement.id)) {
                let contentElementOld = sourceElement.parentNode.querySelector('#' + contentElement.id);
                if (contentElementOld) sourceElement.parentNode.removeChild(contentElementOld);
            }
            sourceElement.parentNode.appendChild(contentElement);
            (0, $346VI.default).IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '100vh');
        }
    }
    if (viewMode == 'modal') {
        if (contentElement.style !== undefined) {
            contentElement.style.width = 'calc(100% + 2rem)';
            contentElement.style.height = 'calc(100% + 1.75rem)';
            contentElement.style.margin = '-1rem -1rem -1rem -1rem';
        }
        (0, $346VI.default).Modal(title, contentElement, {
            //fullScreen: (md === true ? true : false)
            fullScreen: true
        }).show();
    }
    return contentElement;
};
$2687097d5145937a$export$2e2bcd8739ae039.SignIn = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer anmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'signin',
            ret: window.location.href
        },
        modalOption: {
            static: true,
            fullScreen: false,
            size: 'xl'
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SignInAction = function(formElem) {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer Anmeldung',
        sourceElement: formElem,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'signin',
            ret: window.location.href
        },
        postData: {
            username: formElem['username'].value,
            password: formElem['password'].value,
            totp: formElem['totp'] != null ? formElem['totp'].value : ''
        },
        requestMethod: 'POST'
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.SignOut = function(allSessions) {
    return (0, $fWhbk.default).LoadComponent({
        title: 'Benutzer abmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: allSessions === true ? 'signout-all' : 'signout',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TotpEnroll = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'TOTP Enroll',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'totp-enroll',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TotpReset = function() {
    return (0, $fWhbk.default).LoadComponent({
        title: 'TOTP Reset',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'totp-reset',
            ret: window.location.href
        }
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.DevTrust = function(devid) {
    (0, $346VI.default).SetCookie('devsid', devid, 365);
    return (0, $fWhbk.default).LoadComponent({
        title: 'Device Trust',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: {
            mode: 'dev-trust',
            ret: window.location.href
        }
    });
/*{
        username: elem['username'].value,
        password: elem['password'].value,
        totp: elem['totp'] != null ? elem['totp'].value : '',
        'dev-trust': elem['dev-trust'] != null ? elem['dev-trust'].value : ''
    }*/ };
// --
// Drag n Drop Files / Upload
$2687097d5145937a$export$2e2bcd8739ae039._Document_GetFormDataOnDropInternal = function(ev) {
    $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal(ev);
    console.log('DrDoc._Document_GetFormDataOnDropInternal: ', ev);
    return (0, $346VI.default).GetFormDataFromEvent(ev);
};
$2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragOverInternal = function(elem, ev) {
    console.log('DrDoc._Document_OnDragOverInternal');
    //console.log('DragOverHandler: File(s) in drop zone', ev, elem);
    /*if (elem.getAttribute('data-can-drop') != 'true')
    {
        return;
    }*/ // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
    //ev.target.classList.add('drop-hover');
    elem.classList.add('drop-hover');
};
$2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal = function(ev) {
    if (ev !== undefined) {
        console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target);
        /*if (ev.target != undefined && ev.target != null && ev.target.getAttribute('data-can-drop') != 'true') {
            return;
        }*/ console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target.getAttribute('data-can-drop') != 'true', ev.target == this);
        document.querySelectorAll('.drop-hover').forEach(function(elem) {
            elem.classList.remove('drop-hover');
        });
        ev.preventDefault();
    /*if (ev.target)
            ev.target.classList.remove('drop-hover');
        }
        document.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.classList.remove('drop-hover');
        });*/ }
};
$2687097d5145937a$export$2e2bcd8739ae039.Document_OnDragOver = function(elem, _ev, archiveName, presetName, idFieldName, documentId, aiCreateMode) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    if (elem != undefined && elem.getAttribute('data-can-drop') != 'true') {
        console.log('DrDoc.Document_OnDragOver: elem data-can-drop != true: ', elem);
        return;
    }
    if (_ev != undefined && _ev.target.getAttribute('data-can-drop') != 'true') {
        if (_ev != undefined && _ev.target.parentNode.getAttribute('data-can-drop') != 'true') {
            console.log('DrDoc.Document_OnDragOver: _ev.target data-can-drop != true: ', elem);
            return;
        }
    }
    console.log('DrDoc.Document_OnDragOver', elem);
    // dragover, dragleave, drop
    $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragOverInternal(elem, _ev);
    //console.log('DrDoc.Document_OnDragOver: on Drag ');
    // a dragged item leaves a valid drop target.
    elem.ondragleave = $2687097d5145937a$export$2e2bcd8739ae039._Document_OnDragLeaveInternal;
    // an item is dropped on a valid drop target.
    elem.ondrop = function(ev) {
        /*if (ev.target.getAttribute('data-can-drop') != 'true')
        {
            return;
        }*/ document.querySelectorAll('.drop-hover').forEach(function(elem) {
            elem.classList.remove('drop-hover');
        });
        //console.log('DrDoc.Document_OnDragOver: File(s) dropped in zone', ev, this, elem);
        var formData = $2687097d5145937a$export$2e2bcd8739ae039._Document_GetFormDataOnDropInternal(ev);
        $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(ev.target, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData);
    };
/*if (elem.childNodes != null)
    {
        elem.childNodes.forEach(function(childElem)
        {
            //childElem.ondrop = function(_ev2) { return elem.ondrop();
            childElem.ondrop = elem.ondrop;
            childElem.ondragleave = elem.ondragleave;
            childElem.ondragover = function(_ev2) {
                return DrDoc.Document_OnDragOver(elem, _ev2, archiveName, presetName, idFieldName, documentId, aiCreateMode);
            };
        });
    }*/ };
$2687097d5145937a$export$2e2bcd8739ae039.UploadDocumentFile = function(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, multiple, mimeType, getDocument) {
    // <input type="file" id="fileElem" multiple accept="image/*" style="display:none" />
    var fileElem = document.createElement('input');
    fileElem.style.display = 'none';
    fileElem.setAttribute('type', 'file');
    if (!(0, $346VI.default).IsNullOrEmpty(mimeType)) fileElem.setAttribute('accept', mimeType); //'image/*');
    if (multiple) fileElem.setAttribute('multiple', 'true');
    fileElem.addEventListener("change", function(e) {
        $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, fileElem, getDocument);
        fileElem.remove();
    }, false);
    fileElem.click();
};
$2687097d5145937a$export$2e2bcd8739ae039.UploadDocument = function(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument) {
    console.log(`DrDoc.UploadDocument(sourceElement: ${sourceElement}, archiveName: ${archiveName}, presetName: ${presetName}, idFieldName: ${idFieldName}, documentId: ${documentId}, aiCreateMode: ${aiCreateMode}, formData: ${formData}, getDocument: ${getDocument})`);
    if (formData == undefined || formData == null || formData === false) {
        // kein Dokument vorhanden
        console.log('DrDoc.Document_OnDragOver: elem.ondrop: kein Dokument beim Drop vorhanden');
        return;
    }
    //_ev.preventDefault();
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) {
        console.log('DrDoc.UploadDocument: 2nd order / sel archive / archiveName is empty');
        return $2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive(function(archive) {
            return $2687097d5145937a$export$2e2bcd8739ae039.UploadDocument(sourceElement, archive, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument);
        });
    }
    let stateModal = (0, $346VI.default).ModalInfo('', 'Uploading Document...');
    formData = (0, $346VI.default).GetFormDataFromEvent(formData);
    var formGetData = {};
    var formPostData = {};
    (0, $fWhbk.default).ParseFormData(sourceElement, formGetData, formPostData, false);
    //let dsExists = searchNewVersionObj[idFieldName] != undefined && searchNewVersionObj[idFieldName].length > 0 && !DrDocWeb.IsNullOrEmpty(searchNewVersionObj[idFieldName]); // && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    let dsExists = !(0, $346VI.default).IsNullOrEmpty(idFieldName) && !(0, $346VI.default).IsNullOrEmpty(documentId) && documentId != '0';
    //let modeCreate = searchNewVersionObj[DrDoc.ID_FIELD].length > 0 && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    console.log('DrDoc.UploadDocument: dsExists: ', dsExists);
    let sendCallback = null;
    if (aiCreateMode === true) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - AI-CREATE: ', formPostData, formData);
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'ai-create',
            preset: presetName,
            value: formPostData
        }, formData);
    } else if (dsExists) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - SET: ', formPostData, formData);
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'set',
            id_field: idFieldName,
            id: documentId,
            value: formPostData
        }, formData);
    } else {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - CREATE: ', formPostData, formData);
        //sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'create', preset: presetName, value: formPostData }, formData, 'form');
        sendCallback = (0, $346VI.default).Send('POST', 'model/document', {
            archive: archiveName,
            action: 'create',
            preset: presetName,
            value: formPostData
        }, formData);
    }
    return sendCallback.then(function(reponse_Str) {
        let reponse = (0, $346VI.default).JsonToObject(reponse_Str);
        console.log('DrDoc.UploadDocument: response', reponse);
        if (stateModal) stateModal.close();
        if (reponse.HasError) (0, $346VI.default).ModalError('Upload Fehler', ("Datei konnte nicht erfolgreich hochgeladen werden.\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage).replaceAll("\n", "\n<br/>\r\n"));
        else {
            //DrDocWeb.ModalOk('Upload Erfolgreich', 'Datei wurde erfolgreich hochgeladen.');
            let searchNewVersionObj = {};
            let uniqueIdFieldsArr = [
                $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD,
                'DokuNr',
                idFieldName
            ];
            for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField)) searchNewVersionObj[uniqueIdField] = [];
            let resultsArr = null;
            if (reponse.Result != undefined && reponse.Result != null) {
                if (Array.isArray(reponse.Result)) resultsArr = reponse.Result;
                else resultsArr = [
                    reponse.Result
                ];
                resultsArr.forEach(function(obj) {
                    //console.log('DrDoc.UploadDocument: ret: ', obj['DrDocGUID'], obj[DrDoc.ID_FIELD], obj['DokuNr']);
                    //searchNewVersionObj['DrDocGUID'].push(obj['DrDocGUID']);
                    if (!(0, $346VI.default).IsNullOrEmpty(obj['DokuNr']) && searchNewVersionObj['DokuNr'].indexOf(obj['DokuNr']) == -1) searchNewVersionObj['DokuNr'].push(obj['DokuNr']);
                    else if (!(0, $346VI.default).IsNullOrEmpty(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]) && searchNewVersionObj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD].indexOf(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]) == -1) searchNewVersionObj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD].push(obj[$2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD]);
                    for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField) && !(0, $346VI.default).IsNullOrEmpty(obj[uniqueIdField]) && searchNewVersionObj[uniqueIdField].indexOf(obj[uniqueIdField]) == -1) {
                        searchNewVersionObj[uniqueIdField].push(obj[uniqueIdField]);
                        break;
                    }
                    if (!(0, $346VI.default).IsNullOrEmpty(obj.$ModelType)) {
                        console.log('DrDoc.UploadDocument: Change Archive: ', obj.$ModelType);
                        archiveName = obj.$ModelType;
                    }
                });
            }
            for(let propName in searchNewVersionObj)searchNewVersionObj[propName] = searchNewVersionObj[propName].join('|');
            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj);
            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj, ' / reponse.Result: ', resultsArr, ' / reponse.Result.length: ', resultsArr.length, ' / getDocument: ', getDocument, ' / ', reponse.Result != undefined && reponse.Result != null && reponse.Result.length == 1);
            if ((getDocument > 0 || getDocument === true) && resultsArr != undefined && resultsArr != null && resultsArr.length == 1) {
                for (let uniqueIdField of uniqueIdFieldsArr)if (!(0, $346VI.default).IsNullOrEmpty(uniqueIdField) && !(0, $346VI.default).IsNullOrEmpty(searchNewVersionObj[uniqueIdField])) {
                    if (getDocument === true || getDocument === 1) return $2687097d5145937a$export$2e2bcd8739ae039.MaskShowDocumentByField(sourceElement, archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                    else {
                        let url = $2687097d5145937a$export$2e2bcd8739ae039.MaskGetDocumentUrlByField(archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                        window.location.href = url;
                        return true;
                    }
                }
            }
            return $2687097d5145937a$export$2e2bcd8739ae039.SearchFields(sourceElement, archiveName, searchNewVersionObj, false);
        //DrDoc.GetDataset(elem, archiveName, documentIdField, documentId, 'lock');
        }
    }).catch(function(reponse_Str) {
        if (stateModal) stateModal.close();
        console.error(reponse_Str);
        let reponse = (0, $346VI.default).JsonToObject(reponse_Str);
        (0, $346VI.default).ModalError('Upload Fehler', ('Datei konnte nicht erfolgreich hochgeladen werden.' + (reponse && reponse.Error ? "\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage : '')).replaceAll("\n", "\n<br/>\r\n"));
    });
};
// --
// Desktop
$2687097d5145937a$export$2e2bcd8739ae039.DesktopAction = function(sourceElement, xmlStr) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //xmlStr = xmlStr.replaceAll('\\', '&#92;');
    //console.log('DrDoc.DesktopAction: ', xmlStr);
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlStr, "text/xml"); // text/xml application/xml
    //console.log('Desktop 1: ', doc, xmlStr, ' / Src: ', sourceElement);
    let xPathPrefix = 'DesktopSymbol>';
    let treeItemTyp = doc.querySelector(xPathPrefix + 'TreeItemTyp').innerHTML;
    //console.log(treeItemTyp);
    let archiveName = 'LEER';
    let archiveNameNode = doc.querySelector(xPathPrefix + 'ArchivPfad');
    if (archiveNameNode != null) archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveNameNode.innerHTML);
    //console.log(doc, ' / Archive-Path: ', archiveName, ' / Archive-Node: ', archiveNameNode, ' / Src: ', sourceElement);
    //console.log('Desktop 2: ', doc, ' / Archive-Path: ', archiveName, ' / Src: ', sourceElement);
    switch(treeItemTyp){
        case '1':
            break;
        // Archiv wählen
        case '2':
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
            break;
        // Volltextsuche
        case '3':
            let searchText = window.prompt('Volltextsuche in "' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName, archiveName) + '"');
            if (!(0, $346VI.default).IsNullOrEmpty(searchText)) $2687097d5145937a$export$2e2bcd8739ae039.SearchText(sourceElement, archiveName, searchText);
            break;
        // Feldsuche
        case '4':
            $2687097d5145937a$export$2e2bcd8739ae039.SearchFieldsForm(sourceElement, archiveName);
            break;
        // Suchvorlage / Feldsuche mit Vorlage
        case '5':
            let searchTemplateNode = doc.querySelector(xPathPrefix + 'Suchvorlage');
            if (searchTemplateNode) $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplate(sourceElement, archiveName, searchTemplateNode.innerHTML);
            else $2687097d5145937a$export$2e2bcd8739ae039.SearchTemplateForm(sourceElement, null);
            break;
        // Datensatz erstellen
        case '6':
            // Feldvorbelegung
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Neueingebe, Datensatz erstellen
        case '7':
            // Feldvorbelegung
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Scan erstellen als Dok. Definition
        case '8':
            // Feldvorbelegung
            // ScanjobNr
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Neues Dokument
        case '9':
            // Feldvorbelegung
            // ScanjobNr
            $2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;
        // Hypersuche Volltext
        case '19':
            let searchTextHyper = window.prompt('Hyper-Volltextsuche in allen Archiven');
            if (!(0, $346VI.default).IsNullOrEmpty(searchTextHyper)) $2687097d5145937a$export$2e2bcd8739ae039.SearchHyper(sourceElement, archiveName, '', searchTextHyper, 'Hyper-Volltextsuche in allen Archiven');
            break;
        // Workflow Instanz erstellen
        case '12':
            // WfTyp
            // OrgGuid
            (0, $346VI.default).ModalInfo('Desktop Type 12/WF-Instance not implemented yet.');
            break;
        // Export
        case '29':
            // Suchvorlage
            // ReportExportInfo/VorlagenSuche
            // ReportExportInfo/FaExport
            // ReportExportInfo/ZielDateiName
            // ReportExportInfo/DokExport
            // ReportExportInfo/EinzelDateien
            // ReportExportInfo/Ascii
            // ReportExportInfo/FeldTrenner
            // ReportExportInfo/SatzTrenner
            // ReportExportInfo/AbsatzMarke
            (0, $346VI.default).ModalInfo('Desktop Type 29/Export-Def. not implemented yet.');
            break;
        default:
            (0, $346VI.default).ModalInfo('Desktop Type ' + treeItemTyp + ' not implemented yet.');
            break;
    }
    (0, $346VI.default).ModalClose(sourceElement);
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.Client = function(obj) {
    /*let cookie_obj = {
        action: 'cookie'
    };*/ obj['server-url'] = (0, $346VI.default).ServerBase();
    obj['cookie-names'] = [];
    obj['cookie-values'] = [];
    var cookie_prefix_arr = (0, $346VI.default).GetCookiePrefix('uid_');
    if (cookie_prefix_arr != undefined && cookie_prefix_arr.length > 0) for (let cookie of cookie_prefix_arr){
        obj['cookie-names'].push(cookie.name);
        obj['cookie-values'].push(cookie.value);
    /*cookie_obj['name'] = cookie.name;
            cookie_obj['value'] = cookie.value;
            console.log('DrDoc.Client: ', cookie_obj);
            DrDoc.ClientInternal(cookie_obj);*/ }
    let uid_value = (0, $346VI.default).GetCookie('uid');
    if (!(0, $346VI.default).IsNullOrEmpty(uid_value)) {
        obj['cookie-names'].push('uid');
        obj['cookie-values'].push(uid_value);
    /*cookie_obj['name'] = 'uid';
        cookie_obj['value'] = uid_value;
        console.log('DrDoc.Client: ', cookie_obj);
        DrDoc.ClientInternal(cookie_obj);*/ }
    obj['cookie-names'] = obj['cookie-names'].join(';');
    obj['cookie-values'] = obj['cookie-values'].join(';');
    console.log('DrDoc.Client: ', obj['cookie-names'], obj['cookie-values']);
    $2687097d5145937a$export$2e2bcd8739ae039.ClientInternal(obj);
};
$2687097d5145937a$export$2e2bcd8739ae039.ClientInternal = function(obj) {
    window.open('drdoc://' + (0, $346VI.default).ObjectToQueryStr(obj), '_blank');
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.OpenPDF = function(pdfjsLib, url, canvasElem) {
    // If absolute URL from the remote server is provided, configure the CORS
    // header on that server.
    //var url = '{{$_this.Url(false, false)}}';
    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    //var { pdfjsLib } = globalThis;
    // The workerSrc property shall be specified.
    //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.mjs';
    // Asynchronous download of PDF
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');
        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function(page) {
            console.log('Page loaded');
            var scale = 1.5;
            var viewport = page.getViewport({
                scale: scale
            });
            // Prepare canvas using PDF page dimensions
            var canvas = canvasElem; //document.getElementById('the-canvas');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            // Render PDF page into canvas context
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function() {
                console.log('Page rendered');
            });
        });
    }, function(reason) {
        // PDF loading error
        console.error(reason);
    });
};
// --
// Datensatz in Suchergebnisliste Drag n droppen unter Anwednung der Sortierung
$2687097d5145937a$export$2e2bcd8739ae039.ListDragAndDropDataset = function(name, e, archiveName) {
    archiveName = $2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName(archiveName);
    //console.log('DrDoc.DragAndDropDataset: ', name, archiveName);
    let elemTarget = (0, $346VI.default).dnd_getElem(name, e.target);
    if (elemTarget == null || elemTarget == undefined) return;
    let elemPrev = elemTarget.previousElementSibling;
    let elemNext = elemTarget.nextElementSibling;
    //DrDoc.DatasetListSelectItem(elemTarget, archiveName, documentId);
    let documentId = $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID(elemTarget);
    let elemPrevNodeId = '';
    let elemNextNodeId = '';
    // Beim Drag and Drop eines Datensatzes immer "sortFieldSub" wählen,
    // wenn alle Elemente in der gleichen Liste sind also den selben parentNode haben.
    //let selectedSortFieldName = sortField;
    let selectedSortFieldNames = (0, $346VI.default).dnd_getValue(elemTarget);
    //console.log('DrDoc.ListDragAndDropDataset: Sort by: ', selectedSortFieldNames);
    if (elemPrev != undefined && elemPrev != null) {
        let elemPrevNodeIdArr = (0, $fWhbk.default).GetNodeId(elemPrev).split('|');
        elemPrevNodeId = elemPrevNodeIdArr[elemPrevNodeIdArr.length - 1];
    }
    if (elemNext != undefined && elemNext != null) {
        let elemNextNodeIdArr = (0, $fWhbk.default).GetNodeId(elemNext).split('|');
        elemNextNodeId = elemNextNodeIdArr[elemNextNodeIdArr.length - 1];
    }
    //let searchTemplateName2 = DrDoc.GetListTemplateName(elemTarget);
    return (0, $fWhbk.default).LoadComponent({
        title: 'DragAndDropDataset ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
        sourceElement: elemTarget,
        targetElement: elemTarget,
        getData: {
            archive: archiveName,
            mode: 'dragndrop',
            id: documentId,
            id_prev: elemPrevNodeId,
            id_next: elemNextNodeId,
            sort_fields: selectedSortFieldNames,
            searchTemplateName: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(rowElem, archiveName),
            selection: $2687097d5145937a$export$2e2bcd8739ae039.GetSearchFieldSelection(rowElem, archiveName)
        }
    }).then((data)=>{
        //DrDoc.UpdateDatasetRow(elemTarget, archiveName, documentId)
        $2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected(elemTarget, archiveName, '', documentId, 'get');
    });
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.ListSet = function(archiveName, array) {
    $2687097d5145937a$export$2e2bcd8739ae039._datasetList[archiveName] = array;
    console.log('DrDoc.ListSet', $2687097d5145937a$export$2e2bcd8739ae039._datasetList);
};
$2687097d5145937a$export$2e2bcd8739ae039.ListGet = function(archiveName) {
    return $2687097d5145937a$export$2e2bcd8739ae039._datasetList[archiveName];
};
$2687097d5145937a$export$2e2bcd8739ae039.ListIndexOf = function(archiveName, id) {
    let list = $2687097d5145937a$export$2e2bcd8739ae039.ListGet(archiveName);
    return list.indexOf(id);
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem = function(sourceElement, archiveName) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    var tableNodeElem = $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem !== undefined && tableNodeElem !== null) sourceElement = tableNodeElem;
    var old_table_row = (0, $346VI.default).GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetListSelectItem = function(sourceElement, archiveName, documentId) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetListSelectItem: bad source element');
        return;
    }
    // --
    // Layout automatisch setzen je nach endgerät
    //DrDoc.SetViewDataset();
    /*var old_table_row = DrDocWeb.GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        //old_table_row.classList.remove('bg-secondary');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }*/ $2687097d5145937a$export$2e2bcd8739ae039.DatasetListUnselectItem(sourceElement, archiveName);
    let selectedSearchTemplate = $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
    //var row = DrDoc.GetTableRowElementByID(document, archiveName, documentId);
    var row = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    //var row = sourceElement;
    //var row = DrDocWeb.GetElement(sourceElement, 'tr');
    // sourceElement.tagName == 'TR' ? sourceElement : DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('DatasetListSelectItem: Row Element nicht gefunden!', ' / archiveName:', archiveName, ' / selectedSearchTemplate:', selectedSearchTemplate, ' / documentId:', documentId, sourceElement);
        return;
    } else {
        row.classList.add('table-active');
        row.classList.add('table-dark');
        //row.classList.add('bg-secondary');
        row.classList.add('bg-primary');
        row.classList.add('text-light');
        //console.log('DatasetSelected: ', sourceElement, row, documentId);
        //sourceElement = row;
        row.style.scrollMargin = '40px';
        row.scrollIntoView({
            block: 'nearest'
        });
    }
    return row;
};
$2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected = function(sourceElement, archiveName, documentIdField, documentId, mode, sourceObjStr) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //DrDoc._datasetIndex[archiveName] = DrDoc.ListIndexOf(archiveName, documentId);
    //DrDoc.UnlockOnlyDataset(sourceElement, archiveName, documentId);
    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetSelected: bad source element');
        return;
    }
    // --
    let sourceArchiveName = archiveName;
    let source_obj = null;
    if ((0, $346VI.default).IsNullOrEmpty(sourceObjStr)) ;
    else {
        if (typeof sourceObjStr === 'string') {
            var source_decoded = decodeURIComponent(sourceObjStr);
            source_obj = (0, $346VI.default).JsonToObject(source_decoded);
        } else source_obj = sourceObjStr;
        sourceArchiveName = source_obj.archive;
    }
    // --
    // Layout automatisch setzen je nach endgerät
    $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset();
    let row = $2687097d5145937a$export$2e2bcd8739ae039.DatasetListSelectItem(sourceElement, sourceArchiveName, documentId);
    if (row == undefined || row == null) return;
    // --
    //console.log('DatasetSelected: ', table);
    //console.log('DatasetSelected (1): ', archiveName, sourceArchiveName, documentId, mode);
    // Mode bezieht sich auf die Liste
    if (mode === 'get' || mode === 'info' || mode === 'searchfields' || mode === 'textretrieval' || mode === 'template' || mode === 'event' || mode === 'hyper' || mode === 'tmp' || mode === 'tmp-delete-last') {
        if (mode === 'info') (0, $346VI.default).ModalClose(sourceElement);
        //console.log('DatasetSelected: GET / ', sourceElement, archiveName, documentId, 'get');
        //if (prompt('ok?', true))
        //{
        $2687097d5145937a$export$2e2bcd8739ae039.GetSearchTemplate(sourceElement, archiveName);
        return $2687097d5145937a$export$2e2bcd8739ae039.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get').then(function(x) {
            //DrDoc.configDevice.update('view/list-width');
            //DrDoc.configDevice.set('view/list-width', DrDoc.configDevice.get('view/list-width')+0.1);
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateSplitPanel();
            //console.log('Mask Update List W: ',  DrDoc.configDevice.has('view/list-width'), DrDoc.configDevice.get('view/list-width', 50));
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
        });
    //}
    } else if (mode === 'thes') {
        // aus Ziel in Maske Daten importieren!
        //alert('Thes. not implemented yet.');
        // return DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'thes');
        if (source_obj == undefined || source_obj == null) {
            console.error('Thesaurus hat keinen Mode angegeben! ', this);
            //source_mode = mode;
            return;
        }
        //console.log('DatasetSelected (2.1): Thes/Zusatzinfo Source Obj', source_obj, archiveName, sourceArchiveName);
        // Thes
        source_obj.thes = true;
        // gesperrt laden
        source_obj.autolock = true;
        source_obj.thes_id = (0, $346VI.default).IsNullOrEmpty(documentId) ? '' : documentId;
        // Node.GetElement
        let nodeId = $2687097d5145937a$export$2e2bcd8739ae039.GetMaskNodeId(sourceElement, sourceArchiveName);
        let elem = (0, $fWhbk.default).GetElement(nodeId);
        /*if (elem == undefined || elem == null) {
            nodeId = 'system/list|content|' + archiveName + '|dataset';
            elem = Node.GetElement(nodeId);
        }*/ //console.log('DatasetSelected (2.2):', nodeId, elem, sourceArchiveName);
        (0, $346VI.default).ModalClose(sourceElement);
        return (0, $fWhbk.default).LoadComponent({
            title: 'Thesaurus im Archiv ' + $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel(archiveName),
            sourceElement: elem,
            targetElement: nodeId,
            getData: source_obj
        }).then((data)=>{
            // wieder zum Quellarchiv zurückwechseln
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', sourceArchiveName);
        });
    } else {
        alert('Bad Mode ' + mode);
        console.warn('Bad Mode', mode);
    }
};
// DOM Node für Listen
$2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement = function(sourceElement, archiveName, newWindow) {
    //var elem = null;
    /*if (newWindow === true) // || sourceElement == undefined || sourceElement == null)
    {
        //elem = Node.GetElement('system/list-info|content');
        //if (elem != null 
        return 'system/list-info|content';
    }*/ return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(sourceElement, archiveName, false, undefined);
};
$2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID = function(sourceElement, archiveName, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByIDInternal(sourceElement, archiveName, true, documentId);
};
/*DrDoc.GetTableElement = function (sourceElement, archiveName) {
    return DrDocWeb.GetElement(DrDoc.GetTableNodeElement(sourceElement), 'table.list-datasets');
};*/ $2687097d5145937a$export$2e2bcd8739ae039.__GetTableRowElementByID = function(sourceElement, archiveName, documentId) {
    var table = $2687097d5145937a$export$2e2bcd8739ae039.GetTableNodeElement(sourceElement, archiveName);
    if (table == undefined || table === null) {
        console.warn('DrDoc.GetTableRowElementByID: ', sourceElement, archiveName, documentId);
        return undefined;
    }
    let tableNodeId = (0, $fWhbk.default).GetNodeId(table);
    let nodeId = '';
    let elem = null;
    nodeId = tableNodeId + '|' + documentId;
    elem = (0, $fWhbk.default).GetElement(nodeId, table);
    /*if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + DrDoc.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate') + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }*/ /*if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }
    if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }*/ if (elem == undefined || elem == null) {
        console.warn('DrDoc.GetTableRowElementByID: Table found, but Elem/Row Not found! / documentId:', documentId, ' / NodeId: ', nodeId, ' / Table Node Id: ', tableNodeId, ' / Table: ', table);
        return undefined;
    }
    //console.log('DrDoc.GetTableRowElementByID', nodeId, elem); //, table);
    return elem;
};
//DrDoc.OnSelectRowElementRel = 
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel = function(sourceElement, archiveName, documentIdField, documentId, rel) {
    if (typeof sourceElement === 'string') sourceElement = (0, $fWhbk.default).GetElement(sourceElement);
    //var table = DrDoc.GetTableElement(sourceElement, archiveName);
    /*var tableNodeElem = DrDoc.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem === undefined || tableNodeElem === null) {
        console.warn('OnSelectRowElementRel: Table Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = DrDocWeb.GetElement(tableNodeElem, 'table.list-datasets tbody');*/ var row = $2687097d5145937a$export$2e2bcd8739ae039.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('OnSelectRowElementRel: Row Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = (0, $346VI.default).GetElement(row, 'tbody', -1);
    /*var tbody = null;
    while (row.parentNode != null)
    {
        tbody = row.parentNode;
        if (tbody.tagName == 'TBODY')
            break;
    }*/ //var tbody = table.getElementsByTagName('tbody')[0]; // table.tbody; //
    //console.log('OnSelectRowElementRel -> IST', sourceElement, tbody.children, table, row);
    //console.log('OnSelectRowElementRel -> IST', ' / sourceElement: ', sourceElement, ' / tbody: ', tbody, ' / row: ', row);
    if (row !== undefined && row !== null) {
        //row.removeClass('table-active');
        //int i = table.tbody.childNodes.indexOf(row);
        // table.children.indexOf(row);
        // Index der Row herausfinden
        var i = Array.prototype.indexOf.call(tbody.children, row);
        var i_selected = i + rel;
        if (i !== -1 && i_selected >= 0 && i_selected < tbody.children.length) {
            var row_selected = tbody.children[i_selected];
            //documentId = document.querySelector(tbody.children[i]).attr('data-id');
            let documentId_selected = $2687097d5145937a$export$2e2bcd8739ae039.GetListDatasetID(row_selected);
            //console.log('OnSelectRowElementRel -> SOLL Selected ID: ', documentId_selected, '  Elem: ', row_selected);
            //action(row_selected, documentId_selected);
            //return true;
            return $2687097d5145937a$export$2e2bcd8739ae039.DatasetSelected(row_selected, archiveName, documentIdField, documentId_selected, 'get');
        } else {
            console.log('OnSelectRowElementRel, bad index : ', i, sourceElement, archiveName, documentId, rel, tbody, tbody.children, row); //, Node.GetNodeId(tableNodeElem), tableNodeElem);
            return undefined;
        }
    }
    return undefined;
};
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectPrevDataset = function(sourceElement, archiveName, documentIdField, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, -1);
};
$2687097d5145937a$export$2e2bcd8739ae039.OnSelectNextDataset = function(sourceElement, archiveName, documentIdField, documentId) {
    return $2687097d5145937a$export$2e2bcd8739ae039.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, 1);
};
$2687097d5145937a$export$2e2bcd8739ae039.RegisterShortcuts = function(archiveName, shortcuts) {};
// --
// Zeile leeren
$2687097d5145937a$export$2e2bcd8739ae039.TableClearRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Tabellen-Zeile nicht entfernen, sondern nur leeren und ausblenden, sonst funktioniert der Row-Index nicht mehr (z.B. für Thesaurus)!
    //rowElem.parentNode.removeChild(rowElem);
    var inputElems = rowElem1.querySelectorAll('input');
    //console.log('DrDoc.TableRemoveRow: ', inputElems);
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    //console.log('DrDoc.TableRemoveRow - Cell Input: ', inputElem.value, inputElem);
    });
    inputElems = rowElem1.querySelectorAll('textarea');
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    });
    inputElems = rowElem1.querySelectorAll('textarea');
    if (inputElems) inputElems.forEach(function(inputElem) {
        inputElem.value = '';
        inputElem.innerHTML = '';
        inputElem.checked = undefined;
        inputElem.required = false;
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.TableRemoveRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Zeile leeren
    $2687097d5145937a$export$2e2bcd8739ae039.TableClearRow(rowElem1);
    // Zeile ausblenden
    rowElem1.style.display = 'none';
};
$2687097d5145937a$export$2e2bcd8739ae039.TableCopyRow = function(rowElem1) {
    rowElem1 = (0, $346VI.default).GetClosestTag(rowElem1, 'tr');
    if (rowElem1 == undefined || rowElem1 == null) return;
    // Achtung: Element-IDs bleiben gleich!
    let row2Elem = rowElem1.cloneNode(true);
    // element.insertBefore(new, existing)
    rowElem1.parentNode.insertBefore(row2Elem, rowElem1);
};
$2687097d5145937a$export$2e2bcd8739ae039.TableOpenModal = function(sourceElement, title) {
    if (!sourceElement || !sourceElement.parentNode) return;
    let tmp_top = sourceElement.style.top;
    let tmp_left = sourceElement.style.left;
    let tmp_width = sourceElement.style.width;
    let tmp_height = sourceElement.style.height;
    let tmp_position = sourceElement.style.position;
    sourceElement.style.top = '';
    sourceElement.style.left = '';
    sourceElement.style.width = '100%';
    sourceElement.style.height = '100%';
    sourceElement.style.position = 'relative';
    // Placeholder erstellen und mit Tabelle mit Placeholder ersetzen
    let elemPlaceholder = document.createElement('div');
    elemPlaceholder.innerText = 'PLACEHOLDER';
    sourceElement.parentNode.insertBefore(elemPlaceholder, sourceElement);
    // Element aus Maske holen und im Modal einbinden
    sourceElement.parentNode.removeChild(sourceElement);
    let modal = (0, $346VI.default).Modal(title, sourceElement, {
        //color: 'danger',
        fullScreen: true,
        size: 'lg'
    });
    //console.log('DrDoc.TableOpenModal: ', modal);
    // beim Schließen des Modal Tabelle aus dem Modal wieder in die Maske setzen
    modal._element.addEventListener('hidden.bs.modal', function(event) {
        //console.log('DrDoc.TableOpenModal: hidden.bs.modal');
        elemPlaceholder.parentNode.replaceChild(sourceElement, elemPlaceholder);
        // Styles zurücksetzen
        sourceElement.style.top = tmp_top;
        sourceElement.style.left = tmp_left;
        sourceElement.style.width = tmp_width;
        sourceElement.style.height = tmp_height;
        sourceElement.style.position = tmp_position;
    });
};
// --
// Anzahl der Datensatz-Treffer in ein DOM Element laden
// Suche nach Attributen [data-search-archive] und [data-search-template] oder [data-search-hyper]
$2687097d5145937a$export$2e2bcd8739ae039.SearchCountElement = function(elem) {
    if (!(0, $346VI.default).IsNullOrEmpty(elem) && typeof elem === 'string') elem = (0, $fWhbk.default).GetElement(elem);
    if (elem == undefined || elem == null) elem = document;
    let crudAction = function(counterElem) {
        //counterElem.innerText = '..';
        counterElem.innerHtml = `<div class="spinner-border text-danger" role="status">
  <span class="visually-hidden">...</span>
</div>`;
        counterElem.parentNode.style.position = 'relative'; // !important';
        counterElem.style.position = 'absolute'; // !important';
        //counterElem.style.top = 'min(15%, 12px)'; //!important';
        //counterElem.style.left = 'min(85%, 12px)'; //!important';
        //counterElem.style.transform = 'translate(-50%,-50%)'; //!important';
        counterElem.style.top = '0px';
        counterElem.style.right = '0px';
        counterElem.style.transform = 'translate(0%,-20%)';
        //counterElem.style.transform = 'translate(0%,-0.5rem)';
        //counterElem.className = 'position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary';
        return function(dataArr, dataObj) {
            // dataObj = { Count, CountTotal, SortTree }
            //console.log(this, counterElem, dataArr, dataObj, dataObj.CountTotal);
            counterElem.innerHtml = '';
            //console.log('COUNTER!!!!!!!!!!!!!!!!!!', dataObj.CountTotal);
            if (dataObj.CountTotal !== undefined && dataObj.CountTotal > 0) {
                /*if (dataObj.CountTotal > 500)
                    counterElem.classList.add('bg-danger');
                else if (dataObj.CountTotal > 100)
                    counterElem.classList.add('bg-warning');
                else
                    counterElem.classList.add('bg-secondary');*/ counterElem.classList.add('bg-secondary');
                counterElem.classList.add('badge');
                counterElem.innerText = dataObj.CountTotal;
            } else {
                counterElem.classList.add('bg-success');
                counterElem.classList.add('badge');
                counterElem.classList.add('d-none');
                counterElem.innerText = '0';
            }
        };
    };
    let loadDsCountElems1 = elem.querySelectorAll('[data-search-template]');
    if (loadDsCountElems1 != null) for (let loadDsCountElem of loadDsCountElems1){
        let archiveName = loadDsCountElem.getAttribute('data-search-archive');
        let searchTemplateName = loadDsCountElem.getAttribute('data-search-template');
        if ((0, $346VI.default).IsNullOrEmpty(archiveName)) continue;
        if ((0, $346VI.default).IsNullOrEmpty(searchTemplateName)) continue;
        //console.log('Search Template: ', archiveName, searchTemplateName, loadDsCountElem);
        let getObj = {
            action: 'searchtemplate',
            archive: archiveName,
            value: searchTemplateName,
            count: 0,
            max: -1
        };
        (0, $iuVXB.default).Crud(getObj, crudAction(loadDsCountElem));
    }
    let loadDsCountElems2 = elem.querySelectorAll('[data-search-hyper]');
    if (loadDsCountElems2 != null) for (let loadDsCountElem of loadDsCountElems2){
        let archiveName = loadDsCountElem.getAttribute('data-search-archive');
        let searchHyperName = loadDsCountElem.getAttribute('data-search-hyper');
        if ((0, $346VI.default).IsNullOrEmpty(searchHyperName)) continue;
        //console.log('Search Hyper: ', archiveName, searchHyperName, loadDsCountElem);
        let getObj = {
            action: 'hyper',
            archive: archiveName,
            value: searchHyperName,
            count: 0,
            max: -1
        };
        (0, $iuVXB.default).Crud(getObj, crudAction(loadDsCountElem));
    }
};
// ---
// User Data
/*DrDoc.SelectedArchiveName = '';
DrDoc.SetSelectedArchive = function(selectedArchiveName) {
    
    DrDoc.SelectedArchiveName = selectedArchiveName;
    DrDoc.ConfSet('view/selected-archive', selectedArchiveName);
};*/ //DrDoc.configUser.subscribeBool('view/select-archive', false);
//DrDoc.configUser.subscribeBool('view/select-archive');
$2687097d5145937a$export$2e2bcd8739ae039.GetSelectedArchive = function(callback) {
    if (typeof callback !== 'function') {
        console.warn('GetSelectedArchive', "Funktion muss als Argument ein Callback \xfcbergeben!");
        return undefined;
    }
    let isSelectArchive = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/select-archive', false);
    console.log('view/select-archive', isSelectArchive);
    let archiveName = $2687097d5145937a$export$2e2bcd8739ae039.configUser.get('view/selected-archive');
    //let hasSelectedArchive = DrDoc.SelectedArchiveName !== undefined && DrDoc.SelectedArchiveName !== null && DrDoc.SelectedArchiveName.length > 0;
    let hasSelectedArchive = $2687097d5145937a$export$2e2bcd8739ae039.configUser.has('view/selected-archive');
    if (isSelectArchive === false && hasSelectedArchive) callback(archiveName);
    else {
        let modalSrc = '<div class="list-group">';
        let archives = $2687097d5145937a$export$2e2bcd8739ae039.GetUserData().Result.Archives;
        for(let i in archives)modalSrc += `<button class="list-group-item list-group-item-action ${archives[i].Archive.SimpleName === archiveName ? 'active' : ''}" onclick="DrDocWeb.ModalGet(this).callback('${archives[i].Archive.SimpleName}'); ">${archives[i].Label}</button>`;
        modalSrc += '</div>';
        let modal = (0, $346VI.default).Modal("Archiv w\xe4hlen", modalSrc, {
            fullScreen: false
        });
        modal.callback = (selectedArchiveName)=>{
            //DrDoc.SetSelectedArchive(selectedArchiveName);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/selected-archive', selectedArchiveName);
            modal.hide();
            callback(selectedArchiveName);
        //console.log('GetSelectedArchive (Callback)',  selectedArchiveName);
        };
    //console.log('GetSelectedArchive', modal, callback);
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.GetUserData = function() {
    return $2687097d5145937a$export$2e2bcd8739ae039.store.get('userdata');
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession = function(archiveName) {
    if ((0, $346VI.default).IsNullOrEmpty(archiveName)) return null;
    // ip\port\archive
    if (archiveName.indexOf('\\') > 0) {
        let archiveNameComponents = archiveName.split('\\');
        if (archiveNameComponents.length == 3 && (0, $346VI.default).ParseInt(archiveNameComponents[1]) > 0) archiveName = archiveNameComponents[2];
    }
    let userdata = $2687097d5145937a$export$2e2bcd8739ae039.GetUserData();
    if (userdata == null || userdata == undefined) return null;
    if (userdata.Result == null || userdata.Result == undefined) return null;
    let archives = userdata.Result.Archives;
    if (archives == null || archives == undefined) return null;
    for(let i in archives){
        if (archives[i].Archive.SimpleName.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() + '.da') return archives[i];
    }
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchiveLabel = function(archiveName, defaultLabel) {
    let session = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName);
    if (session == null) return defaultLabel === undefined ? archiveName : defaultLabel;
    return session.Label;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetArchive = function(archiveName) {
    let archObj = $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName);
    if (archObj != undefined && archObj != null) return archObj.Archive;
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetSimpleArchiveName = function(archiveName) {
    let archObj = $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName);
    if (archObj != undefined && archObj != null) return archObj.SimpleName;
    console.warn('DrDoc.GetSimpleArchiveName Archive Name not found: ', archiveName);
    return archiveName;
};
$2687097d5145937a$export$2e2bcd8739ae039.GetField = function(archiveName, fieldName) {
    let archive = $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName);
    if (archive == null) return null;
    if ((0, $346VI.default).IsNullOrEmpty(fieldName)) return null;
    let fields = archive.Fields;
    for(let i in fields){
        if (fields[i].Name === fieldName) return fields[i];
    }
    return null;
};
$2687097d5145937a$export$2e2bcd8739ae039.TestUser = function(archiveName, fieldName) {
    console.log('Archive', $2687097d5145937a$export$2e2bcd8739ae039.GetArchive(archiveName));
    console.log('Archive Label', $2687097d5145937a$export$2e2bcd8739ae039.GetArchiveSession(archiveName).Label);
    console.log('Field', $2687097d5145937a$export$2e2bcd8739ae039.GetField(archiveName, $2687097d5145937a$export$2e2bcd8739ae039.ID_FIELD));
};
// --
// Split Panel
var $2687097d5145937a$var$_splitPanels = {};
$2687097d5145937a$export$2e2bcd8739ae039.SplitPanel = function(elemSelContaier, elemSel1, elemSel2, direction, size, onSizeChanged) {
    var obj = $2687097d5145937a$var$_splitPanels[elemSelContaier];
    if (size == null || size == undefined || isNaN(size)) size = 35;
    size = Math.min(Math.max(size, 0), 100);
    if (direction == 'v' || direction == undefined || direction == null) direction = 'vertical';
    if (direction == 'h') direction = 'horizontal';
    // erst altes Objekt freigeben
    /*try
    {
        if (obj != null && obj != undefined) {
            obj.destroy();
            obj = null;
        }
    }
    catch(ex)
    {

    }*/ var elemContainer = document.querySelector(elemSelContaier);
    var elemSplitter = document.querySelector(elemSelContaier + ' > .gutter');
    var elem1 = document.querySelector(elemSel1);
    var elem2 = document.querySelector(elemSel2);
    if (elemContainer == null || elemContainer == undefined) return;
    if (elem1 == null || elem1 == undefined) return;
    if (elem2 == null || elem2 == undefined) return;
    // --
    // bei 100% Splitter garnicht erst anwenden
    if (elemSplitter) elemSplitter.classList.remove('d-none');
    if (elem1) elem1.classList.remove('d-none');
    if (elem2) elem2.classList.remove('d-none');
    if (size >= 99) {
        if (elemSplitter) elemSplitter.classList.add('d-none');
        elem2.classList.add('d-none');
        //console.log('Split Hide 2: ', elem2, elemSplitter1, elemSplitter2);
        elem1.style.width = '100%';
        elem1.style.height = '100%';
        return;
    } else if (size < 1) {
        if (elemSplitter) elemSplitter.classList.add('d-none');
        elem1.classList.add('d-none');
        //console.log('Split Hide 1: ', elem1, elemSplitter1, elemSplitter2);
        elem2.style.width = '100%';
        elem2.style.height = '100%';
        return;
    }
    // --
    // Scroll Pos. merken
    var elem1_scrollTop = elem1.scrollTop;
    var elem1_scrollLeft = elem1.scrollLeft;
    var elem2_scrollTop = elem2.scrollTop;
    var elem2_scrollLeft = elem2.scrollLeft;
    //if (obj)
    //console.log('DrDoc.SplitPanel:  ', obj._elemContainer != elemContainer, obj._elem1 !== elem1, obj._elem2 !== elem2);
    if (obj == null || obj == undefined || obj._elemContainer != elemContainer || obj._elem1 !== elem1 || obj._elem2 !== elem2 || obj.splitObj.pairs[0].direction != direction) //if (obj == null || obj == undefined || obj.splitObj.pairs[0].direction != direction)
    {
        // => Split-Contaoner existiert noch nicht oder Richtung wurde geändert
        /*if (obj != undefined && obj._elemContainer !== elemContainer)
            console.warn('DrDoc.SplitPanel: Elem Container has Changed! ', elemSelContaier);
        if (obj != undefined && obj._elem1 !== elem1)
            console.warn('DrDoc.SplitPanel: Elem 1 has Changed! ', elem1);
        if (obj != undefined && obj._elem2 !== elem2)
            console.warn('DrDoc.SplitPanel: Elem 2 has Changed! ', elem2);*/ if (elemContainer == null || elemContainer == undefined) //console.log('SplitPanel: Element Container exisitert nicht! ', elemSelContaier);
        return;
        if (elem1 == null || elem1 == undefined) //console.log('SplitPanel: Element 1 exisitert nicht! ', elemSel1);
        return;
        if (elem2 == null || elem2 == undefined) //console.log('SplitPanel: Element 2 exisitert nicht! ', elemSel2);
        return;
        // erst altes Objekt freigeben
        if (obj != null && obj != undefined && elem1.nextElementSibling != undefined && elem1.nextElementSibling != null && elem1.nextElementSibling.classList.contains('gutter') && obj.splitObj.pairs[0].direction == direction) {
            // bereits initialisiert, wenn gutter vorhanden
            //console.log('Split, bereits initialisiert', obj, elem1.nextElementSibling);
            var sizes = obj.splitObj.getSizes();
            if (sizes == null || sizes == undefined || sizes.length > 0 && sizes[0] != size) obj.splitObj.setSizes([
                size,
                100 - size
            ]);
        } else {
            //console.log('Split, neu initialisieren', obj); //, elem1.nextElementSibling);
            if (obj != null && obj != undefined) try {
                obj.splitObj.destroy(false, false);
            } catch (ex) {}
            // https://split.js.org/#/?layout=float
            obj = {
                _elemContainer: elemContainer,
                splitObj: window.Split([
                    elemSel1,
                    elemSel2
                ], {
                    sizes: [
                        size,
                        100 - size
                    ],
                    minSize: [
                        15,
                        15
                    ],
                    //expandToMin: true,
                    direction: direction,
                    onDragEnd: onSizeChanged
                })
            };
        }
        $2687097d5145937a$var$_splitPanels[elemSelContaier] = obj;
        // Fallback
        elem1.style.display = 'block';
        elem1.style.float = 'left';
        elem2.style.display = 'block';
        elem2.style.float = 'left';
        // gutter.gutter-vertical: float: left + width: 100%;
        if (direction == 'vertical') {
            // vertical
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'column';
        } else {
            // horizontal
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'row';
        }
        // Scroll Pos. wiederherstellen
        elem1.scrollTop = elem1_scrollTop;
        elem1.scrollLeft = elem1_scrollLeft;
        elem2.scrollTop = elem2_scrollTop;
        elem2.scrollLeft = elem2_scrollLeft;
    } else {
        // => Split-Contaoner existiert bereits und Richtung wurde nicht geändert
        var sizes = obj.splitObj.getSizes();
        if (sizes == null || sizes == undefined || sizes.length > 0 && sizes[0] != size) obj.splitObj.setSizes([
            size,
            100 - size
        ]);
    }
    return obj;
};
$2687097d5145937a$export$2e2bcd8739ae039.HideSplitPanel = function() {
    //if (false && DrDocWeb.IsMobile() && DrDoc.configUser.get('view/list/show-tree')) {
    //    DrDoc.configDevice.set('view/list-sort-width', 20);
    //}
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 100);
};
$2687097d5145937a$export$2e2bcd8739ae039.UpdateSplitPanel = function() {
    let mode = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/layout-mode');
    let size_abs = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-width');
};
/*
DrDoc.configDevice.subscribeInt('view/list-width', function (value, oldValue) {
    //console.log('subscribe: view/list-width: ', value, oldValue, ' / from cookie');
    
    //console.log('view/list-width: ', value, size_abs);
}, 50);

DrDoc.configDevice.subscribe('view/layout-mode', function (value, oldValue) {
    //console.log('subscribe: view/layout-mode: ', value, oldValue, ' / from cookie');
    if (DrDocWeb.IsNullOrEmpty(value))
        value = 'v';
    let size_abs = DrDoc.configDevice.get('view/list-width', 50);
    
}, 'v');*/ $2687097d5145937a$export$2e2bcd8739ae039.SetViewDataset = async function(archiveName) {
    console.log('DrDoc.SetViewDataset');
    //if (DrDoc.configDevice.get('view/list-dataset-width') > 95 || DrDoc.configDevice.get('view/list-dataset-width') < 5)
    if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') > 70) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 40);
    if (!(0, $346VI.default).IsNullOrEmpty(archiveName)) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
};
$2687097d5145937a$export$2e2bcd8739ae039.SetViewList = async function(archiveName) {
    if ($2687097d5145937a$export$2e2bcd8739ae039._setViewInit == undefined) $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
    console.log('DrDoc.SetViewList');
    //console.log('DrDoc.SetViewList: view/list-dataset-width: ', DrDoc.configDevice.get('view/list-dataset-width'));
    //if (DrDoc.configDevice.get('view/list-dataset-width') > 1 && DrDoc.configDevice.get('view/list-dataset-width') < 10)
    if (!$2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') || $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-dataset-width') < 10) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-dataset-width', 50);
    $2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode();
    if (!(0, $346VI.default).IsNullOrEmpty(archiveName)) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', archiveName);
};
$2687097d5145937a$export$2e2bcd8739ae039.SetViewInit = async function() {
    if ($2687097d5145937a$export$2e2bcd8739ae039._setViewInit == undefined) {
        console.log('DrDoc.SetViewInit (1) Initial');
        $2687097d5145937a$export$2e2bcd8739ae039._setViewInit = true;
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/list-sort-mode', function(value) {
            //console.log('DatasetListContaionerWebNode 2 - sort mode - {{$_this.NamePath}}');
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-sort-width');
        }, 'h');
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/list-dataset-mode', function(value) {
            //console.log('DatasetListContaionerWebNode 2 - dataset mode - {{$_this.NamePath}}');
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-dataset-width');
        }, 'v');
        setTimeout($2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode, 500);
    }
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/layout-sm');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/selected-archive');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.Write = false;
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/label-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/button-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.update('view/read-only-style-classes');
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.Write = true;
};
$2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode = async function() {
    //console.log('DrDoc.UpdateView');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-sort-mode');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list-dataset-mode');
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.update('view/list/tree/cols');
};
$2687097d5145937a$export$2e2bcd8739ae039.DisplayDataseListTreeCols = function(cols) {
    //let tree = document.querySelector('.dataset-list .dataset-list-tree-container > .row');
    let treeElementList = document.querySelectorAll('.dataset-list-tree-container');
    //console.log('SetViewInit 1: ', tree, tree.children);
    //console.log('DrDoc.DisplayDataseListTreeCols: ', treeElementList);
    for (var tree of treeElementList)if (tree != null) {
        tree.classList.remove('flex-nowrap');
        tree.classList.remove('flex-wrap');
        tree.classList.remove('card');
        if (cols) tree.classList.add('flex-nowrap');
        else tree.classList.add('flex-wrap');
        if (tree.children) for (var cn of tree.children){
            cn.className = cols ? 'col-sm-12 col-md-6 col-lg-6 col-xxl-6 me-3 tree-item card' : 'col-12 tree-item';
            cn.style.width = cols ? '' : '100%';
        }
    }
};
$2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn = function(searchElemSelector) {
    return function(value, oldValue) {
        // console.log('DrDoc.getOnChangeStyleFn', this);
        var elemRoot = null;
        if (elemRoot == null || elemRoot == undefined) elemRoot = null;
        if (elemRoot == null || elemRoot == undefined) elemRoot = document;
        elemRoot.querySelectorAll(searchElemSelector).forEach(function(elem) {
            // alte Classes suchen und aus Elementen entfernen
            if (!(0, $346VI.default).IsNullOrEmpty(oldValue)) for (let className of oldValue.split(' ')){
                if ((0, $346VI.default).IsNullOrEmpty(className)) continue;
                elem.classList.remove(className);
            }
            // neue Classes an Elemente anfügen
            if (!(0, $346VI.default).IsNullOrEmpty(value)) for (let className of value.split(' ')){
                if ((0, $346VI.default).IsNullOrEmpty(className)) continue;
                elem.classList.add(className);
            }
        });
    };
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.PageSetName = function(oldName, newName) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-set-name',
        name: oldName,
        value: newName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageSetUser = function(oldName, newName) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-set-user',
        name: oldName,
        value: newName
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageAdd = function(name) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-add',
        preset: 'PAGE',
        name: name
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.PageDelete = function(name) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'page-delete',
        name: name
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.AddFav = function(value) {
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'add-fav',
        value: value
    });
};
// --
$2687097d5145937a$export$2e2bcd8739ae039.UserActionObj = function(action, obj) {
    if (obj == undefined) obj = {};
    obj.action = action;
    return (0, $346VI.default).Send('GET', '/user', obj, undefined, 'json', '', '', true).then((data)=>{
        console.log('UserAction: ', action, obj);
        (0, $346VI.default).ModalInfo('UserAction: ' + action, data.Result + '\r\n<br>\r\n<br>' + (0, $346VI.default).ObjectToQueryStr(obj));
    });
};
$2687097d5145937a$export$2e2bcd8739ae039.CreateDatasetObj = function(archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'add';
    getObj.value = value;
    return (0, $346VI.default).Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};
$2687097d5145937a$export$2e2bcd8739ae039.ConfigDeleteDatasetObj = function(archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'delete-all';
    getObj.value = value;
    getObj.usermanager = 'Config.BVD';
    return (0, $346VI.default).Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};
$2687097d5145937a$export$2e2bcd8739ae039.SaveWebNode = function(nodeId, properties) {
    return (0, $346VI.default).Send('PUT', '/node/' + nodeId, {}, properties);
};
// --
// Menu Main
$2687097d5145937a$export$2e2bcd8739ae039.toggleMainMenuExpansion = function() {
    if ($2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion()) $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion(true);
    else $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion(false);
//var elem = document.getElementById('menu-main-drdoc');
//DrDoc.updateMainMenuExpansion();
/*
    // Toggle: Hauptmenü links ein-/ausklappen
    if (elem.classList.contains('expanded'))
    {
        elem.classList.remove('expanded');
    }
    else
    {
        elem.classList.add('expanded');
    }
    */ /*
    // Toggle: Hauptmenü links vollständig ein-/ausblenden
    if (elem.classList.contains('d-none'))
    {
        elem.classList.remove('d-none');
    }
    else
    {
        elem.classList.add('d-none');
    }*/ };
$2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion = function(hide) {
    if (!document.querySelector('#menu-main-drdoc')) return;
    document.querySelector('#menu-main-drdoc-container').classList.remove('d-none');
    // Ausklappen, wenn noch ausgeklappte Menüs vorhanden sind
    let openMenuItems = document.querySelectorAll('#menu-main-drdoc button[aria-expanded]');
    let openMenuItemsExpanded = document.querySelectorAll('#menu-main-drdoc button[aria-expanded="true"]');
    // if ((DrDocWeb.IsMobile() && window.innerWidth > 800) || (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0))
    if (hide === true) {
        //console.log('DrDoc.updateMainMenuExpansion: CLOSE');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.remove('expanded');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).hide();
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
            /*openMenuItem.classList.remove('show');
                openMenuItem.classList.remove('open');*/ openMenuItem.setAttribute('aria-expanded', 'false');
            openMenuItem.classList.remove('expanded');
        });
        openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            openMenuItem.classList.remove('show');
        });
        return false;
    } else if (hide === false) {
        //console.log('DrDoc.updateMainMenuExpansion: OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.add('expanded');
        if (openMenuItems != null) openMenuItems.forEach(function(openMenuItem) {
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).open();
            //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
            /*openMenuItem.classList.add('show');
                openMenuItem.classList.add('open');*/ openMenuItem.setAttribute('aria-expanded', 'true');
            openMenuItem.classList.add('expanded');
        });
        /*openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null)
        {
            openMenuItems.forEach(function(openMenuItem) {
                openMenuItem.classList.remove('show');
            });
        }*/ return true;
    }
    //if (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0)
    if (openMenuItemsExpanded != null && openMenuItemsExpanded.length > 0) {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.add('expanded');
        return true;
    } else {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is CLOSED');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top')) document.querySelector('#menu-main-top').classList.remove('expanded');
        return false;
    }
};
//// ---------------------------------
$2687097d5145937a$export$2e2bcd8739ae039.Init = async function() {
    if (window.DrDoc !== undefined) {
        console.warn("Dr.DOC RE-INIT");
        return window.DrDoc;
    }
    window.DrDoc = $2687097d5145937a$export$2e2bcd8739ae039;
    console.log('Dr.DOC Init() START');
    (0, $hkmmp.default)._debug = false;
    $2687097d5145937a$export$2e2bcd8739ae039.store = new (0, $hkmmp.default)();
    $2687097d5145937a$export$2e2bcd8739ae039.configUser = new (0, $9hg18.default)($2687097d5145937a$export$2e2bcd8739ae039.store, false);
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = true;
    $2687097d5145937a$export$2e2bcd8739ae039.configDevice = new (0, $9hg18.default)($2687097d5145937a$export$2e2bcd8739ae039.store, true);
    $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = false;
    //console.log('DrDoc.store initialized');
    $2687097d5145937a$export$2e2bcd8739ae039.store.init('userdata', function() {
        let userdata = null;
        if (window.__drdoc_ignore_userdata === true) {
            console.log('DrDoc.store: userdata __drdoc_ignore_userdata');
            //userdata = { };
            userdata = new Promise(function(resolve, reject) {
                resolve({});
            });
        } else {
            console.log('DrDoc.store: userdata get..');
            userdata = (0, $346VI.default).SendGet('/user', {
                action: 'status'
            }, 'json');
        }
        $2687097d5145937a$export$2e2bcd8739ae039.store.set('userdata', userdata);
        //DrDoc.TestUser()
        return userdata;
    }).then(function() {
        //console.log('userdata subscribe _sub1 then ok');
        // --
        // wenn "view/selected-archive" nicht gefunden werden kann, dann das erstes verfügbares Archiv wählen.
        $2687097d5145937a$export$2e2bcd8739ae039.store.subscribe('userdata', function(data) {
            if (data && data.Count > 0) $2687097d5145937a$export$2e2bcd8739ae039.configUser.readonly = false;
            console.log('DrDoc.store.subscribe: ', data);
            let selectedArchive = $2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/selected-archive');
            if ($2687097d5145937a$export$2e2bcd8739ae039.GetArchive(selectedArchive) == null) {
                if (data != undefined && data.Result != undefined && data.Result.Archives != undefined && data.Result.Archives && data.Result.Archives.length > 0) //console.log('Selected Archive (configDevice) NOT found: ', selectedArchive, ' - selecting: ', data.Result.Archives[0].Archive.SimpleName);
                $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', data.Result.Archives[0].Archive.SimpleName);
            //console.log('Selected Archive (configDevice) NOT found: Noch Archive found.');
            }
        });
        // --
        // Subscribe
        if (window.__drdoc_ignore_userdata !== true) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/selected-usermanager', function(value, oldValue) {
                // User Daten neu laden
                //DrDoc.store.update('userdata');
                //DrDoc.SearchInbox(document.documentElement);
                console.log('Usermanager has changed: ', value, ' <- ', oldValue);
                if (!(0, $346VI.default).IsNullOrEmpty(oldValue)) setTimeout(function() {
                    window.location.reload();
                }, 1500);
            });
            // Sortierung anzeigen/ausblenden
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree', function(value, oldValue) {
                if (value) {
                    if ($2687097d5145937a$export$2e2bcd8739ae039.configDevice.get('view/list-sort-width') <= 1) $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 15);
                } else {
                    // Tree ausblenden
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 2);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/list-sort-width', 0);
                }
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool('view/list/tree/cols', function(value, oldValue) {
                $2687097d5145937a$export$2e2bcd8739ae039.DisplayDataseListTreeCols(value);
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/label-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-label-style-classes'));
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/button-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-button-style-classes'));
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/read-only-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-read-only-style-classes'));
        } else $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribe('view/button-style-classes', $2687097d5145937a$export$2e2bcd8739ae039.getOnChangeStyleFn('.dd-button-style-classes'));
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool('view/layout-sm', function(value) {
            // 'table-sm', 
            let selectorClasses = [
                'btn-sm',
                'btn-group-sm',
                'btn-toolbar-sm',
                'input-group-sm',
                'form-select-sm',
                'form-control-sm',
                'pagination-sm',
                'table-sm'
            ];
            selectorClasses.forEach(function(selector) {
                // $('.btn .btn-sm').addClass();
                if (value === true) {
                    // *-sm Klassen hinzufügen
                    document.querySelectorAll('.dd-' + selector).forEach(function(elem) {
                        elem.classList.add(selector);
                        elem.classList.remove('dd-' + selector);
                    });
                    document.querySelectorAll(selector).forEach(function(elem) {
                        elem.classList.remove('dd-' + selector);
                    });
                } else {
                    document.querySelectorAll('.' + selector).forEach(function(elem) {
                        elem.classList.add('dd-' + selector);
                        elem.classList.remove(selector);
                    });
                    document.querySelectorAll('.dd-' + selector).forEach(function(elem) {
                        elem.classList.remove(selector);
                    });
                }
            /*else {
                    console.warn('dafuq Value.. ', value);
                }*/ });
        }, true);
        $2687097d5145937a$export$2e2bcd8739ae039._navLastArchive = '';
        $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribe('view/selected-archive', function(value) {
            if (value == undefined || value == null) return;
            console.log('Archive has changed: ', value);
            if ($2687097d5145937a$export$2e2bcd8739ae039._navLastArchive != value) {
                $2687097d5145937a$export$2e2bcd8739ae039._navLastArchive = value;
                console.log('DrDoc.historyAddPage: Archive has changed: ', value);
                window.history.pushState({
                    action: 'change-archive',
                    value: value
                }, window.location.href, window.location.href);
            }
            // Liste als Ansicht wählen
            //DrDoc.SetViewList();
            $2687097d5145937a$export$2e2bcd8739ae039.UpdateViewMode();
        }, '__none__');
        if (window.__drdoc_ignore_userdata !== true) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree-list-group', function(value) {
                if (value === true) $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/list/show-tree', false);
            }, false);
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.subscribeBool('view/list/show-tree', function(value) {
                if (value === true) $2687097d5145937a$export$2e2bcd8739ae039.configUser.set('view/list/show-tree-list-group', false);
            }, false);
        }
    /*
        DrDoc.configUser.subscribeBool('view/menu-system/mask-show', function(value) {
            let elem = document.querySelector('#collapseToolbarMask');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
         
        DrDoc.configUser.subscribeBool('view/menu-system/mask-list', function(value) {
            let elem = document.querySelector('#collapseToolbarList');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
        */ }).catch(function(err) {
        // abbrechen, wenn 'userdata' fehlschlägt
        console.log('userdata subscribe _sub1 failed', err);
    //DrDoc.configUser.clear();
    });
    // init('userdata') Ende
    //window.removeEventListener('popstate', Node.OnNavigateComponentEvent);
    window.addEventListener('popstate', function(e) {
        if (e.state != undefined && e.state != null && e.state.action == 'change-archive') {
            e.preventDefault();
            console.warn('DrDoc.historyAddPage: change Archive: ', e.state.value);
            //console.warn('DrDoc.historyAddPage: set archive: ', e.state.value);
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set('view/selected-archive', e.state.value);
        }
    });
    document.addEventListener('NodeUnloaded', function(e) {
        //console.log("NodeUnloaded");
        let nodeLoadedTarget = e.target;
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(triggerElem) {
            let bs_elem = bootstrap.Tooltip.getInstance(triggerElem);
            if (bs_elem) bs_elem.dispose();
        });
        nodeLoadedTarget.querySelectorAll('.tooltip.bs-tooltip-auto').forEach(function(triggerElem) {
            triggerElem.remove();
        });
    /*nodeLoadedTarget.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Dropdown.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Collapse.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });*/ });
    //window.addEventListener('dragover', null);
    //window.addEventListener('drop', null);
    //document.addEventListener('dragover', null);
    //document.addEventListener('drop', null);
    // Initialisierung
    document.addEventListener('NodeLoaded', function(e) {
        console.log("NodeLoaded DrDOC: ", e, e.target);
        let nodeLoadedTarget = e.target;
        $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
        //DrDoc.UpdateSplitPanel();
        //nodeLoadedTarget.querySelector('.selected-archive').val(value);
        //nodeLoadedTarget.querySelectorAll('[bind-conf-user]').forEach(DrDoc.configUser.BindConfig.bind(DrDoc.configUser));
        //nodeLoadedTarget.querySelectorAll('[bind-conf-dev]').forEach(DrDoc.configDevice.BindConfig.bind(DrDoc.configDevice));
        /*nodeLoadedTarget.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.setAttribute('draggable', 'true');
            elem.setAttribute('droppable', 'true');
            //if (elem.ondrop === undefined)
            //    elem.ondrop = function (ev) { };
    
            elem.addEventListener('dragover', function(ev)
            {
                console.log('dragover TEST');
              ev.preventDefault(); // Necessary. Allows us to drop.    
              ev.currentTarget.setAttribute('style', "border-top:solid;");   
            });
    
            //console.log('Drag/Drop: ', elem);
        });*/ nodeLoadedTarget.querySelectorAll('[bind-conf-user]').forEach(function(elem) {
            $2687097d5145937a$export$2e2bcd8739ae039.configUser.BindConfig(elem, 'bind-conf-user');
        });
        nodeLoadedTarget.querySelectorAll('[bind-conf-dev]').forEach(function(elem) {
            $2687097d5145937a$export$2e2bcd8739ae039.configDevice.BindConfig(elem, 'bind-conf-dev');
        });
        /*var treeToggler = document.getElementsByClassName("tree-caret");
        if (treeToggler != undefined && treeToggler != null)
        {
            let updateTreeElem = function(elem) {
                if (elem.parentElement.querySelector(".tree-nested").classList.contains('tree-active'))
                    elem.classList.add("tree-caret-down");
                else
                    elem.classList.remove("tree-caret-down");
            }
            for (let i = 0; i < treeToggler.length; i++) {
                updateTreeElem(treeToggler[i]);
                treeToggler[i].addEventListener("click", function(e) {
                    e.target.parentElement.querySelector(".tree-nested").classList.toggle("tree-active");
                    updateTreeElem(e.target);
                });
            }
        }*/ // Tree View
        (0, $346VI.default).TreeView();
        //window.addEventListener("beforeunload", function() {
        //    return "Are you sure? You didn't finish the form!";
        //});
        // Drag n Drop
        (0, $346VI.default).dnd_init(document);
        /*document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!DrDocWeb.IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
                console.log('TAB: ', target, ' / ', bs_elem);
            }
        });*/ nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tab"]').forEach(function(triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            //console.log('TAB: ', target, ' / ', bs_elem);
            }
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="pill"]').forEach(function(triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            }
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="popover"]').forEach(function(triggerElem) {
            let title = triggerElem.getAttribute('data-bs-content');
            if (!(0, $346VI.default).IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Popover.getOrCreateInstance(triggerElem);
            }
        //bs_elem.update();
        });
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(triggerElem) {
            let title = triggerElem.getAttribute('data-bs-title');
            if (!(0, $346VI.default).IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Tooltip.getOrCreateInstance(triggerElem);
            }
        //bs_elem.update();
        });
        // --
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function(triggerElem) {
            if (triggerElem._hasHandlerX === true) return;
            triggerElem._hasHandlerX = true;
            let dropdown = triggerElem.parentNode;
            let dropdownMenu = null;
            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            if (!(0, $346VI.default).IsNullOrEmpty(triggerElemSelector)) dropdownMenu = nodeLoadedTarget.querySelector(triggerElemSelector);
            if (dropdownMenu == undefined || dropdownMenu == null) dropdownMenu = dropdown.querySelector('.dropdown-menu');
            let bsDropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
            triggerElem.addEventListener('click', function() {
                //dropdown.classList.add('position-static');
                if (triggerElem._popper != undefined) triggerElem._popper.destroy();
                // noch nicht angezeigt? => anzeigen
                if (dropdownMenu.classList.contains('show')) {
                    dropdown.classList.remove('show');
                    dropdownMenu.classList.remove('show');
                    triggerElem.setAttribute('aria-expanded', false);
                } else {
                    let popperTmp = window.createPopper(dropdown, dropdownMenu, {
                        placement: 'bottom-end',
                        modifiers: {
                            offset: 0,
                            flip: {
                                enabled: true
                            },
                            preventOverflow: {
                                boundariesElement: 'viewport'
                            }
                        }
                    });
                    bsDropdown._popper = popperTmp;
                    triggerElem._popper = popperTmp;
                    triggerElem.focus();
                    triggerElem.setAttribute('aria-expanded', true);
                    dropdown.classList.add('show');
                    dropdownMenu.classList.add('show');
                //console.log('BS Dropdown Click: ', triggerElem, ' => ', dropdownMenu, ' / BS: ', triggerElem._popper);
                }
            });
        /*
            const bs_elem = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
            bs_elem._popper = window.createPopper;
            bs_elem.update();
            bs_elem.show();
            console.log('BS Dropdown Init: ', bs_elem);
            */ //DrDocWeb.BS_DropdownInit(triggerElem);
        });
        // Dropdowns beim Click nicht automatisch schließen
        // .dropdown-menu 
        // .dropdown-leave-open > .dropdown-item
        if (nodeLoadedTarget.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item')) nodeLoadedTarget.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item').forEach(function(elem) {
            elem.addEventListener("click", function(e) {
                e.stopPropagation();
            //console.log('click!');
            });
        });
        // --
        // Menu Main
        // Die Klasse "expanded" dem Element "#menu-main-drdoc" hinzufügen
        $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
        // --
        // Collapese Zustand aus Config laden/merken
        nodeLoadedTarget.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(triggerElem) {
            if (triggerElem._hasCollapseHandler === true) return;
            triggerElem._hasCollapseHandler = true;
            let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
            let triggerElemExpanded = (0, $346VI.default).IsNullOrEmpty(triggerElemExpandedValue) ? null : triggerElemExpandedValue == 'true';
            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            let targetElemArr = nodeLoadedTarget.querySelectorAll(triggerElemSelector);
            if (targetElemArr == null) return;
            if (targetElemArr.length > 1) console.log('more then one target: [data-bs-toggle="collapse"]: ', targetElemArr.length, ' / ', targetElemArr);
            let targetElem = targetElemArr[0];
            //targetElemArr.forEach(function (targetElem) {
            if (targetElem == null) return;
            const bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem, {
                toggle: false
            });
            // Attribute [aria-expanded] undefined?
            // Init State from Config
            if (!(0, $346VI.default).IsNullOrEmpty(triggerElemSelector) && targetElem != undefined && targetElem != null) {
                let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);
                // on Show
                targetElem.addEventListener('show.bs.collapse', function(e) {
                    //console.log('show.bs.collapse: ', targetElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(confName, true);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                // on Hide
                targetElem.addEventListener('hide.bs.collapse', function(e) {
                    //console.log('hide.bs.collapse: ', targetElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.set(confName, false);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                // Menü links einklappen/ausklappen
                targetElem.addEventListener('shown.bs.collapse', function(e) {
                    //console.log('shown.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, true);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                targetElem.addEventListener('hidden.bs.collapse', function(e) {
                    //console.log('hidden.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, false);
                    $2687097d5145937a$export$2e2bcd8739ae039.updateMainMenuExpansion();
                });
                if (triggerElemExpanded == null) {
                    console.log('init.bs.collapse: ', triggerElem, confName);
                    $2687097d5145937a$export$2e2bcd8739ae039.configDevice.subscribeBool(confName, function(valueNew, valueOld) {
                        const bs_elem2 = bootstrap.Collapse.getOrCreateInstance(targetElem);
                        if (valueNew === true) //console.log('init.bs.collapse SHOW: onChange: ', confName, valueNew, valueOld);
                        bs_elem2.show();
                        if (valueNew === false) //console.log('init.bs.collapse HIDE: onChange: ', confName, valueNew, valueOld);
                        bs_elem2.hide();
                    }, false);
                }
            }
            // Element inital einklappen / ausklappen
            if (triggerElemExpanded === true) //console.log('init.bs.collapse: aria-expanded=true SHOW: ', targetElem, triggerElem, confName);
            bs_elem.show();
            else if (triggerElemExpanded === false) //console.log('init.bs.collapse: aria-expanded=false HIDE: ', targetElem, triggerElem, confName);
            bs_elem.hide();
        //});
        });
        // --
        // es können keine Attribute ohne Wert mit Expressions gesetzt werden.
        // für required, readonly, checked kann data-* verwendet werden
        // Allen Pflichtfeldern die Klasse "is-required-empty" hinzufügen
        function initMandatoryFields(e) {
            //console.log('mandatory field changed ', e, this);
            let elems = e.target; //$('[data-required="true"]');
            tmpval = elems.value;
            if ((0, $346VI.default).IsNullOrEmpty(tmpval)) {
                elems.classList.add('is-required-empty');
                elems.classList.remove('is-required-not-empty');
            } else {
                elems.classList.add('is-required-not-empty');
                elems.classList.remove('is-required-empty');
            }
        }
        nodeLoadedTarget.querySelectorAll('[data-required]').forEach(function(elem) {
            elem.removeAttribute('required');
        });
        nodeLoadedTarget.querySelectorAll('[data-required="true"]').forEach(function(elem) {
            elem.setAttribute('required', true);
            elem.addEventListener('change', initMandatoryFields);
            initMandatoryFields({
                target: elem
            });
        });
        let boolAttrs = [
            'readonly',
            'checked',
            'selected'
        ];
        for (let attrName of boolAttrs){
            if (!nodeLoadedTarget.querySelectorAll('[data-' + attrName + ']')) continue;
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + ']').forEach(function(elem) {
                elem.removeAttribute(attrName);
            });
            var setCheckElem = function(elem, attrName, checked) {
                elem.setAttribute('data-' + attrName, checked);
                if (checked) elem.setAttribute(attrName, true);
                else elem.removeAttribute(attrName);
            };
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + '="false"]').forEach(function(elem) {
                setCheckElem(elem, attrName, false);
                elem.addEventListener('change', function(e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
            nodeLoadedTarget.querySelectorAll('[data-' + attrName + '="true"]').forEach(function(elem) {
                setCheckElem(elem, attrName, true);
                elem.addEventListener('change', function(e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
        }
        if (nodeLoadedTarget.querySelector('[required] [data-selected]')) nodeLoadedTarget.querySelectorAll('[required] [data-selected]').forEach(function(optionElem) {
            //nodeLoadedTarget.querySelector(optionElem.parentNode).on('change', initMandatoryFields);
            //nodeLoadedTarget.querySelector(optionElem.parentNode).each(initMandatoryFields);
            initMandatoryFields({
                target: optionElem
            });
        });
        // Focus auf SteuerElemente bei Click
        let allLabels = nodeLoadedTarget.querySelectorAll('label[data-for]');
        if (allLabels != undefined && allLabels != null && allLabels.length > 0) //console.log('Label A: ', allLabels);
        allLabels.forEach(function(labelElem) {
            // document.querySelector('[form={{$@_this.Dataset.FormIDName}}][name={{$@_this.Name}}]')
            let selector = labelElem.getAttribute('data-for');
            if ((0, $346VI.default).IsNullOrEmpty(selector)) return;
            //console.log('Label B: ', selector, ' / ', labelElem);
            labelElem.addEventListener('click', function(e) {
                let selectorElem = nodeLoadedTarget.querySelector(selector);
                //console.log('Label C: ', selector, ' / node: ', selectorElem.nodeName.toLowerCase(), ' / type: ', selectorElem.getAttribute('type'), ' / ', selectorElem);
                if (selectorElem != undefined && selectorElem != null) /*if (selectorElem.nodeName.toLowerCase() == 'input' && selectorElem.getAttribute('type') == 'checkbox')
                        {
                            selectorElem.checked = !selectorElem.checked;
                        }
                        else
                        {*/ selectorElem.focus();
            });
        });
        // --
        /*
        // Toggle Control automatisch öffnen/schließen je nach Endgerät
        $('.ds-nav').each(function(i) {
            let bsCollapse = bootstrap.Collapse.getInstance(this);
     
            // falls bereits eine Instanz exisitert, überspringen
            if (bsCollapse !== undefined && bsCollapse !== null)
                return;
     
            bsCollapse = new bootstrap.Collapse(this, {
              toggle: false
            });
     
            //console.log('toggler', bsCollapse, DrDocWeb.IsMobile());
     
            //if (DrDocWeb.IsMobile())
            //    bsCollapse.hide();
            //else
                bsCollapse.show();
        });
     
        // --
        */ let onLoadDoc = function(e) {
            if (window.DrDoc == undefined) return;
            console.log('Dr.DOC Init(): onLoadDocument');
            $2687097d5145937a$export$2e2bcd8739ae039.SetViewInit();
            (0, $346VI.default).TreeView();
            //window.addEventListener('resize', DrDoc.SetViewInit);
            window.addEventListener('beforeunload', $2687097d5145937a$export$2e2bcd8739ae039.CloseAllDocumentWnd);
            //DrDoc.UpdateViewMode();
            // SetViewList() ruft intern UpdateView() auf
            //DrDoc.SetViewList();
            //setTimeout(DrDoc.SetViewInit, 500);
            (0, $346VI.default).TreeView();
        };
        if (document.readyState === "loading") //console.log('document.readyState === "loading"');
        document.addEventListener('DOMContentLoaded', onLoadDoc);
        else //console.log('onLoadDoc()');
        onLoadDoc();
    });
    // NodeLoaded Ende
    console.log('Dr.DOC Init() END');
};
$2687097d5145937a$export$2e2bcd8739ae039.Init();

});
parcelRegister("a7Paw", function(module, exports) {
//import Popper from 'popperjs'
//import './node_modules/@popperjs/core/dist/esm/index.js';
//import * as Popper from './node_modules/@popperjs/core/dist/umd/popper.min.js';
//window.Popper = Popper;
//import * as Popper from "@popperjs/core"
//window.Popper = Popper;
// // import '@popperjs/core';
//import * from './node_modules/@popperjs/core/dist/esm/index.js';
//import { createPopper } from './node_modules/@popperjs/core/dist/esm/popper.js';

var $2oJ1v = parcelRequire("2oJ1v");

var $cw24N = parcelRequire("cw24N");

var $346VI = parcelRequire("346VI");
window.createPopper = (0, $2oJ1v.createPopper);
// Or import only needed plugins, specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap'
// Or import just one
//import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
window.bootstrap = $cw24N;
// --
// Bootstrap Modal
(0, $346VI.default).Modal = function(title, body, options) {
    if ((0, $346VI.default).IsNullOrEmpty(title) && (0, $346VI.default).IsNullOrEmpty(body)) {
        console.warn('DrDocWeb.Modal: empty arg title + body');
        return;
    }
    !(0, $346VI.default).IsNullOrEmpty(title) && (0, $346VI.default).IsNullOrEmpty(body);
    /*if (doc === undefined || doc === null)
    {
        doc = document;
    }*/ //var doc = (elm.ownerDocument || document);
    var doc = document;
    if (body != undefined && typeof body !== 'string' && body.ownerDocument !== undefined) doc = body.ownerDocument;
    var id = 'modal-dialog-id-' + (0, $346VI.default).RandomChars(12);
    // https://getbootstrap.com/docs/5.0/components/modal/
    var modalClassName = 'modal drdoc-modal';
    var dialogClassName = 'modal-dialog modal-dialog-scrollable';
    let className = 'modal-content';
    //let attributesName = '';
    let optionBackdrop = true;
    if (options !== null && options !== undefined && typeof options === 'object') {
        if (options.fullScreen === true) dialogClassName += ' modal-fullscreen';
        else {
            let size = options.size ? options.size : 'xl';
            // automatisch full-screen, wenn kleiner als XXL
            dialogClassName += ` modal-${size} modal-fullscreen-${size}-down`;
        //dialogClassName += ' modal-xl modal-fullscreen-lg-down';
        }
        //if (options.scrollable === true || options.scrollable === undefined)
        //    dialogClassName += ' modal-fullscreen-sm-down'; // ' modal-xl'; // ' modal-lg';
        if (options.color == 'success') className = 'alert alert-success';
        else if (options.color == 'warning') className = 'alert alert-warning';
        else if (options.color == 'info') className = 'alert alert-info';
        else if (options.color == 'danger' || options.color == 'error') className = 'alert alert-danger';
        if (options.static === true) optionBackdrop = 'static';
        else if (options.backdrop === true) optionBackdrop = true;
        else if (options.backdrop === false) optionBackdrop = false;
    }
    let bodyHtml = `
      <div class="modal-body">

      </div>`;
    /*if (body !== undefined)
    {
        body = `
      <div class="modal-body">
        ${body}
      </div>`;
    }*/ if (!(0, $346VI.default).IsNullOrEmpty(title)) title = `
      <h5 class="modal-title">
        ${title.toHtmlEntities()}
      </h5>`;
    let modalsAll = doc.querySelectorAll('.drdoc-modal');
    // console.log('Modals', modalsAll);
    if (modalsAll !== undefined && modalsAll !== null) {
        modalClassName += ' l' + (modalsAll.length + 1).toString();
        // die "active"-Klasse aus allen Modals entfernen
        for (let itm of modalsAll)//$(modalsAll[i]).removeClass('active');
        itm.classList.remove('active');
    } else modalClassName += 'l0';
    modalClassName += ' active';
    var elem = doc.createElement('div');
    // elem.innerHTML
    (0, $346VI.default).setInnerHTML(elem, `
<div class="${modalClassName}" x-tabindex="-1" id="${id}">
  <div class="${dialogClassName}">
    <div class="${className}">
      <div class="modal-header pt-2 pb-2 x-bg-gradient x-box x-bg-light">
        ${title}
        <!--<div style="margin-left: auto">
        <button type="button" class="btn btn-secondary">Prev</button>
        <button type="button" class="btn btn-secondary" onclick="">Next</button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>-->
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onclick="DrDocWeb.ModalClose(this);"></button>
      </div>
      ${bodyHtml}
      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
      -->
    </div>
  </div>
</div>
    `, doc);
    // Modal DOM-Elem der Seite hinzufpgen
    // getElementById('modal-container')
    doc.body.appendChild(elem);
    // elem neu laden
    elem = doc.getElementById(id);
    if (elem === undefined || elem === null) console.error('Modal: elem ist null, obwohl es gerade erstellt wurde', id);
    var bs = new $cw24N.Modal(elem, {
        keyboard: true,
        focus: true,
        backdrop: optionBackdrop
    });
    console.log('BS Backdrop: ', optionBackdrop);
    // Wenn Body ein Element ist, dann als Element einbinden
    if (body != undefined) {
        let bodyModalElem = elem.querySelector('.modal-body');
        if (bodyModalElem != undefined) {
            if (typeof body === 'string') {
                if (body != title) bodyModalElem.innerHTML = body; //.toHtmlEntities();
            } else bodyModalElem.appendChild(body);
        }
    }
    //setTimeout(function() {
    bs.show();
    //bs.toggle();
    //}, 1000);
    //bs.focus();
    // Event, wenn Modal geschlossen wird
    elem.addEventListener('hide.bs.modal', function(event) {
        //console.log('hide.bs.modal');
        let elem = doc.getElementById(id);
        elem.classList.add('hide');
        elem.classList.remove('active');
        // vorletztes Modal wieder aktivieren durch Setzen der "active"-Klasse
        let modalsAll = doc.querySelectorAll('.drdoc-modal');
        if (modalsAll !== undefined && modalsAll !== null && modalsAll.length > 1) modalsAll[modalsAll.length - 2].classList.add('active');
    });
    bs.close = function(event, removeChilds) {
        if (bs == null || bs._closed === true) return;
        bs._closed = true;
        //console.log('close hidden.bs.modal 1');
        bs.hide();
        // alle Elemente des Modal Content aus dem DOM entfernen
        if (removeChilds === undefined || removeChilds === true) while(elem.firstChild)elem.removeChild(elem.lastChild);
        //console.log('close hidden.bs.modal 2');
        setTimeout(function() {
            let elem = doc.getElementById(id);
            if (elem != undefined) elem.remove();
            if (bs != undefined) bs.dispose();
        //console.log('close hidden.bs.modal 3');
        }, 200);
    };
    // Beim schließen aus DOM entfernen
    elem.addEventListener('hidden.bs.modal', bs.close);
    return bs;
};
(0, $346VI.default).ModalSecondary = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'secondary',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalInfo = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'info',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalWarning = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'warning',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalWarn = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'warning',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalOk = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'success',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).ModalError = function(title, body) {
    return (0, $346VI.default).Modal(title, body, {
        color: 'danger',
        fullScreen: false,
        size: 'lg'
    });
};
(0, $346VI.default).GetModalError = function(title, body) {
    return function(error) {
        console.warn(error);
        return (0, $346VI.default).ModalError(title, body);
    };
};
(0, $346VI.default).ModalGet = function(element) {
    if (element === null || element === undefined) return undefined;
    if (typeof element === 'string') element = document.querySelector(element);
    if (element.classList !== undefined && element.classList.contains('drdoc-modal')) {
        //var modal = bootstrap.Modal.getOrCreateInstance(element);
        var modal = $cw24N.Modal.getInstance(element);
        return modal;
    } else if (element.parentNode !== undefined && element.parentNode !== null) return (0, $346VI.default).ModalGet(element.parentNode);
};
(0, $346VI.default).ModalClose = function(element, removeChilds) {
    let modal = (0, $346VI.default).ModalGet(element);
    if (modal !== null && modal !== undefined) {
        //modal.hide();
        modal.close(undefined, removeChilds);
        return true;
    } else //console.log('DrDocWeb.ModalClose: Element nicht gefunden: ', element);
    return false;
};
(0, $346VI.default).ModalProgress = function(title) {
    let progressBarId = 'progress-' + (0, $346VI.default).RandomChars(12);
    let progressBarHtml = `
<div id="${progressBarId}" class="progress" role="progressbar" aria-label="${title}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
<div id="${progressBarId}-bar" class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%;"></div>
</div>
`;
    let progressBarModal = (0, $346VI.default).ModalSecondary(title, progressBarHtml);
    progressBarModal.setPercentComplete = function(percentComplete) {
        document.getElementById(progressBarId + '-bar').style.width = percentComplete + '%';
        let progressBarElem = document.getElementById(progressBarId);
        progressBarElem.setAttribute('aria-valuenow', percentComplete);
    };
    //progressBarModal.setPercentComplete(0);
    return progressBarModal;
};
// --
// Bootstrap Wrapper
(0, $346VI.default).BS_TabShowFirst = function(containerElem) {
    if (containerElem == undefined || containerElem == null) containerElem = document;
    //if (typeof containerElem === 'string')
    var tabElems = containerElem.querySelectorAll('[data-bs-toggle="pill"], [data-bs-toggle="tab"]');
    if (tabElems != null && tabElems != undefined && tabElems.length > 0) (0, $346VI.default).BS_TabShow(tabElems[0]);
    tabElems.forEach(function(tabElem, tabIndex) {
        tabElem.addEventListener('click', function(e) {
            //console.log('Tab Click', tabIndex, e, tabElem);
            (0, $346VI.default).BS_TabShow(tabElems[tabIndex]);
        //DrDocWeb.BS_TabShow(e.target);
        });
    });
};
(0, $346VI.default).BS_TabShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = (0, $346VI.default).BS_TabShow(document.querySelector(tabElem));
    let elemTriggerBS = $cw24N.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_TabShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_TabShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_CollapseShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Collapse.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Collapse.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Collapse(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_CollapseShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_CollapseShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_DropdownShow = function(tabElem) {
    if (tabElem == null || tabElem == undefined) return undefined;
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Dropdown.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.show();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_DropdownShow: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_DropdownShow: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_TabHide = function(tabElem) {
    if (typeof tabElem === 'string') tabElem = document.querySelector(tabElem);
    let elemTriggerBS = $cw24N.Tab.getOrCreateInstance(tabElem);
    //let elemTriggerBS = bootstrap.Tab.getInstance(tabElem);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Tab(tabElem);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        try {
            elemTriggerBS.hide();
        } catch (Ex) {
            console.warn('DrDocWeb.BS_TabHide: ERROR', Ex, elemTriggerBS, tabElem);
        }
        return elemTriggerBS;
    } else console.log('DrDocWeb.BS_TabHide: Element wurde nicht gefunden!', elemTriggerBS, tabElem);
    return undefined;
};
(0, $346VI.default).BS_DropdownInit = function(triggerElem) {
    /*const dropdown = new bootstrap.Dropdown(triggerElem, {
        popperConfig(defaultBsPopperConfig) {
          // const newPopperConfig = {...}
          // use defaultBsPopperConfig if needed...
          // return newPopperConfig
        }
      });
      dropdown.update();*/ triggerElem.removeEventListener('click', (0, $346VI.default).BS_Dropdown_OnClick);
    triggerElem.addEventListener('click', (0, $346VI.default).BS_Dropdown_OnClick);
//let dropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
//dropdown.update();
};
(0, $346VI.default).BS_Dropdown_OnClick = function(e) {
    // Dropdown anzeigen
    //e.preventDefault();
    if (e.target == undefined || e.target == null) return;
    let dropdownElem = e.target.parentNode.querySelector('.dropdown-menu');
    if (dropdownElem == undefined || dropdownElem == null) return;
    //dropdownElem.style.marginTop = '1.8rem';
    dropdownElem.style.position = 'absolute';
    //dropdownElem.style.transform = 'translate(148px)';
    if (dropdownElem.classList.contains('dropend')) dropdownElem.style.transform = `translate(${dropdownElem.parentNode.offsetWidth.toString()}px, -${dropdownElem.parentNode.offsetHeight.toString()}px)`;
    else dropdownElem.style.transform = `translate(0px, ${dropdownElem.parentNode.offsetHeight.toString()}px)`;
    dropdownElem.classList.toggle('show');
    console.log('BS_Dropdown_OnClick', e, this);
    //dropdownElem.trigger('click.bs.dropdown');
    //$(this).trigger('click.bs.dropdown');
    //$(this).trigger('show.bs.dropdown');
    let elemTriggerBS = $cw24N.Dropdown.getOrCreateInstance(e.target);
    //let elemTriggerBS = bootstrap.Dropdown.getInstance(this);
    //if (elemTriggerBS === undefined || elemTriggerBS === null)
    //    elemTriggerBS = new bootstrap.Dropdown(this);
    //console.log('BS_Dropdown_OnClick -> OPEN 1', e, elemTriggerBS._config);
    if (elemTriggerBS !== undefined && elemTriggerBS !== null) {
        elemTriggerBS.update();
        //elemTriggerBS.toggle();
        //console.log(elemTriggerBS);
        return elemTriggerBS;
    }
    return undefined;
};
// onInitTargetElem (triggerElem, triggerElemSelector targetElem, cb_bs_elem_open, cb_bs_elem_close)
(0, $346VI.default).BS_Collapse = function(onInitTargetElem, onOpen, onClose) {
    // button[data-bs-toggle="collapse"]
    document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function(triggerElem) {
        if (triggerElem._hasHandler === true) return;
        triggerElem._hasHandler = true;
        //if (triggerElem.getAttribute('data-has-config-handler') == 'true')
        //    return;
        //triggerElem.setAttribute('data-has-config-handler', 'true');
        // Attribut [aria-expanded] verwenden, um die initiale
        let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
        let triggerElemExpanded = (0, $346VI.default).IsNullOrEmpty(triggerElemExpandedValue) ? null : triggerElemExpandedValue == 'true';
        let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
        if ((0, $346VI.default).IsNullOrEmpty(triggerElemSelector)) {
            console.warn('Collapse ', 'elemSelector === undefined', triggerElem);
            return;
        }
        let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);
        let targetElem_arr = document.querySelectorAll(triggerElemSelector);
        if (targetElem_arr === undefined || targetElem_arr == null) console.warn('Collapse ', 'targetElem_arr === undefined', triggerElem);
        //console.log('Collapse New ', triggerElemSelector, targetElem_arr, confName);
        targetElem_arr.forEach(function(targetElem) {
            if (targetElem._hasHandler === true) return;
            targetElem._hasHandler = true;
            let bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
            /*let bs_elem = bootstrap.Collapse.getInstance(targetElem);
            if (bs_elem == undefined || bs_elem == null)
            {
            bs_elem = new bootstrap.Collapse(targetElem, {
                toggle: false
            });
            }*/ //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
            if (bs_elem._hasHandler === true) return;
            bs_elem._hasHandler = true;
            //bs_elem.hide();
            //bs_elem._isOpen = false;
            const WAIT_TIME = 10;
            var bs_elem_open = function(signal) {
                bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[+] Target Show ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
                bs_elem._element.classList.add('show');
                triggerElem.setAttribute('aria-expanded', 'true');
                targetElem.classList.add('show');
                targetElem.classList.remove('collapsed');
                onOpen(triggerElem, triggerElemSelector);
            /*if (signal)
                {
                setTimeout(function () {
                    bs_elem_open(false);
                    //triggerElem.setAttribute('aria-expanded', 'true');
                    //targetElem.classList.add('show');
                    //if (window.updateMainMenuExpansion !== undefined)
                    //    window.updateMainMenuExpansion();
                    onOpen(triggerElem, triggerElemSelector);
                }, WAIT_TIME/2);
                }*/ };
            var bs_elem_close = function(signal) {
                bs_elem = $cw24N.Collapse.getOrCreateInstance(targetElem);
                //console.warn('[-] Target Hide ', confName, triggerElemSelector, bs_elem);
                //DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
                triggerElem.setAttribute('aria-expanded', 'false');
                targetElem.classList.remove('show');
                targetElem.classList.add('collapsed');
                if (signal) {
                    setTimeout(function() {
                        bs_elem_close(false);
                        //triggerElem.setAttribute('aria-expanded', 'false');
                        //targetElem.classList.remove('show');
                        //if (window.updateMainMenuExpansion !== undefined)
                        //    window.updateMainMenuExpansion();
                        onClose(triggerElem, triggerElemSelector);
                    }, WAIT_TIME / 2);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 2 * WAIT_TIME);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 10 * WAIT_TIME);
                    setTimeout(function() {
                        bs_elem_close(false);
                    }, 50 * WAIT_TIME);
                }
            };
            //console.log('try close 1', bs_elem);
            bs_elem_close(false);
            if (triggerElemExpanded === true) bs_elem_open(true);
            else if (triggerElemExpanded === false) //console.log('BS Collapse Init: Force Close: ', triggerElemExpanded, triggerElem);
            bs_elem_close(true);
            // Collapse lässt sich nicht soofort schlieeßen!
            setTimeout(function() {
                //console.log('init', bs_elem);
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem, bs_elem_open, bs_elem_close, triggerElemExpanded);
                /*console.log('try close 2');
                bs_elem_close(false);

                setTimeout(function () {
                    console.log('init')
                onInitTargetElem(triggerElem, triggerElemSelector, targetElem); //, bs_elem_open, bs_elem_close);
                //}, 5000);*/ // Wenn irgendwo ins Dokument geklickt wird, das Dropdown schließen
                // Event handler erst nach ein paar Millisekunden aufrufen, da er sonst sofort aufgerufen wird, da gerade geklickt wird.
                /*triggerElem.addEventListener('click', function(e_click) {
                    console.log('BS_Collapse: onClick: triggerElem: ', e_click.target, triggerElem, targetElem);
                    bs_elem_close(true);
                });*/ // Beim Click auf Menu Item, das Menü schließen
                if ((0, $346VI.default).IsMobile()) {
                    targetElem.querySelectorAll('a').forEach(function(targetElemLink) {
                        targetElemLink.addEventListener('click', function(e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                    targetElem.querySelectorAll('button').forEach(function(targetElemLink) {
                        targetElemLink.addEventListener('click', function(e_click) {
                            console.log('BS_Collapse: onClick: targetElem: ', e_click.target, triggerElem, targetElem);
                            bs_elem_close(true);
                        });
                    });
                }
            }, WAIT_TIME);
            triggerElem.addEventListener('click', function(e) {
                e.preventDefault();
                if (!bs_elem._isOpen) //if (!targetElem.classList.contains('show'))
                {
                    console.log('Menu is closed -> open: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_open(true);
                } else {
                    console.log('Menu is open -> close: ', targetElem.className, targetElem.classList.contains('show'), bs_elem._isOpen);
                    bs_elem_close(true);
                }
            });
        /*
            //console.warn('DrDoc.configDevice.subscribeBool PRE ', confName);
            DrDoc.configDevice.subscribeBool(confName, function (valueNew, valueOld) {
                //let bs_elem = new bootstrap.Collapse(targetElem);
                //let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                console.info('DrDoc.configDevice.subscribeBool POST ', confName, ' => ', valueNew); //, '  ', triggerElemSelector, bs_elem);

                //if (bs_elem) {
                    if (valueNew === true) {
                        bs_elem_open();
                    }
                    else {
                        bs_elem_close();
                    }
                //}
            }, false);

            triggerElem.addEventListener('click', function () {
                let bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem);
                DrDoc.configDevice.set(confName, !bs_elem._isOpen);
            });*/ /*targetElem.addEventListener('hidden.bs.collapse', function () {
                console.warn('Target Hide ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, false);
                bs_elem._isOpen = false;
                bs_elem.hide();
            });
            targetElem.addEventListener('shown.bs.collapse', function () {
                console.warn('Target Show ', confName, triggerElemSelector, bs_elem);
                DrDoc.configDevice.set(confName, true);
                bs_elem._isOpen = true;
                bs_elem.show();
            });*/ });
    });
}; // --
 /*
DrDoc.BS_NavInitTabs = function(id)
{
    // Ersten Tab automatisch laden
    //var triggerTabList = document.querySelectorAll('#nav-tab button');
    //var triggerTab = document.querySelector('#nav-tab-' + id + ' button:first-child');
    //var triggerTab = document.querySelector('#' + id + ' button:first-child');
    var triggerTab = DrDocWeb.GetElement('#' + id);
    if (triggerTab !== undefined && triggerTab !== null)
    {
        let tabs = triggerTab.querySelectorAll('button'); //:first-child');
        
        console.log('BS_NavInitTabs', id); //, triggerTab);
        if (tabs === undefined || tabs === null)
        {
            console.warn('MaskLoadFirstTab: Erster Tab (BS) konnte nicht gefunden werden!', id);
        }
        else
        {
            if (tabs.length === 0)
            {
                console.warn('MaskLoadFirstTab: 0 Tabs gefunden', id);
            }
            else
            {
                //for (let i = 0; i < 1; i++)
                for (let i = 0; i < tabs.length; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);
                    if (tabTriggerBS === undefined || tabTriggerBS === null)
                        tabTriggerBS = new bootstrap.Tab(triggerEl);
                        
                    triggerEl.addEventListener('click', function (event) {
                        //console.log('Show!');
                        event.preventDefault();
                        tabTriggerBS.show();
                    });

                    if (i === 0)
                    {
                        //console.log('MaskLoadFirstTab: Erster Tab wurde geladen', id, i, tabTriggerBS);
                        //tabTriggerBS.show();

                    }
                    else
                    {
                        //console.log('MaskLoadFirstTab: X-ter Tab wurde geladen', id, i);
                        //tabTriggerBS.show();
                    }
                }
                for (let i = 0; i < 1; i++)
                {
                    let triggerEl = tabs[i];
                    let tabTriggerBS = bootstrap.Tab.getInstance(triggerEl);

                        setTimeout(function() {
                            tabTriggerBS.show();
                            console.log(tabTriggerBS);
                        }, 1000);
                }
            }
        }
    }
    else {
        console.warn('MaskLoadFirstTab: Erster Tab konnte nicht gefunden werden!', id);
    }
};*/ 

});
parcelRegister("2oJ1v", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");

var $aE9ix = parcelRequire("aE9ix");

var $fhdOY = parcelRequire("fhdOY");

var $4lgpD = parcelRequire("4lgpD");

var $2c83k = parcelRequire("2c83k");

var $201VR = parcelRequire("201VR");


var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default),
    (0, $aE9ix.default),
    (0, $fhdOY.default),
    (0, $4lgpD.default),
    (0, $2c83k.default),
    (0, $201VR.default)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fqRLw", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export(module.exports, "createPopper", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);

var $4wmXH = parcelRequire("4wmXH");

var $4bNP2 = parcelRequire("4bNP2");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $10cit = parcelRequire("10cit");

var $dlaWb = parcelRequire("dlaWb");

var $657FY = parcelRequire("657FY");

var $leSQw = parcelRequire("leSQw");

var $iG0HL = parcelRequire("iG0HL");
var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $iG0HL.isElement)(reference) ? (0, $egjGe.default)(reference) : reference.contextElement ? (0, $egjGe.default)(reference.contextElement) : [],
                    popper: (0, $egjGe.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $10cit.default)((0, $657FY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4wmXH.default)(reference, (0, $ecwzm.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $4bNP2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlaWb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4wmXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $34abf65a06d63352$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $hlFJX = parcelRequire("hlFJX");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $5LRDP = parcelRequire("5LRDP");

var $25Alw = parcelRequire("25Alw");

var $aPr9y = parcelRequire("aPr9y");
function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $aPr9y.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $aPr9y.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $iG0HL.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $iG0HL.isHTMLElement)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $5LRDP.default)(offsetParent);
    var rect = (0, $bkFj6.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6NwRo.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $25Alw.default)(documentElement)) scroll = (0, $hlFJX.default)(offsetParent);
        if ((0, $iG0HL.isHTMLElement)(offsetParent)) {
            offsets = (0, $bkFj6.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $cJ1Bs.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bkFj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $84019ab652aa921b$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");

var $aPr9y = parcelRequire("aPr9y");

var $jc5j7 = parcelRequire("jc5j7");

var $d9GIF = parcelRequire("d9GIF");
function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $iG0HL.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $aPr9y.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $aPr9y.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $iG0HL.isElement)(element) ? (0, $jc5j7.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d9GIF.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("iG0HL", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d98cb23738a6d9d0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d98cb23738a6d9d0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d98cb23738a6d9d0$export$af51f0f06c0f328a);

var $jc5j7 = parcelRequire("jc5j7");
function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $jc5j7.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $jc5j7.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $jc5j7.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("jc5j7", function(module, exports) {

$parcel$export(module.exports, "default", () => $df9341392e6ed7b1$export$2e2bcd8739ae039);
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("aPr9y", function(module, exports) {

$parcel$export(module.exports, "max", () => $7e23bad950468b82$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $7e23bad950468b82$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $7e23bad950468b82$export$2077e0241d6afd3c);
var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d9GIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $993d40d65cc118cd$export$2e2bcd8739ae039);

var $cqLtw = parcelRequire("cqLtw");
function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cqLtw.default)());
}

});
parcelRegister("cqLtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ccbd5892233dd2$export$2e2bcd8739ae039);
function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("hlFJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca14c6927ef497ac$export$2e2bcd8739ae039);

var $8Z1VN = parcelRequire("8Z1VN");

var $jc5j7 = parcelRequire("jc5j7");

var $iG0HL = parcelRequire("iG0HL");

var $crSja = parcelRequire("crSja");
function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $jc5j7.default)(node) || !(0, $iG0HL.isHTMLElement)(node)) return (0, $8Z1VN.default)(node);
    else return (0, $crSja.default)(node);
}

});
parcelRegister("8Z1VN", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a584be1dc90596$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $jc5j7.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("crSja", function(module, exports) {

$parcel$export(module.exports, "default", () => $9102221f9e13ae54$export$2e2bcd8739ae039);
function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("6NwRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f30cf0ce50e075e$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("cJ1Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $943aee5c7065ad53$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");

var $5LRDP = parcelRequire("5LRDP");

var $8Z1VN = parcelRequire("8Z1VN");
function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bkFj6.default)((0, $5LRDP.default)(element)).left + (0, $8Z1VN.default)(element).scrollLeft;
}

});
parcelRegister("5LRDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $433af39bc2fae35d$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $iG0HL.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("25Alw", function(module, exports) {

$parcel$export(module.exports, "default", () => $18583dfdff147fd4$export$2e2bcd8739ae039);

var $5Edas = parcelRequire("5Edas");
function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5Edas.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5Edas", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cae7042543c5d5$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $jc5j7.default)(element).getComputedStyle(element);
}

});



parcelRegister("4bNP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ced62b744c6cfe$export$2e2bcd8739ae039);

var $bkFj6 = parcelRequire("bkFj6");
function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bkFj6.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("egjGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a621d360f1a81b88$export$2e2bcd8739ae039);

var $5nNqk = parcelRequire("5nNqk");

var $23yvR = parcelRequire("23yvR");

var $jc5j7 = parcelRequire("jc5j7");

var $25Alw = parcelRequire("25Alw");
function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5nNqk.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $jc5j7.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $25Alw.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $23yvR.default)(target)));
}

});
parcelRegister("5nNqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb5703c925e0e5d$export$2e2bcd8739ae039);

var $23yvR = parcelRequire("23yvR");

var $25Alw = parcelRequire("25Alw");

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6NwRo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $iG0HL.isHTMLElement)(node) && (0, $25Alw.default)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $23yvR.default)(node));
}

});
parcelRegister("23yvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f6a21d28fc02f5$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $5LRDP = parcelRequire("5LRDP");

var $iG0HL = parcelRequire("iG0HL");
function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $6NwRo.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $iG0HL.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5LRDP.default)(element) // fallback
    );
}

});



parcelRegister("ecwzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56b734280245ffb$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $6NwRo = parcelRequire("6NwRo");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $8WsnW = parcelRequire("8WsnW");

var $23yvR = parcelRequire("23yvR");

var $cqLtw = parcelRequire("cqLtw");
function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $iG0HL.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5Edas.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cqLtw.default)());
    var isIE = /Trident/i.test((0, $cqLtw.default)());
    if (isIE && (0, $iG0HL.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5Edas.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $23yvR.default)(element);
    if ((0, $iG0HL.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $iG0HL.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6NwRo.default)(currentNode)) < 0){
        var css = (0, $5Edas.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $jc5j7.default)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $8WsnW.default)(offsetParent) && (0, $5Edas.default)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6NwRo.default)(offsetParent) === 'html' || (0, $6NwRo.default)(offsetParent) === 'body' && (0, $5Edas.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}

});
parcelRegister("8WsnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6829c22fb01dde5a$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");
function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6NwRo.default)(element)) >= 0;
}

});


parcelRegister("10cit", function(module, exports) {

$parcel$export(module.exports, "default", () => $0baf5472b5ad4a5a$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");
function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $l6ej2.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("l6ej2", function(module, exports) {

$parcel$export(module.exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export(module.exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export(module.exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export(module.exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export(module.exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export(module.exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export(module.exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export(module.exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export(module.exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export(module.exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export(module.exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];

});


parcelRegister("dlaWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b65b878009bf47f$export$2e2bcd8739ae039);
function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("657FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d929ffbbd3136a$export$2e2bcd8739ae039);
function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});

parcelRegister("leSQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f765731200b57f98$export$2e2bcd8739ae039);

var $8vjqA = parcelRequire("8vjqA");

var $5LRDP = parcelRequire("5LRDP");

var $bkFj6 = parcelRequire("bkFj6");

var $kcANe = parcelRequire("kcANe");

var $fbi7z = parcelRequire("fbi7z");

var $l6ej2 = parcelRequire("l6ej2");

var $iG0HL = parcelRequire("iG0HL");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");
function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $l6ej2.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $l6ej2.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $l6ej2.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4QECX.default)(typeof padding !== 'number' ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
    var altContext = elementContext === (0, $l6ej2.popper) ? (0, $l6ej2.reference) : (0, $l6ej2.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $8vjqA.default)((0, $iG0HL.isElement)(element) ? element : element.contextElement || (0, $5LRDP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bkFj6.default)(state.elements.reference);
    var popperOffsets = (0, $kcANe.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $fbi7z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $l6ej2.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $l6ej2.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $l6ej2.right),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $l6ej2.top),
                (0, $l6ej2.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("8vjqA", function(module, exports) {

$parcel$export(module.exports, "default", () => $631049efb60e96c6$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ayVYt = parcelRequire("ayVYt");

var $5mmoF = parcelRequire("5mmoF");

var $egjGe = parcelRequire("egjGe");

var $ecwzm = parcelRequire("ecwzm");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $iG0HL = parcelRequire("iG0HL");

var $bkFj6 = parcelRequire("bkFj6");

var $23yvR = parcelRequire("23yvR");

var $ioj8K = parcelRequire("ioj8K");

var $6NwRo = parcelRequire("6NwRo");

var $fbi7z = parcelRequire("fbi7z");

var $aPr9y = parcelRequire("aPr9y");
function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bkFj6.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $l6ej2.viewport) ? (0, $fbi7z.default)((0, $ayVYt.default)(element, strategy)) : (0, $iG0HL.isElement)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fbi7z.default)((0, $5mmoF.default)((0, $5LRDP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $egjGe.default)((0, $23yvR.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5Edas.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $iG0HL.isHTMLElement)(element) ? (0, $ecwzm.default)(element) : element;
    if (!(0, $iG0HL.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $iG0HL.isElement)(clippingParent) && (0, $ioj8K.default)(clippingParent, clipperElement) && (0, $6NwRo.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $aPr9y.max)(rect.top, accRect.top);
        accRect.right = (0, $aPr9y.min)(rect.right, accRect.right);
        accRect.bottom = (0, $aPr9y.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $aPr9y.max)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ayVYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0a0ce1fa68929f$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $d9GIF = parcelRequire("d9GIF");
function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $jc5j7.default)(element);
    var html = (0, $5LRDP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d9GIF.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $cJ1Bs.default)(element),
        y: y
    };
}

});

parcelRegister("5mmoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e70615fb3e74824$export$2e2bcd8739ae039);

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $cJ1Bs = parcelRequire("cJ1Bs");

var $8Z1VN = parcelRequire("8Z1VN");

var $aPr9y = parcelRequire("aPr9y");
function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5LRDP.default)(element);
    var winScroll = (0, $8Z1VN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $aPr9y.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $aPr9y.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $cJ1Bs.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5Edas.default)(body || html).direction === 'rtl') x += (0, $aPr9y.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ioj8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63950b756706495$export$2e2bcd8739ae039);

var $iG0HL = parcelRequire("iG0HL");
function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $iG0HL.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fbi7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d5f0927fb8bf5c$export$2e2bcd8739ae039);
function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("kcANe", function(module, exports) {

$parcel$export(module.exports, "default", () => $03cba2f7a1498b5f$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $fxYmH = parcelRequire("fxYmH");

var $l6ej2 = parcelRequire("l6ej2");
function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f6ekA.default)(placement) : null;
    var variation = placement ? (0, $ayUxD.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $l6ej2.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $l6ej2.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $l6ej2.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $l6ej2.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fxYmH.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $l6ej2.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $l6ej2.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("f6ekA", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe288682115fde3$export$2e2bcd8739ae039);

function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("ayUxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f0526e425773$export$2e2bcd8739ae039);
function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fxYmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b518c35b71cf930f$export$2e2bcd8739ae039);
function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});


parcelRegister("4QECX", function(module, exports) {

$parcel$export(module.exports, "default", () => $387b887da02b7e69$export$2e2bcd8739ae039);

var $8WQnk = parcelRequire("8WQnk");
function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8WQnk.default)(), paddingObject);
}

});
parcelRegister("8WQnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $683c5e26d5f8bfe5$export$2e2bcd8739ae039);
function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("6CeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d11a6decde23bf9$export$2e2bcd8739ae039);
function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});



parcelRegister("lUt2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);

var $jc5j7 = parcelRequire("jc5j7");
var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $jc5j7.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};

});

parcelRegister("k1fcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92fb10df1450f31$export$2e2bcd8739ae039);

var $kcANe = parcelRequire("kcANe");
function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kcANe.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};

});

parcelRegister("hfLNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $ecwzm = parcelRequire("ecwzm");

var $jc5j7 = parcelRequire("jc5j7");

var $5LRDP = parcelRequire("5LRDP");

var $5Edas = parcelRequire("5Edas");

var $f6ekA = parcelRequire("f6ekA");

var $ayUxD = parcelRequire("ayUxD");

var $aPr9y = parcelRequire("aPr9y");
var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $aPr9y.round)(x * dpr) / dpr || 0,
        y: (0, $aPr9y.round)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $l6ej2.left);
    var sideY = (0, $l6ej2.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ecwzm.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $jc5j7.default)(popper)) {
            offsetParent = (0, $5LRDP.default)(popper);
            if ((0, $5Edas.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $l6ej2.top) || (placement === (0, $l6ej2.left) || placement === (0, $l6ej2.right)) && variation === (0, $l6ej2.end)) {
            sideY = (0, $l6ej2.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $l6ej2.left) || (placement === (0, $l6ej2.top) || placement === (0, $l6ej2.bottom)) && variation === (0, $l6ej2.end)) {
            sideX = (0, $l6ej2.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $jc5j7.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f6ekA.default)(state.placement),
        variation: (0, $ayUxD.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};

});

parcelRegister("bjlic", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);

var $6NwRo = parcelRequire("6NwRo");

var $iG0HL = parcelRequire("iG0HL");
// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $iG0HL.isHTMLElement)(element) || !(0, $6NwRo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("aE9ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $l6ej2 = parcelRequire("l6ej2");
function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f6ekA.default)(placement);
    var invertDistance = [
        (0, $l6ej2.left),
        (0, $l6ej2.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $l6ej2.placements).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};

});

parcelRegister("fhdOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);

var $bbSog = parcelRequire("bbSog");

var $f6ekA = parcelRequire("f6ekA");

var $ac6AR = parcelRequire("ac6AR");

var $leSQw = parcelRequire("leSQw");

var $iScBU = parcelRequire("iScBU");

var $l6ej2 = parcelRequire("l6ej2");

var $ayUxD = parcelRequire("ayUxD");
function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f6ekA.default)(placement) === (0, $l6ej2.auto)) return [];
    var oppositePlacement = (0, $bbSog.default)(placement);
    return [
        (0, $ac6AR.default)(placement),
        oppositePlacement,
        (0, $ac6AR.default)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f6ekA.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bbSog.default)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f6ekA.default)(placement) === (0, $l6ej2.auto) ? (0, $iScBU.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f6ekA.default)(placement);
        var isStartVariation = (0, $ayUxD.default)(placement) === (0, $l6ej2.start);
        var isVertical = [
            (0, $l6ej2.top),
            (0, $l6ej2.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $l6ej2.right) : (0, $l6ej2.left) : isStartVariation ? (0, $l6ej2.bottom) : (0, $l6ej2.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bbSog.default)(mainVariationSide);
        var altVariationSide = (0, $bbSog.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("bbSog", function(module, exports) {

$parcel$export(module.exports, "default", () => $825ae98fe4f5d029$export$2e2bcd8739ae039);
var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}

});

parcelRegister("ac6AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c023b5f4bd6339$export$2e2bcd8739ae039);
var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}

});

parcelRegister("iScBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd70d4ba9902caa$export$2e2bcd8739ae039);

var $ayUxD = parcelRequire("ayUxD");

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");

var $f6ekA = parcelRequire("f6ekA");
function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $l6ej2.placements) : _options$allowedAutoP;
    var variation = (0, $ayUxD.default)(placement);
    var placements = variation ? flipVariations ? (0, $l6ej2.variationPlacements) : (0, $l6ej2.variationPlacements).filter(function(placement) {
        return (0, $ayUxD.default)(placement) === variation;
    }) : (0, $l6ej2.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $leSQw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f6ekA.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("4lgpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3295dac8746ffe59$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $f6ekA = parcelRequire("f6ekA");

var $fxYmH = parcelRequire("fxYmH");

var $iByzU = parcelRequire("iByzU");

var $fHMKD = parcelRequire("fHMKD");

var $4bNP2 = parcelRequire("4bNP2");

var $ecwzm = parcelRequire("ecwzm");

var $leSQw = parcelRequire("leSQw");

var $ayUxD = parcelRequire("ayUxD");

var $8WQnk = parcelRequire("8WQnk");

var $aPr9y = parcelRequire("aPr9y");
function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $leSQw.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var variation = (0, $ayUxD.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fxYmH.default)(basePlacement);
    var altAxis = (0, $iByzU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var altSide = mainAxis === 'y' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $l6ej2.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $l6ej2.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4bNP2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $8WQnk.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $fHMKD.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ecwzm.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $fHMKD.within)(tether ? (0, $aPr9y.min)(min, tetherMin) : min, offset, tether ? (0, $aPr9y.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $l6ej2.top) : (0, $l6ej2.left);
        var _altSide = mainAxis === 'x' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $l6ej2.top),
            (0, $l6ej2.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $fHMKD.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $fHMKD.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("iByzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b68132b61080af$export$2e2bcd8739ae039);
function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("fHMKD", function(module, exports) {

$parcel$export(module.exports, "within", () => $b6f0b0266e764faa$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $b6f0b0266e764faa$export$86c8af6d3ef0b4a);

var $aPr9y = parcelRequire("aPr9y");
function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $aPr9y.max)(min, (0, $aPr9y.min)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("2c83k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1992f2d714808ab6$export$2e2bcd8739ae039);

var $f6ekA = parcelRequire("f6ekA");

var $4bNP2 = parcelRequire("4bNP2");

var $ioj8K = parcelRequire("ioj8K");

var $ecwzm = parcelRequire("ecwzm");

var $fxYmH = parcelRequire("fxYmH");

var $fHMKD = parcelRequire("fHMKD");

var $4QECX = parcelRequire("4QECX");

var $6CeE3 = parcelRequire("6CeE3");

var $l6ej2 = parcelRequire("l6ej2");
var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4QECX.default)(typeof padding !== 'number' ? padding : (0, $6CeE3.default)(padding, (0, $l6ej2.basePlacements)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f6ekA.default)(state.placement);
    var axis = (0, $fxYmH.default)(basePlacement);
    var isVertical = [
        (0, $l6ej2.left),
        (0, $l6ej2.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4bNP2.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $l6ej2.top) : (0, $l6ej2.left);
    var maxProp = axis === 'y' ? (0, $l6ej2.bottom) : (0, $l6ej2.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ecwzm.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $fHMKD.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ioj8K.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("201VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d14927bb4f43b$export$2e2bcd8739ae039);

var $l6ej2 = parcelRequire("l6ej2");

var $leSQw = parcelRequire("leSQw");
function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $l6ej2.top),
        (0, $l6ej2.right),
        (0, $l6ej2.bottom),
        (0, $l6ej2.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $leSQw.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $leSQw.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};

});


parcelRegister("cw24N", function(module, exports) {

$parcel$export(module.exports, "Alert", () => $91ca15859685b28b$export$caec2af78bcc877f);
$parcel$export(module.exports, "Button", () => $91ca15859685b28b$export$353f5b6fc5456de1);
$parcel$export(module.exports, "Carousel", () => $91ca15859685b28b$export$144901db2ea8e967);
$parcel$export(module.exports, "Collapse", () => $91ca15859685b28b$export$78768a9af065a7b);
$parcel$export(module.exports, "Dropdown", () => $91ca15859685b28b$export$931cbfb6bfb85fc);
$parcel$export(module.exports, "Modal", () => $91ca15859685b28b$export$2b77a92f1a5ad772);
$parcel$export(module.exports, "Offcanvas", () => $91ca15859685b28b$export$591ca0244c9dfcd4);
$parcel$export(module.exports, "Tooltip", () => $91ca15859685b28b$export$28c660c63b792dea);
$parcel$export(module.exports, "Popover", () => $91ca15859685b28b$export$5b6b19405a83ff9d);
$parcel$export(module.exports, "ScrollSpy", () => $91ca15859685b28b$export$a6472a5298a374be);
$parcel$export(module.exports, "Tab", () => $91ca15859685b28b$export$3e41faf802a29e71);
$parcel$export(module.exports, "Toast", () => $91ca15859685b28b$export$8d8dc7d5f743331b);
/*!
  * Bootstrap v5.3.5 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
var $i9Aqn = parcelRequire("i9Aqn");
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ''));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, '');
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? 'element' : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = '5.3.5';
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(',') : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = 'alert';
const $91ca15859685b28b$var$DATA_KEY$a = 'bs.alert';
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = 'button';
const $91ca15859685b28b$var$DATA_KEY$9 = 'bs.button';
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = '.data-api';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = 'swipe';
const $91ca15859685b28b$var$EVENT_KEY$9 = '.bs.swipe';
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = 'touch';
const $91ca15859685b28b$var$POINTER_TYPE_PEN = 'pen';
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = 'carousel';
const $91ca15859685b28b$var$DATA_KEY$8 = 'bs.carousel';
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = '.data-api';
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = 'next';
const $91ca15859685b28b$var$ORDER_PREV = 'prev';
const $91ca15859685b28b$var$DIRECTION_LEFT = 'left';
const $91ca15859685b28b$var$DIRECTION_RIGHT = 'right';
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = 'slide';
const $91ca15859685b28b$var$CLASS_NAME_END = 'carousel-item-end';
const $91ca15859685b28b$var$CLASS_NAME_START = 'carousel-item-start';
const $91ca15859685b28b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $91ca15859685b28b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $91ca15859685b28b$var$SELECTOR_ACTIVE = '.active';
const $91ca15859685b28b$var$SELECTOR_ITEM = '.carousel-item';
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $91ca15859685b28b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = 'collapse';
const $91ca15859685b28b$var$DATA_KEY$7 = 'bs.collapse';
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = '.data-api';
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $91ca15859685b28b$var$WIDTH = 'width';
const $91ca15859685b28b$var$HEIGHT = 'height';
const $91ca15859685b28b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = 'dropdown';
const $91ca15859685b28b$var$DATA_KEY$6 = 'bs.dropdown';
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$2 = 'Escape';
const $91ca15859685b28b$var$TAB_KEY$1 = 'Tab';
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = 'dropup';
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = 'dropend';
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$SELECTOR_NAVBAR = '.navbar';
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? 'top-end' : 'top-start';
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? 'top-start' : 'top-end';
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? 'left-start' : 'right-start';
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? 'right-start' : 'left-start';
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = 'top';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $i9Aqn === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $i9Aqn.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = 'backdrop';
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = 'show';
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = 'focustrap';
const $91ca15859685b28b$var$DATA_KEY$5 = 'bs.focustrap';
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = 'Tab';
const $91ca15859685b28b$var$TAB_NAV_FORWARD = 'forward';
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = 'backward';
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $91ca15859685b28b$var$PROPERTY_PADDING = 'padding-right';
const $91ca15859685b28b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = 'modal';
const $91ca15859685b28b$var$DATA_KEY$4 = 'bs.modal';
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$1 = 'Escape';
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = 'modal-open';
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_STATIC = 'modal-static';
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = '.modal.show';
const $91ca15859685b28b$var$SELECTOR_DIALOG = '.modal-dialog';
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = 'offcanvas';
const $91ca15859685b28b$var$DATA_KEY$3 = 'bs.offcanvas';
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = '.data-api';
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = 'Escape';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $91ca15859685b28b$var$CLASS_NAME_HIDING = 'hiding';
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $91ca15859685b28b$var$OPEN_SELECTOR = '.offcanvas.show';
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = 'TemplateFactory';
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = 'tooltip';
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_MODAL = 'modal';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = 'show';
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $91ca15859685b28b$var$TRIGGER_HOVER = 'hover';
const $91ca15859685b28b$var$TRIGGER_FOCUS = 'focus';
const $91ca15859685b28b$var$TRIGGER_CLICK = 'click';
const $91ca15859685b28b$var$TRIGGER_MANUAL = 'manual';
const $91ca15859685b28b$var$EVENT_HIDE$2 = 'hide';
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = 'hidden';
const $91ca15859685b28b$var$EVENT_SHOW$2 = 'show';
const $91ca15859685b28b$var$EVENT_SHOWN$2 = 'shown';
const $91ca15859685b28b$var$EVENT_INSERTED = 'inserted';
const $91ca15859685b28b$var$EVENT_CLICK$1 = 'click';
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = 'focusin';
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $91ca15859685b28b$var$EVENT_MOUSEENTER = 'mouseenter';
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $91ca15859685b28b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $91ca15859685b28b$var$isRTL() ? 'right' : 'left'
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $i9Aqn === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $i9Aqn.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = 'popover';
const $91ca15859685b28b$var$SELECTOR_TITLE = '.popover-header';
const $91ca15859685b28b$var$SELECTOR_CONTENT = '.popover-body';
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = 'scrollspy';
const $91ca15859685b28b$var$DATA_KEY$2 = 'bs.scrollspy';
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = '.data-api';
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = '[href]';
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = '.dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = 'tab';
const $91ca15859685b28b$var$DATA_KEY$1 = 'bs.tab';
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $91ca15859685b28b$var$ARROW_UP_KEY = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $91ca15859685b28b$var$HOME_KEY = 'Home';
const $91ca15859685b28b$var$END_KEY = 'End';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = 'active';
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = 'show';
const $91ca15859685b28b$var$CLASS_DROPDOWN = 'dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = 'toast';
const $91ca15859685b28b$var$DATA_KEY = 'bs.toast';
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = 'showing';
const $91ca15859685b28b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);

});
parcelRegister("i9Aqn", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => (parcelRequire("fqRLw")).popperGenerator);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("leSQw")).default);
$parcel$export(module.exports, "createPopperBase", () => (parcelRequire("fqRLw")).createPopper);
$parcel$export(module.exports, "createPopper", () => (parcelRequire("2oJ1v")).createPopper);
$parcel$export(module.exports, "createPopperLite", () => (parcelRequire("hQXXi")).createPopper);

var $l6ej2 = parcelRequire("l6ej2");

var $1Evkg = parcelRequire("1Evkg");

var $fqRLw = parcelRequire("fqRLw");
var $leSQw = parcelRequire("leSQw");

var $2oJ1v = parcelRequire("2oJ1v");

var $hQXXi = parcelRequire("hQXXi");
$parcel$exportWildcard(module.exports, $l6ej2);
$parcel$exportWildcard(module.exports, $1Evkg);

});
parcelRegister("1Evkg", function(module, exports) {

$parcel$export(module.exports, "applyStyles", () => (parcelRequire("bjlic")).default);
$parcel$export(module.exports, "arrow", () => (parcelRequire("2c83k")).default);
$parcel$export(module.exports, "computeStyles", () => (parcelRequire("hfLNM")).default);
$parcel$export(module.exports, "eventListeners", () => (parcelRequire("lUt2x")).default);
$parcel$export(module.exports, "flip", () => (parcelRequire("fhdOY")).default);
$parcel$export(module.exports, "hide", () => (parcelRequire("201VR")).default);
$parcel$export(module.exports, "offset", () => (parcelRequire("aE9ix")).default);
$parcel$export(module.exports, "popperOffsets", () => (parcelRequire("k1fcs")).default);
$parcel$export(module.exports, "preventOverflow", () => (parcelRequire("4lgpD")).default);

var $bjlic = parcelRequire("bjlic");

var $2c83k = parcelRequire("2c83k");

var $hfLNM = parcelRequire("hfLNM");

var $lUt2x = parcelRequire("lUt2x");

var $fhdOY = parcelRequire("fhdOY");

var $201VR = parcelRequire("201VR");

var $aE9ix = parcelRequire("aE9ix");

var $k1fcs = parcelRequire("k1fcs");

var $4lgpD = parcelRequire("4lgpD");

});

parcelRegister("hQXXi", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);

var $fqRLw = parcelRequire("fqRLw");

var $lUt2x = parcelRequire("lUt2x");

var $k1fcs = parcelRequire("k1fcs");

var $hfLNM = parcelRequire("hfLNM");

var $bjlic = parcelRequire("bjlic");
var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $lUt2x.default),
    (0, $k1fcs.default),
    (0, $hfLNM.default),
    (0, $bjlic.default)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fqRLw.popperGenerator)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});




parcelRegister("iuVXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d777fd1172dec09c$export$2e2bcd8739ae039);

var $346VI = parcelRequire("346VI");
function $d777fd1172dec09c$export$2e2bcd8739ae039(obj) {
    //return obj;
    // obj { ID, Dataset:{Value} }
    if (!$d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset(obj)) {
        // => kein IDataset Model
        console.warn('Dataset: kein Model Type! ' + obj);
        return obj;
    }
    var id1 = $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(obj); // obj[Dataset.ID_FIELD] !== undefined ? obj[Dataset.ID_FIELD] : 0;
    //var thisObj = null;
    var newObj = obj;
    // Namespace.ClassName, AssemblyName => Namespace.ClassName
    /*if (obj.$ModelType == undefined) {
		if (obj.$type === undefined) {
			//console.warn(obj);
		} else
			obj.$ModelType = obj.$type.indexOf(',') === -1 ? obj.$type : obj.$type.substr(0, obj.$type.indexOf(','));
	}*/ //console.log('Model-Name: ' + obj.$ModelType);
    // Namespace.ClassName => ClassName
    /*if (obj.$ClassName == undefined && obj.$ModelType != undefined) {
		obj.$ClassName = obj.$ModelType.lastIndexOf('.') === -1 ? obj.$ModelType : obj.$ModelType.substr(obj.$ModelType.lastIndexOf('.') + 1);
	}**/ //console.log('Class-Name: ' + obj.$ClassName);
    // Dataset Singleton Check
    obj.$id = undefined;
    if (id1 != undefined && id1 > 0 && $d777fd1172dec09c$export$2e2bcd8739ae039.CacheExists(obj)) ;
    else {
        var customInstance = $d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor(obj.$ModelType); //obj.$ClassName);
        if (customInstance !== undefined) {
            //console.log('Call: ' + obj.$ClassName);
            (0, $346VI.default).CloneCopyTo(obj, customInstance, [
                'prototype',
                '__proto__',
                '__ob__',
                '$id',
                '$Username',
                '$Emitter',
                '$Dataset'
            ]); //, '$ModelType', '$type', '$id']);
            //Object.assign(customInstance, obj);
            obj = customInstance;
            console.log('Dataset: new ' + obj.$ModelType + '();');
        //console.log(obj);
        }
    }
    if (id1 != undefined && id1 > 0) {
        // $ModelType setzen
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] == undefined) $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] = [];
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] == null) // Cache Set Dataset
        $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1] = obj;
        else {
            // Cache Merge Dataset (Obj. Identität beibehalten)
            (0, $346VI.default).CloneCopyTo(obj, $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1], [
                'prototype',
                '__proto__',
                '__ob__',
                '$id',
                '$type',
                '$Username',
                '$Emitter',
                '$Dataset'
            ]);
            if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1].$Dataset != null) (0, $346VI.default).CloneCopyTo($d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1].$Dataset, this);
        }
        obj = $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][id1];
        //obj.ID = id;
        $d777fd1172dec09c$export$2e2bcd8739ae039.OnDatasetChanged(obj);
    }
    // ALT: obj.$Dataset = this;
    // ALT: this.ID = id;
    // ALT: this.Value = obj;
    // ALT: setIDatasetProperties(obj);
    obj.$Dataset = this;
    this.Value = obj;
    this.ID = id1;
    // Response von update-field?
    if (newObj.$Username !== undefined && newObj.$Emitter !== undefined && newObj.$Emitter != $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID) {
        let fieldNames = [];
        for(let propName in newObj)if (!propName.startsWith('$') && propName != $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD) {
            fieldNames.push(propName);
            break;
        }
        if (fieldNames != null && fieldNames.length > 0) {
            if (this.UpdateInfos === undefined) {
                this.UpdateInfos = [];
                console.log('Push Update Info: ', 'new UpdateInfos();');
            }
            this.UpdateInfos.push({
                Username: newObj.$Username,
                Date: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString(),
                FieldNames: fieldNames
            });
        //obj.$Username = undefined;
        //obj.$Emitter = undefined;
        //console.log('Push Update Info: ', this, newObj);
        } else console.log('Push Update Info: ', 'empty fieldName');
    }
    /*this.SetPropsGetValue = function()
	{
		setIDatasetProperties(obj);
		return obj;
	};*/ // Funktionen:
    // - Remove
    // - Update
    this.Store = function(successCallback1, errorCallback, finallyCallback1) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'set',
            value: $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value),
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, successCallback1, errorCallback, finallyCallback1);
    //obj.UpdateInternal(refObj);
    };
    // 1. Datensatz Remove-Anfrage an den Server
    // 2. statisches Object _datasets[archiveName][id] löschen
    // 3. Object aus allen refListObj löschen
    this.Remove = function(successCallback1, errorCallback, finallyCallback1) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'remove',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, successCallback1, errorCallback, function() {
            //obj.RemoveInternal();
            $d777fd1172dec09c$export$2e2bcd8739ae039.Remove(obj.$ModelType, id1);
            if (finallyCallback1) finallyCallback1();
        });
    };
    /*this.RemoveInternal = function()
	{
		Dataset.Remove(this.$ModelType, this.ID);
	};*/ this.CopyTo = function(targetObj) {
        for(var i in this)targetObj[i] = this[i];
    };
    this.Call = function(methodName, inputObj, storeAfterCall, successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'call',
            method: methodName,
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD,
            input: inputObj,
            store: storeAfterCall
        }, successCallback1, errorCallback, undefined);
    };
    this.Refresh = function(successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'get',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, (succ_obj)=>{
            this.Value = succ_obj;
            successCallback1(succ_obj);
        }, errorCallback, undefined);
    };
    this.Unlock = function(successCallback1, errorCallback) {
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
            usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
            archive: obj.$ModelType,
            model: obj.$ModelType,
            action: 'unlock',
            id: id1,
            id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD
        }, (succ_obj)=>{
            this.Value = succ_obj;
            successCallback1(succ_obj);
        }, errorCallback, undefined);
    };
    this.SetTableRow = function(fieldName, fieldValue, forceAppend, save, lineFormat) {
        let ret = false;
        let value_tmp = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value);
        //let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
        let fieldValueArray = $d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows(value_tmp[fieldName]);
        if (!(0, $346VI.default).IsNullOrEmpty(fieldValue)) {
            let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            if (forceAppend === true || fieldValueIndex === -1) {
                fieldValueArray.push(fieldValue);
                ret = true;
            //console.log('Dataset.SetTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
            //ret = false;
            }
        }
        if (ret) {
            //this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
            value_tmp[fieldName] = $d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows(fieldValueArray);
            this.Value = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(value_tmp);
            if (save === undefined || save === true) return this.Store();
        }
        return ret;
    };
    this.RemoveTableRow = function(fieldName, fieldValue, save, lineFormat) {
        let ret = false;
        let value_tmp = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(this.Value);
        //let fieldValueArray = lineFormat === true ? Dataset.GetLineArr(this.Value[fieldName]) : Dataset.GetTableRows(this.Value[fieldName]);
        let fieldValueArray = $d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows(value_tmp[fieldName]);
        if (!(0, $346VI.default).IsNullOrEmpty(fieldValue)) {
            let fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            // alle Werte entfernen
            while(fieldValueIndex !== -1){
                fieldValueArray.splice(fieldValueIndex, 1);
                ret = true;
                fieldValueIndex = fieldValueArray.indexOf(fieldValue.toString());
            //console.log('Dataset.RemoveTableRow: ', typeof fieldValue, fieldValue, fieldValueArray);
            }
        }
        if (ret) {
            //this.Value[fieldName] = lineFormat === true ? Dataset.SetLineArr(fieldValueArray) : Dataset.SetTableRows(fieldValueArray);
            value_tmp[fieldName] = $d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows(fieldValueArray);
            this.Value = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(value_tmp);
            if (save === undefined || save === true) return this.Store();
        }
        return ret;
    };
    if (obj.Init !== undefined && typeof obj.Init === 'function') //console.warn('init');
    obj.Init();
    return this;
}
// --
// Statische Funktionen/Member
// Singleton Data
$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD = 'Dokument-Nr.';
$d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$d777fd1172dec09c$export$2e2bcd8739ae039.WindowID = Math.random().toString(36).substring(2, 9);
$d777fd1172dec09c$export$2e2bcd8739ae039.Model = [];
//Dataset.ServerHost = document.location.protocol + '//' + document.location.hostname;
//Dataset.ServerPort = document.location.port;
//Dataset.ServerHost = 'http://127.0.0.1';
//Dataset.ServerPort = '8080';
$d777fd1172dec09c$export$2e2bcd8739ae039.DEBUG = true;
$d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError = null;
$d777fd1172dec09c$export$2e2bcd8739ae039.Ctors = {};
$d777fd1172dec09c$export$2e2bcd8739ae039.ListenState = null;
// --
// Model Constructors
$d777fd1172dec09c$export$2e2bcd8739ae039.AddCtor = function(archiveName1, ctor) {
    //Dataset.Ctors[ctor.prototype.constructor.name] = ctor;
    $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[archiveName1] = ctor;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.HasCtor = function(ctorName) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName] !== undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor = function(ctorName) {
    /*var i = Dataset.Ctors.indexOf(ctor);
	if ( === -1)
	{
		Dataset.Ctors.push(ctor);
	}*/ return $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName] === undefined ? undefined : new $d777fd1172dec09c$export$2e2bcd8739ae039.Ctors[ctorName]();
};
// --
$d777fd1172dec09c$export$2e2bcd8739ae039.GetTableRows = function(fieldValue) {
    if ((0, $346VI.default).IsNullOrEmpty(fieldValue)) return [];
    else return fieldValue.split($d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.SetTableRows = function(array) {
    if (array != undefined && array != null && array.length > 0) return array.join($d777fd1172dec09c$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER);
    else return '';
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetLineArr = function(fieldValue) {
    if ((0, $346VI.default).IsNullOrEmpty(fieldValue)) return [];
    else return fieldValue.replaceAll("\r", "").split("\n");
};
$d777fd1172dec09c$export$2e2bcd8739ae039.SetLineArr = function(array) {
    if (array != undefined && array != null && array.length > 0) return array.join("\r\n");
    else return '';
};
$d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset = function(obj) {
    //if (obj == null && obj.$ModelType == undefined)
    //	return false;
    if (obj == null) return false;
    if (obj.$ModelType == undefined) return false;
    if (typeof obj == "object") return true;
    //if (typeof obj == "dataset")
    //	return true;
    return false;
//return (obj != null && obj.$type != undefined && ((typeof obj === "object") || (typeof obj === "dataset")));
//return (obj != null && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
//return (obj != null && obj.ID !== undefined && obj.$type !== undefined && (typeof obj === "object" || typeof obj === "dataset"));
};
// --
// Crud
/*
Dataset.GetDataRaw = function (url, paramsObj, loadEvent, errorCallback) {
	let onErrorEvent = function (e) {
		let responseObject = {
			Error: {
				Message: 'Verbindungsfehler',
				Error: 'Verbindungsfehler',
				InternalMessage: 'Verbindungsfehler'
			}
		};
		if (errorCallback != null)
			errorCallback(e); //responseObject.Error);
		else if (Dataset.DefaultError != null)
			Dataset.DefaultError(e); //responseObject.Error); //, event.target.status);
		//else
		//	alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);

		console.error('Verbindungsfehler', e);
	};

	if (Dataset.WindowID == undefined || Dataset.WindowID == null)
		Dataset.WindowID = Math.random().toString(36).substring(2, 9) + '-';
	if (paramsObj == null) {
		paramsObj = { emitter: Dataset.WindowID };
	}
	else {
		paramsObj.emitter = Dataset.WindowID;
	}
	// ToDo:
	// statt Callback Promise verwenden
	var requestUrl = Dataset.ServerHost + ':' + Dataset.ServerPort + url;
	var request = new XMLHttpRequest();
	request.open('POST', requestUrl);
	request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	request.addEventListener('load', loadEvent);
	request.addEventListener('error', onErrorEvent);
	request.addEventListener('abort', onErrorEvent);
	request.send(Dataset.ObjectToQueryStr(paramsObj));
};*/ // Crud
$d777fd1172dec09c$export$2e2bcd8739ae039.GetDataRaw = function(url, paramsObj) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.WindowID == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID == null) $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID = Math.random().toString(36).substring(2, 9) + '-';
    if (paramsObj == null) paramsObj = {
        emitter: $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID
    };
    else paramsObj.emitter = $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID;
    let getStr = $d777fd1172dec09c$export$2e2bcd8739ae039.ObjectToQueryStr(paramsObj);
    return (0, $346VI.default).Send('GET', url, getStr, undefined, 'json', '', '', true);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetData = function(url, paramsObj, successCallback1, errorCallback, finallyCallback1) {
    var loadEvent = function(responseObject) {
        return new Promise(function(resolve, reject) {
            //console.log(event);
            /*var responseObject = null;
			if (event.target.getResponseHeader('Content-Type').indexOf('text/json') !== 0) {
				responseObject = {
					HasError: true,
					Result: null,
					Error: {
						Message: 'Der Server hat eine ungültige Antwort geliefert:\n' + event.target.responseText,
						InternalMessage: event.target.responseText
					}
				};
			} else {
				try {
					//responseObject = resolveReferences(JSON.parse(request.responseText));
					//console.warn(responseObject);
					//responseObject = DrDocWeb.JsonRetrocycle(JSON.parse(event.target.responseText));
					responseObject = DrDocWeb.JsonParse(event.target.responseText);
					if (responseObject == null) {
						responseObject = {
							HasError: false,
							Result: null,
							Error: null
						};
					}
					//if (responseObject.$id !== undefined || responseObject.$ref !== undefined || responseObject.$values !== undefined) //console.warn(responseObject);
				} catch (e) {
					console.error('Dataset Deserialize', e);
					responseObject = {
						HasError: true,
						Result: null,
						Error: {
							Message: 'Fehler',
							InternalMessage: event.target.responseText
						}
					};
					if (errorCallback != null)
						errorCallback(e);
					else if (Dataset.DefaultError != null)
						Dataset.DefaultError(e);
				}
			}*/ // $ModelType setzen
            try {
                if (responseObject.$ModelType === undefined) responseObject.$ModelType = paramsObj.archive;
                if (responseObject.$ModelType !== undefined) {
                    if (responseObject.Result != null && responseObject.Result instanceof Array) {
                        for(var i in responseObject.Result)if (typeof responseObject.Result[i] !== 'string' && typeof responseObject.Result[i] !== 'boolean' && responseObject.Result[i].$ModelType === undefined) responseObject.Result[i].$ModelType = responseObject.$ModelType;
                    } else if (typeof responseObject.Result !== 'string' && typeof responseObject.Result !== 'boolean' && responseObject.Result !== undefined && responseObject.Result.$ModelType === undefined) responseObject.Result.$ModelType = responseObject.$ModelType;
                }
            } catch (x) {}
            //console.log(responseObject);
            if (responseObject.HasError === false) {
                // kein Fehler im Response
                var data_obj = null;
                var data_arr = null;
                if (responseObject.Result != null) {
                    if (responseObject.Result instanceof Array) {
                        // Result ist ein Array
                        data_arr = [];
                        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Add(data_arr);
                        for(var arri in responseObject.Result){
                            if (responseObject.Result[arri].$ModelType === undefined) data_arr[arri] = responseObject.Result[arri];
                            else data_arr[arri] = new $d777fd1172dec09c$export$2e2bcd8739ae039(responseObject.Result[arri]).Value;
                            data_arr[arri] = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(data_arr[arri]);
                        }
                    } else {
                        // Result ist ein Objekt
                        // obj-Objekt-Referenz erhalten
                        if (data_obj == null) {
                            if (responseObject.Result.$ModelType === undefined) data_obj = responseObject.Result;
                            else data_obj = new $d777fd1172dec09c$export$2e2bcd8739ae039(responseObject.Result).Value;
                        } else (0, $346VI.default).CloneCopyTo(responseObject.Result, data_obj);
                        data_obj = $d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode(data_obj);
                    }
                }
                if (resolve != undefined && resolve != null) resolve(data_arr ? data_arr : data_obj);
                if (successCallback1 != undefined && successCallback1 != null) {
                    var metaObj = {
                        SortTree: responseObject.MetaSortTree,
                        Count: responseObject.Count,
                        CountTotal: responseObject.CountTotal
                    };
                    if (data_obj == null && data_arr != null) successCallback1(data_arr, metaObj);
                    else if (data_obj != null && data_arr == null) successCallback1(data_obj, metaObj);
                    else successCallback1(null, metaObj);
                }
            } else {
                // Fehler im Reponse vorhanden
                if ($d777fd1172dec09c$export$2e2bcd8739ae039.DEBUG) {
                    if (responseObject != null && responseObject.HasError && responseObject.Error) console.warn(responseObject.Error.Message, responseObject.Error.InternalMessage);
                    else console.warn(event.target.statusText, event.target.responseText);
                }
                if (reject != undefined && reject != null) reject(responseObject.Error);
                if (errorCallback != null) errorCallback(responseObject.Error); //, event.target.status);
                else if ($d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError != null) $d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError(responseObject.Error); //, event.target.status);
                else alert(responseObject.Error.Message + '\n\n' + responseObject.Error.InternalMessage);
            }
            if (finallyCallback1 != undefined && finallyCallback1 != null) finallyCallback1();
        }); // Promise end
    };
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetDataRaw(url, paramsObj).catch(errorCallback).then(loadEvent);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Crud = function(paramsObj, successCallback1, errorCallback, finallyCallback1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetData('/model/crud', paramsObj, successCallback1, errorCallback, finallyCallback1);
};
/*Dataset.Add = function (obj, successCallback, errorCallback, finallyCallback) {
	return Dataset.Crud({
		archive: obj.$ModelType,
		model: obj.$ModelType,
		action: 'add',
		value: obj
	}, successCallback, errorCallback, finallyCallback);
};*/ $d777fd1172dec09c$export$2e2bcd8739ae039.Add = function(archiveName1, obj, preset) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
        archive: archiveName1,
        model: archiveName1,
        action: 'add',
        value: $d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode(obj),
        preset: preset == undefined ? '' : preset
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Get = function(archiveName1, id1, lock) {
    //var className = archiveName.lastIndexOf('.') === -1 ? archiveName : archiveName.substr(archiveName.lastIndexOf('.') + 1);
    //var obj = Dataset.InvokeCtor(className);
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        //usermanager: obj.$Usermanager != undefined ? obj.$Usermanager : '',
        archive: archiveName1,
        model: archiveName1,
        action: 'get',
        id: id1,
        id_field: $d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD,
        lock: lock
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Listen = function(callback) {
    /*if (callback != null)
	{
		callback(null, null);
	}*/ // Dataset.GetData = function (url, paramsObj, successCallback, errorCallback, finallyCallback)
    return $d777fd1172dec09c$export$2e2bcd8739ae039.GetData('/model/cache', {
        listener: $d777fd1172dec09c$export$2e2bcd8739ae039.WindowID
    }, (obj)=>{
        //console.warn('MAIN Load', e.target.responseText);
        //console.warn('MAIN Load', e);
        //Vue.set(Dataset.Model[obj.$ModelType], Dataset.GetID(obj), obj);
        if (callback != null) callback(obj, true);
        //Dataset.ListenState = true;
        //Vue.set(Dataset, 'ListenState', true);
        $d777fd1172dec09c$export$2e2bcd8739ae039.Listen(callback);
    }, (obj)=>{
        //Dataset.ListenState = false;
        //Vue.set(Dataset, 'ListenState', false);
        // Bei Fehler, nach einigen Sekunden erneut versuchen.
        setTimeout(()=>{
            $d777fd1172dec09c$export$2e2bcd8739ae039.Listen(callback);
        }, 1000);
        if (callback != null) callback(null, false);
        console.warn('MAIN Error', obj, callback, false);
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError != null) $d777fd1172dec09c$export$2e2bcd8739ae039.DefaultError(obj);
    });
};
$d777fd1172dec09c$export$2e2bcd8739ae039.OnDatasetChanged = function(value) {};
$d777fd1172dec09c$export$2e2bcd8739ae039.ValueEncode = function(value) {
    return value;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ValueDecode = function(value) {
    return value;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetCached = function(archiveName1, id1) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.CacheExistsExt(archiveName1, id1)) {
        //ds.CopyTo(obj);
        if (successCallback != null) successCallback($d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1]);
        if (finallyCallback != null) finallyCallback();
        return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1];
    } else {
        //return null;
        var className = archiveName1.lastIndexOf('.') === -1 ? archiveName1 : archiveName1.substr(archiveName1.lastIndexOf('.') + 1);
        var obj = $d777fd1172dec09c$export$2e2bcd8739ae039.InvokeCtor(className);
        console.log('Dataset.GetCached: 1 ', '/ CacheExistsExt: false', ' / Archive: ', archiveName1, ' / ID: ', id1);
        //Dataset.Get(archiveName, id, false);
        $d777fd1172dec09c$export$2e2bcd8739ae039.Get(archiveName1, id1, false).then(function(result) {
            console.log('Dataset.GetCached: 2', '/ CacheExistsExt: false', ' / Archive: ', archiveName1, ' / ID: ', id1, ' / Result: ', result);
        });
        return obj;
    }
};
$d777fd1172dec09c$export$2e2bcd8739ae039.List = function(archiveName1, actionParams) {
    /*console.log('-------');
	console.log(archiveName);
	console.log(obj);
	console.log(actionParamArr);
	console.log(successCallback);
	console.log(errorCallback);
	console.log(finallyCallback);
	console.log('-------');*/ if (actionParams == undefined || actionParams == null) actionParams = {};
    actionParams.archive = archiveName1;
    actionParams.action = 'searchfields';
    if (actionParams.value == undefined || actionParams.value == null) {
        actionParams.value = {
        };
        actionParams.value[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD] = '*';
    }
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Template = function(archiveName1, searchTemplate, actionParams) {
    if (actionParams == undefined || actionParams == null) actionParams = {};
    actionParams.archive = archiveName1;
    actionParams.action = 'searchtemplate';
    if (actionParams.value == undefined || actionParams.value == null) actionParams.value = searchTemplate;
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud(actionParams); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.GetID = function(obj) {
    if (obj == undefined || obj == null) return 0;
    //if (obj['DokuNr'] !== undefined)
    //return $event['DokuNr'];
    if (obj[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD] !== undefined) return obj[$d777fd1172dec09c$export$2e2bcd8739ae039.ID_FIELD];
    return 0;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Tree = function(archiveName1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Crud({
        archive: archiveName1,
        model: archiveName1,
        action: 'tree'
    }); //, successCallback, errorCallback, finallyCallback);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ExistsQ = function(obj) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Get(obj.$ModelType, obj.ID) != null;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheExists = function(obj) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[obj.$ModelType][$d777fd1172dec09c$export$2e2bcd8739ae039.GetID(obj)] !== undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheExistsExt = function(archiveName1, id1) {
    return $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1] != undefined;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.CacheGet = function(obj) {
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName] != undefined && $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName][id];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Remove = function(archiveName1, id1) {
    if ($d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1] == undefined || $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1] == undefined) return;
    // aus allen List References entfernen
    $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.RemoveObjects(archiveName1, id1);
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1].splice(id1, 1);
    delete $d777fd1172dec09c$export$2e2bcd8739ae039.Model[archiveName1][id1];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.ClearAll = function() {
    $d777fd1172dec09c$export$2e2bcd8739ae039.Model = [];
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Equals = function(ds1, ds2) {
    if (ds1 == null && ds2 == null) return true;
    if (ds1 != null && ds2 == null || ds1 == null && ds2 != null) return false;
    return ds1.$ModelType !== undefined && ds2.$ModelType !== undefined && ds1.$ModelType == ds2.$ModelType && $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(ds1) == $d777fd1172dec09c$export$2e2bcd8739ae039.GetID(ds2);
//return Dataset.GetID(ds1) == Dataset.GetID(ds2);
};
$d777fd1172dec09c$export$2e2bcd8739ae039.IndexOf = function(list, obj) {
    if (list == null) return -1;
    for(var i in list){
        if ($d777fd1172dec09c$export$2e2bcd8739ae039.Equals(list[i], obj) === true) return i;
    }
    return -1;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.Cmp = $d777fd1172dec09c$export$2e2bcd8739ae039.Equals;
/*function (a, b) {
	if (a == null || b == null) return false;
	else return (a.ID == b.ID && a.$type == b.$type);
};*/ $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays = {
    list: [],
    Find: function(action) {
        for(var i in $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list){
            if (action($d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list[i]) === true) return i;
        }
        return -1;
    },
    Add: function(targetArrayToAdd) {
        var index = $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            return targetArray == targetArrayToAdd;
        });
        if (index == -1) $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list.push(targetArrayToAdd);
    },
    Remove: function(targetArrayToRemove) {
        var index = $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            return targetArray == targetArrayToRemove;
        });
        if (index >= 0) {
            $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list.splice(index, 1);
            delete $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.list[index];
        }
    },
    RemoveObjects: function(archiveName1, id1) {
        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            for(var elem_i in targetArray)if (targetArray[elem_i].$ModelType == archiveName1 && targetArray[elem_i].ID == id1) {
                //console.log('RemoveFromTargetArrays');
                targetArray.splice(elem_i, 1);
                delete targetArray[elem_i];
            }
            return false;
        });
    },
    Refresh: function() {
        //console.log('Refresh');
        $d777fd1172dec09c$export$2e2bcd8739ae039.TargetArrays.Find(function(targetArray) {
            targetArray.$refresh();
            return false;
        });
    }
};
// --
// Helpers
function $d777fd1172dec09c$var$setIDatasetProperties(obj) {
    if (typeof obj === 'object') {
        if (obj.$setIDatasetProperties !== undefined) return;
        else obj.$setIDatasetProperties = true;
    //if (obj.$id !== undefined) delete obj.$id;
    }
    for(var prop in obj){
        if (obj[prop] == null) ;
        else if (obj[prop] instanceof Array) /*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/ $d777fd1172dec09c$var$setIDatasetProperties(obj[prop]);
        else if ($d777fd1172dec09c$export$2e2bcd8739ae039.IsDataset(obj[prop])) obj[prop] = new $d777fd1172dec09c$export$2e2bcd8739ae039(obj[prop]).Value;
        else if (typeof obj[prop] === 'object') //delete obj.$id;
        /*if (obj[prop].$id !== undefined)
			{
				//obj = DrDocWeb.JsonRetrocycle(obj);
				// aus Gott gegebenen Gründen werden nach dem Deserialisieren nicht alle Referenzen aufgelöst. Daher nochmals:
				obj[prop] = resolveReferences(obj[prop]);
			}*/ $d777fd1172dec09c$var$setIDatasetProperties(obj[prop]);
    //else // => ValueType
    //{}
    }
}
$d777fd1172dec09c$export$2e2bcd8739ae039.ObjectToQueryStr = function(obj) {
    if (obj == null) return '';
    var strArr = [];
    for(var p in obj)if (obj.hasOwnProperty(p)) {
        var v = obj[p];
        /*strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? JSON.stringify(JsonResolve(v), function(key, value)
			{
				// => typeof Dataset
				// IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
				if (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset') return;
				else return value;
			}) : v));*/ strArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(typeof v == "object" ? $d777fd1172dec09c$export$2e2bcd8739ae039.JsonToStr(v) : v));
    }
    var str = strArr.join("&");
    //return (str.length == 0 ? '' : '?' + str);
    return str;
};
$d777fd1172dec09c$export$2e2bcd8739ae039.JsonToStr = function(objToConvert) {
    //var cacheObjs = [];
    //var cacheIDs = [];
    /*var seenObjects = [];

	function detect(obj)
	{
		if (obj && (typeof obj === 'object' || obj instanceof Array))
		{
			if (seenObjects.indexOf(obj) !== -1)
			{
				return true;
			}
			seenObjects.push(obj);
			for (var key in obj)
			{
				if (obj.hasOwnProperty(key) && detect(obj[key]))
				{
					console.log(obj, 'cycle at ' + key);
					return true;
				}
			}
		}
		return false;
	};*/ //return detect(obj);
    //return JSON.stringify(DrDocWeb.JsonDecycle(objToConvert));
    return JSON.stringify((0, $346VI.default).JsonDecycle(objToConvert), function(key, value) {
        //if (detect(value)) console.log(value);
        //if (cacheObjs.length > 4) console.log(cacheObjs);
        // => typeof Dataset
        // IDataset / Dataset.IsDataset(value): $ModelType, $ClassName, Dataset
        // Properties, die mit "_out_" beginnen (z.B. _out_DynamicModel) sollen am nicht deserialisiert werden; die Übertragung wäre sinnlos.
        //if (typeof value === 'object' && (key == 'ModelConfig' || key == 'ModelInfos' || key == 'Dataset' || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0))
        if (typeof value === 'object' && key == 'Dataset') // Property "Dataset" ignorieren
        return;
        else if (key.indexOf('__') === 0) // Properties ignorieren, die mit "__" anfangen
        return;
        else if (key.indexOf('_') === 0 && key.endsWith('_') === true || key.indexOf('_out_') === 0 || key.indexOf('_ignore_') === 0) // Properties ignorieren, die mit "_" anfangen und enden, z.B. "_test_"
        return;
        else if (key.indexOf('$') === 0) // Properties ignorieren, die mit "$" beginnen, außer die Property $ModelType
        return;
        else if (key != '' && key != null && value != null && typeof value === 'Dataset' && value.ID !== undefined && value.ID !== 0) // key == 'archive' &&
        // Wenn das Model (als Root-Node) gespeichert wird, ist key == ''
        //console.log(key);
        return {
            ID: value.ID,
            $type: value.$type
        };
        else return value;
    });
};
window.Dataset = $d777fd1172dec09c$export$2e2bcd8739ae039; //export default Dataset

});

parcelRegister("hkmmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d5a63fc97996b1$export$2e2bcd8739ae039);
var $c9d5a63fc97996b1$var$LOCK_INDEX = [];
function $c9d5a63fc97996b1$var$LockCallback(key, action, manual) {
    if ($c9d5a63fc97996b1$var$LOCK_INDEX[key]) return;
    $c9d5a63fc97996b1$var$LOCK_INDEX[key] = true;
    var ret = action(function() {
        delete $c9d5a63fc97996b1$var$LOCK_INDEX[key];
    });
    if (!manual) delete $c9d5a63fc97996b1$var$LOCK_INDEX[key];
    return ret;
}
function $c9d5a63fc97996b1$export$2e2bcd8739ae039() {
    this._handlers = {};
}
//module.exports = Store
//export default Store
window.Store = $c9d5a63fc97996b1$export$2e2bcd8739ae039;
// Static
$c9d5a63fc97996b1$export$2e2bcd8739ae039._debug = false;
$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise = function(value) {
    return (value != undefined && typeof value === 'object' || typeof value === 'Promise' || typeof value === 'promise') && value.then !== undefined && value.then !== null && typeof value.then === 'function';
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse = function(value) {
    return value == undefined || value == null ? '' : value;
//return value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseInt = function(value) {
    let valueInt = typeof value === 'number' ? value : parseInt(value, 10);
    if (value === undefined || value === null || isNaN(value) || value === 'NaN') return 0;
    else return valueInt;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseBool = function(value) {
    if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('parse bool ', value, typeof value);
    let valueBool = typeof value === 'bool' || typeof value === 'boolean' ? value : value === 'true' || value === 'True' || value === 'TRUE' || value === '1';
    return valueBool;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName = function(name, event) {
    if (name === undefined || name === null || typeof name !== 'string' || name.length === 0) {
        console.warn('Store: Bad Name!');
        return false;
    }
    name = name.toLowerCase();
    return name;
};
// Instance
/*
'action/type': { value: 'foo', handlers: [ function(newValue, oldValue) { } ] }
Stati:
this._handlers["name"] = undefined => not set / undefined
this._handlers["name"] = [] => initializing..
this._handlers["name"] = [ event ] => initialized / set

this._handlers["name"] = handlerObj
{
    value: 'foo',
    parser: function(value) => value,
    handlers: [
        function(newValue, oldValue) { }
    ]
}
*/ $c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype._handlers = {};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initEx = function(name, value, parser) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    if (value === undefined || value === null) {
        console.warn('Store->init: Bad value (NULL) ', name, value);
        return false;
    }
    if (this.has(name)) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->init: bereits initialisiert ', name, value);
        return false;
    }
    // Parser setzen
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        handlerObj = {
            value: null,
            handlers: []
        };
        this._handlers[name] = handlerObj;
    }
    if (parser != undefined && parser != null && typeof parser === 'function') handlerObj.parser = parser;
    else handlerObj.parser = $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse;
    return this.set(name, value, true);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.init = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initBool = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseBool);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.initInt = function(name, event) {
    return this.initEx(name, event, $c9d5a63fc97996b1$export$2e2bcd8739ae039.ParseInt);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.subscribe = function(name, event, setInitial) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let toe = typeof event;
    if (event === undefined || event === null || toe !== 'function') {
        console.warn('Store->subscribe: Bad Event!', name, event, toe);
        return false;
    }
    //var hasValue =  this.has(name);
    var oldValue = undefined;
    if (setInitial === true) oldValue = this.get(name);
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) this._handlers[name] = {
        value: null,
        handlers: [
            event
        ]
    };
    else handlerObj.handlers.push(event);
    if (setInitial === true) event(oldValue, oldValue);
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.unsubscribe = function(name, event) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        console.warn('Store->unsubscribe: no Handler found', name);
        return false;
    }
    if (event === undefined || event === null) {
        // alle Handler entfernen
        handlerObj.handlers = [];
        return true;
    } else {
        if (typeof event !== 'function') {
            console.warn('Store->unsubscribe: Bad Event! / function');
            return false;
        }
        let handlers = handlerObj.handlers;
        if (handlers === undefined || handlers === null) {
            console.warn('Store->unsubscribe: no Handler found');
            return false;
        }
        let ret = false;
        if (handlers.length > 0) {
            for(let i = handlers.length - 1; i >= 0; i--)if (handlers[i] === event) {
                handlers.slice(i, 1);
                ret = true;
            }
        }
        return ret;
    }
};
/*Store.prototype.unsubscribeAll = function(name)
{
    name = Store.validateName(name);
    if (name === false)
        return false;
    
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null)
    {
        console.warn('Store->unsubscribeAll: no Handler found');
        return false;
    }
    handlerObj.handlers = [];
    return true;
};*/ $c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.remove = function(name) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    this._handlers[name] = undefined;
    delete this._handlers[name];
    return true;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.clear = function() {
    this._handlers = {};
    return true;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.getFnReturnValueInternal = function(value, parser) {
    // Funktion auflösen
    while(value != null && value !== undefined && !$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value) && typeof value === 'function')value = value();
    // Promise auflösen
    if ($c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value)) {
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function(ret_value) {
        //value = store.getFnReturnValueInternal(ret_value, parser);
        //return value;
        });
    }
    if (parser !== undefined && parser !== null && typeof parser === 'function') value = parser(value);
    return value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.set = function(name, value, signal) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) {
        console.log('Store->set - name not found', name, value, this);
        return false;
    }
    //return LockCallback('someKey',() => {
    var oldValue = this.get(name);
    var isNewValue = false;
    // Falls noch kein Handler existiert, werstmal Wert undefined setzen, damit init nicht öfter aufgerufen wird.
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->set - initialized', name, this);
        handlerObj = {
            value: undefined,
            handlers: []
        };
        this._handlers[name] = handlerObj;
        isNewValue = true;
    }
    // --
    // Funktion auflösen
    // so lange auflösen, bis value einen Wert darstellt
    while(value != null && value !== undefined && !$c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value) && typeof value === 'function')value = value();
    // Promise auflösen
    if (value != null && value !== undefined && $c9d5a63fc97996b1$export$2e2bcd8739ae039.IsPromise(value)) {
        //console.warn(`Store->set: Promise sind nicht erlaubt! Name: "${name}" `);
        //return;
        let store = this;
        // Falls es ein Promise ist, diesen auflösen
        return value.then(function(ret_value) {
            store.set(name, ret_value, signal);
        });
    }
    // neuen Wert parsen
    if (handlerObj.parser !== undefined && handlerObj.parser !== null && typeof handlerObj.parser === 'function') value = handlerObj.parser(value);
    else value = $c9d5a63fc97996b1$export$2e2bcd8739ae039.Parse(value);
    // --
    let handlers = handlerObj.handlers;
    //var oldValue = handlerObj.value;
    if (oldValue != value || signal === true) {
        handlerObj.value = value;
        //if (Store._debug === true)
        //if (!isNewValue && handlers.length > 0)
        if (oldValue != value && (signal === undefined || signal === null) || signal === true) {
            if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warn('Store->set NOTIFY "' + name + '" / Value has Changed  ', oldValue, '  ->  ', value, ' / Signal:' + signal + ' / Listeners: ' + handlers.length);
            let count = handlers.length;
            //for (let i = handlers.length - 1; i >= 0; i--)
            for(let i = 0; i < count; i++)//console.log('set notify', handlers[i]);
            handlers[i](value, oldValue);
        }
        return true;
    } else {
        // Keine Änderung!
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->set X-NOTIFY "' + name + '" / Value has NOT Changed  ', oldValue, '  ==  ', value);
        return false;
    }
//});
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.has = function(name) {
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) return false;
    let handlerObj = this._handlers[name];
    if (handlerObj === undefined || handlerObj === null) return false;
    else {
        if (handlerObj.value === undefined || handlerObj.value === null) return false;
        else if (typeof handlerObj.value === 'string' && handlerObj.value.length == 0) return false;
        else if (typeof handlerObj.value === 'bool' || typeof handlerObj.value === 'boolean') return true;
        else if (typeof handlerObj.value === 'number' && isNaN(handlerObj.value)) return false;
        else return true;
    }
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.get = function(name, defaultValue) {
    if (!this.has(name)) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->get - name not found', name, this);
        return defaultValue;
    }
    name = $c9d5a63fc97996b1$export$2e2bcd8739ae039.validateName(name);
    if (name === false) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.log('Store->get - name is null', name);
        return defaultValue;
    }
    let handlerObj = this._handlers[name];
    if (handlerObj.value === undefined || handlerObj.value === null) {
        if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warning('Store->get - empty value', name);
        return defaultValue;
    } else return handlerObj.value;
};
$c9d5a63fc97996b1$export$2e2bcd8739ae039.prototype.update = function(name) {
    if (this.has(name)) {
        let value = this.get(name);
        //if (Store._debug === true)
        //console.log('Store->update: ', name, ' => ', value, typeof value);
        this.set(name, value, true);
    } else if ($c9d5a63fc97996b1$export$2e2bcd8739ae039._debug === true) console.warn('Store->update: Nothing to update..: ', name);
}; /*
var store = new Store();
console.log('Store 1', store);
store.subscribe('selected-archive', (value, oldValue) => {
    console.log('Changed selected-archive  ', oldValue, ' => ', value);
});
console.log('Store 2', store);
store.set('selected-archive', 1);
console.log('Store 3', store);
console.log('Store 3 get: ', store.get('selected-archive'));
store.set('selected-archive', { sdsd: 'dsdsdsdsdsds'});
console.log('Store 4 get: ', store.get('selected-archive'));
store.unsubscribeAll('selected-archive');
console.log('Store 5', store);
store.remove('selected-archive');
console.log('Store 6', store);
*/ 

});

parcelRegister("9hg18", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c12204ffc79a36c$export$2e2bcd8739ae039);
//import * as $ from "jquery";

var $346VI = parcelRequire("346VI");

var $hkmmp = parcelRequire("hkmmp");
function $6c12204ffc79a36c$export$2e2bcd8739ae039(store, isLocal) {
    this._isLocal = isLocal === true;
    this._store = store;
    this._config = this;
    this.Write = true;
    this.readonly = false;
    //console.log("Dr.DOC INIT 2");
    //Store._debug = true;
    // keep alive senden
    if (!this._isLocal) {
        let _this = this;
        setInterval(function() {
            if ((0, $hkmmp.default)._debug) console.log('CONF keep alive..');
            //_this.get('view/selected-usermanager');
            //_this.subscribeEx = function (name, event, defaultValue, parser);
            //_this.subscribeEx('view/selected-usermanager');
            let ret = _this.getValueInternal('view/selected-usermanager');
            if (ret != undefined) ret.catch(function() {
                (0, $346VI.default).ModalWarning('Keine Internetverbindung oder Server nicht erreichbar.');
            });
        }, 120000);
    }
}
window.DrDocConfig = $6c12204ffc79a36c$export$2e2bcd8739ae039;
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.initEx = function(name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, defaultValue, parser);
};
// Subscriber um die geänderten Werte zu speichern
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.initAutoSaveInternal = function(thisInstance, name, isInitMode) {
    if (thisInstance.has(name)) {
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: wurde bereits initialisiert!', name);
    } else {
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: wird jetzt initialisiert.. ', name);
        // Veränderung der Werte abspeichern
        thisInstance._store.subscribe(name, function(valueNew, valueOld) {
            //var isInitMode = thisInstance._store.has(name) === false;
            //if (Store._debug === true)
            //console.log('subscribeEx -> initEx -> subscribe: ', name, '  isInitMode: ', isInitMode);
            if (thisInstance.readonly) return;
            // "initEx" für via "set" mit Signal diesen Subscriber erneut aus,
            // die Daten sollen aber nicht gesetzt/gesendet werden
            if (isInitMode) {
                if ((0, $hkmmp.default)._debug) console.log('CONF Value has changed (INIT):', name, valueNew);
                isInitMode = false;
            } else thisInstance.setValueInternal(name, valueNew);
        });
        if ((0, $hkmmp.default)._debug) console.log('DrDocConfig.initAutoSaveInternal: state: ', thisInstance.has(name), ' / isInitMode: ', isInitMode);
    }
    return isInitMode;
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.setValueInternal = function(name, valueNew) {
    if ((0, $hkmmp.default)._debug) console.log('CONF Value has changed:', name, valueNew);
    if (this.Write === true) {
        if (this._isLocal) {
            if (window.localStorage !== undefined) window.localStorage.setItem(name, valueNew);
            else (0, $346VI.default).SetCookie(name, valueNew, 365);
        } else (0, $346VI.default).Send('GET', '/config', {
            mode: 'set',
            names: name,
            value: valueNew
        });
    }
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.getValueInternal = function(name, defaultValue) {
    // gespeicherten Wert zu Initialisierung abrufen
    if (this._isLocal) {
        if (window.localStorage !== undefined) {
            let valRet = window.localStorage.getItem(name);
            if (valRet !== undefined && valRet !== null) return valRet;
            else return defaultValue;
        } else {
            if ((0, $hkmmp.default)._debug) console.log('CONF Value wurde aus Cookie geladen:', name, ' == ', (0, $346VI.default).GetCookie(name, defaultValue, 365), '  / [DEFAULT]: ', defaultValue);
            return (0, $346VI.default).GetCookie(name, defaultValue, 365);
        }
    } else // Wer vom Server laden und initialisieren
    return (0, $346VI.default).Send('GET', '/config', {
        mode: 'get',
        names: name
    }).then(function(val) {
        if ((0, $hkmmp.default)._debug) console.log('CONF Value wurde vom Server geladen:', name, val);
        return val != undefined && val != null ? val : defaultValue;
    });
};
// Config Variable initialisieren
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeEx = function(name, event, defaultValue, parser) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeEx: Instance not found!', this);
    // Subscribe zuvor aufrufen, damit der Rückgabewert auch das Event feuert
    if (event !== undefined && event !== null) thisInstance._store.subscribe(name, event);
    thisInstance._store.initEx(name, function() {
        //if (Store._debug === true)
        //console.log('subscribeEx -> initEx: ', name);
        if ((0, $hkmmp.default)._debug) console.log('CONF wurde noch nicht initialisiert:', name, ' / default: ', defaultValue);
        // Wert wurde noch nicht geladen
        // Subscribe for Value Changes
        var isNewValue = thisInstance.initAutoSaveInternal(thisInstance, name, true);
        // Default-Value zurückgeben für die Initialisierung
        // gespeicherten Wert zu Initialisierung abrufen
        return thisInstance.getValueInternal(name, defaultValue);
    }, parser);
//if (!isNewValue)
//    thisInstance._store.subscribe(name, event);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribe = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribe: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, defaultValue, (0, $hkmmp.default).Parse);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeInt = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeInt: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, (0, $hkmmp.default).ParseInt(defaultValue), (0, $hkmmp.default).ParseInt);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.subscribeBool = function(name, event, defaultValue) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.subscribeBool: Instance not found!', this);
    return thisInstance.subscribeEx(name, event, (0, $hkmmp.default).ParseBool(defaultValue), (0, $hkmmp.default).ParseBool);
};
//set: this._store.set.bind(this._store),
//setInt: this._store.setInt.bind(this._store),
//setBool: this._store.setBool.bind(this._store),
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.set = function(name, value, signal) {
    var thisInstance = this;
    /*if (!thisInstance.has(name) && signal)
    {
        // initialisieren, wenn noch nicht geschehen
        console.log('DrDocConfig.set: wurde noch nicht initialisiert: ', name);
        //thisInstance.subscribe(name, null, value);
    }*/ thisInstance.initAutoSaveInternal(thisInstance, name, false);
    //this._config.subscribe(name, undefined);
    return this._store.set(name, value, signal);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.get = function(name, defaultValue) {
    //this._config.subscribe(name, undefined);
    return this._store.get(name, defaultValue);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.has = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.has: Instance not found!', this);
    return thisInstance._store.has(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.update = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.update: Instance not found!', this);
    return thisInstance._store.update(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.remove = function(name) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.remove: Instance not found!', this);
    return thisInstance._store.remove(name);
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.clear = function() {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.clear: Instance not found!', this);
    return thisInstance._store.clear();
};
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.unsubscribe = function(name, event) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.unsubscribe: Instance not found!', this);
    return thisInstance._store.unsubscribe(name, event);
};
/*
function BindConfigValue(elem, attrName)
{
    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '')
        return;
    //console.log('Conf: ' + confName, elem);
    
    $(elem).on('change', function (newValue, oldValue)
    {
        console.log('Conf: ' + confName, ' | onchange | ', newValue, oldValue);
        DrDoc.configUser.set(confName, elem.value);
    });
 
    DrDoc.configUser.subscribe(confName, function(value) {
        if (value == undefined || value == null)
        {
            elem.value = '';
            return;
        }
        elem.value = value;
        console.log('Conf: ' + confName, ' | new value: ', value);
    });
};
    document.querySelectorAll('select['+attrName+']').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="text"]').forEach(BindConfigValue);
    document.querySelectorAll('input['+attrName+'][type="checkbox"]').forEach(BindConfigCheck);
    document.querySelectorAll('input['+attrName+'][type="number"]').forEach(BindConfigInt);
    document.querySelectorAll('span['+attrName+']').forEach(BindConfigHtml);
*/ // bind-conf-user
// bind-conf-dev="config/view/name"
// bind-conf-dev-value="A"
// bind-conf-dev-default="Default Value"
$6c12204ffc79a36c$export$2e2bcd8739ae039.prototype.BindConfig = function(elem, attrName) {
    var thisInstance = this;
    if (this == undefined || this._config == undefined || this._store == undefined) console.warn('DrDocConfig.prototype.BindConfig: Instance not found!', this);
    //thisInstance = DrDocConfig.prototype;
    if (elem._bindConf === true) return;
    elem._bindConf = true;
    attrName = (0, $346VI.default).IsNullOrEmpty(attrName) ? 'bind-conf' : attrName;
    let confName = elem.getAttribute(attrName);
    if (confName == undefined || confName == null || confName == '') {
        console.warn('Biund Conf: empty confName', attrName, elem);
        return;
    }
    let tagName = elem.tagName.toLowerCase();
    let typeName = elem.getAttribute('type') == undefined ? '' : elem.getAttribute('type').toLowerCase();
    let bsToggleName = elem.getAttribute('data-bs-toggle') == undefined ? '' : elem.getAttribute('data-bs-toggle').toLowerCase();
    let defaultValue = elem.getAttribute(attrName + '-default') == undefined ? '' : elem.getAttribute(attrName + '-default');
    let optionValue = elem.getAttribute(attrName + '-value') == undefined ? '' : elem.getAttribute(attrName + '-value');
    let selectValue = elem.getAttribute(attrName + '-select') == undefined ? '' : elem.getAttribute(attrName + '-select');
    //if (defaultValue)
    //console.log('CONF ' , confName, ' = ', defaultValue, ' / tag: ', tagName, ' / bsToggleName: ', bsToggleName);
    function setElemValue(value, oldValue) {
        //console.log('CONF Bind Subsribe fired', confName, '  == ', value, elem);
        switch(tagName){
            case 'select':
            case 'input':
                switch(typeName){
                    case 'checkbox':
                        elem.checked = (0, $hkmmp.default).ParseBool(value); // value == undefined || value == null ? false : value;
                        break;
                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + (0, $346VI.default).SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set elem from conf', value, radioOptionElems, radioOptionElems2);
                            for(var i = 0; i < radioOptionElems.length; i++)if (radioOptionElems[i].value == value) radioOptionElems[i].checked = true;
                        }
                        break;
                    case 'number':
                    case 'text':
                    default:
                        elem.value = value;
                        break;
                }
                break;
            case 'textarea':
                elem.value = value;
                break;
            case 'li':
            case 'button':
            case 'a':
                //console.log('CONF toggle tab: ', confName, ' = ', value, ' | ', optionValue, ' | ', value == optionValue);
                if (value == optionValue) switch(bsToggleName){
                    case 'dropdown':
                        (0, $346VI.default).BS_DropdownShow(elem);
                        break;
                    case 'collapse':
                        (0, $346VI.default).BS_CollapseShow(elem);
                        break;
                    default:
                    case 'tab':
                        (0, $346VI.default).BS_TabShow(elem);
                        break;
                }
                break;
            default:
                elem.innerHTML = value; // value == undefined || value == null ? '' : value;
                break;
        }
    }
    // Default Value aus dem ersten verfügbaren Element wählen
    if ((0, $346VI.default).IsNullOrEmpty(defaultValue)) {
        let selectValueNum = (0, $346VI.default).ParseInt(selectValue);
        // suche nach [bind-conf-dev=confName][bind-conf-dev-value=".."] oder [bind-conf-dev=confName]>[bind-conf-dev-value=".."]
        let elemDefault = document.querySelector(`[${attrName}="${(0, $346VI.default).SelectorAttributeEncode(confName)}"][${(0, $346VI.default).SelectorAttributeEncode(attrName)}-value], [${(0, $346VI.default).SelectorAttributeEncode(attrName)}="${(0, $346VI.default).SelectorAttributeEncode(confName)}"]>[${(0, $346VI.default).SelectorAttributeEncode(attrName)}-value]`);
        if (elemDefault != undefined && elemDefault != null) {
            defaultValue = elemDefault.getAttribute(attrName + '-value');
            if (defaultValue == undefined) defaultValue = '';
            if (!(0, $346VI.default).IsNullOrEmpty(defaultValue) && !(0, $346VI.default).IsNullOrEmpty(bsToggleName)) //console.log('Dr.DOC Config: ', 'Name: ', confName, ' / Select-Num: ', selectValueNum, ' / ', ' => ', defaultValue);
            setElemValue(defaultValue);
        }
    }
    // Subscriber einrichten
    // Auf neue Werte warten (listen)
    switch(tagName){
        case 'select':
        case 'input':
            switch(typeName){
                case 'number':
                    thisInstance.subscribeInt(confName, setElemValue, defaultValue);
                    break;
                case 'checkbox':
                    thisInstance.subscribeBool(confName, setElemValue, defaultValue);
                    break;
                case 'radio':
                case 'text':
                default:
                    thisInstance.subscribe(confName, setElemValue, defaultValue);
                    break;
            }
            break;
        case 'textarea':
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            //DrDocWeb.BS_TabShow(elem);
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
        default:
            thisInstance.subscribe(confName, setElemValue, defaultValue);
            break;
    }
    //thisInstance.update(confName);
    if (thisInstance.has(confName)) setElemValue(thisInstance.get(confName));
    // Über neue Werte benachrichtigen
    // bei Änderung des Werts
    elem.addEventListener('change', function(newValue, oldValue) {
        if ((0, $hkmmp.default)._debug) console.log('Conf onChange: ' + confName, ' | onchange: ', oldValue, ' => ', newValue.data, ' / ', elem.value, elem);
        switch(tagName){
            case 'select':
            case 'input':
                switch(typeName){
                    case 'checkbox':
                        thisInstance.set(confName, elem.checked);
                        break;
                    case 'radio':
                        var radioOptionElems = document.querySelectorAll('input[type="radio"][name="' + (0, $346VI.default).SelectorAttributeEncode(elem.getAttribute('name')) + '"]');
                        if (radioOptionElems != null) {
                            //var radioOptionElems2 = document.getElementsByName(elem.getAttribute('name'));
                            //console.log('CONF set conf from elem', newValue, radioOptionElems, radioOptionElems2);
                            for(var i = 0; i < radioOptionElems.length; i++)if (radioOptionElems[i].checked) {
                                thisInstance.set(confName, radioOptionElems[i].value);
                                break;
                            }
                        }
                        break;
                    case 'number':
                    case 'text':
                    default:
                        thisInstance.set(confName, elem.value);
                        break;
                }
                break;
            case 'textarea':
                thisInstance.set(confName, elem.value.replaceAll("\r", "").replaceAll("\n", "\r\n"));
                break;
            case 'button':
            case 'li':
            case 'a':
                break;
            default:
                console.warn('Conf onChange: Unknown Tag Name: ', tagName, ' | ', confName);
                break;
        }
    });
    // Über neue Werte benachrichtigen
    // bei Click
    switch(tagName){
        case 'li':
        case 'button':
        case 'a':
            //switch (bsToggleName) {
            //    case 'tab':
            elem.addEventListener('click', function(x) {
                //console.log('CONF click ', confName, ' = ', optionValue);
                //DrDocWeb.BS_TabShow(x.target);
                thisInstance.set(confName, optionValue);
            });
            break;
    }
};

});

parcelRegister("fWhbk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a999bb32e8c605$export$2e2bcd8739ae039);

var $346VI = parcelRequire("346VI");
// --
// Node
// Lädt, holt Dr.DOC Node Components
// Requires: DrDocWeb, Bootstrap
if (window.Node !== undefined) console.warn('Lib Duplicate: DrDocNode');
function $b9a999bb32e8c605$export$2e2bcd8739ae039() {}
//module.exports = Node
//export default Node
window.Node = $b9a999bb32e8c605$export$2e2bcd8739ae039;
$b9a999bb32e8c605$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER = String.fromCharCode(1);
$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME = 'node-id';
$b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement = function(nodeId, targetElement, allElements) {
    /*
            let targetElement_arr = DrDocWeb.FindChildElements(document.documentElement, Node.ATTR_NAME, nodeId);
            //targetElement = DrDocWeb.FindChildElement(document.documentElement, Node.ATTR_NAME, nodeId);
            if (targetElement_arr !== undefined)
            {
                let targetElement = targetElement_arr[targetElement_arr.length-1];
                return targetElement;
            }
            return undefined;*/ if ((0, $346VI.default).IsNullOrEmpty(nodeId)) return undefined;
    if (typeof nodeId !== 'string') return nodeId;
    if (nodeId == $b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId(targetElement)) // Angefragte Element war bereits das richtige!
    //console.warn('Node.GetElement: Angefragte Element war bereits das richtige!', nodeId, '  ', targetElement);
    return targetElement;
    // ignoriert normalerweise alle Child-Elements von Elementen mit Attribut "data-form-ignore"
    // Für rekursive Formulare notwendig
    if (allElements === true) return (0, $346VI.default).GetElement(targetElement, '[node-id="' + (0, $346VI.default).SelectorAttributeEncode(nodeId) + '"]');
    else return (0, $346VI.default).GetElement(targetElement, '[node-id="' + (0, $346VI.default).SelectorAttributeEncode(nodeId) + '"]:not([data-form-ignore] *)');
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId = function(targetElement) {
    if (targetElement !== undefined && targetElement !== null) {
        if (typeof targetElement === 'string') // annehmen, dass es sich um eine node-id handelt
        return targetElement;
        //console.log('LoadComponent', targetElement);
        let nodeId = targetElement.getAttribute($b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME);
        if (nodeId != undefined && nodeId != null) return nodeId;
    }
    return undefined;
};
// Lädt eine Komponente in ein DOM-Node
// title, view, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, closeModalBefore, requestMethod, ignoreLoadEvent, nav, nodeId
// sourceElement: DOM Element für Form Daten, Attribute Daten, Modal
// targetElement: Ziel Node-Name-Path (noodeId) oder DOM Element; nach targetElement kopieren; Wenn Node-Name-Path (noodeId) im zu ladenden Element gefunden wird, dieses Child DOM Element verwenden.
$b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent = function(obj) {
    // title, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, requestMethod, ignoreLoadEvent
    //console.log('Node.LoadComponent', ' / title:', title, ' / sourceElement:', sourceElement, ' / targetElement:', targetElement, ' / getData:', getData);
    // 1. Target Element und Node-ID laden
    if (!(0, $346VI.default).IsNullOrEmpty(obj.nodeId) && (0, $346VI.default).IsNullOrEmpty(obj.targetElement)) obj.targetElement = obj.nodeId;
    if (obj.targetElement !== undefined && obj.targetElement !== null && obj.targetElement !== '') {
        if (typeof obj.targetElement === 'string') {
            // obj.targetElement ist ein String im Format "NodePath"
            if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) obj.nodeId = obj.targetElement;
            obj.targetElement = null;
            obj.targetElement = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.nodeId); //, obj.sourceElement);
        } else // obj.targetElement ist ein DOM Element
        // Node-Path-ID aus 'node-id' Attribut hoeln
        if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) obj.nodeId = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetNodeId(obj.targetElement);
    }
    if ((0, $346VI.default).IsNullOrEmpty(obj.nodeId)) {
        console.warn("LoadComponent: Element (obj.targetElement) konnte nicht geladen werden, da keine Node-ID \xfcbergeben wurde!", obj);
        return undefined;
    }
    if (obj.navRoot == true) {
        let nodeIdRoot = obj.nodeId.split('|')[0];
        let targetElementTmp = obj.targetElement;
        let targetElementRoot = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeIdRoot);
        // Ziel Komponente in Ziel nodeId laden
        let loadComponentNoRoot = function() {
            //obj.sourceElement = targetElementTmp;
            obj.targetElement = obj.nodeId;
            if (obj.sourceElement == undefined || obj.sourceElement == null) obj.sourceElement = obj.targetElement;
            obj.navRoot = false;
            //console.log('Node.LoadComponent: navRoot: / targetElementRoot wurde gefunden: ', targetElementRoot);
            return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(obj);
        };
        if (targetElementRoot == undefined || targetElementRoot == null) // Element für nodeId Root nicht gefunden
        // => Komponente mit Root Node-Name-Path (noodeId) laden
        //console.log('Node.LoadComponent: navRoot: / nodeIdRoot: ', nodeIdRoot, ' / obj.navRoot: ', obj.navRoot, ' / obj.nodeId: ', obj.nodeId);
        return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
            nodeId: nodeIdRoot,
            targetElement: targetElementTmp,
            sourceElement: targetElementTmp
        }).then(loadComponentNoRoot);
        else loadComponentNoRoot();
    }
    // --
    // 2. Url bauen
    //console.log('Load Com - Target Elem', obj.targetElement, obj.targetElement.innerHTML);
    //let url = target_url !== undefined && target_url.length > 0 ? target_url : window.location.href;
    //console.log('Url', url);
    let url = '/node/' + obj.nodeId;
    // --
    // 3. POST Data
    let hasPostData = false;
    if (obj.postData === undefined || obj.postData === null) {
        obj.postData = {};
        hasPostData = false;
    } else {
        hasPostData = true;
        if (typeof obj.postData === 'string') obj.postData = (0, $346VI.default).QueryStrToObject(obj.postData);
    }
    // --
    // 4. GET Data laden
    let hasGetData = false;
    if (obj.getData === undefined || obj.getData === null) {
        obj.getData = {};
        hasGetData = false;
    } else {
        hasGetData = true;
        // Falls obj.getData ein Query-String ist, in ein Objekt verwandeln
        if (typeof obj.getData === 'string') obj.getData = (0, $346VI.default).QueryStrToObject(obj.getData);
    }
    /// TODO: viewName aus URL oder aus Element obj.targetElement laden
    let viewName = 'None'; // 'Inline';
    //getArgs['prop'] = props;
    //obj.getData['prop_orig'] = obj.nodeId;
    if (!(0, $346VI.default).IsNullOrEmpty(obj.view)) viewName = obj.view;
    if ((0, $346VI.default).IsNullOrEmpty(obj.getData['view'])) obj.getData['view'] = viewName;
    if (obj.ignoreUnloadEvent === true) window.onbeforeunload = undefined;
    let attrElementsArr = [];
    // --
    // 5. Source Element / Node-id + Formular-Daten laden
    // Form Daten in obj.getData setzen
    // Alle Felder mit "$" am Anfang werden direkt als "<FieldName>" übernommen, alle anderen in "form_<FieldName>" umgewandelt
    if (obj.sourceElement !== undefined && obj.sourceElement !== null) {
        if (typeof obj.sourceElement === 'string') obj.sourceElement = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.sourceElement);
        if (obj.sourceElement !== undefined && obj.sourceElement !== null) // Existiert ein "beforeunload" Event auf dem Element?
        {
            if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
            obj.sourceElement.beforeunload !== undefined && obj.sourceElement.beforeunload !== null && typeof obj.sourceElement.beforeunload === 'function') {
                // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
                if (obj.sourceElement.beforeunload() !== true) return undefined;
            }
        } else console.warn('Node.LoadComponent', 'obj.sourceElement == undefined');
        attrElementsArr.push(obj.sourceElement);
    } else console.warn('Node.LoadComponent', 'obj.sourceElement (DOM) == undefined');
    // --
    // Wenn keine POST Daten vorhanden sind, Feldwerte aus Formular laden
    if (!hasPostData) $b9a999bb32e8c605$export$2e2bcd8739ae039.ParseFormData(obj.sourceElement, obj.getData, obj.postData, obj.formFieldsOr, obj.writeToGetData);
    // --
    // DOM Node Objekt löschen, damit es nicht zwei mal im DOM vorkommt
    //DrDoc.store.set('node|' + obj.nodeId, undefined);
    // --
    // Daten aus Target-Element lesen
    if (obj.targetElement !== undefined && obj.targetElement !== null) {
        // Existiert ein "beforeunload" Event auf dem Element?
        if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
        obj.targetElement.beforeunload !== undefined && obj.targetElement.beforeunload !== null && typeof obj.targetElement.beforeunload === 'function') {
            // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
            if (obj.targetElement.beforeunload() !== true) return undefined;
        }
        attrElementsArr.push(obj.targetElement);
    }
    for (let attrElement of attrElementsArr){
        //console.log("node form ", attrElement, attrElement.attributes);
        // Html/DOM Attribute aus dem "attrElement" extrahieren und in POST/GET-Parameter mergen
        if (attrElement == null || attrElement == undefined || attrElement.attributes == undefined) continue;
        var attrs = attrElement.attributes;
        if (attrs != undefined && attrs != null && attrs.length > 0) {
            //if (!hasPostData) {
            for(var i = attrs.length - 1; i >= 0; i--)if (attrs[i].name.indexOf('node-post-') === 0) {
                let fieldName = attrs[i].name.substring(10);
                //console.log("node form post " + fieldName + " -> " + attrs[i].value);
                obj.postData[fieldName] = attrs[i].value;
            }
            //}
            //if (!hasGetData) {
            for(var i = attrs.length - 1; i >= 0; i--)if (attrs[i].name.indexOf('node-get-') === 0) {
                let fieldName = attrs[i].name.substring(9);
                //console.log("node form get " + fieldName + " -> " + attrs[i].value);
                obj.getData[fieldName] = attrs[i].value;
            }
        //}
        }
        let attrTitle = attrElement.getAttribute('node-title');
        if (!(0, $346VI.default).IsNullOrEmpty(attrTitle)) obj.title = attrTitle;
        // Navigation
        let attrNav = attrElement.getAttribute('node-nav');
        if (!(0, $346VI.default).IsNullOrEmpty(attrNav)) // Url für den Root WebNode
        //let navUrl = DrDocWeb.GetRequestUrl(url.split('|')[0], obj.getData);
        //console.log('NAVIGATE Node B: ', obj.title, navUrl, attrElement);
        obj.nav = attrNav;
    }
    // --
    // Modal schließen, NACHDEM die Form Felder geladen wurden
    if (obj.closeModalBefore === true) (0, $346VI.default).ModalClose(obj.sourceElement, true);
    // --
    // navigieren
    if (obj.nav !== undefined && obj.nav !== null && !(obj.nav === 'false' || obj.nav === '0' || obj.nav === false)) $b9a999bb32e8c605$export$2e2bcd8739ae039.NavigateComponent(obj);
    // Scroll Position und Focus merken, um diese nach dem Laden wiederherzustellen
    let sourceScrollTop = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollTop : 0;
    let sourceScrollLeft = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollLeft : 0;
    let targetScrollTop = obj.targetElement != undefined && obj.targetElement != null ? obj.targetElement.scrollTop : 0;
    let targetScrollLeft = obj.targetElement != undefined && obj.targetElement != null ? obj.targetElement.scrollLeft : 0;
    let activeElementId = document.activeElement != null ? document.activeElement.id : null;
    return $b9a999bb32e8c605$export$2e2bcd8739ae039._initTargetElement(obj).then(function(targetElement) {
        // Modal schließen
        if (obj.closeModalAfter === true) (0, $346VI.default).ModalClose(obj.sourceElement, true);
        //if ((obj.sourceElement !== undefined && obj.sourceElement !== null) && (targetElement !== undefined && targetElement !== null)) {
        //    targetElement._triggerElement = obj.sourceElement;
        //    obj.sourceElement._triggerElement = targetElement;
        //}
        targetElement.UpdateComponent = function() {
            obj.targetElement = targetElement;
            //if (obj.getData == undefined || obj.getData == null)
            obj.getData.update = 'true';
            //Node.UpdateComponent(obj.nodeId);
            //return Node.LoadComponent(obj.title, obj.sourceElement, targetElement, obj.getData, obj.postData);
            return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(obj);
        };
        if (obj.requestMethod == undefined || obj.requestMethod == null || obj.requestMethod.length == 0) //obj.requestMethod = 'GET';
        obj.requestMethod = 'POST';
        // Dr.DOC Server anfragen
        // DrDocWeb.Send = function (method, url, getData, postData, parseAs, sendAs, cookie, retAsync)
        return (0, $346VI.default).Send(obj.requestMethod, url, obj.getData, obj.postData, undefined, undefined, undefined, true).then(function(response) {
            if (targetElement === null || targetElement === undefined) // Öffnet ein Modal, falls kein DOM-Element vorhanden ist.
            console.warn('LoadComponent', 'targetElement == null');
            else {
                //console.log('LoadComponent', 'Response ok');
                //DrDocWeb.setInnerHTML(targetElement, '...');
                //DrDocWeb.setInnerHTML(targetElement, response);
                //DrDocWeb.EventFire(targetElement, 'NodeLoaded');
                if (obj.ignoreLoadEvent !== true) (0, $346VI.default).EventFire(targetElement, 'NodeUnloaded');
                //targetElement.innerHTML = response;
                //var v_elem = document.createElement('div');
                var doc = targetElement.ownerDocument || document;
                var v_elem = doc.createElement('div');
                v_elem.innerHTML = response;
                //var v_elem_child = DrDocWeb.FindChildElement(v_elem, Node.ATTR_NAME, obj.nodeId);
                var v_elem_child = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(obj.nodeId, v_elem);
                if (v_elem_child !== undefined && v_elem_child !== null) //console.log(`LoadComponent: DOM-Element ${Node.ATTR_NAME}="${obj.nodeId}"`, 'target', targetElement, v_elem, v_elem_child, response);
                //targetElement.innerHTML = v_elem_child.innerHTML;
                // über setInnerHTML aufrufen, damit Scripts ausgeführt werden können
                //--DrDocWeb.setInnerHTML(targetElement, v_elem_child.outerHTML);
                (0, $346VI.default).setInnerHTML(targetElement, v_elem_child.innerHTML);
                else {
                    console.warn(`LoadComponent: DOM-Element ${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME}="${obj.nodeId}" konnte nicht gefunden werden!`, ' / response: ', response, ' / v_elem: ', v_elem, ' / targetElement: ', targetElement, ' / sourceElement: ', obj.sourceElement);
                    //targetElement.outerHTML = v_elem.innerHTML;
                    //DrDocWeb.setInnerHTML(targetElement, v_elem.innerHTML);
                    if (obj.exact === true) (0, $346VI.default).setInnerHTML(targetElement, `Zugriff verweigert: Element ${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME} ${obj.nodeId} konnte nicht gefunden werden!`);
                    else (0, $346VI.default).setInnerHTML(targetElement, v_elem.innerHTML);
                }
                // node-id Attribute des Target Elements ändern
                if (targetElement.hasAttribute('node-id')) targetElement.setAttribute('node-id', obj.nodeId);
                if (obj.ignoreLoadEvent !== true) (0, $346VI.default).EventFire(targetElement, 'NodeLoaded');
                if (obj.sourceElement != undefined && obj.sourceElement != null) {
                    obj.sourceElement.scrollTop = sourceScrollTop;
                    obj.sourceElement.scrollLeft = sourceScrollLeft;
                }
                if (obj.targetElement != undefined && obj.targetElement != null) {
                    obj.targetElement.scrollTop = targetScrollTop;
                    obj.targetElement.scrollLeft = targetScrollLeft;
                }
                if (!(0, $346VI.default).IsNullOrEmpty(activeElementId)) {
                    //console.log('LoadComponent: Reload active elem', activeElementId, document.getElementById(activeElementId));
                    var activeElementTmp = document.getElementById(activeElementId);
                    if (activeElementTmp != undefined && activeElementTmp != null) {
                        document.activeElement = activeElementTmp;
                        if (activeElementTmp.focus !== undefined && typeof activeElementTmp.focus === 'function') activeElementTmp.focus();
                    }
                }
            // DOM Node in Store setzen
            //DrDoc.store.set('node|' + obj.nodeId, targetElement);
            }
        }).catch($b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem(obj.title, obj.nodeId, targetElement));
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.ParseFormData = function(sourceElement, getData, postData, formFieldsOr, writeToGetData) {
    let splitter_char = formFieldsOr === true ? '|' : $b9a999bb32e8c605$export$2e2bcd8739ae039.TABLE_ROW_SPLITTER;
    let formData = (0, $346VI.default).GetClosestFormToObject(sourceElement, splitter_char);
    // Formular-Daten in GET Parameter übertragen
    if (formData !== undefined && formData !== null) //console.log('Node.ParseFormData: ', formData);
    for(let fieldName in formData){
        let fieldValue = formData[fieldName];
        // Leere Feldwerte überspringen
        if (formFieldsOr === true) {
            if (fieldValue === undefined || fieldValue === null || fieldValue === '') continue;
        //else
        //    fieldValue = fieldValue.replace(/[\|]+$/, '');
        //fieldValue = fieldValue.replace(/[\s\|]+$/, '');
        }
        // Formular-Daten kommen in POST
        // Formulardaten mit Prefix "$" kommen in GET
        if (fieldName.substring(0, 1) === '$') getData[fieldName.substring(1)] = fieldValue;
        else if (writeToGetData === true) getData['field_' + fieldName] = fieldValue;
        else postData[fieldName] = fieldValue;
    }
    return formData;
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SetFormFieldGetData = function(getObj, data) {
    //console.log('Node.SetFormFieldGetData() 1: ', getObj, data);
    if (data != undefined && data != null) {
        if (typeof data === 'string') {
            // Wenn "data" ein "String" ist, dann annehmen, dass die Feld-Namen im Format "field_<FieldName>" ist
            data = (0, $346VI.default).QueryStrToObject(data);
            for(let i in data)getObj[i] = data[i];
        } else {
            // "data" ist ein Object, daher "field" voranstellen
            for(let name in data)if (name[0] == '$') getObj[name.substring(1)] = data[name];
            else getObj['field_' + name] = data[name];
        }
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading = function(targetElement) {
    if (targetElement == undefined || targetElement == null) return;
    // "Loading" Info in das Element schreiben
    // Manche Elemente müssen gesondert behandelt werden
    switch(targetElement.tagName.toLowerCase()){
        case 'button':
        case 'input':
            targetElement.innerHTML = 'loading..';
            break;
        case 'select':
            targetElement.innerHTML = '<option>loading..</option>';
            break;
        default:
            targetElement.innerHTML = `
    <div class="d-flex justify-content-center align-items-center align-self-center p-3">
        <div class="spinner-border text-primary-subtle" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <!--<br /><b><i class="bi bi-hourglass-split"></i>&nbsp;&nbsp;&nbsp;Wird geladen...</b>-->
    </div>`;
            break;
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem = function(title, nodeId, targetElement) {
    return function(err) {
        console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem', err);
        //console.log('ERROR / LoadComponent 1', err);
        (0, $346VI.default).ModalError(`Fehler f\xfcr: ${title}`, `Komponente "${$b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);
        //DrDocWeb.ModalError(`Fehler für: ${title} konnte nicht abgerufen werden!`);
        //alert(`Fehler für: ${title}`, `Komponente "${Node.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);
        if (targetElement != undefined && targetElement != null) {
            var origInnerHtml = targetElement.innerHTML;
            // Im Fehlerfall die Kompontente zurücksetzen
            if (origInnerHtml.length > 0) origInnerHtml = `<b>Komponente konnte nicht abgerufen werden! Die Komponente wird auf den vorherigen Wert zur\xfcckgesetzt. Bitte Internetverbindung \xfcberpr\xfcfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>
        <br />${origInnerHtml}`;
            else origInnerHtml = `<b>Bitte Internetverbindung \xfcberpr\xfcfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>`;
            targetElement.innerHTML = origInnerHtml;
        } else console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem: targetElement == null', err);
    //reject(err);
    };
};
// Target Element erstellen oder initialisieren
// Return: Promise(targetElement)
$b9a999bb32e8c605$export$2e2bcd8739ae039._initTargetElement = function(obj) {
    let origInnerHtml = '';
    return new Promise(function(resolve, reject) {
        //try
        //{
        // falls kein "targetElement" übergeben wurde, ein Modal erstellen oder ein neues Fenster öffnen.
        if (obj.targetElement === undefined || obj.targetElement === null || obj.newWindow === true) {
            if (obj.newWindow === true) // Get New Window
            return $b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindowSelectElement(obj.title, obj.nodeId).then(function(targetElementArg) {
                obj.targetElement = targetElementArg;
                $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
                resolve(targetElementArg);
            }).catch(reject);
            else {
                // falls kein "targetElement" übergeben wurde, ein Modal erstellen.
                obj.targetElement = document.createElement('div');
                obj.targetElement.setAttribute($b9a999bb32e8c605$export$2e2bcd8739ae039.ATTR_NAME, obj.nodeId);
                $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
                if (obj.modalOption === undefined || obj.modalOption === null) obj.modalOption = {
                    fullScreen: false,
                    size: 'xl'
                };
                (0, $346VI.default).Modal(obj.title, obj.targetElement, obj.modalOption);
            }
        } else {
            // Original-Element für den Fehlerfall zwischenspeichern
            origInnerHtml = obj.targetElement.innerHTML;
            $b9a999bb32e8c605$export$2e2bcd8739ae039._setElementStateLoading(obj.targetElement);
        }
        resolve(obj.targetElement);
    /*}
        catch (err)
        {
            onError(err);
        }*/ }).catch($b9a999bb32e8c605$export$2e2bcd8739ae039._onErrorLoadElem(obj.title, obj.nodeId, obj.targetElement));
};
// Node DOM Element im Temp Window wählen
$b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindowSelectElement = function(title, nodeId) {
    return new Promise(function(resolve, reject) {
        $b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindow(nodeId).then(function(newWindow) {
            newWindow.title = title;
            var newWindowDoc = newWindow.document.documentElement;
            console.log('New Window Target Elem', newWindowDoc);
            resolve(newWindowDoc);
        }).catch(reject);
    });
};
// Temp Window für den Node öffnen und Promis zurückgeben
$b9a999bb32e8c605$export$2e2bcd8739ae039._getTempNodeWindow = function(nodeId) {
    return new Promise(function(resolve, reject) {
        try {
            // falls kein "targetElement" übergeben wurde, ein neues Fenster öffnen.
            //var newWindow = window.open(url, '_blank'); //'/node/')
            var thisDocHtml = null; //document.documentElement.innerHTML;
            // Fenster speichern in "window._comWindow[Node-Path]"
            if (window._comWindow === undefined || window._comWindow === null) window._comWindow = {};
            if (window._comWindowCounter === undefined || window._comWindowCounter === null) window._comWindowCounter = 0;
            var newWindow = null;
            if (window._comWindow[nodeId] !== undefined && window._comWindow[nodeId] !== null && window._comWindow[nodeId].closed === false) {
                newWindow = window._comWindow[nodeId];
                newWindow.focus();
                resolve(newWindow);
            } else {
                window._comWindowCounter++;
                newWindow = window.open('/node/system/empty#nr-' + window._comWindowCounter, nodeId + " - " + window._comWindowCounter, 'width=1200, height=1000');
                //newWindow = window.open('about:blank', nodeId, 'width=700, height=800');
                window._comWindow[nodeId] = newWindow;
                newWindow.addEventListener('load', function(e) {
                    //console.log('_getTempNodeWindow: New Window has been loadad', e, e.target.documentElement);
                    newWindow.focus();
                    resolve(newWindow);
                }, true);
                newWindow.addEventListener('beforeunload', function(e) {
                    if (window._comWindow != undefined) window._comWindow[nodeId] = undefined;
                }, false);
                if (thisDocHtml != null && thisDocHtml != undefined) {
                    var newWindowDoc = newWindow.document.open();
                    newWindowDoc.write(thisDocHtml);
                    newWindowDoc.close();
                }
            //console.log('New Window ', newWindow, newWindow.documentElement, newWindowDoc);
            //console.log('New Window ', nodeId, newWindow, newWindowDoc, newWindow.document, newWindow.document.documentElement);
            /*while (newWindow.document.readyState != 'complete')
                {
                    // wait..
                }*/ }
        } catch (err) {
            reject(err);
        }
    });
};
// Aktualisiert alle Nodes, die diesen Node im NodePath enthalten
$b9a999bb32e8c605$export$2e2bcd8739ae039.UpdateComponent = function(nodeName) {
    let nodeElem = $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName);
    if (nodeElem != undefined && nodeElem != null && typeof nodeElem.UpdateComponent === 'function') {
        console.log('Node.UpdateComponent: ', nodeName, nodeElem);
        return nodeElem.UpdateComponent();
    } else {
        console.log('Node.UpdateComponent: ', nodeName, 'Nicht gefunden!');
        return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
            title: 'Komponente aktualisieren',
            sourceElement: nodeElem,
            targetElement: nodeElem
        });
    }
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
        title: 'Komponente aktualisieren',
        sourceElement: $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName),
        targetElement: $b9a999bb32e8c605$export$2e2bcd8739ae039.GetElement(nodeName)
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom = {
    nodeId: '',
    getData: '',
    postData: ''
};
// History Verlauf
$b9a999bb32e8c605$export$2e2bcd8739ae039.NavigateComponent = function(obj) {
    var replace = obj.nav == 'replace';
    var state = (0, $346VI.default).CloneCopy(obj);
    state.sourceElement = obj.nodeId;
    state.targetElement = obj.nodeId;
    state.action = 'nav';
    state.nav = undefined;
    if ($b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.nodeId == obj.nodeId && $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.getData == (0, $346VI.default).ObjectToQueryStr(state.getData) && $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.postData == (0, $346VI.default).ObjectToQueryStr(state.postData)) return;
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.nodeId = obj.nodeId;
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.getData = (0, $346VI.default).ObjectToQueryStr(state.getData);
    $b9a999bb32e8c605$export$2e2bcd8739ae039._lastNavCom.postData = (0, $346VI.default).ObjectToQueryStr(state.postData);
    var navUrl = '/node/' + obj.nodeId.split('|')[0] + '?' + (0, $346VI.default).ObjectToQueryStr(state.getData);
    var navTitle = !(0, $346VI.default).IsNullOrEmpty(state.title) ? state.title : document.title;
    /*var navSourceElem = Node.GetElement(obj.nodeId);
    if (navSourceElem == undefined || navSourceElem == null) {
        console.log('Node.NavigateComponent: Node id not found / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
        return;
    }*/ /*var setState = {
        //html: sourceElem.innerHTML,
        //html: navSourceElem.innerHTML,
        nodeId: obj.nodeId,
        pageTitle: navTitle,
        url: navUrl
    };*/ try {
        if (replace) {
            console.log('Node.NavigateComponent: REPLACE state / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
            window.history.replaceState(state, navTitle, navUrl);
        } else {
            console.log('Node.NavigateComponent: PUSH state / title: ', navTitle, ' / navUrl: ', navUrl, ' / nodeId: ', obj.nodeId);
            window.history.pushState(state, navTitle, navUrl);
        }
    } catch (ex) {
        console.warn('Node.NavigateComponent:', obj.nodeId, obj, ex);
    }
    //if (window.onpopstate != Node.OnNavigateComponentEvent)
    //    window.onpopstate = Node.OnNavigateComponentEvent;
    window.removeEventListener('popstate', $b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent);
    window.addEventListener('popstate', $b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent);
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.OnNavigateComponentEvent = function(e) //window.addEventListener('popstate', function(e)
{
    if (e.state) /*if (e.state.url == navUrl)
        {
            //console.log('window.onpopstate->e.state: ENDE! ', e, e.state);
            return;
        }*/ //document.getElementById("content").innerHTML = e.state.html;
    //var navSourceElem = Node.GetElement(e.state.nodeId);
    //navSourceElem.innerHTML = e.state.html;
    //document.title = e.state.pageTitle;
    {
        if (e.state.action == 'nav') {
            console.log('Node.OnNavigateComponentEvent: window.onpopstate->e.state:', e.state);
            e.preventDefault();
            $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent(e.state);
        }
    }
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SaveThis = function(node_id, node_prop_name, node_prop_value, node_prop_type, node_prop_inherit, new_name) {
    if ((0, $346VI.default).IsNullOrEmpty(node_id)) {
        console.error("Node.Save: Kein Argument f\xfcr node_id angegeben!");
        return;
    }
    // HTTP PUT
    // POST Object = {
    //    __name: <Name>
    //    __prototype: <Prototype>
    //    <PropertyName>: <PropertyValue>
    //    $<PropertyName>: <PropertyType>
    //    ~<OldPropertyName>: <NewPropertyName>
    //    -<RemovePropertyName>: ''
    //    +<InheritPropertyName>: true
    //}
    let postData = {};
    if (!(0, $346VI.default).IsNullOrEmpty(new_name)) postData['__name'] = new_name;
    //if (!DrDocWeb.IsNullOrEmpty(new_prototype)) {
    //    postData['__prototype'] = new_prototype;
    //}
    if (!(0, $346VI.default).IsNullOrEmpty(node_prop_name)) {
        postData[node_prop_name] = !(0, $346VI.default).IsNullOrEmpty(node_prop_value) ? node_prop_value : '';
        // Property Type
        if (!(0, $346VI.default).IsNullOrEmpty(node_prop_type)) postData['$' + node_prop_name] = node_prop_type;
        // Property vererben
        if (node_prop_inherit != null && node_prop_inherit != undefined) postData['+' + node_prop_name] = node_prop_inherit == true;
    }
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.LoadComponent({
        //getData,
        postData: postData,
        view: 'Inline',
        targetElement: node_id,
        sourceElement: node_id,
        //sourceElement: (!DrDocWeb.IsNullOrEmpty(node_prop_name) ? (node_id + '|' + node_prop_name) : node_id),
        requestMethod: 'PUT'
    });
//let path = '/node/' + node_id;
//console.log('SendValue, load inline editor', node_id, node_id, path, getData, postData);
//return DrDocWeb.Send('PUT', path, getData, postData).then(function (data) {
//    return Node.UpdateComponent(node_id);
//});
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.Save = function(node_id, node_prop_value, node_prop_type, ode_prop_inherit, new_name) {
    if (node_id == undefined || node_id == null || node_id == '') {
        console.error("Node.Save: Kein Argument f\xfcr node_id angegeben!");
        return;
    }
    // node_id = page_home|menu_main|de/property
    let node_id_path_arr = node_id.split('|');
    let node_prop_name = node_id_path_arr[node_id_path_arr.length - 1];
    node_id_path_arr.splice(node_id_path_arr.length - 1, 1);
    let node_id_parent = node_id_path_arr.join('|');
    // =>
    // node_id_parent = page_home|menu_main
    // node_prop_name = de/property
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SaveThis(node_id_parent, node_prop_name, node_prop_value, node_prop_type, ode_prop_inherit, new_name);
};
//Node.SendElementValue = function(path, node_id, node_name, element, elemBase)
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement = function(node_id, element, elemBase, parser) {
    let elem = element !== undefined && element !== null && typeof element === 'string' ? (0, $346VI.default).GetElement(elemBase, element) : element;
    if (element == undefined || element == null) {
        console.warn('Node.SendElementValue: Element not found (by id)!', element, elem);
        return false;
    }
    //let elem = Node.GetElement(element);
    let value = parser(elem);
    //console.log('Node.SendElementValue: ', 'Path: ', path, 'Node-ID: ', element, 'Value: ', value, 'Elements: ', elem);
    //return Node.Save(path, node_id, node_name, value, '');
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.Save(node_id, value, undefined, undefined);
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentMarkdown = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContentMarkdown', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.value;
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentHtml = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.innerHTML;
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', '<br />');
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', '<br />');
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementContentText = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.InnerText !== undefined ? _elem.InnerText : _elem.innerHTML;
        console.log('Node.SendElementContent', 'Text 1', ret_value);
        ret_value = ret_value.replaceAll('&nbsp;', " ");
        ret_value = ret_value.replaceAll('&lt;', "<");
        ret_value = ret_value.replaceAll('&gt;', ">");
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', "\r\n");
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', "\r\n");
        ret_value = ret_value.replaceAll('<br>', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br&gt;', "\r\n");
        ret_value = ret_value.replaceAll('<br/>', "\r\n");
        ret_value = ret_value.replaceAll('<br />', "\r\n");
        ret_value = ret_value.replaceAll('</p>', "\r\n");
        ret_value = ret_value.replaceAll('<p>', '');
        console.log('Node.SendElementContent', 'Text 2', ret_value);
        return ret_value;
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementChecked = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('SendElementChecked', _elem);
        return _elem.checked ? 'true' : 'false';
    });
};
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementValue = function(node_id, element, elemBase) {
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.SendElement(node_id, element, elemBase, function(_elem) {
        console.log('SendElementValue', _elem);
        return _elem.value;
    });
};
//Node.SendElementName = function(path, node_id, new_name)
$b9a999bb32e8c605$export$2e2bcd8739ae039.SendElementName = function(node_id, new_name, elemBase) {
    // ist new_name ein Element?
    if (new_name !== undefined && typeof new_name !== 'string' && new_name.value !== undefined) new_name = new_name.value;
    //return Node.Save(path, node_id, undefined, undefined, new_name);
    return $b9a999bb32e8c605$export$2e2bcd8739ae039.Save(node_id, undefined, undefined, new_name);
};

});

parcelRegister("60OaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4609a9aa19959f74$export$2e2bcd8739ae039);
// The programming goals of Split.js are to deliver readable, understandable and
// maintainable code, while at the same time manually optimizing for tiny minified file size,
// browser compatibility without additional requirements
// and very few assumptions about the user's page layout.
var $4609a9aa19959f74$var$global = typeof window !== 'undefined' ? window : null;
var $4609a9aa19959f74$var$ssr = $4609a9aa19959f74$var$global === null;
var $4609a9aa19959f74$var$document = !$4609a9aa19959f74$var$ssr ? $4609a9aa19959f74$var$global.document : undefined;
// Save a couple long function names that are used frequently.
// This optimization saves around 400 bytes.
var $4609a9aa19959f74$var$addEventListener = 'addEventListener';
var $4609a9aa19959f74$var$removeEventListener = 'removeEventListener';
var $4609a9aa19959f74$var$getBoundingClientRect = 'getBoundingClientRect';
var $4609a9aa19959f74$var$gutterStartDragging = '_a';
var $4609a9aa19959f74$var$aGutterSize = '_b';
var $4609a9aa19959f74$var$bGutterSize = '_c';
var $4609a9aa19959f74$var$HORIZONTAL = 'horizontal';
var $4609a9aa19959f74$var$NOOP = function() {
    return false;
};
// Helper function determines which prefixes of CSS calc we need.
// We only need to do this once on startup, when this anonymous function is called.
//
// Tests -webkit, -moz and -o prefixes. Modified from StackOverflow:
// http://stackoverflow.com/questions/16625140/js-feature-detection-to-detect-the-usage-of-webkit-calc-over-calc/16625167#16625167
var $4609a9aa19959f74$var$calc = $4609a9aa19959f74$var$ssr ? 'calc' : [
    '',
    '-webkit-',
    '-moz-',
    '-o-'
].filter(function(prefix) {
    var el = $4609a9aa19959f74$var$document.createElement('div');
    el.style.cssText = "width:" + prefix + "calc(9px)";
    return !!el.style.length;
}).shift() + "calc";
// Helper function checks if its argument is a string-like type
var $4609a9aa19959f74$var$isString = function(v) {
    return typeof v === 'string' || v instanceof String;
};
// Helper function allows elements and string selectors to be used
// interchangeably. In either case an element is returned. This allows us to
// do `Split([elem1, elem2])` as well as `Split(['#id1', '#id2'])`.
var $4609a9aa19959f74$var$elementOrSelector = function(el) {
    if ($4609a9aa19959f74$var$isString(el)) {
        var ele = $4609a9aa19959f74$var$document.querySelector(el);
        if (!ele) throw new Error("Selector " + el + " did not match a DOM element");
        return ele;
    }
    return el;
};
// Helper function gets a property from the properties object, with a default fallback
var $4609a9aa19959f74$var$getOption = function(options, propName, def) {
    var value = options[propName];
    if (value !== undefined) return value;
    return def;
};
var $4609a9aa19959f74$var$getGutterSize = function(gutterSize, isFirst, isLast, gutterAlign) {
    if (isFirst) {
        if (gutterAlign === 'end') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    } else if (isLast) {
        if (gutterAlign === 'start') return 0;
        if (gutterAlign === 'center') return gutterSize / 2;
    }
    return gutterSize;
};
// Default options
var $4609a9aa19959f74$var$defaultGutterFn = function(i, gutterDirection) {
    var gut = $4609a9aa19959f74$var$document.createElement('div');
    gut.className = "gutter gutter-" + gutterDirection;
    return gut;
};
var $4609a9aa19959f74$var$defaultElementStyleFn = function(dim, size, gutSize) {
    var style = {};
    if (!$4609a9aa19959f74$var$isString(size)) style[dim] = $4609a9aa19959f74$var$calc + "(" + size + "% - " + gutSize + "px)";
    else style[dim] = size;
    return style;
};
var $4609a9aa19959f74$var$defaultGutterStyleFn = function(dim, gutSize) {
    var obj;
    return obj = {}, obj[dim] = gutSize + "px", obj;
};
// The main function to initialize a split. Split.js thinks about each pair
// of elements as an independant pair. Dragging the gutter between two elements
// only changes the dimensions of elements in that pair. This is key to understanding
// how the following functions operate, since each function is bound to a pair.
//
// A pair object is shaped like this:
//
// {
//     a: DOM element,
//     b: DOM element,
//     aMin: Number,
//     bMin: Number,
//     dragging: Boolean,
//     parent: DOM element,
//     direction: 'horizontal' | 'vertical'
// }
//
// The basic sequence:
//
// 1. Set defaults to something sane. `options` doesn't have to be passed at all.
// 2. Initialize a bunch of strings based on the direction we're splitting.
//    A lot of the behavior in the rest of the library is paramatized down to
//    rely on CSS strings and classes.
// 3. Define the dragging helper functions, and a few helpers to go with them.
// 4. Loop through the elements while pairing them off. Every pair gets an
//    `pair` object and a gutter.
// 5. Actually size the pair elements, insert gutters and attach event listeners.
var $4609a9aa19959f74$var$Split = function(idsOption, options) {
    if (options === void 0) options = {};
    if ($4609a9aa19959f74$var$ssr) return {};
    var ids = idsOption;
    var dimension;
    var clientAxis;
    var position;
    var positionEnd;
    var clientSize;
    var elements;
    // Allow HTMLCollection to be used as an argument when supported
    if (Array.from) ids = Array.from(ids);
    // All DOM elements in the split should have a common parent. We can grab
    // the first elements parent and hope users read the docs because the
    // behavior will be whacky otherwise.
    var firstElement = $4609a9aa19959f74$var$elementOrSelector(ids[0]);
    var parent = firstElement.parentNode;
    var parentStyle = getComputedStyle ? getComputedStyle(parent) : null;
    var parentFlexDirection = parentStyle ? parentStyle.flexDirection : null;
    // Set default options.sizes to equal percentages of the parent element.
    var sizes = $4609a9aa19959f74$var$getOption(options, 'sizes') || ids.map(function() {
        return 100 / ids.length;
    });
    // Standardize minSize and maxSize to an array if it isn't already.
    // This allows minSize and maxSize to be passed as a number.
    var minSize = $4609a9aa19959f74$var$getOption(options, 'minSize', 100);
    var minSizes = Array.isArray(minSize) ? minSize : ids.map(function() {
        return minSize;
    });
    var maxSize = $4609a9aa19959f74$var$getOption(options, 'maxSize', Infinity);
    var maxSizes = Array.isArray(maxSize) ? maxSize : ids.map(function() {
        return maxSize;
    });
    // Get other options
    var expandToMin = $4609a9aa19959f74$var$getOption(options, 'expandToMin', false);
    var gutterSize = $4609a9aa19959f74$var$getOption(options, 'gutterSize', 10);
    var gutterAlign = $4609a9aa19959f74$var$getOption(options, 'gutterAlign', 'center');
    var snapOffset = $4609a9aa19959f74$var$getOption(options, 'snapOffset', 30);
    var snapOffsets = Array.isArray(snapOffset) ? snapOffset : ids.map(function() {
        return snapOffset;
    });
    var dragInterval = $4609a9aa19959f74$var$getOption(options, 'dragInterval', 1);
    var direction = $4609a9aa19959f74$var$getOption(options, 'direction', $4609a9aa19959f74$var$HORIZONTAL);
    var cursor = $4609a9aa19959f74$var$getOption(options, 'cursor', direction === $4609a9aa19959f74$var$HORIZONTAL ? 'col-resize' : 'row-resize');
    var gutter = $4609a9aa19959f74$var$getOption(options, 'gutter', $4609a9aa19959f74$var$defaultGutterFn);
    var elementStyle = $4609a9aa19959f74$var$getOption(options, 'elementStyle', $4609a9aa19959f74$var$defaultElementStyleFn);
    var gutterStyle = $4609a9aa19959f74$var$getOption(options, 'gutterStyle', $4609a9aa19959f74$var$defaultGutterStyleFn);
    // 2. Initialize a bunch of strings based on the direction we're splitting.
    // A lot of the behavior in the rest of the library is paramatized down to
    // rely on CSS strings and classes.
    if (direction === $4609a9aa19959f74$var$HORIZONTAL) {
        dimension = 'width';
        clientAxis = 'clientX';
        position = 'left';
        positionEnd = 'right';
        clientSize = 'clientWidth';
    } else if (direction === 'vertical') {
        dimension = 'height';
        clientAxis = 'clientY';
        position = 'top';
        positionEnd = 'bottom';
        clientSize = 'clientHeight';
    }
    // 3. Define the dragging helper functions, and a few helpers to go with them.
    // Each helper is bound to a pair object that contains its metadata. This
    // also makes it easy to store references to listeners that that will be
    // added and removed.
    //
    // Even though there are no other functions contained in them, aliasing
    // this to self saves 50 bytes or so since it's used so frequently.
    //
    // The pair object saves metadata like dragging state, position and
    // event listener references.
    function setElementSize(el, size, gutSize, i) {
        // Split.js allows setting sizes via numbers (ideally), or if you must,
        // by string, like '300px'. This is less than ideal, because it breaks
        // the fluid layout that `calc(% - px)` provides. You're on your own if you do that,
        // make sure you calculate the gutter size by hand.
        var style = elementStyle(dimension, size, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            el.style[prop] = style[prop];
        });
    }
    function setGutterSize(gutterElement, gutSize, i) {
        var style = gutterStyle(dimension, gutSize, i);
        Object.keys(style).forEach(function(prop) {
            // eslint-disable-next-line no-param-reassign
            gutterElement.style[prop] = style[prop];
        });
    }
    function getSizes() {
        return elements.map(function(element) {
            return element.size;
        });
    }
    // Supports touch events, but not multitouch, so only the first
    // finger `touches[0]` is counted.
    function getMousePosition(e) {
        if ('touches' in e) return e.touches[0][clientAxis];
        return e[clientAxis];
    }
    // Actually adjust the size of elements `a` and `b` to `offset` while dragging.
    // calc is used to allow calc(percentage + gutterpx) on the whole split instance,
    // which allows the viewport to be resized without additional logic.
    // Element a's size is the same as offset. b's size is total size - a size.
    // Both sizes are calculated from the initial parent percentage,
    // then the gutter size is subtracted.
    function adjust(offset) {
        var a = elements[this.a];
        var b = elements[this.b];
        var percentage = a.size + b.size;
        a.size = offset / this.size * percentage;
        b.size = percentage - offset / this.size * percentage;
        setElementSize(a.element, a.size, this[$4609a9aa19959f74$var$aGutterSize], a.i);
        setElementSize(b.element, b.size, this[$4609a9aa19959f74$var$bGutterSize], b.i);
    }
    // drag, where all the magic happens. The logic is really quite simple:
    //
    // 1. Ignore if the pair is not dragging.
    // 2. Get the offset of the event.
    // 3. Snap offset to min if within snappable range (within min + snapOffset).
    // 4. Actually adjust each element in the pair to offset.
    //
    // ---------------------------------------------------------------------
    // |    | <- a.minSize               ||              b.minSize -> |    |
    // |    |  | <- this.snapOffset      ||     this.snapOffset -> |  |    |
    // |    |  |                         ||                        |  |    |
    // |    |  |                         ||                        |  |    |
    // ---------------------------------------------------------------------
    // | <- this.start                                        this.size -> |
    function drag(e) {
        var offset;
        var a = elements[this.a];
        var b = elements[this.b];
        if (!this.dragging) return;
        // Get the offset of the event from the first side of the
        // pair `this.start`. Then offset by the initial position of the
        // mouse compared to the gutter size.
        offset = getMousePosition(e) - this.start + (this[$4609a9aa19959f74$var$aGutterSize] - this.dragOffset);
        if (dragInterval > 1) offset = Math.round(offset / dragInterval) * dragInterval;
        // If within snapOffset of min or max, set offset to min or max.
        // snapOffset buffers a.minSize and b.minSize, so logic is opposite for both.
        // Include the appropriate gutter sizes to prevent overflows.
        if (offset <= a.minSize + a.snapOffset + this[$4609a9aa19959f74$var$aGutterSize]) offset = a.minSize + this[$4609a9aa19959f74$var$aGutterSize];
        else if (offset >= this.size - (b.minSize + b.snapOffset + this[$4609a9aa19959f74$var$bGutterSize])) offset = this.size - (b.minSize + this[$4609a9aa19959f74$var$bGutterSize]);
        if (offset >= a.maxSize - a.snapOffset + this[$4609a9aa19959f74$var$aGutterSize]) offset = a.maxSize + this[$4609a9aa19959f74$var$aGutterSize];
        else if (offset <= this.size - (b.maxSize - b.snapOffset + this[$4609a9aa19959f74$var$bGutterSize])) offset = this.size - (b.maxSize + this[$4609a9aa19959f74$var$bGutterSize]);
        // Actually adjust the size.
        adjust.call(this, offset);
        // Call the drag callback continously. Don't do anything too intensive
        // in this callback.
        $4609a9aa19959f74$var$getOption(options, 'onDrag', $4609a9aa19959f74$var$NOOP)(getSizes());
    }
    // Cache some important sizes when drag starts, so we don't have to do that
    // continously:
    //
    // `size`: The total size of the pair. First + second + first gutter + second gutter.
    // `start`: The leading side of the first element.
    //
    // ------------------------------------------------
    // |      aGutterSize -> |||                      |
    // |                     |||                      |
    // |                     |||                      |
    // |                     ||| <- bGutterSize       |
    // ------------------------------------------------
    // | <- start                             size -> |
    function calculateSizes() {
        // Figure out the parent size minus padding.
        var a = elements[this.a].element;
        var b = elements[this.b].element;
        var aBounds = a[$4609a9aa19959f74$var$getBoundingClientRect]();
        var bBounds = b[$4609a9aa19959f74$var$getBoundingClientRect]();
        this.size = aBounds[dimension] + bBounds[dimension] + this[$4609a9aa19959f74$var$aGutterSize] + this[$4609a9aa19959f74$var$bGutterSize];
        this.start = aBounds[position];
        this.end = aBounds[positionEnd];
    }
    function innerSize(element) {
        // Return nothing if getComputedStyle is not supported (< IE9)
        // Or if parent element has no layout yet
        if (!getComputedStyle) return null;
        var computedStyle = getComputedStyle(element);
        if (!computedStyle) return null;
        var size = element[clientSize];
        if (size === 0) return null;
        if (direction === $4609a9aa19959f74$var$HORIZONTAL) size -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
        else size -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
        return size;
    }
    // When specifying percentage sizes that are less than the computed
    // size of the element minus the gutter, the lesser percentages must be increased
    // (and decreased from the other elements) to make space for the pixels
    // subtracted by the gutters.
    function trimToMin(sizesToTrim) {
        // Try to get inner size of parent element.
        // If it's no supported, return original sizes.
        var parentSize = innerSize(parent);
        if (parentSize === null) return sizesToTrim;
        if (minSizes.reduce(function(a, b) {
            return a + b;
        }, 0) > parentSize) return sizesToTrim;
        // Keep track of the excess pixels, the amount of pixels over the desired percentage
        // Also keep track of the elements with pixels to spare, to decrease after if needed
        var excessPixels = 0;
        var toSpare = [];
        var pixelSizes = sizesToTrim.map(function(size, i) {
            // Convert requested percentages to pixel sizes
            var pixelSize = parentSize * size / 100;
            var elementGutterSize = $4609a9aa19959f74$var$getGutterSize(gutterSize, i === 0, i === sizesToTrim.length - 1, gutterAlign);
            var elementMinSize = minSizes[i] + elementGutterSize;
            // If element is too smal, increase excess pixels by the difference
            // and mark that it has no pixels to spare
            if (pixelSize < elementMinSize) {
                excessPixels += elementMinSize - pixelSize;
                toSpare.push(0);
                return elementMinSize;
            }
            // Otherwise, mark the pixels it has to spare and return it's original size
            toSpare.push(pixelSize - elementMinSize);
            return pixelSize;
        });
        // If nothing was adjusted, return the original sizes
        if (excessPixels === 0) return sizesToTrim;
        return pixelSizes.map(function(pixelSize, i) {
            var newPixelSize = pixelSize;
            // While there's still pixels to take, and there's enough pixels to spare,
            // take as many as possible up to the total excess pixels
            if (excessPixels > 0 && toSpare[i] - excessPixels > 0) {
                var takenPixels = Math.min(excessPixels, toSpare[i] - excessPixels);
                // Subtract the amount taken for the next iteration
                excessPixels -= takenPixels;
                newPixelSize = pixelSize - takenPixels;
            }
            // Return the pixel size adjusted as a percentage
            return newPixelSize / parentSize * 100;
        });
    }
    // stopDragging is very similar to startDragging in reverse.
    function stopDragging() {
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        if (self.dragging) $4609a9aa19959f74$var$getOption(options, 'onDragEnd', $4609a9aa19959f74$var$NOOP)(getSizes());
        self.dragging = false;
        // Remove the stored event listeners. This is why we store them.
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('mouseup', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchend', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchcancel', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('mousemove', self.move);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$removeEventListener]('touchmove', self.move);
        // Clear bound function references
        self.stop = null;
        self.move = null;
        a[$4609a9aa19959f74$var$removeEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        a[$4609a9aa19959f74$var$removeEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$removeEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$removeEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        a.style.userSelect = '';
        a.style.webkitUserSelect = '';
        a.style.MozUserSelect = '';
        a.style.pointerEvents = '';
        b.style.userSelect = '';
        b.style.webkitUserSelect = '';
        b.style.MozUserSelect = '';
        b.style.pointerEvents = '';
        self.gutter.style.cursor = '';
        self.parent.style.cursor = '';
        $4609a9aa19959f74$var$document.body.style.cursor = '';
    }
    // startDragging calls `calculateSizes` to store the inital size in the pair object.
    // It also adds event listeners for mouse/touch events,
    // and prevents selection while dragging so avoid the selecting text.
    function startDragging(e) {
        // Right-clicking can't start dragging.
        if ('button' in e && e.button !== 0) return;
        // Alias frequently used variables to save space. 200 bytes.
        var self = this;
        var a = elements[self.a].element;
        var b = elements[self.b].element;
        // Call the onDragStart callback.
        if (!self.dragging) $4609a9aa19959f74$var$getOption(options, 'onDragStart', $4609a9aa19959f74$var$NOOP)(getSizes());
        // Don't actually drag the element. We emulate that in the drag function.
        e.preventDefault();
        // Set the dragging property of the pair object.
        self.dragging = true;
        // Create two event listeners bound to the same pair object and store
        // them in the pair object.
        self.move = drag.bind(self);
        self.stop = stopDragging.bind(self);
        // All the binding. `window` gets the stop events in case we drag out of the elements.
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('mouseup', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchend', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchcancel', self.stop);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('mousemove', self.move);
        $4609a9aa19959f74$var$global[$4609a9aa19959f74$var$addEventListener]('touchmove', self.move);
        // Disable selection. Disable!
        a[$4609a9aa19959f74$var$addEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        a[$4609a9aa19959f74$var$addEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$addEventListener]('selectstart', $4609a9aa19959f74$var$NOOP);
        b[$4609a9aa19959f74$var$addEventListener]('dragstart', $4609a9aa19959f74$var$NOOP);
        a.style.userSelect = 'none';
        a.style.webkitUserSelect = 'none';
        a.style.MozUserSelect = 'none';
        a.style.pointerEvents = 'none';
        b.style.userSelect = 'none';
        b.style.webkitUserSelect = 'none';
        b.style.MozUserSelect = 'none';
        b.style.pointerEvents = 'none';
        // Set the cursor at multiple levels
        self.gutter.style.cursor = cursor;
        self.parent.style.cursor = cursor;
        $4609a9aa19959f74$var$document.body.style.cursor = cursor;
        // Cache the initial sizes of the pair.
        calculateSizes.call(self);
        // Determine the position of the mouse compared to the gutter
        self.dragOffset = getMousePosition(e) - self.end;
    }
    // adjust sizes to ensure percentage is within min size and gutter.
    sizes = trimToMin(sizes);
    // 5. Create pair and element objects. Each pair has an index reference to
    // elements `a` and `b` of the pair (first and second elements).
    // Loop through the elements while pairing them off. Every pair gets a
    // `pair` object and a gutter.
    //
    // Basic logic:
    //
    // - Starting with the second element `i > 0`, create `pair` objects with
    //   `a = i - 1` and `b = i`
    // - Set gutter sizes based on the _pair_ being first/last. The first and last
    //   pair have gutterSize / 2, since they only have one half gutter, and not two.
    // - Create gutter elements and add event listeners.
    // - Set the size of the elements, minus the gutter sizes.
    //
    // -----------------------------------------------------------------------
    // |     i=0     |         i=1         |        i=2       |      i=3     |
    // |             |                     |                  |              |
    // |           pair 0                pair 1             pair 2           |
    // |             |                     |                  |              |
    // -----------------------------------------------------------------------
    var pairs = [];
    elements = ids.map(function(id, i) {
        // Create the element object.
        var element = {
            element: $4609a9aa19959f74$var$elementOrSelector(id),
            size: sizes[i],
            minSize: minSizes[i],
            maxSize: maxSizes[i],
            snapOffset: snapOffsets[i],
            i: i
        };
        var pair;
        if (i > 0) {
            // Create the pair object with its metadata.
            pair = {
                a: i - 1,
                b: i,
                dragging: false,
                direction: direction,
                parent: parent
            };
            pair[$4609a9aa19959f74$var$aGutterSize] = $4609a9aa19959f74$var$getGutterSize(gutterSize, i - 1 === 0, false, gutterAlign);
            pair[$4609a9aa19959f74$var$bGutterSize] = $4609a9aa19959f74$var$getGutterSize(gutterSize, false, i === ids.length - 1, gutterAlign);
            // if the parent has a reverse flex-direction, switch the pair elements.
            if (parentFlexDirection === 'row-reverse' || parentFlexDirection === 'column-reverse') {
                var temp = pair.a;
                pair.a = pair.b;
                pair.b = temp;
            }
        }
        // Determine the size of the current element. IE8 is supported by
        // staticly assigning sizes without draggable gutters. Assigns a string
        // to `size`.
        //
        // Create gutter elements for each pair.
        if (i > 0) {
            var gutterElement = gutter(i, direction, element.element);
            setGutterSize(gutterElement, gutterSize, i);
            // Save bound event listener for removal later
            pair[$4609a9aa19959f74$var$gutterStartDragging] = startDragging.bind(pair);
            // Attach bound event listener
            gutterElement[$4609a9aa19959f74$var$addEventListener]('mousedown', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            gutterElement[$4609a9aa19959f74$var$addEventListener]('touchstart', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            parent.insertBefore(gutterElement, element.element);
            pair.gutter = gutterElement;
        }
        setElementSize(element.element, element.size, $4609a9aa19959f74$var$getGutterSize(gutterSize, i === 0, i === ids.length - 1, gutterAlign), i);
        // After the first iteration, and we have a pair object, append it to the
        // list of pairs.
        if (i > 0) pairs.push(pair);
        return element;
    });
    function adjustToMin(element) {
        var isLast = element.i === pairs.length;
        var pair = isLast ? pairs[element.i - 1] : pairs[element.i];
        calculateSizes.call(pair);
        var size = isLast ? pair.size - element.minSize - pair[$4609a9aa19959f74$var$bGutterSize] : element.minSize + pair[$4609a9aa19959f74$var$aGutterSize];
        adjust.call(pair, size);
    }
    elements.forEach(function(element) {
        var computedSize = element.element[$4609a9aa19959f74$var$getBoundingClientRect]()[dimension];
        if (computedSize < element.minSize) {
            if (expandToMin) adjustToMin(element);
            else // eslint-disable-next-line no-param-reassign
            element.minSize = computedSize;
        }
    });
    function setSizes(newSizes) {
        var trimmed = trimToMin(newSizes);
        trimmed.forEach(function(newSize, i) {
            if (i > 0) {
                var pair = pairs[i - 1];
                var a = elements[pair.a];
                var b = elements[pair.b];
                a.size = trimmed[i - 1];
                b.size = newSize;
                setElementSize(a.element, a.size, pair[$4609a9aa19959f74$var$aGutterSize], a.i);
                setElementSize(b.element, b.size, pair[$4609a9aa19959f74$var$bGutterSize], b.i);
            }
        });
    }
    function destroy(preserveStyles, preserveGutter) {
        pairs.forEach(function(pair) {
            if (preserveGutter !== true) pair.parent.removeChild(pair.gutter);
            else {
                pair.gutter[$4609a9aa19959f74$var$removeEventListener]('mousedown', pair[$4609a9aa19959f74$var$gutterStartDragging]);
                pair.gutter[$4609a9aa19959f74$var$removeEventListener]('touchstart', pair[$4609a9aa19959f74$var$gutterStartDragging]);
            }
            if (preserveStyles !== true) {
                var style = elementStyle(dimension, pair.a.size, pair[$4609a9aa19959f74$var$aGutterSize]);
                Object.keys(style).forEach(function(prop) {
                    elements[pair.a].element.style[prop] = '';
                    elements[pair.b].element.style[prop] = '';
                });
            }
        });
    }
    return {
        setSizes: setSizes,
        getSizes: getSizes,
        collapse: function collapse(i) {
            adjustToMin(elements[i]);
        },
        destroy: destroy,
        parent: parent,
        pairs: pairs
    };
};
var $4609a9aa19959f74$export$2e2bcd8739ae039 = $4609a9aa19959f74$var$Split;

});

parcelRegister("iiLdM", function(module, exports) {
/**
* Generate unique and beautiful colors from any texts or numbers
 * @version v1.1.1
 * @link https://github.com/dastoori/uniqolor#README
 * @author Rasool Dastoori
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var SATURATION_BOUND = [
        0,
        100
    ];
    var LIGHTNESS_BOUND = [
        0,
        100
    ];
    var pad2 = function pad2(str) {
        return "".concat(str.length === 1 ? '0' : '').concat(str);
    };
    var clamp = function clamp(num, min, max) {
        return Math.max(Math.min(num, max), min);
    };
    var random = function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var randomExclude = function randomExclude(min, max, exclude) {
        var r = random(min, max);
        for(var i = 0; i < (exclude === null || exclude === void 0 ? void 0 : exclude.length); i++){
            var value = exclude[i];
            if ((value === null || value === void 0 ? void 0 : value.length) === 2 && r >= value[0] && r <= value[1]) return randomExclude(min, max, exclude);
        }
        return r;
    };
    /**
   * Generate hashCode
   * @param  {string} str
   * @return {number}
   */ var hashCode = function hashCode(str) {
        var len = str.length;
        var hash = 0;
        for(var i = 0; i < len; i++){
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash &= hash; // Convert to 32bit integer
        }
        return hash;
    };
    /**
  * Clamps `num` within the inclusive `range` bounds
  * @param  {number}       num
  * @param  {number|Array} range
  * @return {number}
  */ var boundHashCode = function boundHashCode(num, range) {
        if (typeof range === 'number') return range;
        return num % Math.abs(range[1] - range[0]) + range[0];
    };
    /**
   * Sanitizing the `range`
   * @param  {number|Array} range
   * @param  {Array}        bound
   * @return {number|Array}
   */ var sanitizeRange = function sanitizeRange(range, bound) {
        if (typeof range === 'number') return clamp.apply(void 0, [
            Math.abs(range)
        ].concat(_toConsumableArray(bound)));
        if (range.length === 1 || range[0] === range[1]) return clamp.apply(void 0, [
            Math.abs(range[0])
        ].concat(_toConsumableArray(bound)));
        return [
            Math.abs(clamp.apply(void 0, [
                range[0]
            ].concat(_toConsumableArray(bound)))),
            clamp.apply(void 0, [
                Math.abs(range[1])
            ].concat(_toConsumableArray(bound)))
        ];
    };
    /**
   * @param  {number} p
   * @param  {number} q
   * @param  {number} t
   * @return {number}
   */ var hueToRgb = function hueToRgb(p, q, t) {
        if (t < 0) t += 1;
        else if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    };
    /**
   * Converts an HSL color to RGB
   * @param  {number} h Hue
   * @param  {number} s Saturation
   * @param  {number} l Lightness
   * @return {Array}
   */ var hslToRgb = function hslToRgb(h, s, l) {
        var r;
        var g;
        var b;
        h /= 360;
        s /= 100;
        l /= 100;
        if (s === 0) // achromatic
        r = g = b = l;
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hueToRgb(p, q, h + 1 / 3);
            g = hueToRgb(p, q, h);
            b = hueToRgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255)
        ];
    };
    /**
   * Determines whether the RGB color is light or not
   * http://www.w3.org/TR/AERT#color-contrast
   * @param  {number}  r               Red
   * @param  {number}  g               Green
   * @param  {number}  b               Blue
   * @param  {number}  differencePoint
   * @return {boolean}
   */ var rgbIsLight = function rgbIsLight(r, g, b, differencePoint) {
        return (r * 299 + g * 587 + b * 114) / 1000 >= differencePoint;
    }; // eslint-disable-line max-len
    /**
   * Converts an HSL color to string format
   * @param  {number} h Hue
   * @param  {number} s Saturation
   * @param  {number} l Lightness
   * @return {string}
   */ var hslToString = function hslToString(h, s, l) {
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
    };
    /**
   * Converts RGB color to string format
   * @param  {number}  r      Red
   * @param  {number}  g      Green
   * @param  {number}  b      Blue
   * @param  {string}  format Color format
   * @return {string}
   */ var rgbFormat = function rgbFormat(r, g, b, format) {
        switch(format){
            case 'rgb':
                return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
            case 'hex':
            default:
                return "#".concat(pad2(r.toString(16))).concat(pad2(g.toString(16))).concat(pad2(b.toString(16)));
        }
    };
    /**
   * Generate unique color from `value`
   * @param  {string|number} value
   * @param  {Object}        [options={}]
   * @param  {string}        [options.format='hex']
   *  The color format, it can be one of `hex`, `rgb` or `hsl`
   * @param  {number|Array}  [options.saturation=[50, 55]]
   *  Determines the color saturation, it can be a number or a range between 0 and 100
   * @param  {number|Array}  [options.lightness=[50, 60]]
   *  Determines the color lightness, it can be a number or a range between 0 and 100
   * @param  {number}        [options.differencePoint=130]
   *  Determines the color brightness difference point. We use it to obtain the `isLight` value
   *  in the output, it can be a number between 0 and 255
   * @return {Object}
   * @example
   *
   * ```js
   * uniqolor('Hello world!')
   * // { color: "#5cc653", isLight: true }
   *
   * uniqolor('Hello world!', { format: 'rgb' })
   * // { color: "rgb(92, 198, 83)", isLight: true }
   *
   * uniqolor('Hello world!', {
   *   saturation: 30,
   *   lightness: [70, 80],
   * })
   * // { color: "#afd2ac", isLight: true }
   *
   * uniqolor('Hello world!', {
   *   saturation: 30,
   *   lightness: [70, 80],
   *   differencePoint: 200,
   * })
   * // { color: "#afd2ac", isLight: false }
   * ```
   */ var uniqolor = function uniqolor(value) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$format = _ref.format, format = _ref$format === void 0 ? 'hex' : _ref$format, _ref$saturation = _ref.saturation, saturation = _ref$saturation === void 0 ? [
            50,
            55
        ] : _ref$saturation, _ref$lightness = _ref.lightness, lightness = _ref$lightness === void 0 ? [
            50,
            60
        ] : _ref$lightness, _ref$differencePoint = _ref.differencePoint, differencePoint = _ref$differencePoint === void 0 ? 130 : _ref$differencePoint;
        var hash = Math.abs(hashCode(String(value)));
        var h = boundHashCode(hash, [
            0,
            360
        ]);
        var s = boundHashCode(hash, sanitizeRange(saturation, SATURATION_BOUND));
        var l = boundHashCode(hash, sanitizeRange(lightness, LIGHTNESS_BOUND));
        var _hslToRgb = hslToRgb(h, s, l), _hslToRgb2 = _slicedToArray(_hslToRgb, 3), r = _hslToRgb2[0], g = _hslToRgb2[1], b = _hslToRgb2[2];
        return {
            color: format === 'hsl' ? hslToString(h, s, l) : rgbFormat(r, g, b, format),
            isLight: rgbIsLight(r, g, b, differencePoint)
        };
    };
    /**
   * Generate random color
   * @param  {Object}       [options={}]
   * @param  {string}       [options.format='hex']
   *  The color format, it can be one of `hex`, `rgb` or `hsl`
   * @param  {number|Array} [options.saturation=[50, 55]]
   *  Determines the color saturation, it can be a number or a range between 0 and 100
   * @param  {number|Array} [options.lightness=[50, 60]]
   *  Determines the color lightness, it can be a number or a range between 0 and 100
   * @param  {number}       [options.differencePoint=130]
   *  Determines the color brightness difference point. We use it to obtain the `isLight` value
   *  in the output, it can be a number between 0 and 255
   * @param  {Array}        [options.excludeHue]
   *  Exclude certain hue ranges. For example to exclude red color range: `[[0, 20], [325, 359]]`
   * @return {Object}
   * @example
   *
   * ```js
   * // Generate random color
   * uniqolor.random()
   * // { color: "#644cc8", isLight: false }
   *
   * // Generate a random color with HSL format
   * uniqolor.random({ format: 'hsl' })
   * // { color: "hsl(89, 55%, 60%)", isLight: true }
   *
   * // Generate a random color in specific saturation and lightness
   * uniqolor.random({
   *   saturation: 80,
   *   lightness: [70, 80],
   * })
   * // { color: "#c7b9da", isLight: true }
   *
   * // Generate a random color but exclude red color range
   * uniqolor.random({
   *   excludeHue: [[0, 20], [325, 359]],
   * })
   * // {color: '#53caab', isLight: true}
   * ```
   */ uniqolor.random = function() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$format = _ref2.format, format = _ref2$format === void 0 ? 'hex' : _ref2$format, _ref2$saturation = _ref2.saturation, saturation = _ref2$saturation === void 0 ? [
            50,
            55
        ] : _ref2$saturation, _ref2$lightness = _ref2.lightness, lightness = _ref2$lightness === void 0 ? [
            50,
            60
        ] : _ref2$lightness, _ref2$differencePoint = _ref2.differencePoint, differencePoint = _ref2$differencePoint === void 0 ? 130 : _ref2$differencePoint, excludeHue = _ref2.excludeHue;
        saturation = sanitizeRange(saturation, SATURATION_BOUND);
        lightness = sanitizeRange(lightness, LIGHTNESS_BOUND);
        var h = excludeHue ? randomExclude(0, 359, excludeHue) : random(0, 359);
        var s = typeof saturation === 'number' ? saturation : random.apply(void 0, _toConsumableArray(saturation));
        var l = typeof lightness === 'number' ? lightness : random.apply(void 0, _toConsumableArray(lightness));
        var _hslToRgb3 = hslToRgb(h, s, l), _hslToRgb4 = _slicedToArray(_hslToRgb3, 3), r = _hslToRgb4[0], g = _hslToRgb4[1], b = _hslToRgb4[2];
        return {
            color: format === 'hsl' ? hslToString(h, s, l) : rgbFormat(r, g, b, format),
            isLight: rgbIsLight(r, g, b, differencePoint)
        };
    };
    return uniqolor;
});

});


parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

//import Chart from "./node_modules/chart.js/auto";
//import { Chart } from "chart.js/auto";
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $5e534ae1a972f4ab$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $5e534ae1a972f4ab$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $5e534ae1a972f4ab$export$bcc6e673dfa14d36(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $5e534ae1a972f4ab$export$869b26d4e1bbdb63(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $5e534ae1a972f4ab$export$dbf961a8d278dbef(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $5e534ae1a972f4ab$export$aa35ef1f24408ab9(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $5e534ae1a972f4ab$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $5e534ae1a972f4ab$var$hex = [
    ...'0123456789ABCDEF'
];
const $5e534ae1a972f4ab$var$h1 = (b)=>$5e534ae1a972f4ab$var$hex[b & 0xF];
const $5e534ae1a972f4ab$var$h2 = (b)=>$5e534ae1a972f4ab$var$hex[(b & 0xF0) >> 4] + $5e534ae1a972f4ab$var$hex[b & 0xF];
const $5e534ae1a972f4ab$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $5e534ae1a972f4ab$var$isShort = (v)=>$5e534ae1a972f4ab$var$eq(v.r) && $5e534ae1a972f4ab$var$eq(v.g) && $5e534ae1a972f4ab$var$eq(v.b) && $5e534ae1a972f4ab$var$eq(v.a);
function $5e534ae1a972f4ab$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $5e534ae1a972f4ab$var$map$1[str[1]] * 17,
            g: 255 & $5e534ae1a972f4ab$var$map$1[str[2]] * 17,
            b: 255 & $5e534ae1a972f4ab$var$map$1[str[3]] * 17,
            a: len === 5 ? $5e534ae1a972f4ab$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $5e534ae1a972f4ab$var$map$1[str[1]] << 4 | $5e534ae1a972f4ab$var$map$1[str[2]],
            g: $5e534ae1a972f4ab$var$map$1[str[3]] << 4 | $5e534ae1a972f4ab$var$map$1[str[4]],
            b: $5e534ae1a972f4ab$var$map$1[str[5]] << 4 | $5e534ae1a972f4ab$var$map$1[str[6]],
            a: len === 9 ? $5e534ae1a972f4ab$var$map$1[str[7]] << 4 | $5e534ae1a972f4ab$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $5e534ae1a972f4ab$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $5e534ae1a972f4ab$export$1b06654353ef9f67(v) {
    var f = $5e534ae1a972f4ab$var$isShort(v) ? $5e534ae1a972f4ab$var$h1 : $5e534ae1a972f4ab$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $5e534ae1a972f4ab$var$alpha(v.a, f) : undefined;
}
const $5e534ae1a972f4ab$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5e534ae1a972f4ab$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $5e534ae1a972f4ab$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $5e534ae1a972f4ab$var$hwb2rgbn(h, w, b) {
    const rgb = $5e534ae1a972f4ab$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $5e534ae1a972f4ab$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $5e534ae1a972f4ab$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $5e534ae1a972f4ab$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($5e534ae1a972f4ab$export$ed9bd8dcaeba14f6);
}
function $5e534ae1a972f4ab$export$4c15bd42559b811d(h, s, l) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hsl2rgbn, h, s, l);
}
function $5e534ae1a972f4ab$export$e2710022c70fc9ee(h, w, b) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hwb2rgbn, h, w, b);
}
function $5e534ae1a972f4ab$export$b785a357c84e4a04(h, s, v) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hsv2rgbn, h, s, v);
}
function $5e534ae1a972f4ab$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $5e534ae1a972f4ab$export$5e91288c399be4f9(str) {
    const m = $5e534ae1a972f4ab$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(+m[5]) : $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $5e534ae1a972f4ab$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $5e534ae1a972f4ab$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $5e534ae1a972f4ab$export$b785a357c84e4a04(h, p1, p2);
    else v = $5e534ae1a972f4ab$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $5e534ae1a972f4ab$export$bb628a54ab399bc9(v, deg) {
    var h = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
    h[0] = $5e534ae1a972f4ab$var$hue(h[0] + deg);
    h = $5e534ae1a972f4ab$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $5e534ae1a972f4ab$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $5e534ae1a972f4ab$export$aa35ef1f24408ab9(a[1]);
    const l = $5e534ae1a972f4ab$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $5e534ae1a972f4ab$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $5e534ae1a972f4ab$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $5e534ae1a972f4ab$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($5e534ae1a972f4ab$var$names$1);
    const tkeys = Object.keys($5e534ae1a972f4ab$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $5e534ae1a972f4ab$var$map[k]);
        }
        k = parseInt($5e534ae1a972f4ab$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $5e534ae1a972f4ab$var$names;
function $5e534ae1a972f4ab$export$b2f06b640faad956(str) {
    if (!$5e534ae1a972f4ab$var$names) {
        $5e534ae1a972f4ab$var$names = $5e534ae1a972f4ab$var$unpack();
        $5e534ae1a972f4ab$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $5e534ae1a972f4ab$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $5e534ae1a972f4ab$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5e534ae1a972f4ab$export$91aedb20f296e541(str) {
    const m = $5e534ae1a972f4ab$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(v) : $5e534ae1a972f4ab$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(r) : $5e534ae1a972f4ab$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(g) : $5e534ae1a972f4ab$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(b) : $5e534ae1a972f4ab$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $5e534ae1a972f4ab$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $5e534ae1a972f4ab$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $5e534ae1a972f4ab$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $5e534ae1a972f4ab$var$interpolate(rgb1, rgb2, t) {
    const r = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.r));
    const g = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.g));
    const b = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(r + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(g + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(b + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $5e534ae1a972f4ab$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $5e534ae1a972f4ab$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $5e534ae1a972f4ab$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $5e534ae1a972f4ab$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $5e534ae1a972f4ab$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $5e534ae1a972f4ab$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $5e534ae1a972f4ab$export$91aedb20f296e541(str);
    return $5e534ae1a972f4ab$export$5e91288c399be4f9(str);
}
class $5e534ae1a972f4ab$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $5e534ae1a972f4ab$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $5e534ae1a972f4ab$var$fromObject(input);
        else if (type === 'string') v = $5e534ae1a972f4ab$export$625a38b961e8b5e9(input) || $5e534ae1a972f4ab$export$b2f06b640faad956(input) || $5e534ae1a972f4ab$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $5e534ae1a972f4ab$var$clone(this._rgb);
        if (v) v.a = $5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $5e534ae1a972f4ab$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $5e534ae1a972f4ab$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $5e534ae1a972f4ab$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $5e534ae1a972f4ab$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $5e534ae1a972f4ab$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $5e534ae1a972f4ab$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $5e534ae1a972f4ab$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $5e534ae1a972f4ab$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $5e534ae1a972f4ab$export$2e2bcd8739ae039(input) {
    return new $5e534ae1a972f4ab$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $fcad3ca699dd0b9d$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $fcad3ca699dd0b9d$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $fcad3ca699dd0b9d$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $fcad3ca699dd0b9d$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $fcad3ca699dd0b9d$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $fcad3ca699dd0b9d$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $fcad3ca699dd0b9d$export$c4ce752e73470fba(value, defaultValue) {
    return $fcad3ca699dd0b9d$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $fcad3ca699dd0b9d$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $fcad3ca699dd0b9d$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $fcad3ca699dd0b9d$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $fcad3ca699dd0b9d$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $fcad3ca699dd0b9d$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($fcad3ca699dd0b9d$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $fcad3ca699dd0b9d$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $fcad3ca699dd0b9d$export$d377dcb2b61d6c4e(source) {
    if ($fcad3ca699dd0b9d$export$8b22cf2602fb60ce(source)) return source.map($fcad3ca699dd0b9d$export$d377dcb2b61d6c4e);
    if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $fcad3ca699dd0b9d$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $fcad3ca699dd0b9d$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $fcad3ca699dd0b9d$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$fcad3ca699dd0b9d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(tval) && $fcad3ca699dd0b9d$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $fcad3ca699dd0b9d$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $fcad3ca699dd0b9d$export$d377dcb2b61d6c4e(sval);
}
function $fcad3ca699dd0b9d$export$efca4cbe5dd06740(target, source, options) {
    const sources = $fcad3ca699dd0b9d$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$fcad3ca699dd0b9d$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $fcad3ca699dd0b9d$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$fcad3ca699dd0b9d$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $fcad3ca699dd0b9d$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $fcad3ca699dd0b9d$export$efca4cbe5dd06740(target, source, {
        merger: $fcad3ca699dd0b9d$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $fcad3ca699dd0b9d$export$317a3d46287192d8(key, target, source) {
    if (!$fcad3ca699dd0b9d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(tval) && $fcad3ca699dd0b9d$export$23f2a1d2818174ef(sval)) $fcad3ca699dd0b9d$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $fcad3ca699dd0b9d$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $fcad3ca699dd0b9d$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$9d0e2d13d04f7070(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $fcad3ca699dd0b9d$var$_getKeyResolver(key) {
    const keys = $fcad3ca699dd0b9d$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $fcad3ca699dd0b9d$export$2d1720544b23b823(obj, key) {
    const resolver = $fcad3ca699dd0b9d$var$keyResolvers[key] || ($fcad3ca699dd0b9d$var$keyResolvers[key] = $fcad3ca699dd0b9d$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $fcad3ca699dd0b9d$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $fcad3ca699dd0b9d$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $fcad3ca699dd0b9d$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $fcad3ca699dd0b9d$export$f38c853ae54ed474(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $fcad3ca699dd0b9d$export$56c0d5a1e737357d = Math.PI;
const $fcad3ca699dd0b9d$export$971d5caa766a69d7 = 2 * $fcad3ca699dd0b9d$export$56c0d5a1e737357d;
const $fcad3ca699dd0b9d$export$d29e374196577086 = $fcad3ca699dd0b9d$export$971d5caa766a69d7 + $fcad3ca699dd0b9d$export$56c0d5a1e737357d;
const $fcad3ca699dd0b9d$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $fcad3ca699dd0b9d$export$53c86fa97d611818 = $fcad3ca699dd0b9d$export$56c0d5a1e737357d / 180;
const $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd = $fcad3ca699dd0b9d$export$56c0d5a1e737357d / 2;
const $fcad3ca699dd0b9d$export$39c1cc7c062529d4 = $fcad3ca699dd0b9d$export$56c0d5a1e737357d / 4;
const $fcad3ca699dd0b9d$export$7a0bdf7d4a91ea88 = $fcad3ca699dd0b9d$export$56c0d5a1e737357d * 2 / 3;
const $fcad3ca699dd0b9d$export$9f4f30ee63539e24 = Math.log10;
const $fcad3ca699dd0b9d$export$2408f22a0fab9ae5 = Math.sign;
function $fcad3ca699dd0b9d$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $fcad3ca699dd0b9d$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $fcad3ca699dd0b9d$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($fcad3ca699dd0b9d$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $fcad3ca699dd0b9d$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $fcad3ca699dd0b9d$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $fcad3ca699dd0b9d$export$d141bba7fdc215a3(n) {
    return !$fcad3ca699dd0b9d$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $fcad3ca699dd0b9d$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $fcad3ca699dd0b9d$export$625550452a3fa3ec(degrees) {
    return degrees * ($fcad3ca699dd0b9d$export$56c0d5a1e737357d / 180);
}
function $fcad3ca699dd0b9d$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $fcad3ca699dd0b9d$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $fcad3ca699dd0b9d$export$23ebac1979863676(x) {
    if (!$fcad3ca699dd0b9d$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $fcad3ca699dd0b9d$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $fcad3ca699dd0b9d$export$56c0d5a1e737357d) angle += $fcad3ca699dd0b9d$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $fcad3ca699dd0b9d$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $fcad3ca699dd0b9d$export$c18d01048907ea92(a, b) {
    return (a - b + $fcad3ca699dd0b9d$export$d29e374196577086) % $fcad3ca699dd0b9d$export$971d5caa766a69d7 - $fcad3ca699dd0b9d$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $fcad3ca699dd0b9d$export$28f7fcd39efa255(a) {
    return (a % $fcad3ca699dd0b9d$export$971d5caa766a69d7 + $fcad3ca699dd0b9d$export$971d5caa766a69d7) % $fcad3ca699dd0b9d$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $fcad3ca699dd0b9d$export$28f7fcd39efa255(angle);
    const s = $fcad3ca699dd0b9d$export$28f7fcd39efa255(start);
    const e = $fcad3ca699dd0b9d$export$28f7fcd39efa255(end);
    const angleToStart = $fcad3ca699dd0b9d$export$28f7fcd39efa255(s - a);
    const angleToEnd = $fcad3ca699dd0b9d$export$28f7fcd39efa255(e - a);
    const startToAngle = $fcad3ca699dd0b9d$export$28f7fcd39efa255(a - s);
    const endToAngle = $fcad3ca699dd0b9d$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $fcad3ca699dd0b9d$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $fcad3ca699dd0b9d$export$71cec2538cb2c617(value) {
    return $fcad3ca699dd0b9d$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $fcad3ca699dd0b9d$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $fcad3ca699dd0b9d$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $fcad3ca699dd0b9d$export$ef35774e6d314e91 = (table, key, value, last)=>$fcad3ca699dd0b9d$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $fcad3ca699dd0b9d$export$ebd11618f299a286 = (table, key, value)=>$fcad3ca699dd0b9d$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $fcad3ca699dd0b9d$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $fcad3ca699dd0b9d$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $fcad3ca699dd0b9d$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $fcad3ca699dd0b9d$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $fcad3ca699dd0b9d$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $fcad3ca699dd0b9d$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $fcad3ca699dd0b9d$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $fcad3ca699dd0b9d$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $fcad3ca699dd0b9d$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $fcad3ca699dd0b9d$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $fcad3ca699dd0b9d$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $fcad3ca699dd0b9d$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $fcad3ca699dd0b9d$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $fcad3ca699dd0b9d$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $fcad3ca699dd0b9d$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $fcad3ca699dd0b9d$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $fcad3ca699dd0b9d$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($fcad3ca699dd0b9d$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $fcad3ca699dd0b9d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$fcad3ca699dd0b9d$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $fcad3ca699dd0b9d$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($fcad3ca699dd0b9d$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $fcad3ca699dd0b9d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$fcad3ca699dd0b9d$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $fcad3ca699dd0b9d$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $fcad3ca699dd0b9d$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $fcad3ca699dd0b9d$var$atEdge = (t)=>t === 0 || t === 1;
const $fcad3ca699dd0b9d$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $fcad3ca699dd0b9d$export$971d5caa766a69d7 / p));
const $fcad3ca699dd0b9d$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $fcad3ca699dd0b9d$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $fcad3ca699dd0b9d$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($fcad3ca699dd0b9d$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$fcad3ca699dd0b9d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$fcad3ca699dd0b9d$var$atEdge(t) ? t : $fcad3ca699dd0b9d$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$fcad3ca699dd0b9d$var$atEdge(t) ? t : $fcad3ca699dd0b9d$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $fcad3ca699dd0b9d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $fcad3ca699dd0b9d$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $fcad3ca699dd0b9d$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $fcad3ca699dd0b9d$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $fcad3ca699dd0b9d$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $fcad3ca699dd0b9d$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $fcad3ca699dd0b9d$export$f96d196f7728bb5(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $fcad3ca699dd0b9d$export$db3b6bfb95261072(value) {
    return $fcad3ca699dd0b9d$export$f96d196f7728bb5(value) ? value : new (0, $5e534ae1a972f4ab$export$892596cec99bc70e)(value);
}
function $fcad3ca699dd0b9d$export$738ab4df8bf92ae9(value) {
    return $fcad3ca699dd0b9d$export$f96d196f7728bb5(value) ? value : new (0, $5e534ae1a972f4ab$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $fcad3ca699dd0b9d$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $fcad3ca699dd0b9d$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $fcad3ca699dd0b9d$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $fcad3ca699dd0b9d$var$colors
        },
        numbers: {
            type: 'number',
            properties: $fcad3ca699dd0b9d$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $fcad3ca699dd0b9d$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $fcad3ca699dd0b9d$var$intlCache = new Map();
function $fcad3ca699dd0b9d$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $fcad3ca699dd0b9d$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $fcad3ca699dd0b9d$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $fcad3ca699dd0b9d$export$ae1af26003f05816(num, locale, options) {
    return $fcad3ca699dd0b9d$var$getNumberFormat(locale, options).format(num);
}
const $fcad3ca699dd0b9d$var$formatters = {
    values (value) {
        return $fcad3ca699dd0b9d$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $fcad3ca699dd0b9d$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $fcad3ca699dd0b9d$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $fcad3ca699dd0b9d$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($fcad3ca699dd0b9d$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $fcad3ca699dd0b9d$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $fcad3ca699dd0b9d$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $fcad3ca699dd0b9d$export$91477dc880baac21 = {
    formatters: $fcad3ca699dd0b9d$var$formatters
};
function $fcad3ca699dd0b9d$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $fcad3ca699dd0b9d$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $fcad3ca699dd0b9d$export$6559d589eb85fbb6 = Object.create(null);
const $fcad3ca699dd0b9d$export$2e2af4578d910ddf = Object.create(null);
function $fcad3ca699dd0b9d$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $fcad3ca699dd0b9d$var$set(root, scope, values) {
    if (typeof scope === 'string') return $fcad3ca699dd0b9d$export$efca4cbe5dd06740($fcad3ca699dd0b9d$var$getScope$1(root, scope), values);
    return $fcad3ca699dd0b9d$export$efca4cbe5dd06740($fcad3ca699dd0b9d$var$getScope$1(root, ''), scope);
}
class $fcad3ca699dd0b9d$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$fcad3ca699dd0b9d$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$fcad3ca699dd0b9d$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$fcad3ca699dd0b9d$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $fcad3ca699dd0b9d$var$set(this, scope, values);
    }
    get(scope) {
        return $fcad3ca699dd0b9d$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $fcad3ca699dd0b9d$var$set($fcad3ca699dd0b9d$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $fcad3ca699dd0b9d$var$set($fcad3ca699dd0b9d$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $fcad3ca699dd0b9d$var$getScope$1(this, scope);
        const targetScopeObject = $fcad3ca699dd0b9d$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $fcad3ca699dd0b9d$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $fcad3ca699dd0b9d$export$4368d992c4eafac0 = /* #__PURE__ */ new $fcad3ca699dd0b9d$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $fcad3ca699dd0b9d$var$applyAnimationsDefaults,
    $fcad3ca699dd0b9d$var$applyLayoutsDefaults,
    $fcad3ca699dd0b9d$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $fcad3ca699dd0b9d$export$1a8f5705751d8277(font) {
    if (!font || $fcad3ca699dd0b9d$export$342063e11d6c3cad(font.size) || $fcad3ca699dd0b9d$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $fcad3ca699dd0b9d$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$fcad3ca699dd0b9d$export$8b22cf2602fb60ce(thing)) longest = $fcad3ca699dd0b9d$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($fcad3ca699dd0b9d$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$fcad3ca699dd0b9d$export$8b22cf2602fb60ce(nestedThing)) longest = $fcad3ca699dd0b9d$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $fcad3ca699dd0b9d$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $fcad3ca699dd0b9d$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $fcad3ca699dd0b9d$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $fcad3ca699dd0b9d$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $fcad3ca699dd0b9d$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $fcad3ca699dd0b9d$export$53c86fa97d611818;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $fcad3ca699dd0b9d$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $fcad3ca699dd0b9d$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $fcad3ca699dd0b9d$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $fcad3ca699dd0b9d$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $fcad3ca699dd0b9d$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $fcad3ca699dd0b9d$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $fcad3ca699dd0b9d$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $fcad3ca699dd0b9d$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $fcad3ca699dd0b9d$export$56c0d5a1e737357d, rad - $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd, rad + $fcad3ca699dd0b9d$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $fcad3ca699dd0b9d$export$39c1cc7c062529d4;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $fcad3ca699dd0b9d$export$39c1cc7c062529d4;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $fcad3ca699dd0b9d$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $fcad3ca699dd0b9d$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $fcad3ca699dd0b9d$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $fcad3ca699dd0b9d$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $fcad3ca699dd0b9d$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$fcad3ca699dd0b9d$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $fcad3ca699dd0b9d$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $fcad3ca699dd0b9d$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $fcad3ca699dd0b9d$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $fcad3ca699dd0b9d$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $fcad3ca699dd0b9d$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $fcad3ca699dd0b9d$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$fcad3ca699dd0b9d$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $fcad3ca699dd0b9d$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $fcad3ca699dd0b9d$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $fcad3ca699dd0b9d$export$56c0d5a1e737357d, $fcad3ca699dd0b9d$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $fcad3ca699dd0b9d$export$56c0d5a1e737357d, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $fcad3ca699dd0b9d$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $fcad3ca699dd0b9d$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $fcad3ca699dd0b9d$export$8c78c7c36408ea29(value, size) {
    const matches = ('' + value).match($fcad3ca699dd0b9d$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $fcad3ca699dd0b9d$var$numberOrZero = (v)=>+v || 0;
function $fcad3ca699dd0b9d$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $fcad3ca699dd0b9d$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $fcad3ca699dd0b9d$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$fcad3ca699dd0b9d$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $fcad3ca699dd0b9d$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $fcad3ca699dd0b9d$export$d66dc83d8cfc8dd(value) {
    return $fcad3ca699dd0b9d$export$21579262ef46735b(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $fcad3ca699dd0b9d$export$92108d983e8ee699(value) {
    return $fcad3ca699dd0b9d$export$21579262ef46735b(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca(value) {
    const obj = $fcad3ca699dd0b9d$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $fcad3ca699dd0b9d$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $fcad3ca699dd0b9d$export$4368d992c4eafac0.font;
    let size = $fcad3ca699dd0b9d$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $fcad3ca699dd0b9d$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($fcad3ca699dd0b9d$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $fcad3ca699dd0b9d$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $fcad3ca699dd0b9d$export$8c78c7c36408ea29($fcad3ca699dd0b9d$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $fcad3ca699dd0b9d$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $fcad3ca699dd0b9d$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $fcad3ca699dd0b9d$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $fcad3ca699dd0b9d$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $fcad3ca699dd0b9d$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $fcad3ca699dd0b9d$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $fcad3ca699dd0b9d$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $fcad3ca699dd0b9d$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $fcad3ca699dd0b9d$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$fcad3ca699dd0b9d$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $fcad3ca699dd0b9d$var$_cached(target, prop, ()=>$fcad3ca699dd0b9d$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $fcad3ca699dd0b9d$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $fcad3ca699dd0b9d$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $fcad3ca699dd0b9d$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $fcad3ca699dd0b9d$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$fcad3ca699dd0b9d$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$fcad3ca699dd0b9d$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $fcad3ca699dd0b9d$var$_cached(target, prop, ()=>$fcad3ca699dd0b9d$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $fcad3ca699dd0b9d$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $fcad3ca699dd0b9d$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $fcad3ca699dd0b9d$var$readKey = (prefix, name)=>prefix ? prefix + $fcad3ca699dd0b9d$export$a8550f7dbe79f93a(name) : name;
const $fcad3ca699dd0b9d$var$needsSubResolver = (prop, value)=>$fcad3ca699dd0b9d$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $fcad3ca699dd0b9d$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $fcad3ca699dd0b9d$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($fcad3ca699dd0b9d$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $fcad3ca699dd0b9d$var$_resolveScriptable(prop, value, target, receiver);
    if ($fcad3ca699dd0b9d$export$8b22cf2602fb60ce(value) && value.length) value = $fcad3ca699dd0b9d$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($fcad3ca699dd0b9d$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $fcad3ca699dd0b9d$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $fcad3ca699dd0b9d$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($fcad3ca699dd0b9d$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $fcad3ca699dd0b9d$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $fcad3ca699dd0b9d$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($fcad3ca699dd0b9d$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $fcad3ca699dd0b9d$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($fcad3ca699dd0b9d$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $fcad3ca699dd0b9d$var$resolveFallback(fallback, prop, value) {
    return $fcad3ca699dd0b9d$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $fcad3ca699dd0b9d$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $fcad3ca699dd0b9d$export$2d1720544b23b823(parent, key) : undefined;
function $fcad3ca699dd0b9d$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $fcad3ca699dd0b9d$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $fcad3ca699dd0b9d$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $fcad3ca699dd0b9d$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $fcad3ca699dd0b9d$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $fcad3ca699dd0b9d$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $fcad3ca699dd0b9d$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $fcad3ca699dd0b9d$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$fcad3ca699dd0b9d$var$subGetTarget(resolver, prop, value));
}
function $fcad3ca699dd0b9d$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $fcad3ca699dd0b9d$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $fcad3ca699dd0b9d$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($fcad3ca699dd0b9d$export$8b22cf2602fb60ce(target) && $fcad3ca699dd0b9d$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $fcad3ca699dd0b9d$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $fcad3ca699dd0b9d$var$_resolve($fcad3ca699dd0b9d$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $fcad3ca699dd0b9d$var$needsSubResolver(prop, value) ? $fcad3ca699dd0b9d$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $fcad3ca699dd0b9d$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $fcad3ca699dd0b9d$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $fcad3ca699dd0b9d$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $fcad3ca699dd0b9d$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $fcad3ca699dd0b9d$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($fcad3ca699dd0b9d$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $fcad3ca699dd0b9d$var$EPSILON = Number.EPSILON || 1e-14;
const $fcad3ca699dd0b9d$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $fcad3ca699dd0b9d$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $fcad3ca699dd0b9d$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $fcad3ca699dd0b9d$export$158acd800e1ef08b(current, previous);
    const d12 = $fcad3ca699dd0b9d$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $fcad3ca699dd0b9d$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($fcad3ca699dd0b9d$export$a05254e7c3aeba6e(deltaK[i], 0, $fcad3ca699dd0b9d$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $fcad3ca699dd0b9d$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $fcad3ca699dd0b9d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $fcad3ca699dd0b9d$export$527e9aa3390079e9(points, indexAxis = 'x') {
    const valueAxis = $fcad3ca699dd0b9d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $fcad3ca699dd0b9d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $fcad3ca699dd0b9d$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $fcad3ca699dd0b9d$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $fcad3ca699dd0b9d$var$monotoneAdjust(points, deltaK, mK);
    $fcad3ca699dd0b9d$var$monotoneCompute(points, mK, indexAxis);
}
function $fcad3ca699dd0b9d$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $fcad3ca699dd0b9d$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $fcad3ca699dd0b9d$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $fcad3ca699dd0b9d$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $fcad3ca699dd0b9d$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $fcad3ca699dd0b9d$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $fcad3ca699dd0b9d$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $fcad3ca699dd0b9d$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $fcad3ca699dd0b9d$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $fcad3ca699dd0b9d$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $fcad3ca699dd0b9d$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $fcad3ca699dd0b9d$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $fcad3ca699dd0b9d$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $fcad3ca699dd0b9d$export$a17c37559e1db147(el, property) {
    return $fcad3ca699dd0b9d$var$getComputedStyle(el).getPropertyValue(property);
}
const $fcad3ca699dd0b9d$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $fcad3ca699dd0b9d$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $fcad3ca699dd0b9d$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $fcad3ca699dd0b9d$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $fcad3ca699dd0b9d$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($fcad3ca699dd0b9d$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $fcad3ca699dd0b9d$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $fcad3ca699dd0b9d$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $fcad3ca699dd0b9d$var$getPositionedStyle(style, 'padding');
    const borders = $fcad3ca699dd0b9d$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $fcad3ca699dd0b9d$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $fcad3ca699dd0b9d$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $fcad3ca699dd0b9d$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $fcad3ca699dd0b9d$var$getComputedStyle(container);
            const containerBorder = $fcad3ca699dd0b9d$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $fcad3ca699dd0b9d$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $fcad3ca699dd0b9d$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $fcad3ca699dd0b9d$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $fcad3ca699dd0b9d$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $fcad3ca699dd0b9d$export$2ec5befb9e6c97d4
    };
}
const $fcad3ca699dd0b9d$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $fcad3ca699dd0b9d$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $fcad3ca699dd0b9d$var$getComputedStyle(canvas);
    const margins = $fcad3ca699dd0b9d$var$getPositionedStyle(style, 'margin');
    const maxWidth = $fcad3ca699dd0b9d$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $fcad3ca699dd0b9d$export$2ec5befb9e6c97d4;
    const maxHeight = $fcad3ca699dd0b9d$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $fcad3ca699dd0b9d$export$2ec5befb9e6c97d4;
    const containerSize = $fcad3ca699dd0b9d$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $fcad3ca699dd0b9d$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $fcad3ca699dd0b9d$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $fcad3ca699dd0b9d$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $fcad3ca699dd0b9d$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $fcad3ca699dd0b9d$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $fcad3ca699dd0b9d$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $fcad3ca699dd0b9d$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $fcad3ca699dd0b9d$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($fcad3ca699dd0b9d$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $fcad3ca699dd0b9d$export$b4171a6734a65d42(element, property) {
    const value = $fcad3ca699dd0b9d$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $fcad3ca699dd0b9d$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $fcad3ca699dd0b9d$export$8a5498727ef6be21(p1, cp1, t);
    const b = $fcad3ca699dd0b9d$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $fcad3ca699dd0b9d$export$8a5498727ef6be21(cp2, p2, t);
    const d = $fcad3ca699dd0b9d$export$8a5498727ef6be21(a, b, t);
    const e = $fcad3ca699dd0b9d$export$8a5498727ef6be21(b, c, t);
    return $fcad3ca699dd0b9d$export$8a5498727ef6be21(d, e, t);
}
const $fcad3ca699dd0b9d$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $fcad3ca699dd0b9d$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $fcad3ca699dd0b9d$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $fcad3ca699dd0b9d$var$getRightToLeftAdapter(rectX, width) : $fcad3ca699dd0b9d$var$getLeftToRightAdapter();
}
function $fcad3ca699dd0b9d$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $fcad3ca699dd0b9d$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $fcad3ca699dd0b9d$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $fcad3ca699dd0b9d$export$ffb5f4729a158638,
        compare: $fcad3ca699dd0b9d$export$c18d01048907ea92,
        normalize: $fcad3ca699dd0b9d$export$28f7fcd39efa255
    };
    return {
        between: $fcad3ca699dd0b9d$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $fcad3ca699dd0b9d$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $fcad3ca699dd0b9d$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $fcad3ca699dd0b9d$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $fcad3ca699dd0b9d$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $fcad3ca699dd0b9d$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $fcad3ca699dd0b9d$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($fcad3ca699dd0b9d$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($fcad3ca699dd0b9d$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $fcad3ca699dd0b9d$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $fcad3ca699dd0b9d$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $fcad3ca699dd0b9d$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $fcad3ca699dd0b9d$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $fcad3ca699dd0b9d$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $fcad3ca699dd0b9d$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $fcad3ca699dd0b9d$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $fcad3ca699dd0b9d$var$splitByStyles(line, $fcad3ca699dd0b9d$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $fcad3ca699dd0b9d$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $fcad3ca699dd0b9d$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $fcad3ca699dd0b9d$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $fcad3ca699dd0b9d$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $fcad3ca699dd0b9d$var$readStyle(segmentOptions.setContext($fcad3ca699dd0b9d$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($fcad3ca699dd0b9d$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $fcad3ca699dd0b9d$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $fcad3ca699dd0b9d$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$fcad3ca699dd0b9d$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $41e2c210a1c3aa9f$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $fcad3ca699dd0b9d$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $41e2c210a1c3aa9f$export$a424a0aa8f687495 = /* #__PURE__ */ new $41e2c210a1c3aa9f$var$Animator();
const $41e2c210a1c3aa9f$var$transparent = 'transparent';
const $41e2c210a1c3aa9f$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $fcad3ca699dd0b9d$export$db3b6bfb95261072)(from || $41e2c210a1c3aa9f$var$transparent);
        const c1 = c0.valid && (0, $fcad3ca699dd0b9d$export$db3b6bfb95261072)(to || $41e2c210a1c3aa9f$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $41e2c210a1c3aa9f$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $fcad3ca699dd0b9d$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $fcad3ca699dd0b9d$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $41e2c210a1c3aa9f$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $fcad3ca699dd0b9d$export$f1e1789686576879)[cfg.easing] || (0, $fcad3ca699dd0b9d$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $fcad3ca699dd0b9d$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $fcad3ca699dd0b9d$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $41e2c210a1c3aa9f$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $41e2c210a1c3aa9f$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $41e2c210a1c3aa9f$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $41e2c210a1c3aa9f$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $41e2c210a1c3aa9f$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $41e2c210a1c3aa9f$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $41e2c210a1c3aa9f$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $41e2c210a1c3aa9f$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $41e2c210a1c3aa9f$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $41e2c210a1c3aa9f$var$scaleClip(xScale, allowedOverflow);
    const y = $41e2c210a1c3aa9f$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $41e2c210a1c3aa9f$var$toClip(value) {
    let t, r, b, l;
    if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $41e2c210a1c3aa9f$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(value) === (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $41e2c210a1c3aa9f$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $41e2c210a1c3aa9f$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $41e2c210a1c3aa9f$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $41e2c210a1c3aa9f$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $41e2c210a1c3aa9f$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $41e2c210a1c3aa9f$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $41e2c210a1c3aa9f$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $41e2c210a1c3aa9f$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $41e2c210a1c3aa9f$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $41e2c210a1c3aa9f$var$createDatasetContext(parent, index) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $41e2c210a1c3aa9f$var$createDataContext(parent, index, element) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $41e2c210a1c3aa9f$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $41e2c210a1c3aa9f$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $41e2c210a1c3aa9f$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $41e2c210a1c3aa9f$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $41e2c210a1c3aa9f$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(dataset.xAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(dataset.yAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(dataset.rAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $fcad3ca699dd0b9d$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $41e2c210a1c3aa9f$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $41e2c210a1c3aa9f$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $fcad3ca699dd0b9d$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $41e2c210a1c3aa9f$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $fcad3ca699dd0b9d$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $41e2c210a1c3aa9f$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $41e2c210a1c3aa9f$var$updateStacks(this, meta._parsed);
            meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $41e2c210a1c3aa9f$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $41e2c210a1c3aa9f$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $41e2c210a1c3aa9f$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $41e2c210a1c3aa9f$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $41e2c210a1c3aa9f$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $41e2c210a1c3aa9f$var$toClip((0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(this.options.clip, $41e2c210a1c3aa9f$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $41e2c210a1c3aa9f$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $41e2c210a1c3aa9f$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $fcad3ca699dd0b9d$export$dda1d9f60106f0e9)(index);
        if (cached) return $41e2c210a1c3aa9f$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($41e2c210a1c3aa9f$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $41e2c210a1c3aa9f$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $41e2c210a1c3aa9f$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($41e2c210a1c3aa9f$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$41e2c210a1c3aa9f$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $41e2c210a1c3aa9f$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $41e2c210a1c3aa9f$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $fcad3ca699dd0b9d$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $41e2c210a1c3aa9f$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $41e2c210a1c3aa9f$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $fcad3ca699dd0b9d$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $41e2c210a1c3aa9f$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $41e2c210a1c3aa9f$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $41e2c210a1c3aa9f$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $41e2c210a1c3aa9f$var$parseValue(entry, item, vScale, i) {
    if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(entry)) $41e2c210a1c3aa9f$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($41e2c210a1c3aa9f$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $41e2c210a1c3aa9f$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $41e2c210a1c3aa9f$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $41e2c210a1c3aa9f$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $41e2c210a1c3aa9f$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $41e2c210a1c3aa9f$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$41e2c210a1c3aa9f$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$41e2c210a1c3aa9f$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $41e2c210a1c3aa9f$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $41e2c210a1c3aa9f$var$swap(edge, a, b);
        edge = $41e2c210a1c3aa9f$var$startEnd(edge, b, a);
    } else edge = $41e2c210a1c3aa9f$var$startEnd(edge, a, b);
    return edge;
}
function $41e2c210a1c3aa9f$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $41e2c210a1c3aa9f$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $41e2c210a1c3aa9f$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $41e2c210a1c3aa9f$export$e97d5dc64e999004 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($41e2c210a1c3aa9f$var$parseValue((0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $41e2c210a1c3aa9f$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $41e2c210a1c3aa9f$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $41e2c210a1c3aa9f$var$setBorderSkipped(properties, options, stack, index);
            $41e2c210a1c3aa9f$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $41e2c210a1c3aa9f$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $41e2c210a1c3aa9f$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(value) !== (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $41e2c210a1c3aa9f$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $41e2c210a1c3aa9f$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $41e2c210a1c3aa9f$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $41e2c210a1c3aa9f$export$19b5c4773f17abe extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $41e2c210a1c3aa9f$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $fcad3ca699dd0b9d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $fcad3ca699dd0b9d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d) + (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $41e2c210a1c3aa9f$export$e04603e7d8b77172 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7);
        let max = -(0, $fcad3ca699dd0b9d$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $fcad3ca699dd0b9d$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $41e2c210a1c3aa9f$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $fcad3ca699dd0b9d$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $fcad3ca699dd0b9d$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $41e2c210a1c3aa9f$export$3c9b5d28c11cbfd0 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $fcad3ca699dd0b9d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $fcad3ca699dd0b9d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $41e2c210a1c3aa9f$export$2a270b3a0d973c85 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $fcad3ca699dd0b9d$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $fcad3ca699dd0b9d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $41e2c210a1c3aa9f$export$b21a3f1286706191 extends $41e2c210a1c3aa9f$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $41e2c210a1c3aa9f$export$48dbc6ac651bf8be extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $fcad3ca699dd0b9d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $41e2c210a1c3aa9f$export$b2f2bae6713db87 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $fcad3ca699dd0b9d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $fcad3ca699dd0b9d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $41e2c210a1c3aa9f$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $41e2c210a1c3aa9f$export$e97d5dc64e999004,
    BubbleController: $41e2c210a1c3aa9f$export$19b5c4773f17abe,
    DoughnutController: $41e2c210a1c3aa9f$export$e04603e7d8b77172,
    LineController: $41e2c210a1c3aa9f$export$3c9b5d28c11cbfd0,
    PieController: $41e2c210a1c3aa9f$export$b21a3f1286706191,
    PolarAreaController: $41e2c210a1c3aa9f$export$2a270b3a0d973c85,
    RadarController: $41e2c210a1c3aa9f$export$48dbc6ac651bf8be,
    ScatterController: $41e2c210a1c3aa9f$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $41e2c210a1c3aa9f$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $41e2c210a1c3aa9f$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($41e2c210a1c3aa9f$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    parse() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    format() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    add() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    diff() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    startOf() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    endOf() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
}
var $41e2c210a1c3aa9f$export$f32766ea09ec8bc4 = {
    _date: $41e2c210a1c3aa9f$var$DateAdapterBase
};
function $41e2c210a1c3aa9f$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $fcad3ca699dd0b9d$export$ebd11618f299a286) : (0, $fcad3ca699dd0b9d$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $41e2c210a1c3aa9f$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $41e2c210a1c3aa9f$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $fcad3ca699dd0b9d$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $fcad3ca699dd0b9d$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $41e2c210a1c3aa9f$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $41e2c210a1c3aa9f$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $41e2c210a1c3aa9f$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $41e2c210a1c3aa9f$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $41e2c210a1c3aa9f$export$a13296960cae0384 = {
    evaluateInteractionItems: $41e2c210a1c3aa9f$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            return $41e2c210a1c3aa9f$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(e, chart);
            return $41e2c210a1c3aa9f$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $41e2c210a1c3aa9f$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $41e2c210a1c3aa9f$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$41e2c210a1c3aa9f$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $41e2c210a1c3aa9f$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $41e2c210a1c3aa9f$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $41e2c210a1c3aa9f$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$41e2c210a1c3aa9f$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $41e2c210a1c3aa9f$var$setLayoutDims(layouts, params) {
    const stacks = $41e2c210a1c3aa9f$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $41e2c210a1c3aa9f$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $41e2c210a1c3aa9f$var$wrapBoxes(boxes);
    const fullSize = $41e2c210a1c3aa9f$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'right'));
    const top = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $41e2c210a1c3aa9f$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $41e2c210a1c3aa9f$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $41e2c210a1c3aa9f$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $41e2c210a1c3aa9f$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $41e2c210a1c3aa9f$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $41e2c210a1c3aa9f$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $41e2c210a1c3aa9f$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $41e2c210a1c3aa9f$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $41e2c210a1c3aa9f$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $fcad3ca699dd0b9d$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $41e2c210a1c3aa9f$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $41e2c210a1c3aa9f$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $fcad3ca699dd0b9d$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $41e2c210a1c3aa9f$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $41e2c210a1c3aa9f$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $41e2c210a1c3aa9f$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $41e2c210a1c3aa9f$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $41e2c210a1c3aa9f$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $41e2c210a1c3aa9f$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $41e2c210a1c3aa9f$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($41e2c210a1c3aa9f$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $41e2c210a1c3aa9f$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $41e2c210a1c3aa9f$var$handleMaxPadding(chartArea);
        $41e2c210a1c3aa9f$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $41e2c210a1c3aa9f$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $41e2c210a1c3aa9f$export$a40a96b24b46cf35 extends $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $41e2c210a1c3aa9f$var$EXPANDO_KEY = '$chartjs';
const $41e2c210a1c3aa9f$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $41e2c210a1c3aa9f$var$isNullOrEmpty = (value)=>value === null || value === '';
function $41e2c210a1c3aa9f$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($41e2c210a1c3aa9f$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $fcad3ca699dd0b9d$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($41e2c210a1c3aa9f$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $fcad3ca699dd0b9d$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $41e2c210a1c3aa9f$var$eventListenerOptions = (0, $fcad3ca699dd0b9d$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $41e2c210a1c3aa9f$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $41e2c210a1c3aa9f$var$eventListenerOptions);
}
function $41e2c210a1c3aa9f$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $41e2c210a1c3aa9f$var$eventListenerOptions);
}
function $41e2c210a1c3aa9f$var$fromNativeEvent(event, chart) {
    const type = $41e2c210a1c3aa9f$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $fcad3ca699dd0b9d$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $41e2c210a1c3aa9f$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $41e2c210a1c3aa9f$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41e2c210a1c3aa9f$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$41e2c210a1c3aa9f$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $41e2c210a1c3aa9f$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41e2c210a1c3aa9f$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$41e2c210a1c3aa9f$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $41e2c210a1c3aa9f$var$drpListeningCharts = new Map();
let $41e2c210a1c3aa9f$var$oldDevicePixelRatio = 0;
function $41e2c210a1c3aa9f$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $41e2c210a1c3aa9f$var$oldDevicePixelRatio) return;
    $41e2c210a1c3aa9f$var$oldDevicePixelRatio = dpr;
    $41e2c210a1c3aa9f$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $41e2c210a1c3aa9f$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$41e2c210a1c3aa9f$var$drpListeningCharts.size) window.addEventListener('resize', $41e2c210a1c3aa9f$var$onWindowResize);
    $41e2c210a1c3aa9f$var$drpListeningCharts.set(chart, resize);
}
function $41e2c210a1c3aa9f$var$unlistenDevicePixelRatioChanges(chart) {
    $41e2c210a1c3aa9f$var$drpListeningCharts.delete(chart);
    if (!$41e2c210a1c3aa9f$var$drpListeningCharts.size) window.removeEventListener('resize', $41e2c210a1c3aa9f$var$onWindowResize);
}
function $41e2c210a1c3aa9f$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $fcad3ca699dd0b9d$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $fcad3ca699dd0b9d$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $41e2c210a1c3aa9f$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $41e2c210a1c3aa9f$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $41e2c210a1c3aa9f$var$unlistenDevicePixelRatioChanges(chart);
}
function $41e2c210a1c3aa9f$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $fcad3ca699dd0b9d$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($41e2c210a1c3aa9f$var$fromNativeEvent(event, chart));
    }, chart);
    $41e2c210a1c3aa9f$var$addListener(canvas, type, proxy);
    return proxy;
}
class $41e2c210a1c3aa9f$export$f02da7f882cf6b2e extends $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $41e2c210a1c3aa9f$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY]) return false;
        const initial = canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $41e2c210a1c3aa9f$var$createAttachObserver,
            detach: $41e2c210a1c3aa9f$var$createDetachObserver,
            resize: $41e2c210a1c3aa9f$var$createResizeObserver
        };
        const handler = handlers[type] || $41e2c210a1c3aa9f$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $41e2c210a1c3aa9f$var$releaseObserver,
            detach: $41e2c210a1c3aa9f$var$releaseObserver,
            resize: $41e2c210a1c3aa9f$var$releaseObserver
        };
        const handler = handlers[type] || $41e2c210a1c3aa9f$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $fcad3ca699dd0b9d$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $fcad3ca699dd0b9d$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $41e2c210a1c3aa9f$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $fcad3ca699dd0b9d$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $41e2c210a1c3aa9f$export$a40a96b24b46cf35;
    return $41e2c210a1c3aa9f$export$f02da7f882cf6b2e;
}
class $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(this.x) && (0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $41e2c210a1c3aa9f$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $41e2c210a1c3aa9f$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $41e2c210a1c3aa9f$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $41e2c210a1c3aa9f$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $41e2c210a1c3aa9f$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, last, (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $41e2c210a1c3aa9f$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $41e2c210a1c3aa9f$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $41e2c210a1c3aa9f$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $fcad3ca699dd0b9d$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $41e2c210a1c3aa9f$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $41e2c210a1c3aa9f$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $41e2c210a1c3aa9f$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $41e2c210a1c3aa9f$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $41e2c210a1c3aa9f$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $41e2c210a1c3aa9f$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $41e2c210a1c3aa9f$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $41e2c210a1c3aa9f$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $41e2c210a1c3aa9f$var$garbageCollect(caches, length) {
    (0, $fcad3ca699dd0b9d$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $41e2c210a1c3aa9f$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $41e2c210a1c3aa9f$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $41e2c210a1c3aa9f$var$createScaleContext(parent, scale) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $41e2c210a1c3aa9f$var$createTickContext(parent, index, tick) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $41e2c210a1c3aa9f$var$titleAlign(align, position, reverse) {
    let ret = (0, $fcad3ca699dd0b9d$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $41e2c210a1c3aa9f$var$reverseAlign(ret);
    return ret;
}
function $41e2c210a1c3aa9f$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $41e2c210a1c3aa9f$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $41e2c210a1c3aa9f$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd) : (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(min, (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(max, min)),
            max: (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(max, (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $fcad3ca699dd0b9d$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $41e2c210a1c3aa9f$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $41e2c210a1c3aa9f$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $41e2c210a1c3aa9f$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $41e2c210a1c3aa9f$var$getTickMarkLength(options.grid) - tickOpts.padding - $41e2c210a1c3aa9f$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $fcad3ca699dd0b9d$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $41e2c210a1c3aa9f$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $41e2c210a1c3aa9f$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $41e2c210a1c3aa9f$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $41e2c210a1c3aa9f$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $41e2c210a1c3aa9f$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(label) && !(0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(label)) {
                width = (0, $fcad3ca699dd0b9d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(nestedLabel) && !(0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $fcad3ca699dd0b9d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $41e2c210a1c3aa9f$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $fcad3ca699dd0b9d$export$71cec2538cb2c617)(this._alignToPixels ? (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $41e2c210a1c3aa9f$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $41e2c210a1c3aa9f$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $41e2c210a1c3aa9f$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $41e2c210a1c3aa9f$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $41e2c210a1c3aa9f$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $fcad3ca699dd0b9d$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $fcad3ca699dd0b9d$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $fcad3ca699dd0b9d$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(title.font);
        const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $41e2c210a1c3aa9f$var$titleArgs(this, offset, position, align);
        (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $41e2c210a1c3aa9f$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $41e2c210a1c3aa9f$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $41e2c210a1c3aa9f$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($41e2c210a1c3aa9f$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $41e2c210a1c3aa9f$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0)[scope]) {
            delete (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6)[id];
        }
    }
}
function $41e2c210a1c3aa9f$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $fcad3ca699dd0b9d$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $41e2c210a1c3aa9f$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $41e2c210a1c3aa9f$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $41e2c210a1c3aa9f$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $41e2c210a1c3aa9f$var$Registry {
    constructor(){
        this.controllers = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $41e2c210a1c3aa9f$var$TypedRegistry(Object, 'plugins');
        this.scales = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $fcad3ca699dd0b9d$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $fcad3ca699dd0b9d$export$a8550f7dbe79f93a)(method);
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $41e2c210a1c3aa9f$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $41e2c210a1c3aa9f$var$Registry();
class $41e2c210a1c3aa9f$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $41e2c210a1c3aa9f$var$allPlugins(config);
        return options === false && !all ? [] : $41e2c210a1c3aa9f$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $41e2c210a1c3aa9f$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($41e2c210a1c3aa9f$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $41e2c210a1c3aa9f$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $41e2c210a1c3aa9f$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $41e2c210a1c3aa9f$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $41e2c210a1c3aa9f$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $41e2c210a1c3aa9f$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $41e2c210a1c3aa9f$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $41e2c210a1c3aa9f$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $41e2c210a1c3aa9f$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $41e2c210a1c3aa9f$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $41e2c210a1c3aa9f$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $41e2c210a1c3aa9f$var$determineAxis(id, ...scaleOptions) {
    if ($41e2c210a1c3aa9f$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $41e2c210a1c3aa9f$var$axisFromPosition(opts.position) || id.length > 1 && $41e2c210a1c3aa9f$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $41e2c210a1c3aa9f$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $41e2c210a1c3aa9f$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $41e2c210a1c3aa9f$var$getAxisFromDataset(id, 'x', boundDs[0]) || $41e2c210a1c3aa9f$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $41e2c210a1c3aa9f$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $41e2c210a1c3aa9f$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleConf, $41e2c210a1c3aa9f$var$retrieveAxisFromDatasets(id, config), (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $41e2c210a1c3aa9f$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $fcad3ca699dd0b9d$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $41e2c210a1c3aa9f$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $41e2c210a1c3aa9f$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $fcad3ca699dd0b9d$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $fcad3ca699dd0b9d$export$555508cbc6add439)(scale, [
            (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).scales[scale.type],
            (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $41e2c210a1c3aa9f$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $41e2c210a1c3aa9f$var$mergeScaleConfig(config, options);
}
function $41e2c210a1c3aa9f$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $41e2c210a1c3aa9f$var$initConfig(config) {
    config = config || {};
    config.data = $41e2c210a1c3aa9f$var$initData(config.data);
    $41e2c210a1c3aa9f$var$initOptions(config);
    return config;
}
const $41e2c210a1c3aa9f$var$keyCache = new Map();
const $41e2c210a1c3aa9f$var$keysCached = new Set();
function $41e2c210a1c3aa9f$var$cachedKeys(cacheKey, generate) {
    let keys = $41e2c210a1c3aa9f$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $41e2c210a1c3aa9f$var$keyCache.set(cacheKey, keys);
        $41e2c210a1c3aa9f$var$keysCached.add(keys);
    }
    return keys;
}
const $41e2c210a1c3aa9f$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $fcad3ca699dd0b9d$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $41e2c210a1c3aa9f$var$Config {
    constructor(config){
        this._config = $41e2c210a1c3aa9f$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $41e2c210a1c3aa9f$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $41e2c210a1c3aa9f$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $41e2c210a1c3aa9f$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $41e2c210a1c3aa9f$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $41e2c210a1c3aa9f$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $41e2c210a1c3aa9f$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $fcad3ca699dd0b9d$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($41e2c210a1c3aa9f$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6)[type] || {},
            (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0),
            (0, $fcad3ca699dd0b9d$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $41e2c210a1c3aa9f$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($41e2c210a1c3aa9f$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $fcad3ca699dd0b9d$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $fcad3ca699dd0b9d$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $41e2c210a1c3aa9f$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(context) ? (0, $fcad3ca699dd0b9d$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $41e2c210a1c3aa9f$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $fcad3ca699dd0b9d$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $41e2c210a1c3aa9f$var$hasFunction = (value)=>(0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $fcad3ca699dd0b9d$export$a93c5207d687da10)(value[key]));
function $41e2c210a1c3aa9f$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $fcad3ca699dd0b9d$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $fcad3ca699dd0b9d$export$a93c5207d687da10)(value) || $41e2c210a1c3aa9f$var$hasFunction(value)) || indexable && (0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $41e2c210a1c3aa9f$var$version = "4.4.8";
const $41e2c210a1c3aa9f$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $41e2c210a1c3aa9f$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $41e2c210a1c3aa9f$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $41e2c210a1c3aa9f$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $41e2c210a1c3aa9f$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $41e2c210a1c3aa9f$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $41e2c210a1c3aa9f$var$getCanvas(item) {
    if ((0, $fcad3ca699dd0b9d$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $41e2c210a1c3aa9f$var$instances = {};
const $41e2c210a1c3aa9f$var$getChart = (key)=>{
    const canvas = $41e2c210a1c3aa9f$var$getCanvas(key);
    return Object.values($41e2c210a1c3aa9f$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $41e2c210a1c3aa9f$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $41e2c210a1c3aa9f$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function $41e2c210a1c3aa9f$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $41e2c210a1c3aa9f$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $41e2c210a1c3aa9f$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $41e2c210a1c3aa9f$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $41e2c210a1c3aa9f$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $41e2c210a1c3aa9f$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
class $41e2c210a1c3aa9f$export$acaa6426d77a227e {
    static defaults = (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0);
    static instances = $41e2c210a1c3aa9f$var$instances;
    static overrides = (0, $fcad3ca699dd0b9d$export$6559d589eb85fbb6);
    static registry = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5;
    static version = $41e2c210a1c3aa9f$var$version;
    static getChart = $41e2c210a1c3aa9f$var$getChart;
    static register(...items) {
        $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.add(...items);
        $41e2c210a1c3aa9f$var$invalidatePlugins();
    }
    static unregister(...items) {
        $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.remove(...items);
        $41e2c210a1c3aa9f$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $41e2c210a1c3aa9f$var$Config(userConfig);
        const initialCanvas = $41e2c210a1c3aa9f$var$getCanvas(item);
        const existingChart = $41e2c210a1c3aa9f$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $41e2c210a1c3aa9f$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $fcad3ca699dd0b9d$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $41e2c210a1c3aa9f$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $fcad3ca699dd0b9d$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $41e2c210a1c3aa9f$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.listen(this, 'complete', $41e2c210a1c3aa9f$var$onAnimationsComplete);
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.listen(this, 'progress', $41e2c210a1c3aa9f$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $41e2c210a1c3aa9f$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $fcad3ca699dd0b9d$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $fcad3ca699dd0b9d$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$41e2c210a1c3aa9f$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $fcad3ca699dd0b9d$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $41e2c210a1c3aa9f$var$positionIsHorizontal(scaleOptions.position, axis) !== $41e2c210a1c3aa9f$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(scales, (scale)=>{
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($41e2c210a1c3aa9f$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $41e2c210a1c3aa9f$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $fcad3ca699dd0b9d$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($41e2c210a1c3aa9f$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.scales, (scale)=>{
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $fcad3ca699dd0b9d$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $41e2c210a1c3aa9f$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $fcad3ca699dd0b9d$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $fcad3ca699dd0b9d$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($41e2c210a1c3aa9f$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$41e2c210a1c3aa9f$export$a424a0aa8f687495.running(this)) $41e2c210a1c3aa9f$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $41e2c210a1c3aa9f$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $41e2c210a1c3aa9f$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $fcad3ca699dd0b9d$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $fcad3ca699dd0b9d$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $41e2c210a1c3aa9f$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $fcad3ca699dd0b9d$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $fcad3ca699dd0b9d$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $41e2c210a1c3aa9f$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $fcad3ca699dd0b9d$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $fcad3ca699dd0b9d$export$f38c853ae54ed474)(e);
        const lastEvent = $41e2c210a1c3aa9f$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $fcad3ca699dd0b9d$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $41e2c210a1c3aa9f$var$invalidatePlugins() {
    return (0, $fcad3ca699dd0b9d$export$d66501df72047452)($41e2c210a1c3aa9f$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $41e2c210a1c3aa9f$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd), startAngle - (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $41e2c210a1c3aa9f$var$toRadiusCorners(value) {
    return (0, $fcad3ca699dd0b9d$export$21579262ef46735b)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $41e2c210a1c3aa9f$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $41e2c210a1c3aa9f$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $41e2c210a1c3aa9f$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $41e2c210a1c3aa9f$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $41e2c210a1c3aa9f$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $41e2c210a1c3aa9f$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $41e2c210a1c3aa9f$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) || (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7));
    }
    $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $41e2c210a1c3aa9f$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) || (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7));
    }
    if (inner) $41e2c210a1c3aa9f$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $41e2c210a1c3aa9f$export$d48203c759d6a1fc extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $fcad3ca699dd0b9d$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $fcad3ca699dd0b9d$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $41e2c210a1c3aa9f$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $41e2c210a1c3aa9f$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $41e2c210a1c3aa9f$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $41e2c210a1c3aa9f$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $41e2c210a1c3aa9f$var$getLineMethod(options) {
    if (options.stepped) return 0, $fcad3ca699dd0b9d$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $fcad3ca699dd0b9d$export$6554612db691658e;
    return $41e2c210a1c3aa9f$var$lineTo;
}
function $41e2c210a1c3aa9f$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $41e2c210a1c3aa9f$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $41e2c210a1c3aa9f$var$pathVars(points, segment, params);
    const lineMethod = $41e2c210a1c3aa9f$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $41e2c210a1c3aa9f$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $41e2c210a1c3aa9f$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $41e2c210a1c3aa9f$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $41e2c210a1c3aa9f$var$fastPathSegment : $41e2c210a1c3aa9f$var$pathSegment;
}
function $41e2c210a1c3aa9f$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $fcad3ca699dd0b9d$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $fcad3ca699dd0b9d$export$2f6ca3d3b1f80bf5;
    return 0, $fcad3ca699dd0b9d$export$8a5498727ef6be21;
}
function $41e2c210a1c3aa9f$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $41e2c210a1c3aa9f$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $41e2c210a1c3aa9f$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(line);
    for (const segment of segments){
        $41e2c210a1c3aa9f$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $41e2c210a1c3aa9f$var$usePath2D = typeof Path2D === 'function';
function $41e2c210a1c3aa9f$var$draw(ctx, line, start, count) {
    if ($41e2c210a1c3aa9f$var$usePath2D && !line.options.segment) $41e2c210a1c3aa9f$var$strokePathWithCache(ctx, line, start, count);
    else $41e2c210a1c3aa9f$var$strokePathDirect(ctx, line, start, count);
}
class $41e2c210a1c3aa9f$export$55e463fa7bcd3469 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $fcad3ca699dd0b9d$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $fcad3ca699dd0b9d$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $fcad3ca699dd0b9d$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $41e2c210a1c3aa9f$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $41e2c210a1c3aa9f$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $41e2c210a1c3aa9f$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $41e2c210a1c3aa9f$export$bd159b522b230b7a extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $fcad3ca699dd0b9d$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $41e2c210a1c3aa9f$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $41e2c210a1c3aa9f$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(value, min, max);
}
function $41e2c210a1c3aa9f$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $fcad3ca699dd0b9d$export$d66dc83d8cfc8dd)(value);
    return {
        t: $41e2c210a1c3aa9f$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $41e2c210a1c3aa9f$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $41e2c210a1c3aa9f$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $41e2c210a1c3aa9f$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $41e2c210a1c3aa9f$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $41e2c210a1c3aa9f$var$boundingRects(bar) {
    const bounds = $41e2c210a1c3aa9f$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $41e2c210a1c3aa9f$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $41e2c210a1c3aa9f$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $41e2c210a1c3aa9f$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $41e2c210a1c3aa9f$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $41e2c210a1c3aa9f$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $41e2c210a1c3aa9f$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $41e2c210a1c3aa9f$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $41e2c210a1c3aa9f$export$a16ed71bf4b07672 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $41e2c210a1c3aa9f$var$boundingRects(this);
        const addRectPath = $41e2c210a1c3aa9f$var$hasRadius(outer.radius) ? (0, $fcad3ca699dd0b9d$export$1fbe638ecf81657e) : $41e2c210a1c3aa9f$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $41e2c210a1c3aa9f$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $41e2c210a1c3aa9f$export$d48203c759d6a1fc,
    BarElement: $41e2c210a1c3aa9f$export$a16ed71bf4b07672,
    LineElement: $41e2c210a1c3aa9f$export$55e463fa7bcd3469,
    PointElement: $41e2c210a1c3aa9f$export$bd159b522b230b7a
});
const $41e2c210a1c3aa9f$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $41e2c210a1c3aa9f$var$BACKGROUND_COLORS = /* #__PURE__ */ $41e2c210a1c3aa9f$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $41e2c210a1c3aa9f$var$getBorderColor(i) {
    return $41e2c210a1c3aa9f$var$BORDER_COLORS[i % $41e2c210a1c3aa9f$var$BORDER_COLORS.length];
}
function $41e2c210a1c3aa9f$var$getBackgroundColor(i) {
    return $41e2c210a1c3aa9f$var$BACKGROUND_COLORS[i % $41e2c210a1c3aa9f$var$BACKGROUND_COLORS.length];
}
function $41e2c210a1c3aa9f$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $41e2c210a1c3aa9f$var$getBorderColor(i);
    dataset.backgroundColor = $41e2c210a1c3aa9f$var$getBackgroundColor(i);
    return ++i;
}
function $41e2c210a1c3aa9f$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$41e2c210a1c3aa9f$var$getBorderColor(i++));
    return i;
}
function $41e2c210a1c3aa9f$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$41e2c210a1c3aa9f$var$getBackgroundColor(i++));
    return i;
}
function $41e2c210a1c3aa9f$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $41e2c210a1c3aa9f$export$e04603e7d8b77172) i = $41e2c210a1c3aa9f$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $41e2c210a1c3aa9f$export$2a270b3a0d973c85) i = $41e2c210a1c3aa9f$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $41e2c210a1c3aa9f$var$colorizeDefaultDataset(dataset, i);
    };
}
function $41e2c210a1c3aa9f$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $41e2c210a1c3aa9f$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $41e2c210a1c3aa9f$var$containsDefaultColorsDefenitions() {
    return (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $41e2c210a1c3aa9f$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $41e2c210a1c3aa9f$var$containsColorsDefinitions(datasets) || $41e2c210a1c3aa9f$var$containsColorsDefinition(chartOptions) || elements && $41e2c210a1c3aa9f$var$containsColorsDefinitions(elements) || $41e2c210a1c3aa9f$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $41e2c210a1c3aa9f$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $41e2c210a1c3aa9f$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $41e2c210a1c3aa9f$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(minIndex) && !(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $41e2c210a1c3aa9f$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset);
    });
}
function $41e2c210a1c3aa9f$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)((0, $fcad3ca699dd0b9d$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)((0, $fcad3ca699dd0b9d$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $41e2c210a1c3aa9f$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $41e2c210a1c3aa9f$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $fcad3ca699dd0b9d$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $41e2c210a1c3aa9f$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $41e2c210a1c3aa9f$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $41e2c210a1c3aa9f$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $41e2c210a1c3aa9f$var$cleanDecimatedData(chart);
    }
};
function $41e2c210a1c3aa9f$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points);
        const bounds = $41e2c210a1c3aa9f$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $fcad3ca699dd0b9d$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $41e2c210a1c3aa9f$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $fcad3ca699dd0b9d$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $41e2c210a1c3aa9f$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $41e2c210a1c3aa9f$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $41e2c210a1c3aa9f$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $fcad3ca699dd0b9d$export$28f7fcd39efa255)(start);
        end = (0, $fcad3ca699dd0b9d$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $41e2c210a1c3aa9f$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $41e2c210a1c3aa9f$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $41e2c210a1c3aa9f$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $41e2c210a1c3aa9f$var$_pointsFromSegments(boundary, line);
    return points.length ? new $41e2c210a1c3aa9f$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $41e2c210a1c3aa9f$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $41e2c210a1c3aa9f$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $41e2c210a1c3aa9f$var$_decodeFill(line, index, count) {
    const fill = $41e2c210a1c3aa9f$var$parseFillOption(line);
    if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $41e2c210a1c3aa9f$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $41e2c210a1c3aa9f$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $41e2c210a1c3aa9f$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $41e2c210a1c3aa9f$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $41e2c210a1c3aa9f$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $41e2c210a1c3aa9f$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $41e2c210a1c3aa9f$var$getLinesBelow(scale, index);
    linesBelow.push($41e2c210a1c3aa9f$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$41e2c210a1c3aa9f$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $41e2c210a1c3aa9f$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $41e2c210a1c3aa9f$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $41e2c210a1c3aa9f$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $41e2c210a1c3aa9f$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $41e2c210a1c3aa9f$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $41e2c210a1c3aa9f$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $41e2c210a1c3aa9f$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(fill)) return $41e2c210a1c3aa9f$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $41e2c210a1c3aa9f$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $41e2c210a1c3aa9f$var$computeBoundary(source);
    if (boundary instanceof $41e2c210a1c3aa9f$var$simpleArc) return boundary;
    return $41e2c210a1c3aa9f$var$_createBoundaryLine(boundary, line);
}
function $41e2c210a1c3aa9f$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $41e2c210a1c3aa9f$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $41e2c210a1c3aa9f$var$computeCircularBoundary(source);
    return $41e2c210a1c3aa9f$var$computeLinearBoundary(source);
}
function $41e2c210a1c3aa9f$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $41e2c210a1c3aa9f$var$_getTargetPixel(fill, scale);
    if ((0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $41e2c210a1c3aa9f$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $41e2c210a1c3aa9f$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $41e2c210a1c3aa9f$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $41e2c210a1c3aa9f$var$_drawfill(ctx, source, area) {
    const target = $41e2c210a1c3aa9f$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $fcad3ca699dd0b9d$export$8743009a87fcb00f)(ctx, area);
        $41e2c210a1c3aa9f$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $fcad3ca699dd0b9d$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $41e2c210a1c3aa9f$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $41e2c210a1c3aa9f$var$clipVertical(ctx, target, area.top);
        $41e2c210a1c3aa9f$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $41e2c210a1c3aa9f$var$clipVertical(ctx, target, area.bottom);
    }
    $41e2c210a1c3aa9f$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $41e2c210a1c3aa9f$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $41e2c210a1c3aa9f$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $41e2c210a1c3aa9f$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $41e2c210a1c3aa9f$var$clipBounds(ctx, scale, notShape && $41e2c210a1c3aa9f$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $41e2c210a1c3aa9f$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $41e2c210a1c3aa9f$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $41e2c210a1c3aa9f$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $41e2c210a1c3aa9f$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $41e2c210a1c3aa9f$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($41e2c210a1c3aa9f$var$_shouldApplyFill(source)) $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$41e2c210a1c3aa9f$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $41e2c210a1c3aa9f$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $41e2c210a1c3aa9f$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $41e2c210a1c3aa9f$var$Legend extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $fcad3ca699dd0b9d$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $fcad3ca699dd0b9d$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $fcad3ca699dd0b9d$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $fcad3ca699dd0b9d$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $fcad3ca699dd0b9d$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $fcad3ca699dd0b9d$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $fcad3ca699dd0b9d$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $fcad3ca699dd0b9d$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $fcad3ca699dd0b9d$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$41e2c210a1c3aa9f$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $41e2c210a1c3aa9f$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $41e2c210a1c3aa9f$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $41e2c210a1c3aa9f$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $41e2c210a1c3aa9f$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $41e2c210a1c3aa9f$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $41e2c210a1c3aa9f$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $41e2c210a1c3aa9f$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $41e2c210a1c3aa9f$export$ed247974535929c7 = {
    id: 'legend',
    _element: $41e2c210a1c3aa9f$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $41e2c210a1c3aa9f$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $41e2c210a1c3aa9f$var$Title extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $fcad3ca699dd0b9d$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $fcad3ca699dd0b9d$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $41e2c210a1c3aa9f$var$createTitle(chart, titleOpts) {
    const title = new $41e2c210a1c3aa9f$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $41e2c210a1c3aa9f$export$f99233281efd08a0 = {
    id: 'title',
    _element: $41e2c210a1c3aa9f$var$Title,
    start (chart, _args, options) {
        $41e2c210a1c3aa9f$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41e2c210a1c3aa9f$var$map = new WeakMap();
var $41e2c210a1c3aa9f$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $41e2c210a1c3aa9f$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, title);
        $41e2c210a1c3aa9f$var$map.set(chart, title);
    },
    stop (chart) {
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, $41e2c210a1c3aa9f$var$map.get(chart));
        $41e2c210a1c3aa9f$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $41e2c210a1c3aa9f$var$map.get(chart);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41e2c210a1c3aa9f$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $fcad3ca699dd0b9d$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $41e2c210a1c3aa9f$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $41e2c210a1c3aa9f$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $41e2c210a1c3aa9f$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $41e2c210a1c3aa9f$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $fcad3ca699dd0b9d$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $fcad3ca699dd0b9d$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $fcad3ca699dd0b9d$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $fcad3ca699dd0b9d$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $41e2c210a1c3aa9f$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $41e2c210a1c3aa9f$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $41e2c210a1c3aa9f$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($41e2c210a1c3aa9f$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $41e2c210a1c3aa9f$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $41e2c210a1c3aa9f$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $41e2c210a1c3aa9f$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $41e2c210a1c3aa9f$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $41e2c210a1c3aa9f$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $41e2c210a1c3aa9f$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(cornerRadius);
    let x = $41e2c210a1c3aa9f$var$alignX(size, xAlign);
    const y = $41e2c210a1c3aa9f$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $41e2c210a1c3aa9f$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines(callback) {
    return $41e2c210a1c3aa9f$var$pushOrConcat([], $41e2c210a1c3aa9f$var$splitNewlines(callback));
}
function $41e2c210a1c3aa9f$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $41e2c210a1c3aa9f$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $41e2c210a1c3aa9f$var$defaultCallbacks = {
    beforeTitle: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    beforeBody: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    beforeLabel: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    afterBody: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    beforeFooter: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    footer: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46),
    afterFooter: (0, $fcad3ca699dd0b9d$export$cf2f7c5792f80b46)
};
function $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $41e2c210a1c3aa9f$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $41e2c210a1c3aa9f$var$Tooltip extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static positioners = $41e2c210a1c3aa9f$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $41e2c210a1c3aa9f$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $41e2c210a1c3aa9f$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(beforeTitle));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(title));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $41e2c210a1c3aa9f$var$overrideCallbacks(callbacks, context);
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.before, $41e2c210a1c3aa9f$var$splitNewlines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.lines, $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.after, $41e2c210a1c3aa9f$var$splitNewlines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(beforeFooter));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(footer));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($41e2c210a1c3aa9f$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $41e2c210a1c3aa9f$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $41e2c210a1c3aa9f$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $41e2c210a1c3aa9f$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $41e2c210a1c3aa9f$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.bodyFont);
        const colorX = $41e2c210a1c3aa9f$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $fcad3ca699dd0b9d$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $fcad3ca699dd0b9d$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $fcad3ca699dd0b9d$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $fcad3ca699dd0b9d$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $fcad3ca699dd0b9d$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $fcad3ca699dd0b9d$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $fcad3ca699dd0b9d$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $fcad3ca699dd0b9d$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $fcad3ca699dd0b9d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $41e2c210a1c3aa9f$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $41e2c210a1c3aa9f$var$determineAlignment(chart, options, positionAndSize);
            const point = $41e2c210a1c3aa9f$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $fcad3ca699dd0b9d$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $fcad3ca699dd0b9d$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $fcad3ca699dd0b9d$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $fcad3ca699dd0b9d$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $41e2c210a1c3aa9f$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $41e2c210a1c3aa9f$var$Tooltip,
    positioners: $41e2c210a1c3aa9f$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $41e2c210a1c3aa9f$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $41e2c210a1c3aa9f$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $41e2c210a1c3aa9f$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $41e2c210a1c3aa9f$export$c537fa0d021d010b,
    Decimation: $41e2c210a1c3aa9f$export$be17f937e9aa7533,
    Filler: $41e2c210a1c3aa9f$export$d19ba4d812bed757,
    Legend: $41e2c210a1c3aa9f$export$ed247974535929c7,
    SubTitle: $41e2c210a1c3aa9f$export$d5c56664638992a4,
    Title: $41e2c210a1c3aa9f$export$f99233281efd08a0,
    Tooltip: $41e2c210a1c3aa9f$export$28c660c63b792dea
});
const $41e2c210a1c3aa9f$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $41e2c210a1c3aa9f$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $41e2c210a1c3aa9f$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $41e2c210a1c3aa9f$var$validIndex = (index, max)=>index === null ? null : (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $41e2c210a1c3aa9f$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $41e2c210a1c3aa9f$export$29e663ba4d09fe7 extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $41e2c210a1c3aa9f$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $41e2c210a1c3aa9f$var$findOrAddLabel(labels, raw, (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $41e2c210a1c3aa9f$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $41e2c210a1c3aa9f$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $41e2c210a1c3aa9f$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $fcad3ca699dd0b9d$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $fcad3ca699dd0b9d$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $fcad3ca699dd0b9d$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $fcad3ca699dd0b9d$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $fcad3ca699dd0b9d$export$23ebac1979863676)(spacing), (0, $fcad3ca699dd0b9d$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $fcad3ca699dd0b9d$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $41e2c210a1c3aa9f$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $fcad3ca699dd0b9d$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $41e2c210a1c3aa9f$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $41e2c210a1c3aa9f$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $41e2c210a1c3aa9f$var$LinearScaleBase extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $fcad3ca699dd0b9d$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $41e2c210a1c3aa9f$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $fcad3ca699dd0b9d$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $fcad3ca699dd0b9d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $41e2c210a1c3aa9f$export$e7f4e5e8656f0b93 extends $41e2c210a1c3aa9f$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $fcad3ca699dd0b9d$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $41e2c210a1c3aa9f$var$log10Floor = (v)=>Math.floor((0, $fcad3ca699dd0b9d$export$9f4f30ee63539e24)(v));
const $41e2c210a1c3aa9f$var$changeExponent = (v, m)=>Math.pow(10, $41e2c210a1c3aa9f$var$log10Floor(v) + m);
function $41e2c210a1c3aa9f$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $41e2c210a1c3aa9f$var$log10Floor(tickVal));
    return remain === 1;
}
function $41e2c210a1c3aa9f$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $41e2c210a1c3aa9f$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $41e2c210a1c3aa9f$var$log10Floor(range);
    while($41e2c210a1c3aa9f$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($41e2c210a1c3aa9f$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $41e2c210a1c3aa9f$var$log10Floor(min));
}
function $41e2c210a1c3aa9f$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $41e2c210a1c3aa9f$var$log10Floor(min);
    let exp = $41e2c210a1c3aa9f$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $41e2c210a1c3aa9f$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $fcad3ca699dd0b9d$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $41e2c210a1c3aa9f$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $41e2c210a1c3aa9f$export$85295eaf7cb3ac3e extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $fcad3ca699dd0b9d$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $41e2c210a1c3aa9f$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(this._userMin)) this.min = min === $41e2c210a1c3aa9f$var$changeExponent(this.min, 0) ? $41e2c210a1c3aa9f$var$changeExponent(this.min, -1) : $41e2c210a1c3aa9f$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($41e2c210a1c3aa9f$var$changeExponent(min, -1));
                setMax($41e2c210a1c3aa9f$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($41e2c210a1c3aa9f$var$changeExponent(max, -1));
        if (max <= 0) setMax($41e2c210a1c3aa9f$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $41e2c210a1c3aa9f$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $fcad3ca699dd0b9d$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $fcad3ca699dd0b9d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $fcad3ca699dd0b9d$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $fcad3ca699dd0b9d$export$9f4f30ee63539e24)(this.max) - (0, $fcad3ca699dd0b9d$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $fcad3ca699dd0b9d$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $41e2c210a1c3aa9f$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $fcad3ca699dd0b9d$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $41e2c210a1c3aa9f$var$measureLabelSize(ctx, font, label) {
    label = (0, $fcad3ca699dd0b9d$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $fcad3ca699dd0b9d$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $41e2c210a1c3aa9f$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $41e2c210a1c3aa9f$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(opts.font);
        const textSize = $41e2c210a1c3aa9f$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $fcad3ca699dd0b9d$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $fcad3ca699dd0b9d$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $41e2c210a1c3aa9f$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $41e2c210a1c3aa9f$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $41e2c210a1c3aa9f$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $41e2c210a1c3aa9f$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $41e2c210a1c3aa9f$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $41e2c210a1c3aa9f$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $fcad3ca699dd0b9d$export$3a6d5c9ae78a2c08)((0, $fcad3ca699dd0b9d$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd))));
    const y = $41e2c210a1c3aa9f$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $41e2c210a1c3aa9f$var$getTextAlignForAngle(angle);
    const left = $41e2c210a1c3aa9f$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $41e2c210a1c3aa9f$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $fcad3ca699dd0b9d$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $41e2c210a1c3aa9f$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $41e2c210a1c3aa9f$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $fcad3ca699dd0b9d$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $41e2c210a1c3aa9f$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $41e2c210a1c3aa9f$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $41e2c210a1c3aa9f$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $41e2c210a1c3aa9f$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $41e2c210a1c3aa9f$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $41e2c210a1c3aa9f$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $fcad3ca699dd0b9d$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $fcad3ca699dd0b9d$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $41e2c210a1c3aa9f$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $41e2c210a1c3aa9f$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $41e2c210a1c3aa9f$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $41e2c210a1c3aa9f$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $41e2c210a1c3aa9f$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $41e2c210a1c3aa9f$var$createPointLabelContext(parent, index, label) {
    return (0, $fcad3ca699dd0b9d$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $41e2c210a1c3aa9f$export$cfafc36d95386d38 extends $41e2c210a1c3aa9f$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $fcad3ca699dd0b9d$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)($41e2c210a1c3aa9f$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $41e2c210a1c3aa9f$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $41e2c210a1c3aa9f$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $41e2c210a1c3aa9f$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $fcad3ca699dd0b9d$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $fcad3ca699dd0b9d$export$28f7fcd39efa255)(index * angleMultiplier + (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $41e2c210a1c3aa9f$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $fcad3ca699dd0b9d$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $41e2c210a1c3aa9f$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $41e2c210a1c3aa9f$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $41e2c210a1c3aa9f$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $fcad3ca699dd0b9d$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $fcad3ca699dd0b9d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $fcad3ca699dd0b9d$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $41e2c210a1c3aa9f$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $41e2c210a1c3aa9f$var$UNITS = /* #__PURE__ */ Object.keys($41e2c210a1c3aa9f$var$INTERVALS);
function $41e2c210a1c3aa9f$var$sorter(a, b) {
    return a - b;
}
function $41e2c210a1c3aa9f$var$parse(scale, input) {
    if ((0, $fcad3ca699dd0b9d$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $41e2c210a1c3aa9f$var$UNITS.length;
    for(let i = $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $41e2c210a1c3aa9f$var$INTERVALS[$41e2c210a1c3aa9f$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $41e2c210a1c3aa9f$var$UNITS[i];
    }
    return $41e2c210a1c3aa9f$var$UNITS[ilen - 1];
}
function $41e2c210a1c3aa9f$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $41e2c210a1c3aa9f$var$UNITS.length - 1; i >= $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit); i--){
        const unit = $41e2c210a1c3aa9f$var$UNITS[i];
        if ($41e2c210a1c3aa9f$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $41e2c210a1c3aa9f$var$UNITS[minUnit ? $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit) : 0];
}
function $41e2c210a1c3aa9f$var$determineMajorUnit(unit) {
    for(let i = $41e2c210a1c3aa9f$var$UNITS.indexOf(unit) + 1, ilen = $41e2c210a1c3aa9f$var$UNITS.length; i < ilen; ++i){
        if ($41e2c210a1c3aa9f$var$INTERVALS[$41e2c210a1c3aa9f$var$UNITS[i]].common) return $41e2c210a1c3aa9f$var$UNITS[i];
    }
}
function $41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $fcad3ca699dd0b9d$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $41e2c210a1c3aa9f$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $41e2c210a1c3aa9f$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $41e2c210a1c3aa9f$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $41e2c210a1c3aa9f$export$a894c72689ff3ec extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $41e2c210a1c3aa9f$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $fcad3ca699dd0b9d$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $41e2c210a1c3aa9f$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $fcad3ca699dd0b9d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $fcad3ca699dd0b9d$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $41e2c210a1c3aa9f$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $41e2c210a1c3aa9f$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $41e2c210a1c3aa9f$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $fcad3ca699dd0b9d$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $fcad3ca699dd0b9d$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $fcad3ca699dd0b9d$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($41e2c210a1c3aa9f$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $fcad3ca699dd0b9d$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $fcad3ca699dd0b9d$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $41e2c210a1c3aa9f$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($41e2c210a1c3aa9f$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $fcad3ca699dd0b9d$export$71511d61b312f219)(values.sort($41e2c210a1c3aa9f$var$sorter));
    }
}
function $41e2c210a1c3aa9f$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $fcad3ca699dd0b9d$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $fcad3ca699dd0b9d$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $41e2c210a1c3aa9f$export$85df64a8eb6dc986 extends $41e2c210a1c3aa9f$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $41e2c210a1c3aa9f$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $41e2c210a1c3aa9f$var$interpolate(table, this.min);
        this._tableRange = $41e2c210a1c3aa9f$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($41e2c210a1c3aa9f$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $41e2c210a1c3aa9f$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $41e2c210a1c3aa9f$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $41e2c210a1c3aa9f$export$29e663ba4d09fe7,
    LinearScale: $41e2c210a1c3aa9f$export$e7f4e5e8656f0b93,
    LogarithmicScale: $41e2c210a1c3aa9f$export$85295eaf7cb3ac3e,
    RadialLinearScale: $41e2c210a1c3aa9f$export$cfafc36d95386d38,
    TimeScale: $41e2c210a1c3aa9f$export$a894c72689ff3ec,
    TimeSeriesScale: $41e2c210a1c3aa9f$export$85df64a8eb6dc986
});
const $41e2c210a1c3aa9f$export$e8959e79e3af550f = [
    $41e2c210a1c3aa9f$export$a6506504f799c5d5,
    $41e2c210a1c3aa9f$export$7a5d735b2ab6389d,
    $41e2c210a1c3aa9f$export$8b3ca321c77fdea6,
    $41e2c210a1c3aa9f$export$bcac1c16f1530ec2
];


(0, $41e2c210a1c3aa9f$export$acaa6426d77a227e).register(...(0, $41e2c210a1c3aa9f$export$e8959e79e3af550f));
var $7dfe3e9d8091ad58$export$2e2bcd8739ae039 = (0, $41e2c210a1c3aa9f$export$acaa6426d77a227e);



var $346VI = parcelRequire("346VI");

var $3j512 = parcelRequire("3j512");
/*!
  * chartjs-adapter-moment v1.0.1
  * https://www.chartjs.org
  * (c) 2022 chartjs-adapter-moment Contributors
  * Released under the MIT license
  */ 
var $YChVI = parcelRequire("YChVI");

const $6bb7dbd08a8e00d9$var$FORMATS = {
    datetime: 'MMM D, YYYY, h:mm:ss a',
    millisecond: 'h:mm:ss.SSS a',
    second: 'h:mm:ss a',
    minute: 'h:mm a',
    hour: 'hA',
    day: 'MMM D',
    week: 'll',
    month: 'MMM YYYY',
    quarter: '[Q]Q - YYYY',
    year: 'YYYY'
};
(0, $41e2c210a1c3aa9f$export$f32766ea09ec8bc4)._date.override(typeof (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))) === 'function' ? {
    _id: 'moment',
    formats: function() {
        return $6bb7dbd08a8e00d9$var$FORMATS;
    },
    parse: function(value, format) {
        if (typeof value === 'string' && typeof format === 'string') value = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(value, format);
        else if (!(value instanceof (0, (/*@__PURE__*/$parcel$interopDefault($YChVI))))) value = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(value);
        return value.isValid() ? value.valueOf() : null;
    },
    format: function(time, format) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(time).format(format);
    },
    add: function(time, amount, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(time).add(amount, unit).valueOf();
    },
    diff: function(max, min, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(max).diff((0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(min), unit);
    },
    startOf: function(time, unit, weekday) {
        time = (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(time);
        if (unit === 'isoWeek') {
            weekday = Math.trunc(Math.min(Math.max(0, weekday), 6));
            return time.isoWeekday(weekday).startOf('day').valueOf();
        }
        return time.startOf(unit).valueOf();
    },
    endOf: function(time, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($YChVI)))(time).endOf(unit).valueOf();
    }
} : {});


//import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
//Chart.register(MatrixController, MatrixElement);
/*
chartAxis = {
    // gibt die primäre Achse an
    primary: 'x',
    sort: 'x',
    color: 'x',
    tableFieldName: '',
    type: 'logarithmic', 'linear', 'bar', 'line',
    groupLabel1: {
        fieldName: ,
    },
    groupLabel2: {
        fieldName: ,
    },
    groupLabel3: {
        fieldName: ,
    },

    // Achsen: 'x', 'y', 'y2', 'y3', 'y4', 'y5', 'y_alt', 'r'
    x: {
        title: ,
        fieldName: ,
    },
    y: {
        title: ,
        fieldName: '',
        fieldNamesAlt: [ ],
        format: 'number', 'string', 'date'
        stack: true,
        sum: true,
        showMedian: true,
        showMin: true,
        showMax: true,
        type: 'logarithmic', 'linear',
        hideNull: false, // für primary Axis
    },
    r: {
        title: ,
        fieldName: ,
        type: 'linear'
    },
}
*/ //if (window.DrDocChart !== undefined)
//    return;
if (window._chart_auto_resize === undefined) {
    window._chart_auto_resize = true;
    function beforePrintHandler() {
        for(let id in (0, $7dfe3e9d8091ad58$export$2e2bcd8739ae039).instances)(0, $7dfe3e9d8091ad58$export$2e2bcd8739ae039).instances[id].resize();
    }
    window.addEventListener('beforeprint', beforePrintHandler);
    window.addEventListener('afterprint', beforePrintHandler);
}
const $e16bedfaee0f439e$var$DrDocChartAxisNameArr = [
    'x',
    'y',
    'y2',
    'y3',
    'y4',
    'y5',
    'y_alt',
    'r',
    'r_alt'
];
function $e16bedfaee0f439e$export$2e2bcd8739ae039(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync, preprocess, selection) //function DrDocChart(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
//DrDocWeb.Chart = function(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
//window.DrDocChart = function(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
{
    if ((0, $7dfe3e9d8091ad58$export$2e2bcd8739ae039).getChart(chartId)) (0, $7dfe3e9d8091ad58$export$2e2bcd8739ae039).getChart(chartId).destroy();
    if (log) log('Chart.js: before promise');
    //return new Promise(function (resolve, reject) {
    if (chartAxis.primary == undefined) chartAxis.primary = 'x';
    if (chartAxis.color == undefined) chartAxis.color = 'r';
    if (searchObj == undefined) {
        searchObj = {};
        //searchObj[chartAxis.y.fieldName] = '!0';
        searchObj[chartAxis[chartAxis.primary].fieldName] = '*';
        console.log(JSON.stringify(searchObj));
    }
    let getObj = {
        archive: archiveName,
        action: 'searchfields',
        value: JSON.stringify(searchObj),
        selection: (0, $346VI.default).IsNullOrEmpty(selection) ? ';' : selection + ';',
        content_tablerows: true,
        target_profile: true,
        max: -1,
        start: 0,
        count: 10000
    };
    var addFieldSelection = function(fn) {
        if (!(0, $346VI.default).IsNullOrEmpty(fn) && getObj.selection.indexOf(';' + fn + ';') == -1) getObj.selection += fn + ';';
    };
    // forEachAxisName(function(axisName) { });
    var hasAxisName = function(axisName) {
        if ((0, $346VI.default).IsNullOrEmpty(axisName)) return false;
        return chartAxis[axisName] !== undefined && chartAxis[axisName] !== null && !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].fieldName);
    };
    var forEachAxisName = function(fn) {
        for(let i = $e16bedfaee0f439e$var$DrDocChartAxisNameArr.length - 1; i >= 0; i--){
            // Falls eine Achse nicht in Config enthalten ist, diese Achse entfernen
            let axisName = $e16bedfaee0f439e$var$DrDocChartAxisNameArr[i];
            if (!hasAxisName(axisName)) continue;
            fn(axisName);
        }
    };
    addFieldSelection(chartAxis.tableFieldName);
    // Achse initialisieren
    forEachAxisName(function(axisName) {
        // fieldNames enthält alle Feldnamen
        chartAxis[axisName].fieldNames = [];
        chartAxis[axisName].fieldNames.push(chartAxis[axisName].fieldName);
        if (chartAxis[axisName].fieldNamesAlt != undefined) for (let fieldName of chartAxis[axisName].fieldNamesAlt){
            chartAxis[axisName].fieldNames.push(fieldName);
            // Feldauswahl für Werte
            addFieldSelection(fieldName);
        }
        // Feldauswahl für Werte
        addFieldSelection(chartAxis[axisName].fieldName);
        chartAxis[axisName].max = 0.0;
        chartAxis[axisName].min = 0.0;
        if ((0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].stack)) chartAxis[axisName].stack = false;
    });
    // Feldauswahl für Label
    for(let group_i = 1; group_i <= 5; group_i++){
        if (chartAxis['groupLabel' + group_i] == undefined || (0, $346VI.default).IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName)) continue;
        //if (hasAxisName(chartAxis.groupLabel1.fieldName))
        addFieldSelection(chartAxis['groupLabel' + group_i].fieldName);
    }
    //getObj.selection += ';' + chartAxis[chartAxis.primary].fieldName;
    if (hasAxisName(chartAxis.primary)) addFieldSelection(chartAxis[chartAxis.primary].fieldName);
    getObj.selection = getObj.selection.trim(';');
    //DrDocWeb.ServerHost = 'http://192.168.200.38';
    //DrDocWeb.ServerPort = 8080;
    const getDataUrl = '/model/crud';
    if (log) log('Chart.js: Request URL: ' + (0, $346VI.default).GetRequestUrl(getDataUrl, getObj));
    /*let promiseReq = DrDocWeb.Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie);
    
    if (log)
    log('Chart.js: proc resp 1');

    // promiseReq ende
    promiseReq.catch(function(err){
        if (log)
          log('Chart.js: ERROR  DrDocWeb.Send: ' + err);
    });
    return promiseReq.then(function (data) {*/ var processResponse = function(data) {
        console.log('response data', data);
        if (log) log('Chart.js: proc resp 2');
        var chart_data = {
            labels: [],
            datasets: []
        };
        if (data.Result == undefined || data.Result == null || data.Result.length == 0) {
            if (log) log('Chart.js: response data: 0');
            //reject(new Error('Keine Suchergebnisse vorhanden.'));
            return;
        }
        if (log) log('Chart.js: response data: OK');
        // leere Elemente entfernen
        for(var i = data.Result.length - 1; i >= 0; i--){
            var itm = data.Result[i];
            // für jede Achse/Feld die alternativen Feldwerte laden
            forEachAxisName(function(axisName) {
                // alle alternativen Feldnamen durchlaufen, bis ein gefüllter Wert für die Achse vorhanden ist.
                for (let fieldName of chartAxis[axisName].fieldNames){
                    if ((0, $346VI.default).IsNullOrEmpty(itm[fieldName])) continue;
                    if (chartAxis[axisName].fieldName != fieldName) itm[chartAxis[axisName].fieldName] = itm[fieldName];
                    break;
                }
            });
            // Leere Datensätze aus Liste entfernen, wenn Primary Axis fieldName keinen Wert hat
            if (hasAxisName(chartAxis.primary) && (0, $346VI.default).IsNullOrEmpty(itm[chartAxis[chartAxis.primary].fieldName])) {
                if (chartAxis.hideNull === true) // leeres Element entfernen
                data.Result.splice(i, 1);
                else {
                    // leeres Element umbenennen
                    itm[chartAxis[chartAxis.primary].fieldName] = 'ERROR';
                    //itm[chartAxis[chartAxis.primary].fieldName] = null;
                    if ((0, $346VI.default).IsNullOrEmpty(chartAxis[chartAxis.primary].format)) {
                        chartAxis[chartAxis.primary].format = 'number';
                        itm[chartAxis[chartAxis.primary].fieldName] = null;
                    }
                }
            }
        }
        // Daten parsen
        data.Result.forEach(function(itm) {
            for(let group_i = 1; group_i <= 5; group_i++){
                if (chartAxis['groupLabel' + group_i] == undefined || (0, $346VI.default).IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName)) continue;
                if ((0, $346VI.default).IsNullOrEmpty(itm[chartAxis['groupLabel' + group_i].fieldName])) itm[chartAxis['groupLabel' + group_i].fieldName] = 'parse LEER ' + chartAxis['groupLabel' + group_i].fieldName;
            }
            //itm[chartAxis.y.fieldName] = isNaN(parseInt(itm[chartAxis.y.fieldName])) ? itm[chartAxis.y.fieldName] : parseInt(itm[chartAxis.y.fieldName]);
            forEachAxisName(function(axisName) {
                if (chartAxis[axisName] === undefined) {
                    console.warn('Axis undefined!', axisName);
                    return;
                }
                //itm[chartAxis[axisName].fieldName
                if (chartAxis[axisName].format == 'string') {
                    if ((0, $346VI.default).IsNullOrEmpty(itm[chartAxis[axisName].fieldName])) itm[chartAxis[axisName].fieldName] = null;
                } else if (chartAxis[axisName].format == 'date' || chartAxis[axisName].format == 'ttm') // toDateString();
                itm[chartAxis[axisName].fieldName] = (0, $346VI.default).ToIsoDateTimeStr(itm[chartAxis[axisName].fieldName]);
                else {
                    chartAxis[axisName].format = 'number';
                    // Maximalwet auslesen
                    // "max" Wert für Radar setzen wg. Normierung
                    if (itm[chartAxis[axisName].fieldName] !== undefined && itm[chartAxis[axisName].fieldName] !== null && !isNaN(parseFloat(itm[chartAxis[axisName].fieldName]))) itm[chartAxis[axisName].fieldName] = parseFloat(itm[chartAxis[axisName].fieldName]);
                    else //itm[chartAxis[axisName].fieldName] = 0;
                    itm[chartAxis[axisName].fieldName] = null;
                }
            /*else
                {
                    //console.warn('Bad Axis Format!', axisName, chartAxis[axisName].format);
                }*/ });
        });
        /*function getItemLabel1(itm) {
            return itm[chartAxis.groupLabel1.fieldName];
            //return itm[chartAxis.groupLabel1.fieldName] + ' / ' + itm['dateY'];
        };
        function getItemLabel2(itm) {
            return itm[chartAxis.groupLabel2.fieldName];
        };*/ function getItemLabel(itm) {
            let ret = '';
            for(let group_i = 1; group_i <= 5; group_i++){
                if (chartAxis['groupLabel' + group_i] == undefined || (0, $346VI.default).IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName)) continue;
                if (group_i > 1) ret += ' | ';
                ret += itm[chartAxis['groupLabel' + group_i].fieldName];
            }
            return ret;
        }
        function getItemLabelXAxis(itm) {
            if (chartAxis.x !== undefined && !(0, $346VI.default).IsNullOrEmpty(chartAxis.x.fieldName) && !(0, $346VI.default).IsNullOrEmpty(itm[chartAxis.x.fieldName])) return itm[chartAxis.x.fieldName];
            //console.warn ('getItemLabelXAxis X-LEER', itm);
            return 0; //'getItemLabelXAxis X-LEER ' + getItemLabel1(itm);
        //return undefined;
        }
        /*function getItemYAxis(itm) {
            if (chartAxis.y !== undefined && !DrDocWeb.IsNullOrEmpty(chartAxis.y.fieldName) && !DrDocWeb.IsNullOrEmpty(itm[chartAxis.y.fieldName]))
                return itm[chartAxis.y.fieldName];

            //return 0;
            return getItemLabelXAxis(itm);
        };*/ function sortByValueByFieldName(fieldName) {
            return function(itm_a, itm_b) {
                //return itm_a[chartAxis.y.fieldName].localeCompare(itm_b[chartAxis.y.fieldName]);
                if ((0, $346VI.default).IsNullOrEmpty(fieldName)) return 0;
                let a = 0;
                let b = 0;
                let cmp = 0;
                a = itm_a[fieldName];
                b = itm_b[fieldName];
                if (a === null || a === undefined) a = 0.0;
                if (b === null || b === undefined) b = 0.0;
                if (typeof a === 'string') {
                    cmp = a.localeCompare(b);
                    if (cmp != 0) return cmp;
                } else if (typeof a === 'number' || typeof a === 'date') {
                    if (a > b) return 1;
                    if (a < b) return -1;
                } else console.warn('bad type cmp', a, b);
                return 0;
            };
        }
        function sortByValue(axisName) {
            if ((0, $346VI.default).IsNullOrEmpty(axisName)) return null;
            if ((0, $346VI.default).IsNullOrEmpty(chartAxis[axisName])) return null;
            if ((0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].fieldName)) return null;
            return sortByValueByFieldName(chartAxis[axisName].fieldName);
        }
        // Daten sortieren
        data.sort = function(sortAxisName) {
            if ((0, $346VI.default).IsNullOrEmpty(sortAxisName)) sortAxisName = chartAxis.sort;
            if ((0, $346VI.default).IsNullOrEmpty(chartAxis.primary)) sortAxisName = chartAxis.primary;
            if (!(0, $346VI.default).IsNullOrEmpty(sortAxisName) && hasAxisName(sortAxisName)) {
                let sortFn = sortByValue(sortAxisName);
                if (sortFn) data.Result.sort(sortFn);
            }
        };
        if (preprocess !== undefined && preprocess !== null) preprocess(data);
        data.sort();
        /*else if (!DrDocWeb.IsNullOrEmpty(chartAxis.primary) && hasAxisName(chartAxis.primary))
        {
            data.Result.sort(sortByValue(chartAxis.primary));
            //console.log('Axis "R" not found: ', chartAxis);
            console.log('sorted data primary ', chartAxis.primary, ': ', data.Result);
        }*/ //console.log('Primary: ', chartAxis.primary);
        // --
        // Farben laden
        let chartColorsFg = []; // [ 'rgb(128,0,0)', 'rgb(0,128,0)', 'rgb(0,0,128)', 'rgb(0,128,128)', 'rgb(128,0,128)' ];
        let chartColorsBg = []; // [ 'rgba(128,0,0, 0.3)', 'rgba(0,128,0, 0.3)', 'rgba(0,0,128, 0.3)', 'rgba(0,128,128, 0.3)', 'rgba(128,0,128, 0.3)' ];
        let groupCount = 0;
        let chartColorArr = [
            128,
            192,
            64,
            224,
            32,
            160,
            96,
            250
        ];
        chartColorArr.forEach(function(colorNum) {
            chartColorsFg.push(`rgb(${colorNum}, 0, 0)`);
            chartColorsFg.push(`rgb(0, ${colorNum}, 0)`);
            chartColorsFg.push(`rgb(0, 0, ${colorNum})`);
            chartColorsFg.push(`rgb(${colorNum}, 0, ${colorNum})`);
            chartColorsFg.push(`rgb(${colorNum}, ${colorNum}, 0)`);
            chartColorsFg.push(`rgb(0, ${colorNum}, ${colorNum})`);
            //});
            //chartColorArr.forEach(function(colorNum) {
            chartColorsBg.push(`rgba(${colorNum}, 0, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, ${colorNum}, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, 0, ${colorNum}, 0.33)`);
            chartColorsBg.push(`rgba(${colorNum}, 0, ${colorNum}, 0.33)`);
            chartColorsBg.push(`rgba(${colorNum}, ${colorNum}, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, ${colorNum}, ${colorNum}, 0.33)`);
        });
        chartColorArr.forEach(function(colorNum) {
            // grau
            chartColorsFg.push(`rgb(${colorNum}, ${colorNum}, ${colorNum})`);
            chartColorsBg.push(`rgba(${colorNum}, ${colorNum}, ${colorNum}, 0.33)`);
        });
        // console.log('colors', chartColorsFg, chartColorsBg);
        // --
        // Für TTM Trailing twelve months, yoy year on year:
        // Y = Summe der letzten 12 Monate
        const axisName_x = 'x';
        if (chartAxis[axisName_x] !== undefined && chartAxis[axisName_x].format == 'ttm' && !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName_x].fieldName)) {
            let fieldName_x = chartAxis[axisName_x].fieldName;
            let stack = data.Result;
            // X-Achse ist vom Typ Datum und TTM
            //let axisName_y = 'y';
            forEachAxisName(function(axisName_y) {
                if (chartAxis[axisName_y].format == 'number' && !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName_y].fieldName)) {
                    let fieldName_y = chartAxis[axisName_y].fieldName;
                    let fieldName_y_ttm_tmp = fieldName_y + '_ttm_' + (0, $346VI.default).Random(8);
                    //chartAxis[axisName_y].sum = false;
                    //chartAxis[axisName_y].stack = false;
                    //for (let stack_i = stack.length - 1; stack_i >= 0; stack_i--) {
                    //    let dataset_itm = stack[stack_i];
                    for (let dataset_itm of stack){
                        // TTM Property mit Wert "0" initialisieren
                        let dataset_itm_y = 0.0;
                        let dataset_itm_x = dataset_itm[fieldName_x];
                        let dataset_itm_x_max = (0, $346VI.default).ParseDateTime(dataset_itm_x);
                        //DrDocWeb.DateTimeAdd(dataset_itm_x_max, -1, 'day');
                        let dataset_itm_x_min = (0, $346VI.default).ParseDateTime(dataset_itm_x);
                        //DrDocWeb.DateTimeAdd(dataset_itm_x_min, -3, 'day');
                        (0, $346VI.default).DateTimeAdd(dataset_itm_x_min, -1, 'year');
                        for (let dataset_itm_tmp of stack){
                            // Doppelte Datensätze ignorieren
                            //if (dataset_itm[DrDoc.ID_FIELD] === dataset_itm_tmp[DrDoc.ID_FIELD])
                            //    continue;
                            // ist "dataset_itm" im Bereich?
                            let dataset_itm_tmp_x = dataset_itm_tmp[fieldName_x];
                            let dataset_itm_tmp_y = dataset_itm_tmp[fieldName_y];
                            let dataset_itm_tmp_x_dateTime = (0, $346VI.default).ParseDateTime(dataset_itm_tmp_x);
                            if (dataset_itm_x === dataset_itm_tmp_x || dataset_itm_tmp_x_dateTime <= dataset_itm_x_max && dataset_itm_tmp_x_dateTime > dataset_itm_x_min) //console.log('Chart TTM: ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_x_min).substring(0,10), ' < ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_tmp_x_dateTime).substring(0,10), ' < ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_x_max).substring(0,10));
                            dataset_itm_y += dataset_itm_tmp_y;
                        }
                        dataset_itm[fieldName_y_ttm_tmp] = dataset_itm_y;
                    }
                    // TTM Property setzen und Temp wieder löschen
                    for (let dataset_itm of stack){
                        dataset_itm[fieldName_y] = dataset_itm[fieldName_y_ttm_tmp];
                        delete dataset_itm[fieldName_y_ttm_tmp];
                    }
                }
            });
        }
        // Saldo Felder erstellen
        if (chartAxis[axisName_x] !== undefined && chartAxis[axisName_x].format == 'date' && !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName_x].fieldName)) {
            let fieldName_x = chartAxis[axisName_x].fieldName;
            let stack = data.Result;
            // X-Achse ist vom Typ Datum und Y als Saldo aufsummieren
            //let axisName_y = 'y';
            forEachAxisName(function(axisName_y) {
                if (chartAxis[axisName_y].format == 'number' && !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName_y].fieldName)) {
                    let fieldName_y = chartAxis[axisName_y].fieldName;
                    let fieldName_y_tmp = fieldName_y + '_saldo_' + (0, $346VI.default).Random(8);
                    for (let dataset_itm of stack){
                        // mit Wert "0" initialisieren
                        let dataset_itm_y = 0.0;
                        let dataset_itm_x = dataset_itm[fieldName_x];
                        let dataset_itm_x_max = (0, $346VI.default).ParseDateTime(dataset_itm_x);
                        for (let dataset_itm_tmp of stack){
                            // ist "dataset_itm" im Bereich?
                            let dataset_itm_tmp_x = dataset_itm_tmp[fieldName_x];
                            let dataset_itm_tmp_y = dataset_itm_tmp[fieldName_y];
                            let dataset_itm_tmp_x_dateTime = (0, $346VI.default).ParseDateTime(dataset_itm_tmp_x);
                            // von Start bis jetzt
                            if (dataset_itm_x === dataset_itm_tmp_x || dataset_itm_tmp_x_dateTime <= dataset_itm_x_max) dataset_itm_y += dataset_itm_tmp_y;
                        }
                        dataset_itm[fieldName_y_tmp] = dataset_itm_y;
                    }
                    // TTM Property setzen und Temp wieder löschen
                    for (let dataset_itm of stack){
                        dataset_itm[fieldName_y + '--saldo'] = dataset_itm[fieldName_y_tmp];
                        delete dataset_itm[fieldName_y_tmp];
                    }
                }
            });
        }
        // min/Max Value lesen, für Bubble-Chart Radius
        forEachAxisName(function(axisName) {
            chartAxis[axisName].max = 0.0;
            chartAxis[axisName].min = 0.0;
        });
        data.Result.forEach(function(itm) {
            forEachAxisName(function(axisName) {
                if (chartAxis[axisName].format == 'number') {
                    // Maximalwet auslesen
                    let val = (0, $346VI.default).ParseInt(itm[chartAxis[axisName].fieldName]);
                    if (val !== 0) {
                        chartAxis[axisName].max = Math.max(val, chartAxis[axisName].max);
                        chartAxis[axisName].min = Math.min(val, chartAxis[axisName].max);
                    //console.log('min/max: ', axisName, ' / ', chartAxis[axisName].min, ' <-> ', chartAxis[axisName].max);
                    }
                }
            });
        });
        // Daten Gruppieren
        // Nach X-Werten gruppieren und X-Achse füllen
        let groupObjX = (0, $346VI.default).DataGroup(data.Result, [
            getItemLabelXAxis
        ]);
        console.log('groupObjX data', groupObjX);
        chart_data.labels = (0, $346VI.default).ObjGetKeys(groupObjX);
        // Nach Label (Gruppe 1, 2, 3) + X-Achse gruppieren
        let groupObjLabel = (0, $346VI.default).DataGroup(data.Result, [
            getItemLabel,
            getItemLabelXAxis
        ]);
        console.log('groupObjLabel data', groupObjLabel);
        for(let label in groupObjLabel){
            if (label === undefined) console.warn('nullll', label);
            let ds_IDs = [];
            let ds_colors = [];
            // axisName -> values[]
            let ds_sum = {};
            let ds_sum_arr = {};
            let ds_sum_detail_arr = {};
            let ds_data = {};
            forEachAxisName(function(axisName) {
                ds_sum[axisName] = 0.0;
                ds_sum_arr[axisName] = [];
                ds_data[axisName] = [];
                ds_sum_detail_arr[axisName] = {};
            });
            let label_datasets = groupObjLabel[label];
            for(let xAxisValue in groupObjX){
                forEachAxisName(function(axisName) {
                    ds_sum_detail_arr[axisName][xAxisValue] = [];
                });
                var stack = null;
                // wenn "stackID" gesetzt ist, alle Datensätze anzeigen
                //if (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stackID))
                //    stack = groupObjX[xAxisValue];
                //else
                stack = label_datasets[xAxisValue];
                // Daten sortieren
                /*if (!DrDocWeb.IsNullOrEmpty(chartAxis.sort) && hasAxisName(chartAxis.sort) && stack != undefined) {
                    stack.sort(sortByValue(chartAxis.sort));
                    console.log('sorted data ', chartAxis.sort, ': ', stack);
                }*/ // Wenn es ein Radar Chart ist, die Daten als Array und nicht als Objekt ausgeben
                if (chartType === 'radar' || chartType === 'doughnut' || chartType === 'pie') {
                    if (stack === undefined) {
                        // Mit "0" auffüllen, damit Daten an den N-ten Index rutschen
                        forEachAxisName(function(axisName) {
                            //if (0 > 0)
                            //ds_sum_arr2[axisName].push(0);
                            ds_data[axisName].push(null);
                        });
                        ds_colors.push(`rgba(128,128,128, 0.2)`);
                        ds_IDs.push('0');
                    } else {
                        // Nach-Werten sortieren
                        //stack.sort(sortByValue('y'));
                        //console.log('Group sorted by y / Label: ', label, ' -> ', xAxisValue, ' / by y: ', stack);
                        // Alle Werte der Achse summieren und IDs merken
                        //let dataset_itm_id_sum = '';
                        let dataset_itm_y_value_sum = {};
                        forEachAxisName(function(axisName) {
                            dataset_itm_y_value_sum[axisName] = 0.0;
                        });
                        for(let stack_i in stack){
                            var dataset_itm = stack[stack_i];
                            forEachAxisName(function(axisName) {
                                let dataset_itm_y_value = dataset_itm[chartAxis[axisName].fieldName];
                                if (chartAxis[axisName].format == 'number') {
                                    dataset_itm_y_value_sum[axisName] += dataset_itm_y_value;
                                    if (dataset_itm_y_value != null) ds_sum_arr[axisName].push(dataset_itm_y_value);
                                }
                                if (dataset_itm_y_value != null) ds_sum_detail_arr[axisName][xAxisValue].push(dataset_itm_y_value);
                            });
                            //dataset_itm_id_sum += dataset_itm[DrDoc.ID_FIELD] + '|';
                            ds_IDs.push(dataset_itm[(0, $3j512.default).ID_FIELD]);
                        }
                        forEachAxisName(function(axisName) {
                            let dataset_itm_y_value = dataset_itm_y_value_sum[axisName];
                            ds_sum[axisName] += dataset_itm_y_value;
                            //if (dataset_itm_y_value != null)
                            //    ds_sum_arr[axisName].push(dataset_itm_y_value);
                            ds_data[axisName].push(dataset_itm_y_value);
                        });
                    //let r_color = Math.round(50 + Math.abs(dataset_itm_r_value_sum) / chartAxis[chartAxis.color].max * 165);
                    //r_color = isNaN(r_color) ? 128 : r_color;
                    //ds_colors.push(dataset_itm_r_value_sum < 0.0 ? `rgba(${r_color}, 0, 0, 0.2)` : `rgba(0, ${r_color}, 0, 0.2)`);
                    //ds_IDs.push(dataset_itm_id_sum.trim('|'));
                    }
                } else // => kein Radar Chart
                // Nach-Werten sortieren
                //stack.sort(sortByValue('y'));
                //console.log('Group sorted by y / Label: ', label, ' -> ', xAxisValue, ' / by y: ', stack);
                for(let stack_i in stack){
                    let dataset_itm = stack[stack_i];
                    //let dataset_itm_x_value = dataset_itm[chartAxis.x.fieldName];
                    // Für Bubble Charts die Größe der Blasen setzen durch normieren vom Achse "r"
                    let dataset_itm_r_value_pixel = 10;
                    if (chartAxis.r !== undefined && chartAxis.r !== null && chartAxis.r.format == 'number') {
                        let dataset_itm_r_value = chartAxis.r !== undefined ? dataset_itm[chartAxis.r.fieldName] : 0;
                        dataset_itm_r_value_pixel = 1 + Math.abs(dataset_itm_r_value) / (Math.abs(chartAxis.r.max) + Math.abs(chartAxis.r.min)) * 46.0;
                        if (isNaN(dataset_itm_r_value_pixel)) dataset_itm_r_value_pixel = 0;
                    }
                    ds_IDs.push(dataset_itm[(0, $3j512.default).ID_FIELD]);
                    forEachAxisName(function(axisName) {
                        let dataset_itm_y_value = dataset_itm[chartAxis[axisName].fieldName];
                        //if ((xAxisValue == 'ERROR' || (dataset_itm_y_value == undefined || dataset_itm_y_value == null)) && chartAxis[axisName].hideNull === true)
                        //    return;
                        if (chartAxis[axisName].format == 'number') {
                            ds_sum[axisName] += dataset_itm_y_value;
                            //ds_sum2[axisName][xAxisValue] += dataset_itm_y_value;
                            if (dataset_itm_y_value != null) ds_sum_arr[axisName].push(dataset_itm_y_value);
                        }
                        let itm_i = chartAxis[axisName].sum === true ? (0, $346VI.default).GetArrayItemIndexWhere(ds_data[axisName], function(itm) {
                            return itm.x == xAxisValue;
                        }) : -1;
                        if (itm_i >= 0) {
                            if (chartAxis[axisName].format == 'number') ds_data[axisName][itm_i].y += dataset_itm_y_value;
                            ds_data[axisName][itm_i]._ids.push(dataset_itm[(0, $3j512.default).ID_FIELD]);
                        } else ds_data[axisName].push({
                            //stack: label + '--' + axisName + '--' + (+xAxisValue < 10 ? '0' + xAxisValue : xAxisValue),
                            stack: label + '--' + axisName + '--' + xAxisValue,
                            x: xAxisValue,
                            y: dataset_itm_y_value,
                            r: dataset_itm_r_value_pixel,
                            pointRadius: dataset_itm_r_value_pixel,
                            pointHoverRadius: dataset_itm_r_value_pixel + 2,
                            _ids: [
                                dataset_itm[(0, $3j512.default).ID_FIELD]
                            ]
                        });
                        if (dataset_itm_y_value != null) ds_sum_detail_arr[axisName][xAxisValue].push(dataset_itm_y_value);
                    });
                }
            } // Ende for (let xAxisValue in groupObjX)
            /*for (let xAxisValue in groupObjX) {

            }*/ // Datensatz-Group erzeugen / eines je Label bzw. Stack
            forEachAxisName(function(axisName) {
                /*
                // Datensätze nach X-Achsen-Wert sortieren
                ds_data[axisName].sort(function (itm_a, itm_b) {
                    return itm_a.stack.localeCompare(itm_b.stack);
                });
                */ if (axisName.substring(0, 1) === 'y') {
                    //if (chartAxis[axisName] !== undefined && ds_data[axisName].length > 0) {
                    // Datensatz Label erzeugen
                    let ds_label = '';
                    ds_label += label;
                    ds_label += ' - ';
                    //ds_label += 'x = ' + xAxisValue;
                    ds_label += chartAxis[axisName].title;
                    // Median etc berechnen
                    if (chartAxis[axisName].format == 'number') {
                        let ds_label_math = '';
                        if (chartAxis[axisName].sum === true) ds_label_math += 'Summe: ' + ds_sum[axisName].toLocaleString('de-DE', {
                            minimumFractionDigits: 2
                        }) + '; ';
                        if (chartAxis[axisName].showMedian === true) ds_label_math += 'Median: ' + (0, $346VI.default).Math_Median(ds_sum_arr[axisName]).toLocaleString('de-DE', {
                            minimumFractionDigits: 1
                        }) + '; ';
                        if (chartAxis[axisName].showMin === true) ds_label_math += 'Min: ' + chartAxis[axisName].min.toLocaleString('de-DE', {
                            minimumFractionDigits: 2
                        }) + '; ';
                        if (chartAxis[axisName].showMax === true) ds_label_math += 'Max: ' + chartAxis[axisName].max.toLocaleString('de-DE', {
                            minimumFractionDigits: 2
                        }) + '; ';
                        if (Object.keys(ds_sum_detail_arr[axisName]).length <= 10 && chartAxis[axisName].showMedian === true) {
                            ds_label_math = ds_label_math.trim();
                            ds_label_math += ' ';
                            for(var xAxisValue in ds_sum_detail_arr[axisName])if (ds_sum_detail_arr[axisName][xAxisValue] > 0) ds_label_math += ';  Median "' + xAxisValue + '": ' + (0, $346VI.default).Math_Median(ds_sum_detail_arr[axisName][xAxisValue]).toLocaleString('de-DE', {
                                minimumFractionDigits: 1
                            });
                        }
                        if (!(0, $346VI.default).IsNullOrEmpty(ds_label_math)) ds_label += '(' + ds_label_math.trim() + ')';
                    }
                    /*
                    let ds_label = [];
                    ds_label.push(label);
                    ds_label.push(chartAxis[axisName].title);
                    if (chartAxis[axisName].sum === true)
                        ds_label.push('Summe: ' + ds_sum[axisName].toLocaleString('de-DE', { minimumFractionDigits: 2 }));
                    ds_label.push('Median: ' + DrDocWeb.Math_Median(ds_sum_arr[axisName]).toLocaleString('de-DE', { minimumFractionDigits: 1 }));
                    
                    for (var xAxisValue in ds_sum_detail_arr[axisName])
                    {
                        ds_label.push(
                            //'Median von "' + xAxisValue + '": ' +
                            'Med.:"' + xAxisValue + '": ' +
                            DrDocWeb.Math_Median(ds_sum_detail_arr[axisName][xAxisValue]).toLocaleString('de-DE', { minimumFractionDigits: 1 }));
                    }
                    */ //console.log('ds_sum_arr[axisName]', ds_label, chartAxis[axisName].title, '(', axisName, ')', ds_sum_arr, ds_sum_detail_arr[axisName]);
                    let stackID = !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].stackID) ? chartAxis[axisName].stackID : label + '--' + axisName + '--' + groupCount;
                    let ds_i_found = -1;
                    for(let ds_i in chart_data.datasets)if (chart_data.datasets[ds_i].stack == stackID) ds_i_found = ds_i;
                    if (ds_i_found >= 0) chart_data.datasets[ds_i_found].data.push(ds_data[axisName]);
                    else {
                        // Datensätze eines Labels anfügen
                        chart_data.datasets.push({
                            type: chartAxis[axisName].type !== undefined ? chartAxis[axisName].type : chartType,
                            xAxisID: 'x',
                            yAxisID: axisName === 'y_alt' || chartAxis[axisName].alt === true ? 'y_alt' : 'y',
                            //yAxisID: 'y3',
                            //label: (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stackID) ? chartAxis[axisName].stackID : ds_label),
                            label: ds_label,
                            data: ds_data[axisName],
                            _ids: ds_IDs,
                            stack: stackID,
                            //color: chartColorsFg[groupCount],
                            borderColor: !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].color) ? chartAxis[axisName].color : chartColorsBg[groupCount],
                            backgroundColor: !(0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].color) ? chartAxis[axisName].color : chartColorsBg[groupCount],
                            fill: false
                        });
                        if ((0, $346VI.default).IsNullOrEmpty(chartAxis[axisName].color)) groupCount++;
                    }
                //}
                }
            });
        //console.log(label, ' => ', label_datasets);
        }
        console.log('chart data', chart_data);
        // xAxisDatasets
        const ctx = document.getElementById(chartId).getContext('2d');
        const config = {
            type: chartType,
            data: chart_data,
            plugins: [],
            events: [
                'click'
            ],
            options: {
                // Boolean - whether or not the chart should be responsive and resize when the browser does.
                responsive: true,
                // Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top'
                    },
                    title: {
                        display: true,
                        text: chartTitle
                    },
                    decimation: {
                        enabled: true,
                        algorithm: 'min-max'
                    }
                },
                // https://www.chartjs.org/docs/latest/configuration/interactions.html
                interaction: {
                    //mode: 'index',
                    mode: 'point',
                    //mode: 'x',
                    //mode: 'nearest',
                    //mode: 'new mode',
                    intersect: true,
                    axis: 'x'
                },
                //stacked: false,
                // indexAxis: chartAxis.primary,
                hover: {
                },
                scales: {},
                parsing: {
                    /*rAxisKey: chartAxis.r.fieldName,
                    xAxisKey: chartAxis.x.fieldName,
                    yAxisKey: chartAxis.y.fieldName,*/ rAxisKey: 'r',
                    xAxisKey: 'x',
                    yAxisKey: 'y'
                },
                /*tooltips: {
                    callbacks: {
                      footer: (tooltipItems, data) => {
                          console.log('Tooltip', tooltipItems, data);
                        let total = tooltipItems.reduce((a, e) => a + parseInt(e.yLabel), 0);
                        return 'Total: ' + total;
                      }
                    }
                  },*/ onClick: function(e, item) {
                    //console.log('onClick 1', e, item, item.length);
                    let item_i = item.length - 1;
                    if (item[item_i] == undefined) console.warn('item[item_i] == undefined', item);
                    if (item[item_i] != undefined && item[item_i].datasetIndex == undefined) console.warn('item[item_i].datasetIndex == undefined', item, item_i, item[item_i]);
                    if (chart_data.datasets == undefined) console.warn('chart_data.datasets == undefined', chart_data);
                    // Datenreihe pro Label
                    let dataset = chart_data.datasets[item[item_i].datasetIndex]; //.data[item[0].index];
                    // Datensatz
                    let dataset_sub = dataset.data[item[item_i].index];
                    //console.log('onClick 2', dataset, dataset_sub);
                    /*
                    let id = dataset._ids[item[item_i].index];
                    let valueObj = dataset.data[item[item_i].index];
                    console.log(`Item with text ${item[item_i].index} and index ${item[item_i].datasetIndex} clicked`);
                    console.log('onclick', id, valueObj['ref_num'], valueObj, dataset);
                    DrDoc.GetDataset(null, archiveName, '', id, 'get');
                    */ console.log(`Item with text index "${item[item_i].index}" and datasetIndex "${item[item_i].datasetIndex}" clicked`);
                    let idArr = null;
                    if (dataset_sub._ids != undefined && dataset_sub._ids != null && dataset_sub._ids.length > 0) // dataset.data ist eine Array von Objekten z.B. für Bar
                    idArr = dataset_sub._ids;
                    else // dataset.data ist eine Array von Zahlen z.B. für Radar
                    idArr = [
                        dataset._ids[item[item_i].index]
                    ];
                    let searchFieldsObj = {};
                    searchFieldsObj[(0, $3j512.default).ID_FIELD] = idArr.join('|');
                    console.log('onclick idArr', idArr);
                    console.log('onclick ds', dataset, dataset._ids);
                    console.log('onclick ds-sub', dataset_sub, dataset_sub._ids);
                    //DrDoc.SearchFields(null, archiveName, searchFieldsObj);
                    //DrDoc.SearchFields(document.documentElement, archiveName, searchFieldsObj);
                    (0, $3j512.default).SearchFieldsInfo(null, archiveName, searchFieldsObj);
                }
            }
        };
        // Achsen etc. formattieren
        forEachAxisName(function(axisName) {
            if (chartAxis[axisName] == undefined && config.options.scales[axisName] === undefined) return;
            if (config.options.scales[axisName] === undefined && axisName != 'r') // Achse initialisieren, außer für "r"
            config.options.scales[axisName] = {
                id: axisName,
                //position: 'left',
                beginAtZero: false,
                title: {
                    display: true,
                    text: chartAxis[axisName] !== undefined ? chartAxis[axisName].title : 'null'
                },
                gridLines: {
                    offsetGridLines: true,
                    drawOnChartArea: true
                },
                stacked: chartAxis[axisName] !== undefined && chartAxis[axisName].stack !== undefined ? chartAxis[axisName].stack : false,
                //type: chartAxis[axisName] !== undefined && chartAxis[axisName].type !== undefined ? chartAxis[axisName].type : chartType,
                display: axisName == 'y_alt' || !(axisName.indexOf('y') === 0 && axisName.length >= 2),
                axis: axisName.indexOf('y') === 0 ? 'y' : axisName.indexOf('r') === 0 ? 'r' : 'x'
            };
            if (config.options.scales[axisName] == undefined) return;
            if (axisName.indexOf('x') === 0) config.options.scales[axisName].position = 'bottom';
            chartAxis[axisName].distribution = 'linear';
            if (chartAxis[axisName].format == 'string') {
                config.options.scales[axisName].type = 'category';
                //config.options.scales[axisName].drawOnChartArea = false;
                config.options.scales[axisName].stackWeight = 1;
                config.options.scales[axisName].offset = false;
                let groupObjAxisName = (0, $346VI.default).DataGroup(data.Result, [
                    function(itm) {
                        return itm[chartAxis[axisName].fieldName];
                    }
                ]);
                console.log('groupObjAxisName data', groupObjAxisName);
                let catLabels = (0, $346VI.default).ObjGetKeys(groupObjAxisName);
                console.log('groupObjAxisName labels', catLabels);
                config.options.scales[axisName].labels = catLabels;
            } else if (chartAxis[axisName].format == 'date' || chartAxis[axisName].format == 'ttm') {
                config.options.scales[axisName].beginAtZero = false;
                config.options.scales[axisName].type = 'time';
                config.options.scales[axisName].time = {
                    parser: 'YYYY-MM-DDTHH:mm',
                    //unit: 'year',
                    unit: 'month',
                    //min: '2015-01-01T00:00',
                    displayFormats: {
                        'millisecond': 'YYYY MMM DD',
                        'second': 'YYYY MMM DD',
                        'minute': 'YYYY MMM DD',
                        'hour': 'YYYY MMM DD',
                        'day': 'YYYY MMM DD',
                        'week': 'YYYY MMM DD',
                        'month': 'YYYY MMM DD',
                        'quarter': 'YYYY MMM DD',
                        'year': 'YYYY MMM'
                    }
                };
            } else config.options.scales[axisName].type = 'linear'; //'logarithmic';
        /*if (axisName == 'r')
            {
                config.options.scales[axisName].display = false;
                //config.options.scales[axisName].gridLines.drawOnChartArea = false;
            }*/ });
        if (config.options.scales['y_alt'] !== undefined) {
            config.options.scales['y_alt'].position = 'right';
            //config.options.scales['y_alt'].display = false;
            //config.options.scales['y_alt'].gridLines.drawOnChartArea = false;
            //config.options.scales['y_alt'].gridLines.offsetGridLines = false;
            config.options.scales['y_alt'].gridLines = {};
        }
        if (config.options.scales['r_alt'] !== undefined) {
            config.options.scales['r_alt'].position = 'right';
            //config.options.scales['r_alt'].display = false;
            config.options.scales['r_alt'].gridLines.drawOnChartArea = false;
        }
        /*if (config.options.scales['x'] !== undefined)
        {
            config.options.scales['x'].axis = 'x';
        }*/ //config.options.scales.x.display = chartAxis.x !== undefined;
        //config.options.scales.y.display = chartAxis.y !== undefined;
        //config.options.scales.y_alt.display = chartAxis.y_alt !== undefined;
        //config.options.scales.y3.display = chartAxis.y3 !== undefined;
        //config.options.scales.r.display = chartAxis.r !== undefined;
        if (chartType == 'radar' || chartType == 'doughnut' || chartType == 'pie') {
            forEachAxisName(function(axisName) {
                // alle Achsen entfernen/ausblenden, außer "r"
                if (config.options.scales[axisName] != undefined) config.options.scales[axisName].display = axisName.indexOf('r') === 0;
            });
            //config.options.scales.r.display = true;
            //config.options.scales.r.display = false;
            //config.options.scales.r.display = true;
            /*delete config.options.scales.x;
            delete config.options.scales.y;
            delete config.options.parsing.xAxisKey;
            delete config.options.parsing.yAxisKey;*/ //config.options.parsing.yAxisKey = 'r';
            //config.options.parsing.rAxisKey = 'y';
            if (config.options.scales.y != undefined) config.options.scales.y.axis = 'r';
            if (config.options.scales.y_2 != undefined) config.options.scales.y_2.axis = 'r';
        //if (config.options.scales.r != undefined)
        //    config.options.scales.r.axis = 'y';
        } else {
            //config.options.scales.x.display = true;
            //config.options.scales.y.display = true;
            //config.options.scales.r.display = false;
            let allAxisScalableNumber = true;
            forEachAxisName(function(axisName) {
                // alle Achsen entfernen/ausblenden, außer "r"
                if (config.options.scales[axisName] != undefined) {
                    if (chartAxis[axisName].format !== 'number') allAxisScalableNumber = false;
                }
            });
            if (allAxisScalableNumber) {
                config.options.plugins.quadrants = {
                    topLeft: 'rgb(255, 255, 64, 0.03)',
                    topRight: 'rgb(0, 255, 0, 0.03)',
                    bottomLeft: 'rgb(255, 0, 0, 0.03)',
                    bottomRight: 'rgb(255, 128, 64, 0.03)'
                };
                const quadrants = {
                    id: 'quadrants',
                    beforeDraw: function(chart, args, options) {
                        const { ctx: ctx, chartArea: { left: left, top: top, right: right, bottom: bottom }, scales: { x: x, y: y } } = chart;
                        const midX = x.getPixelForValue(0);
                        const midY = y.getPixelForValue(0);
                        ctx.save();
                        ctx.fillStyle = options.topLeft;
                        ctx.fillRect(left, top, midX - left, midY - top);
                        ctx.fillStyle = options.topRight;
                        ctx.fillRect(midX, top, right - midX, midY - top);
                        ctx.fillStyle = options.bottomRight;
                        ctx.fillRect(midX, midY, right - midX, bottom - midY);
                        ctx.fillStyle = options.bottomLeft;
                        ctx.fillRect(left, midY, midX - left, bottom - midY);
                        ctx.restore();
                    }
                };
                config.plugins.push(quadrants);
            }
        }
        console.log('Chart Scales: ', config.options.scales);
        var myChart = new (0, $7dfe3e9d8091ad58$export$2e2bcd8739ae039)(ctx, config);
        //resolve({ data: data.Result, chart: myChart });
        if (log) log('Chart.js: resolve');
        return {
            data: data.Result,
            chart: myChart
        };
    }; // processResponse Ende
    if (retAsync === true) {
        if (log) log('Chart.js: proc resp 1: Async');
        return (0, $346VI.default).Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie, retAsync === true).then(processResponse);
    } else {
        if (log) log('Chart.js: proc resp 1: Synchronous');
        let data = (0, $346VI.default).Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie, retAsync === true);
        if (log) log('Chart.js: proc resp 2: Synchronous');
        return processResponse(data);
    }
//}); // DrDocWeb.Send then ENDE
//}); // Promise ENDE
}
//module.exports = DrDocChart
//export default DrDocChart;
window.DrDocChart = $e16bedfaee0f439e$export$2e2bcd8739ae039;

})();
//# sourceMappingURL=drdocchart.js.map
